export default [
    {
        NAME: 'test111',
        codeList: [
            {
                CODE: '222',
                NAME: '2222',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'CLOUD계획타입',
        codeList: [
            {
                CODE: '1',
                NAME: '자체장비심의위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'testGroup!!!!!!!',
                NAME: '테스트!!!!!!!!',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'CLOUD심의결과',
        codeList: [
            {
                CODE: 'J',
                NAME: '구입인정',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '구입불인정',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '구입인정',
                ENG_NAME: null,
            },
            {
                CODE: 'T',
                NAME: '보완 후 재심',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'CLOUD심의유형',
        codeList: [
            {
                CODE: 'ON',
                NAME: '온라인',
                ENG_NAME: null,
            },
            {
                CODE: 'OFF',
                NAME: '오프라인',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'CLOUD심의진행상태',
        codeList: [
            {
                CODE: 'W',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'WF',
                NAME: '작성완료',
                ENG_NAME: null,
            },
            {
                CODE: 'DR',
                NAME: '심의접수',
                ENG_NAME: null,
            },
            {
                CODE: 'DF',
                NAME: '심의접수완료',
                ENG_NAME: null,
            },
            {
                CODE: 'DP',
                NAME: '심의진행',
                ENG_NAME: null,
            },
            {
                CODE: '1E',
                NAME: '1차심의완료',
                ENG_NAME: null,
            },
            {
                CODE: 'OR',
                NAME: '이의신청',
                ENG_NAME: null,
            },
            {
                CODE: '2E',
                NAME: '2차심의완료',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '심의완료',
                ENG_NAME: null,
            },
            {
                CODE: 'DS',
                NAME: '심의결과통보',
                ENG_NAME: null,
            },
            {
                CODE: 'ON',
                NAME: '2차심의진행',
                ENG_NAME: null,
            },
            {
                CODE: 'X',
                NAME: '삭제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'CLOUD요청서상태',
        codeList: [
            {
                CODE: 'OP',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'DS',
                NAME: '통보',
                ENG_NAME: null,
            },
            {
                CODE: 'SM',
                NAME: '제출',
                ENG_NAME: null,
            },
            {
                CODE: 'NR',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'NC',
                NAME: '접수',
                ENG_NAME: null,
            },
            {
                CODE: 'RR',
                NAME: '이의신청',
                ENG_NAME: null,
            },
            {
                CODE: 'X',
                NAME: '삭제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'CLOUD장비구축계획서상태',
        codeList: [
            {
                CODE: 'OR',
                NAME: '이의신청반려',
                ENG_NAME: null,
            },
            {
                CODE: 'NR',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'RO',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'RF',
                NAME: '제출',
                ENG_NAME: null,
            },
            {
                CODE: 'NC',
                NAME: '접수',
                ENG_NAME: null,
            },
            {
                CODE: 'MC',
                NAME: '1차심의완료',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'DS',
                NAME: '통보',
                ENG_NAME: null,
            },
            {
                CODE: 'X',
                NAME: '삭제',
                ENG_NAME: null,
            },
            {
                CODE: 'OM',
                NAME: '이의신청',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'CLOUD취득방법',
        codeList: [
            {
                CODE: 'P',
                NAME: '구매',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '제작의뢰',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '렌탈(단기임대)',
                ENG_NAME: null,
            },
            {
                CODE: 'OM',
                NAME: '자체제작',
                ENG_NAME: null,
            },
            {
                CODE: '99',
                NAME: '기타',
                ENG_NAME: null,
            },
            {
                CODE: 'L',
                NAME: '리스(장기임대)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '경제사회목적코드',
        codeList: [
            {
                CODE: 'RPT17.001',
                NAME: '지구개발 및 탐사',
                ENG_NAME: '지구개발 및 탐사',
            },
            {
                CODE: 'RPT17.002',
                NAME: '환경',
                ENG_NAME: '환경',
            },
            {
                CODE: 'RPT17.003',
                NAME: '우주개발 및 탐사',
                ENG_NAME: '우주개발 및 탐사',
            },
            {
                CODE: 'RPT17.004',
                NAME: '교통,전기통신 등 기반시설',
                ENG_NAME: '교통,전기통신 등 기반시설',
            },
            {
                CODE: 'RPT17.005',
                NAME: '에너지 ',
                ENG_NAME: '에너지 ',
            },
            {
                CODE: 'RPT17.006',
                NAME: '산업생산 및 기술',
                ENG_NAME: '산업생산 및 기술',
            },
            {
                CODE: 'RPT17.007',
                NAME: '건강',
                ENG_NAME: '건강',
            },
            {
                CODE: 'RPT17.008',
                NAME: '농업',
                ENG_NAME: '농업',
            },
            {
                CODE: 'RPT17.009',
                NAME: '교육',
                ENG_NAME: '교육',
            },
            {
                CODE: 'RPT17.010',
                NAME: '문화,휴학,종교 및 매스미디어',
                ENG_NAME: '문화,휴학,종교 및 매스미디어',
            },
            {
                CODE: 'RPT17.011',
                NAME: '정치, 사회시스템, 구조 및 과제',
                ENG_NAME: '정치, 사회시스템, 구조 및 과제',
            },
            {
                CODE: 'RPT17.012',
                NAME: '지식의 일반적 진보',
                ENG_NAME: '지식의 일반적 진보',
            },
            {
                CODE: 'RPT17.013',
                NAME: '국방',
                ENG_NAME: '국방',
            },
        ],
    },
    {
        NAME: '과제상태코드',
        codeList: [
            {
                CODE: 'RPT28.PROS',
                NAME: '진행',
                ENG_NAME: '진행',
            },
            {
                CODE: 'RPT28.CMPTL',
                NAME: '완료',
                ENG_NAME: '완료',
            },
            {
                CODE: 'RPT28.CNCEL',
                NAME: '해약',
                ENG_NAME: '해약',
            },
            {
                CODE: 'RPT28.HLT',
                NAME: '중단',
                ENG_NAME: '중단',
            },
            {
                CODE: 'RPT28.TRAN',
                NAME: '이관',
                ENG_NAME: '이관',
            },
            {
                CODE: 'RPT28.BRKUP',
                NAME: '해제(사용하지 않을 계획)',
                ENG_NAME: '해제(사용하지 않을 계획)',
            },
            {
                CODE: 'RPT28.CHG',
                NAME: '변경(사용하지 않을 계획)',
                ENG_NAME: '변경(사용하지 않을 계획)',
            },
            {
                CODE: 'RPT28.CNCL',
                NAME: '취소(사용하지 않을 계획)',
                ENG_NAME: '취소(사용하지 않을 계획)',
            },
            {
                CODE: 'RPT28.STOP',
                NAME: '정지(사용하지 않을 계획)',
                ENG_NAME: '정지(사용하지 않을 계획)',
            },
            {
                CODE: 'RPT28.TRMN',
                NAME: '해지(사용하지 않을 계획)',
                ENG_NAME: '해지(사용하지 않을 계획)',
            },
        ],
    },
    {
        NAME: '국가기술지도코드',
        codeList: [
            {
                CODE: 'RPT20.001',
                NAME: '광통신기술',
                ENG_NAME: '광통신기술',
            },
            {
                CODE: 'RPT20.002',
                NAME: '초고속무선멀티미디어 기술',
                ENG_NAME: '초고속무선멀티미디어 기술',
            },
            {
                CODE: 'RPT20.003',
                NAME: '4G이동통신기술',
                ENG_NAME: '4G이동통신기술',
            },
            {
                CODE: 'RPT20.004',
                NAME: '이동멀티미디어컨텐츠기술',
                ENG_NAME: '이동멀티미디어컨텐츠기술',
            },
            {
                CODE: 'RPT20.005',
                NAME: '반도체나노신소자기술',
                ENG_NAME: '반도체나노신소자기술',
            },
            {
                CODE: 'RPT20.006',
                NAME: '지능네트워크기술',
                ENG_NAME: '지능네트워크기술',
            },
            {
                CODE: 'RPT20.007',
                NAME: '고성능정보처리및저장장치',
                ENG_NAME: '고성능정보처리및저장장치',
            },
            {
                CODE: 'RPT20.008',
                NAME: '유무선통합시스템기술',
                ENG_NAME: '유무선통합시스템기술',
            },
            {
                CODE: 'RPT20.009',
                NAME: '디지털신호처리개발',
                ENG_NAME: '디지털신호처리개발',
            },
            {
                CODE: 'RPT20.010',
                NAME: '디지털방송기술',
                ENG_NAME: '디지털방송기술',
            },
            {
                CODE: 'RPT20.011',
                NAME: '착용형컴퓨터기술',
                ENG_NAME: '착용형컴퓨터기술',
            },
            {
                CODE: 'RPT20.012',
                NAME: '전자상거래시스템기술',
                ENG_NAME: '전자상거래시스템기술',
            },
            {
                CODE: 'RPT20.013',
                NAME: '전자금융기술',
                ENG_NAME: '전자금융기술',
            },
            {
                CODE: 'RPT20.014',
                NAME: '차세대정보시스템',
                ENG_NAME: '차세대정보시스템',
            },
            {
                CODE: 'RPT20.015',
                NAME: 'SW표준화및설계재이용기술',
                ENG_NAME: 'SW표준화및설계재이용기술',
            },
            {
                CODE: 'RPT20.016',
                NAME: '정보검색및DBMS기술',
                ENG_NAME: '정보검색및DBMS기술',
            },
            {
                CODE: 'RPT20.017',
                NAME: '정보보호기술',
                ENG_NAME: '정보보호기술',
            },
            {
                CODE: 'RPT20.018',
                NAME: '디지털정보디자인기술',
                ENG_NAME: '디지털정보디자인기술',
            },
            {
                CODE: 'RPT20.019',
                NAME: '문화원형복원기술',
                ENG_NAME: '문화원형복원기술',
            },
            {
                CODE: 'RPT20.020',
                NAME: '디지털컨텐츠저작도구',
                ENG_NAME: '디지털컨텐츠저작도구',
            },
            {
                CODE: 'RPT20.021',
                NAME: '게임엔진제작및기반기술',
                ENG_NAME: '게임엔진제작및기반기술',
            },
            {
                CODE: 'RPT20.022',
                NAME: '영화영상디지털미디어표준',
                ENG_NAME: '영화영상디지털미디어표준',
            },
            {
                CODE: 'RPT20.023',
                NAME: '사이버커뮤니케이션기술',
                ENG_NAME: '사이버커뮤니케이션기술',
            },
            {
                CODE: 'RPT20.024',
                NAME: '인공지능및지능로봇기술',
                ENG_NAME: '인공지능및지능로봇기술',
            },
            {
                CODE: 'RPT20.025',
                NAME: 'MEMS기술',
                ENG_NAME: 'MEMS기술',
            },
            {
                CODE: 'RPT20.026',
                NAME: '홈네트워크기술',
                ENG_NAME: '홈네트워크기술',
            },
            {
                CODE: 'RPT20.027',
                NAME: '가전기기지능화기술',
                ENG_NAME: '가전기기지능화기술',
            },
            {
                CODE: 'RPT20.028',
                NAME: '차세대디스플레이기술',
                ENG_NAME: '차세대디스플레이기술',
            },
            {
                CODE: 'RPT20.029',
                NAME: '생체진단기술',
                ENG_NAME: '생체진단기술',
            },
            {
                CODE: 'RPT20.030',
                NAME: '초고속분석시스템기술',
                ENG_NAME: '초고속분석시스템기술',
            },
            {
                CODE: 'RPT20.031',
                NAME: 'Target인식타당성검증기술',
                ENG_NAME: 'Target인식타당성검증기술',
            },
            {
                CODE: 'RPT20.032',
                NAME: '선도물질도출기술',
                ENG_NAME: '선도물질도출기술',
            },
            {
                CODE: 'RPT20.033',
                NAME: '선도물질최적화기술',
                ENG_NAME: '선도물질최적화기술',
            },
            {
                CODE: 'RPT20.034',
                NAME: '후보물질도출기술',
                ENG_NAME: '후보물질도출기술',
            },
            {
                CODE: 'RPT20.035',
                NAME: '대량생산공정기술',
                ENG_NAME: '대량생산공정기술',
            },
            {
                CODE: 'RPT20.036',
                NAME: '제제화기술',
                ENG_NAME: '제제화기술',
            },
            {
                CODE: 'RPT20.037',
                NAME: '약물전달시스템기술',
                ENG_NAME: '약물전달시스템기술',
            },
            {
                CODE: 'RPT20.038',
                NAME: '안전성및약효분석평가기술',
                ENG_NAME: '안전성및약효분석평가기술',
            },
            {
                CODE: 'RPT20.039',
                NAME: '임상시험기술',
                ENG_NAME: '임상시험기술',
            },
            {
                CODE: 'RPT20.040',
                NAME: '생체신호처리기술',
                ENG_NAME: '생체신호처리기술',
            },
            {
                CODE: 'RPT20.041',
                NAME: '생체영상처리기술',
                ENG_NAME: '생체영상처리기술',
            },
            {
                CODE: 'RPT20.042',
                NAME: '바이오칩센서기술',
                ENG_NAME: '바이오칩센서기술',
            },
            {
                CODE: 'RPT20.043',
                NAME: '생체재료기술',
                ENG_NAME: '생체재료기술',
            },
            {
                CODE: 'RPT20.044',
                NAME: '줄기세포응용기술',
                ENG_NAME: '줄기세포응용기술',
            },
            {
                CODE: 'RPT20.045',
                NAME: '유전자조작전달기술',
                ENG_NAME: '유전자조작전달기술',
            },
            {
                CODE: 'RPT20.046',
                NAME: '생체기능모니터링기술',
                ENG_NAME: '생체기능모니터링기술',
            },
            {
                CODE: 'RPT20.047',
                NAME: '생체정보생성저장분석활용',
                ENG_NAME: '생체정보생성저장분석활용',
            },
            {
                CODE: 'RPT20.048',
                NAME: '대기오염물질저감및제거',
                ENG_NAME: '대기오염물질저감및제거',
            },
            {
                CODE: 'RPT20.049',
                NAME: '수질및수자원관리기술',
                ENG_NAME: '수질및수자원관리기술',
            },
            {
                CODE: 'RPT20.050',
                NAME: '폐기물저감및재활용기술',
                ENG_NAME: '폐기물저감및재활용기술',
            },
            {
                CODE: 'RPT20.051',
                NAME: '환경친화적소재기술',
                ENG_NAME: '환경친화적소재기술',
            },
            {
                CODE: 'RPT20.052',
                NAME: '생태계오염토양지하수복원',
                ENG_NAME: '생태계오염토양지하수복원',
            },
            {
                CODE: 'RPT20.053',
                NAME: '해양오염평가및저감기술',
                ENG_NAME: '해양오염평가및저감기술',
            },
            {
                CODE: 'RPT20.054',
                NAME: '위해성관리를통한환경보건',
                ENG_NAME: '위해성관리를통한환경보건',
            },
            {
                CODE: 'RPT20.055',
                NAME: '자연재해예측및저감기술',
                ENG_NAME: '자연재해예측및저감기술',
            },
            {
                CODE: 'RPT20.056',
                NAME: '기상조절기술',
                ENG_NAME: '기상조절기술',
            },
            {
                CODE: 'RPT20.057',
                NAME: '연료전지기술',
                ENG_NAME: '연료전지기술',
            },
            {
                CODE: 'RPT20.058',
                NAME: '수소에너지기술',
                ENG_NAME: '수소에너지기술',
            },
            {
                CODE: 'RPT20.059',
                NAME: '소형열병합발전시스템기술',
                ENG_NAME: '소형열병합발전시스템기술',
            },
            {
                CODE: 'RPT20.060',
                NAME: '에너지소재기술',
                ENG_NAME: '에너지소재기술',
            },
            {
                CODE: 'RPT20.061',
                NAME: '에너지절약형반응분리공정',
                ENG_NAME: '에너지절약형반응분리공정',
            },
            {
                CODE: 'RPT20.062',
                NAME: '미활용에너지이용기술',
                ENG_NAME: '미활용에너지이용기술',
            },
            {
                CODE: 'RPT20.063',
                NAME: '바이오에너지기술',
                ENG_NAME: '바이오에너지기술',
            },
            {
                CODE: 'RPT20.064',
                NAME: '미래형일체형원자로기술',
                ENG_NAME: '미래형일체형원자로기술',
            },
            {
                CODE: 'RPT20.065',
                NAME: '태양에너지기술',
                ENG_NAME: '태양에너지기술',
            },
            {
                CODE: 'RPT20.066',
                NAME: '2차전지기술',
                ENG_NAME: '2차전지기술',
            },
            {
                CODE: 'RPT20.067',
                NAME: '풍력에너지기술',
                ENG_NAME: '풍력에너지기술',
            },
            {
                CODE: 'RPT20.068',
                NAME: '고신뢰성전력시스템기술',
                ENG_NAME: '고신뢰성전력시스템기술',
            },
            {
                CODE: 'RPT20.069',
                NAME: '차세대자동차기술',
                ENG_NAME: '차세대자동차기술',
            },
            {
                CODE: 'RPT20.070',
                NAME: '고부가가치선박기술',
                ENG_NAME: '고부가가치선박기술',
            },
            {
                CODE: 'RPT20.071',
                NAME: '해양구조물및장비기술',
                ENG_NAME: '해양구조물및장비기술',
            },
            {
                CODE: 'RPT20.072',
                NAME: '한국형고속전철첨단경전철',
                ENG_NAME: '한국형고속전철첨단경전철',
            },
            {
                CODE: 'RPT20.073',
                NAME: '지능형교통시스템기술',
                ENG_NAME: '지능형교통시스템기술',
            },
            {
                CODE: 'RPT20.074',
                NAME: '통합물류수송시스템구축',
                ENG_NAME: '통합물류수송시스템구축',
            },
            {
                CODE: 'RPT20.075',
                NAME: '첨단SOC인프라건설기술',
                ENG_NAME: '첨단SOC인프라건설기술',
            },
            {
                CODE: 'RPT20.076',
                NAME: '건설정보화기술',
                ENG_NAME: '건설정보화기술',
            },
            {
                CODE: 'RPT20.077',
                NAME: '인간친화형고기능건축기술',
                ENG_NAME: '인간친화형고기능건축기술',
            },
            {
                CODE: 'RPT20.078',
                NAME: '기존건물수명연장기술',
                ENG_NAME: '기존건물수명연장기술',
            },
            {
                CODE: 'RPT20.079',
                NAME: '청정해양에너지개발기술',
                ENG_NAME: '청정해양에너지개발기술',
            },
            {
                CODE: 'RPT20.080',
                NAME: '지능형생산시스템기술',
                ENG_NAME: '지능형생산시스템기술',
            },
            {
                CODE: 'RPT20.081',
                NAME: '청정생산시스템기술',
                ENG_NAME: '청정생산시스템기술',
            },
            {
                CODE: 'RPT20.082',
                NAME: '초정밀가공시스템기술',
                ENG_NAME: '초정밀가공시스템기술',
            },
            {
                CODE: 'RPT20.083',
                NAME: '초미세공정및장비기술',
                ENG_NAME: '초미세공정및장비기술',
            },
            {
                CODE: 'RPT20.084',
                NAME: '나노소재소자기술',
                ENG_NAME: '나노소재소자기술',
            },
            {
                CODE: 'RPT20.085',
                NAME: '고기능금속소재기술',
                ENG_NAME: '고기능금속소재기술',
            },
            {
                CODE: 'RPT20.086',
                NAME: '고기능세라믹소재기술',
                ENG_NAME: '고기능세라믹소재기술',
            },
            {
                CODE: 'RPT20.087',
                NAME: '고기능고분자소재기술',
                ENG_NAME: '고기능고분자소재기술',
            },
            {
                CODE: 'RPT20.088',
                NAME: '고성능복합기능섬유소재',
                ENG_NAME: '고성능복합기능섬유소재',
            },
            {
                CODE: 'RPT20.089',
                NAME: '위성체 개발기술',
                ENG_NAME: '위성체 개발기술',
            },
            {
                CODE: 'RPT20.090',
                NAME: '위성 탑재체기술',
                ENG_NAME: '위성 탑재체기술',
            },
            {
                CODE: 'RPT20.091',
                NAME: '저궤도위성발사체개발기술',
                ENG_NAME: '저궤도위성발사체개발기술',
            },
            {
                CODE: 'RPT20.092',
                NAME: '액체추진기관개발기술',
                ENG_NAME: '액체추진기관개발기술',
            },
            {
                CODE: 'RPT20.093',
                NAME: '무인비행체및시스템개발',
                ENG_NAME: '무인비행체및시스템개발',
            },
            {
                CODE: 'RPT20.094',
                NAME: '차세대회전익기체계및서브',
                ENG_NAME: '차세대회전익기체계및서브',
            },
            {
                CODE: 'RPT20.095',
                NAME: '고품질다수확작물생산기술',
                ENG_NAME: '고품질다수확작물생산기술',
            },
            {
                CODE: 'RPT20.096',
                NAME: 'BT활용고부가농수축산물',
                ENG_NAME: 'BT활용고부가농수축산물',
            },
            {
                CODE: 'RPT20.097',
                NAME: '고기능성식품생산가공',
                ENG_NAME: '고기능성식품생산가공',
            },
            {
                CODE: 'RPT20.098',
                NAME: '친환경수산증양식개발응용',
                ENG_NAME: '친환경수산증양식개발응용',
            },
            {
                CODE: 'RPT20.099',
                NAME: '유용동식물자원보전이용',
                ENG_NAME: '유용동식물자원보전이용',
            },
            {
                CODE: 'RPT20.100',
                NAME: '어장환경',
                ENG_NAME: '어장환경',
            },
            {
                CODE: 'RPT20.101',
                NAME: '물환경정책 대응기술',
                ENG_NAME: '물환경정책 대응기술',
            },
            {
                CODE: 'RPT20.102',
                NAME: '해양탐사/관측기술',
                ENG_NAME: '해양탐사/관측기술',
            },
            {
                CODE: 'RPT20.103',
                NAME: '관절질환관련기술',
                ENG_NAME: '관절질환관련기술',
            },
            {
                CODE: 'RPT20.104',
                NAME: '인간-시스템상호작용기술',
                ENG_NAME: '인간-시스템상호작용기술',
            },
            {
                CODE: 'RPT20.105',
                NAME: '수술용 치료기기',
                ENG_NAME: '수술용 치료기기',
            },
            {
                CODE: 'RPT20.999',
                NAME: '기타',
                ENG_NAME: '기타',
            },
        ],
    },
    {
        NAME: '국가코드',
        codeList: [
            {
                CODE: 'CMN58.KR',
                NAME: '대한민국',
                ENG_NAME: 'KOREA, REPUBLIC OF',
            },
            {
                CODE: 'CMN58.AD',
                NAME: '안도라',
                ENG_NAME: 'ANDORRA',
            },
            {
                CODE: 'CMN58.AE',
                NAME: '아랍에미리트',
                ENG_NAME: 'UNITED ARAB EMIRATES',
            },
            {
                CODE: 'CMN58.AF',
                NAME: '아프가니스탄',
                ENG_NAME: 'AFGHANISTAN',
            },
            {
                CODE: 'CMN58.AG',
                NAME: '앤티가 바부다',
                ENG_NAME: 'ANTIGUA AND BARBUDA',
            },
            {
                CODE: 'CMN58.AI',
                NAME: '앵귈라',
                ENG_NAME: 'ANGUILLA',
            },
            {
                CODE: 'CMN58.AL',
                NAME: '알바니아',
                ENG_NAME: 'ALBANIA',
            },
            {
                CODE: 'CMN58.AM',
                NAME: '아르메니아',
                ENG_NAME: 'ARMENIA',
            },
            {
                CODE: 'CMN58.AN',
                NAME: '네덜란드령 안틸레스',
                ENG_NAME: 'NETHERLANDS ANTILLES',
            },
            {
                CODE: 'CMN58.AO',
                NAME: '앙골라',
                ENG_NAME: 'ANGOLA',
            },
            {
                CODE: 'CMN58.AQ',
                NAME: '남극',
                ENG_NAME: 'ANTARCTICA',
            },
            {
                CODE: 'CMN58.AR',
                NAME: '아르헨티나',
                ENG_NAME: 'ARGENTINA',
            },
            {
                CODE: 'CMN58.AS',
                NAME: '아메리칸사모아',
                ENG_NAME: 'AMERICAN SAMOA',
            },
            {
                CODE: 'CMN58.AT',
                NAME: '오스트리아',
                ENG_NAME: 'AUSTRIA',
            },
            {
                CODE: 'CMN58.AU',
                NAME: '오스트레일리아',
                ENG_NAME: 'AUSTRALIA',
            },
            {
                CODE: 'CMN58.AW',
                NAME: '아루바',
                ENG_NAME: 'ARUBA',
            },
            {
                CODE: 'CMN58.AX',
                NAME: '올란드 제도',
                ENG_NAME: 'ALAND ISLANDS',
            },
            {
                CODE: 'CMN58.AZ',
                NAME: '아제르바이잔',
                ENG_NAME: 'AZERBAIJAN',
            },
            {
                CODE: 'CMN58.BA',
                NAME: '보스니아 헤르체고비나',
                ENG_NAME: 'BOSNIA AND HERZEGOVINA',
            },
            {
                CODE: 'CMN58.BB',
                NAME: '바베이도스',
                ENG_NAME: 'BARBADOS',
            },
            {
                CODE: 'CMN58.BD',
                NAME: '방글라데시',
                ENG_NAME: 'BANGLADESH',
            },
            {
                CODE: 'CMN58.BE',
                NAME: '벨기에',
                ENG_NAME: 'BELGIUM',
            },
            {
                CODE: 'CMN58.BF',
                NAME: '부르키나파소',
                ENG_NAME: 'BURKINA FASO',
            },
            {
                CODE: 'CMN58.BG',
                NAME: '불가리아',
                ENG_NAME: 'BULGARIA',
            },
            {
                CODE: 'CMN58.BH',
                NAME: '바레인',
                ENG_NAME: 'BAHRAIN',
            },
            {
                CODE: 'CMN58.BI',
                NAME: '부룬디',
                ENG_NAME: 'BURUNDI',
            },
            {
                CODE: 'CMN58.BJ',
                NAME: '베냉',
                ENG_NAME: 'BENIN',
            },
            {
                CODE: 'CMN58.BM',
                NAME: '버뮤다',
                ENG_NAME: 'BERMUDA',
            },
            {
                CODE: 'CMN58.BN',
                NAME: '브루나이',
                ENG_NAME: 'BRUNEI DARUSSALAM',
            },
            {
                CODE: 'CMN58.BO',
                NAME: '볼리비아',
                ENG_NAME: 'BOLIVIA',
            },
            {
                CODE: 'CMN58.BR',
                NAME: '브라질',
                ENG_NAME: 'BRAZIL',
            },
            {
                CODE: 'CMN58.BS',
                NAME: '바하마',
                ENG_NAME: 'BAHAMAS',
            },
            {
                CODE: 'CMN58.BT',
                NAME: '부탄',
                ENG_NAME: 'BHUTAN',
            },
            {
                CODE: 'CMN58.BV',
                NAME: '부베 섬',
                ENG_NAME: 'BOUVET ISLAND',
            },
            {
                CODE: 'CMN58.BW',
                NAME: '보츠와나',
                ENG_NAME: 'BOTSWANA',
            },
            {
                CODE: 'CMN58.BY',
                NAME: '벨라루스',
                ENG_NAME: 'BELARUS',
            },
            {
                CODE: 'CMN58.BZ',
                NAME: '벨리즈',
                ENG_NAME: 'BELIZE',
            },
            {
                CODE: 'CMN58.CA',
                NAME: '캐나다',
                ENG_NAME: 'CANADA',
            },
            {
                CODE: 'CMN58.CC',
                NAME: '코코스 제도',
                ENG_NAME: 'COCOS (KEELING) ISLANDS',
            },
            {
                CODE: 'CMN58.CD',
                NAME: '콩고 민주 공화국',
                ENG_NAME: 'DR Congo',
            },
            {
                CODE: 'CMN58.CF',
                NAME: '중앙아프리카 공화국',
                ENG_NAME: 'CENTRAL AFRICAN REPUBLIC',
            },
            {
                CODE: 'CMN58.CG',
                NAME: '콩고 공화국',
                ENG_NAME: 'CONGO',
            },
            {
                CODE: 'CMN58.CH',
                NAME: '스위스',
                ENG_NAME: 'SWITZERLAND',
            },
            {
                CODE: 'CMN58.CI',
                NAME: '코트디부아르',
                ENG_NAME: 'COTE D`IVOIRE',
            },
            {
                CODE: 'CMN58.CK',
                NAME: '쿡 제도',
                ENG_NAME: 'COOK ISLANDS',
            },
            {
                CODE: 'CMN58.CL',
                NAME: '칠레',
                ENG_NAME: 'CHILE',
            },
            {
                CODE: 'CMN58.CM',
                NAME: '카메룬',
                ENG_NAME: 'CAMEROON',
            },
            {
                CODE: 'CMN58.CN',
                NAME: '중화인민공화국',
                ENG_NAME: 'CHINA',
            },
            {
                CODE: 'CMN58.CO',
                NAME: '콜롬비아',
                ENG_NAME: 'COLOMBIA',
            },
            {
                CODE: 'CMN58.CR',
                NAME: '코스타리카',
                ENG_NAME: 'COSTA RICA',
            },
            {
                CODE: 'CMN58.CU',
                NAME: '쿠바',
                ENG_NAME: 'CUBA',
            },
            {
                CODE: 'CMN58.CV',
                NAME: '카보베르데',
                ENG_NAME: 'CAPE VERDE',
            },
            {
                CODE: 'CMN58.CX',
                NAME: '크리스마스 섬',
                ENG_NAME: 'CHRISTMAS ISLAND',
            },
            {
                CODE: 'CMN58.CY',
                NAME: '키프로스',
                ENG_NAME: 'CYPRUS',
            },
            {
                CODE: 'CMN58.CZ',
                NAME: '체코',
                ENG_NAME: 'CZECH REPUBLIC',
            },
            {
                CODE: 'CMN58.DE',
                NAME: '독일',
                ENG_NAME: 'GERMANY',
            },
            {
                CODE: 'CMN58.DJ',
                NAME: '지부티',
                ENG_NAME: 'DJIBOUTI',
            },
            {
                CODE: 'CMN58.DK',
                NAME: '덴마크',
                ENG_NAME: 'DENMARK',
            },
            {
                CODE: 'CMN58.DM',
                NAME: '도미니카 연방',
                ENG_NAME: 'DOMINICA',
            },
            {
                CODE: 'CMN58.DO',
                NAME: '도미니카 공화국',
                ENG_NAME: 'DOMINICAN REPUBLIC',
            },
            {
                CODE: 'CMN58.DZ',
                NAME: '알제리',
                ENG_NAME: 'ALGERIA',
            },
            {
                CODE: 'CMN58.EC',
                NAME: '에콰도르',
                ENG_NAME: 'ECUADOR',
            },
            {
                CODE: 'CMN58.EE',
                NAME: '에스토니아',
                ENG_NAME: 'ESTONIA',
            },
            {
                CODE: 'CMN58.EG',
                NAME: '이집트',
                ENG_NAME: 'EGYPT',
            },
            {
                CODE: 'CMN58.EH',
                NAME: '서사하라',
                ENG_NAME: 'WESTERN SAHARA',
            },
            {
                CODE: 'CMN58.ER',
                NAME: '에리트레아',
                ENG_NAME: 'ERITREA',
            },
            {
                CODE: 'CMN58.ES',
                NAME: '스페인',
                ENG_NAME: 'SPAIN',
            },
            {
                CODE: 'CMN58.ET',
                NAME: '에티오피아',
                ENG_NAME: 'ETHIOPIA',
            },
            {
                CODE: 'CMN58.FI',
                NAME: '핀란드',
                ENG_NAME: 'FINLAND',
            },
            {
                CODE: 'CMN58.FJ',
                NAME: '피지',
                ENG_NAME: 'FIJI',
            },
            {
                CODE: 'CMN58.FK',
                NAME: '포클랜드 제도',
                ENG_NAME: 'FALKLAND ISLANDS (MALVINAS)',
            },
            {
                CODE: 'CMN58.FM',
                NAME: '미크로네시아 연방',
                ENG_NAME: 'MICRONESIA, FEDERATED STATES OF',
            },
            {
                CODE: 'CMN58.FO',
                NAME: '페로 제도',
                ENG_NAME: 'FAROE ISLANDS',
            },
            {
                CODE: 'CMN58.FR',
                NAME: '프랑스',
                ENG_NAME: 'FRANCE',
            },
            {
                CODE: 'CMN58.GA',
                NAME: '가봉',
                ENG_NAME: 'GABON',
            },
            {
                CODE: 'CMN58.GB',
                NAME: '영국',
                ENG_NAME: 'UNITED KINGDOM',
            },
            {
                CODE: 'CMN58.GD',
                NAME: '그레나다',
                ENG_NAME: 'GRENADA',
            },
            {
                CODE: 'CMN58.GE',
                NAME: '조지아',
                ENG_NAME: 'GEORGIA',
            },
            {
                CODE: 'CMN58.GF',
                NAME: '프랑스령 기아나',
                ENG_NAME: 'FRENCH GUIANA',
            },
            {
                CODE: 'CMN58.GG',
                NAME: '건지 섬',
                ENG_NAME: 'Bailiwick of Guernsey',
            },
            {
                CODE: 'CMN58.GH',
                NAME: '가나',
                ENG_NAME: 'GHANA',
            },
            {
                CODE: 'CMN58.GI',
                NAME: '지브롤터',
                ENG_NAME: 'GIBRALTAR',
            },
            {
                CODE: 'CMN58.GL',
                NAME: '그린란드',
                ENG_NAME: 'GREENLAND',
            },
            {
                CODE: 'CMN58.GM',
                NAME: '감비아',
                ENG_NAME: 'GAMBIA',
            },
            {
                CODE: 'CMN58.GN',
                NAME: '기니',
                ENG_NAME: 'GUINEA',
            },
            {
                CODE: 'CMN58.GP',
                NAME: '과들루프',
                ENG_NAME: 'GUADELOUPE',
            },
            {
                CODE: 'CMN58.GQ',
                NAME: '적도 기니',
                ENG_NAME: 'EQUATORIAL GUINEA',
            },
            {
                CODE: 'CMN58.GR',
                NAME: '그리스',
                ENG_NAME: 'GREECE',
            },
            {
                CODE: 'CMN58.GS',
                NAME: '사우스조지아 사우스샌드위치 제도',
                ENG_NAME: 'South Georgia and the South Sandwich Islands',
            },
            {
                CODE: 'CMN58.GT',
                NAME: '과테말라',
                ENG_NAME: 'GUATEMALA',
            },
            {
                CODE: 'CMN58.GU',
                NAME: '괌',
                ENG_NAME: 'GUAM',
            },
            {
                CODE: 'CMN58.GW',
                NAME: '기니비사우',
                ENG_NAME: 'GUINEA-BISSAU',
            },
            {
                CODE: 'CMN58.GY',
                NAME: '가이아나',
                ENG_NAME: 'GUYANA',
            },
            {
                CODE: 'CMN58.HK',
                NAME: '홍콩',
                ENG_NAME: 'HONG KONG',
            },
            {
                CODE: 'CMN58.HM',
                NAME: '허드 맥도널드 제도',
                ENG_NAME: 'HEARD ISLAND AND MCDONALD ISLANDS',
            },
            {
                CODE: 'CMN58.HN',
                NAME: '온두라스',
                ENG_NAME: 'HONDURAS',
            },
            {
                CODE: 'CMN58.HR',
                NAME: '크로아티아',
                ENG_NAME: 'CROATIA',
            },
            {
                CODE: 'CMN58.HT',
                NAME: '아이티',
                ENG_NAME: 'HAITI',
            },
            {
                CODE: 'CMN58.HU',
                NAME: '헝가리',
                ENG_NAME: 'HUNGARY',
            },
            {
                CODE: 'CMN58.ID',
                NAME: '인도네시아',
                ENG_NAME: 'INDONESIA',
            },
            {
                CODE: 'CMN58.IE',
                NAME: '아일랜드',
                ENG_NAME: 'IRELAND',
            },
            {
                CODE: 'CMN58.IL',
                NAME: '이스라엘',
                ENG_NAME: 'ISRAEL',
            },
            {
                CODE: 'CMN58.IM',
                NAME: '맨 섬',
                ENG_NAME: 'Isle of Man',
            },
            {
                CODE: 'CMN58.IN',
                NAME: '인도',
                ENG_NAME: 'INDIA',
            },
            {
                CODE: 'CMN58.IO',
                NAME: '영국령 인도양 지역',
                ENG_NAME: 'BRITISH INDIAN OCEAN TERRITORY',
            },
            {
                CODE: 'CMN58.IQ',
                NAME: '이라크',
                ENG_NAME: 'IRAQ',
            },
            {
                CODE: 'CMN58.IR',
                NAME: '이란',
                ENG_NAME: 'IRAN, ISLAMIC REPUBLIC OF',
            },
            {
                CODE: 'CMN58.IS',
                NAME: '아이슬란드',
                ENG_NAME: 'ICELAND',
            },
            {
                CODE: 'CMN58.IT',
                NAME: '이탈리아',
                ENG_NAME: 'ITALY',
            },
            {
                CODE: 'CMN58.JE',
                NAME: '저지 섬',
                ENG_NAME: 'Bailiwick of Jersey',
            },
            {
                CODE: 'CMN58.JM',
                NAME: '자메이카',
                ENG_NAME: 'JAMAICA',
            },
            {
                CODE: 'CMN58.JO',
                NAME: '요르단',
                ENG_NAME: 'JORDAN',
            },
            {
                CODE: 'CMN58.JP',
                NAME: '일본',
                ENG_NAME: 'JAPAN',
            },
            {
                CODE: 'CMN58.KE',
                NAME: '케냐',
                ENG_NAME: 'KENYA',
            },
            {
                CODE: 'CMN58.KG',
                NAME: '키르기스스탄',
                ENG_NAME: 'KYRGYZSTAN',
            },
            {
                CODE: 'CMN58.KH',
                NAME: '캄보디아',
                ENG_NAME: 'CAMBODIA',
            },
            {
                CODE: 'CMN58.KI',
                NAME: '키리바시',
                ENG_NAME: 'KIRIBATI',
            },
            {
                CODE: 'CMN58.KM',
                NAME: '코모로',
                ENG_NAME: 'COMOROS',
            },
            {
                CODE: 'CMN58.KN',
                NAME: '세인트키츠 네비스',
                ENG_NAME: 'SAINT KITTS AND NEVIS',
            },
            {
                CODE: 'CMN58.KP',
                NAME: '조선민주주의인민공화국',
                ENG_NAME: 'KOREA, DEMOCRATIC PEOPLE`S REPUBLIC OF',
            },
            {
                CODE: 'CMN58.KW',
                NAME: '쿠웨이트',
                ENG_NAME: 'KUWAIT',
            },
            {
                CODE: 'CMN58.KY',
                NAME: '케이맨 제도',
                ENG_NAME: 'CAYMAN ISLANDS',
            },
            {
                CODE: 'CMN58.KZ',
                NAME: '카자흐스탄',
                ENG_NAME: 'KAZAKHSTAN',
            },
            {
                CODE: 'CMN58.LA',
                NAME: '라오스',
                ENG_NAME: 'LAO PEOPLE`S DEMOCRATIC REPUBLIC',
            },
            {
                CODE: 'CMN58.LB',
                NAME: '레바논',
                ENG_NAME: 'LEBANON',
            },
            {
                CODE: 'CMN58.LC',
                NAME: '세인트루시아',
                ENG_NAME: 'SAINT LUCIA',
            },
            {
                CODE: 'CMN58.LI',
                NAME: '리히텐슈타인',
                ENG_NAME: 'LIECHTENSTEIN',
            },
            {
                CODE: 'CMN58.LK',
                NAME: '스리랑카',
                ENG_NAME: 'SRI LANKA',
            },
            {
                CODE: 'CMN58.LR',
                NAME: '라이베리아',
                ENG_NAME: 'LIBERIA',
            },
            {
                CODE: 'CMN58.LS',
                NAME: '레소토',
                ENG_NAME: 'LESOTHO',
            },
            {
                CODE: 'CMN58.LT',
                NAME: '리투아니아',
                ENG_NAME: 'LITHUANIA',
            },
            {
                CODE: 'CMN58.LU',
                NAME: '룩셈부르크',
                ENG_NAME: 'LUXEMBOURG',
            },
            {
                CODE: 'CMN58.LV',
                NAME: '라트비아',
                ENG_NAME: 'LATVIA',
            },
            {
                CODE: 'CMN58.LY',
                NAME: '리비아',
                ENG_NAME: 'LIBYAN ARAB JAMAHIRIYA',
            },
            {
                CODE: 'CMN58.MA',
                NAME: '모로코',
                ENG_NAME: 'MOROCCO',
            },
            {
                CODE: 'CMN58.MC',
                NAME: '모나코',
                ENG_NAME: 'MONACO',
            },
            {
                CODE: 'CMN58.MD',
                NAME: '몰도바',
                ENG_NAME: 'MOLDOVA',
            },
            {
                CODE: 'CMN58.ME',
                NAME: '몬테네그로',
                ENG_NAME: 'MONTENEGRO',
            },
            {
                CODE: 'CMN58.MG',
                NAME: '마다가스카르',
                ENG_NAME: 'MADAGASCAR',
            },
            {
                CODE: 'CMN58.MH',
                NAME: '마셜 제도',
                ENG_NAME: 'MARSHALL ISLANDS',
            },
            {
                CODE: 'CMN58.MK',
                NAME: '마케도니아 공화국',
                ENG_NAME: 'The Republic of Macedonia',
            },
            {
                CODE: 'CMN58.ML',
                NAME: '말리',
                ENG_NAME: 'MALI',
            },
            {
                CODE: 'CMN58.MM',
                NAME: '미얀마',
                ENG_NAME: 'MYANMAR',
            },
            {
                CODE: 'CMN58.MN',
                NAME: '몽골',
                ENG_NAME: 'MONGOLIA',
            },
            {
                CODE: 'CMN58.MO',
                NAME: '마카오',
                ENG_NAME: 'MACAO',
            },
            {
                CODE: 'CMN58.MP',
                NAME: '북마리아나 제도',
                ENG_NAME: 'NORTHERN MARIANA ISLANDS',
            },
            {
                CODE: 'CMN58.MQ',
                NAME: '마르티니크',
                ENG_NAME: 'MARTINIQUE',
            },
            {
                CODE: 'CMN58.MR',
                NAME: '모리타니',
                ENG_NAME: 'MAURITANIA',
            },
            {
                CODE: 'CMN58.MS',
                NAME: '몬트세랫',
                ENG_NAME: 'MONTSERRAT',
            },
            {
                CODE: 'CMN58.MT',
                NAME: '몰타',
                ENG_NAME: 'MALTA',
            },
            {
                CODE: 'CMN58.MU',
                NAME: '모리셔스',
                ENG_NAME: 'MAURITIUS',
            },
            {
                CODE: 'CMN58.MV',
                NAME: '몰디브',
                ENG_NAME: 'MALDIVES',
            },
            {
                CODE: 'CMN58.MW',
                NAME: '말라위',
                ENG_NAME: 'MALAWI',
            },
            {
                CODE: 'CMN58.MX',
                NAME: '멕시코',
                ENG_NAME: 'MEXICO',
            },
            {
                CODE: 'CMN58.MY',
                NAME: '말레이시아',
                ENG_NAME: 'MALAYSIA',
            },
            {
                CODE: 'CMN58.MZ',
                NAME: '모잠비크',
                ENG_NAME: 'MOZAMBIQUE',
            },
            {
                CODE: 'CMN58.NA',
                NAME: '나미비아',
                ENG_NAME: 'NAMIBIA',
            },
            {
                CODE: 'CMN58.NC',
                NAME: '누벨칼레도니',
                ENG_NAME: 'NEW CALEDONIA',
            },
            {
                CODE: 'CMN58.NE',
                NAME: '니제르',
                ENG_NAME: 'NIGER',
            },
            {
                CODE: 'CMN58.NF',
                NAME: '노퍽 섬',
                ENG_NAME: 'NORFOLK ISLAND',
            },
            {
                CODE: 'CMN58.NG',
                NAME: '나이지리아',
                ENG_NAME: 'NIGERIA',
            },
            {
                CODE: 'CMN58.NI',
                NAME: '니카라과',
                ENG_NAME: 'NICARAGUA',
            },
            {
                CODE: 'CMN58.NL',
                NAME: '네덜란드',
                ENG_NAME: 'NETHERLANDS',
            },
            {
                CODE: 'CMN58.NO',
                NAME: '노르웨이',
                ENG_NAME: 'NORWAY',
            },
            {
                CODE: 'CMN58.NP',
                NAME: '네팔',
                ENG_NAME: 'NEPAL',
            },
            {
                CODE: 'CMN58.NR',
                NAME: '나우루',
                ENG_NAME: 'NAURU',
            },
            {
                CODE: 'CMN58.NU',
                NAME: '니우에',
                ENG_NAME: 'NIUE',
            },
            {
                CODE: 'CMN58.NZ',
                NAME: '뉴질랜드',
                ENG_NAME: 'NEW ZEALAND',
            },
            {
                CODE: 'CMN58.OM',
                NAME: '오만',
                ENG_NAME: 'OMAN',
            },
            {
                CODE: 'CMN58.PA',
                NAME: '파나마',
                ENG_NAME: 'PANAMA',
            },
            {
                CODE: 'CMN58.PE',
                NAME: '페루',
                ENG_NAME: 'PERU',
            },
            {
                CODE: 'CMN58.PF',
                NAME: '프랑스령 폴리네시아',
                ENG_NAME: 'FRENCH POLYNESIA',
            },
            {
                CODE: 'CMN58.PG',
                NAME: '파푸아 뉴기니',
                ENG_NAME: 'PAPUA NEW GUINEA',
            },
            {
                CODE: 'CMN58.PH',
                NAME: '필리핀',
                ENG_NAME: 'PHILIPPINES',
            },
            {
                CODE: 'CMN58.PK',
                NAME: '파키스탄',
                ENG_NAME: 'PAKISTAN',
            },
            {
                CODE: 'CMN58.PL',
                NAME: '폴란드',
                ENG_NAME: 'POLAND',
            },
            {
                CODE: 'CMN58.PM',
                NAME: '생피에르 미클롱',
                ENG_NAME: 'SAINT PIERRE AND MIQUELON',
            },
            {
                CODE: 'CMN58.PN',
                NAME: '핏케언 제도',
                ENG_NAME: 'PITCAIRN',
            },
            {
                CODE: 'CMN58.PR',
                NAME: '푸에르토리코',
                ENG_NAME: 'PUERTO RICO',
            },
            {
                CODE: 'CMN58.PS',
                NAME: '팔레스타인',
                ENG_NAME: 'PALESTINIAN TERRITORY, OCCUPIED',
            },
            {
                CODE: 'CMN58.PT',
                NAME: '포르투갈',
                ENG_NAME: 'PORTUGAL',
            },
            {
                CODE: 'CMN58.PW',
                NAME: '팔라우',
                ENG_NAME: 'PALAU',
            },
            {
                CODE: 'CMN58.PY',
                NAME: '파라과이',
                ENG_NAME: 'PARAGUAY',
            },
            {
                CODE: 'CMN58.QA',
                NAME: '카타르',
                ENG_NAME: 'QATAR',
            },
            {
                CODE: 'CMN58.RE',
                NAME: '레위니옹',
                ENG_NAME: 'REUNION',
            },
            {
                CODE: 'CMN58.RO',
                NAME: '루마니아',
                ENG_NAME: 'ROMANIA',
            },
            {
                CODE: 'CMN58.RS',
                NAME: '세르비아',
                ENG_NAME: 'Serbia',
            },
            {
                CODE: 'CMN58.RU',
                NAME: '러시아',
                ENG_NAME: 'RUSSIAN FEDERATION',
            },
            {
                CODE: 'CMN58.RW',
                NAME: '르완다',
                ENG_NAME: 'RWANDA',
            },
            {
                CODE: 'CMN58.SA',
                NAME: '사우디아라비아',
                ENG_NAME: 'SAUDI ARABIA',
            },
            {
                CODE: 'CMN58.SB',
                NAME: '솔로몬 제도',
                ENG_NAME: 'SOLOMON ISLANDS',
            },
            {
                CODE: 'CMN58.SC',
                NAME: '세이셸',
                ENG_NAME: 'SEYCHELLES',
            },
            {
                CODE: 'CMN58.SD',
                NAME: '수단',
                ENG_NAME: 'SUDAN',
            },
            {
                CODE: 'CMN58.SE',
                NAME: '스웨덴',
                ENG_NAME: 'SWEDEN',
            },
            {
                CODE: 'CMN58.SG',
                NAME: '싱가포르',
                ENG_NAME: 'SINGAPORE',
            },
            {
                CODE: 'CMN58.SH',
                NAME: '세인트헬레나',
                ENG_NAME: 'SAINT HELENA',
            },
            {
                CODE: 'CMN58.SI',
                NAME: '슬로베니아',
                ENG_NAME: 'SLOVENIA',
            },
            {
                CODE: 'CMN58.SJ',
                NAME: '스발바르 얀마옌 제',
                ENG_NAME: 'SVALBARD AND JAN MAYEN ISLANDS',
            },
            {
                CODE: 'CMN58.SK',
                NAME: '슬로바키아',
                ENG_NAME: 'Slovakia',
            },
            {
                CODE: 'CMN58.SL',
                NAME: '시에라리온',
                ENG_NAME: 'SIERRA LEONE',
            },
            {
                CODE: 'CMN58.SM',
                NAME: '산마리노',
                ENG_NAME: 'SAN MARINO',
            },
            {
                CODE: 'CMN58.SN',
                NAME: '세네갈',
                ENG_NAME: 'SENEGAL',
            },
            {
                CODE: 'CMN58.SO',
                NAME: '소말리아',
                ENG_NAME: 'SOMALIA',
            },
            {
                CODE: 'CMN58.SR',
                NAME: '수리남',
                ENG_NAME: 'SURINAME',
            },
            {
                CODE: 'CMN58.SS',
                NAME: '남수단',
                ENG_NAME: '남수단',
            },
            {
                CODE: 'CMN58.ST',
                NAME: '상투메 프린시페',
                ENG_NAME: 'SAO TOME AND PRINCIPE',
            },
            {
                CODE: 'CMN58.SV',
                NAME: '엘살바도르',
                ENG_NAME: 'EL SALVADOR',
            },
            {
                CODE: 'CMN58.SY',
                NAME: '시리아',
                ENG_NAME: 'SYRIAN ARAB REPUBLIC',
            },
            {
                CODE: 'CMN58.SZ',
                NAME: '스와질란드',
                ENG_NAME: 'SWAZILAND',
            },
            {
                CODE: 'CMN58.TC',
                NAME: '터크스 케이커스 제도',
                ENG_NAME: 'TURKS AND CAICOS ISLANDS',
            },
            {
                CODE: 'CMN58.TD',
                NAME: '차드',
                ENG_NAME: 'CHAD',
            },
            {
                CODE: 'CMN58.TF',
                NAME: '프랑스령 남부와 남극 지역',
                ENG_NAME: 'FRENCH SOUTHERN TERRITORIES',
            },
            {
                CODE: 'CMN58.TG',
                NAME: '토고',
                ENG_NAME: 'TOGO',
            },
            {
                CODE: 'CMN58.TH',
                NAME: '타이',
                ENG_NAME: 'THAILAND',
            },
            {
                CODE: 'CMN58.TJ',
                NAME: '타지키스탄',
                ENG_NAME: 'TAJIKISTAN',
            },
            {
                CODE: 'CMN58.TK',
                NAME: '토켈라우',
                ENG_NAME: 'TOKELAU',
            },
            {
                CODE: 'CMN58.TL',
                NAME: '동티모르',
                ENG_NAME: 'TIMOR-LESTE',
            },
            {
                CODE: 'CMN58.TM',
                NAME: '투르크메니스탄',
                ENG_NAME: 'TURKMENISTAN',
            },
            {
                CODE: 'CMN58.TN',
                NAME: '튀니지',
                ENG_NAME: 'TUNISIA',
            },
            {
                CODE: 'CMN58.TO',
                NAME: '통가',
                ENG_NAME: 'TONGA',
            },
            {
                CODE: 'CMN58.TR',
                NAME: '터키',
                ENG_NAME: 'TURKEY',
            },
            {
                CODE: 'CMN58.TT',
                NAME: '트리니다드 토바고',
                ENG_NAME: 'TRINIDAD AND TOBAGO',
            },
            {
                CODE: 'CMN58.TV',
                NAME: '투발루',
                ENG_NAME: 'TUVALU',
            },
            {
                CODE: 'CMN58.TW',
                NAME: '중화민국',
                ENG_NAME: 'TAIWAN, PROVINCE OF CHINA',
            },
            {
                CODE: 'CMN58.TZ',
                NAME: '탄자니아',
                ENG_NAME: 'TANZANIA, UNITED REPUBLIC OF',
            },
            {
                CODE: 'CMN58.UA',
                NAME: '우크라이나',
                ENG_NAME: 'UKRAINE',
            },
            {
                CODE: 'CMN58.UG',
                NAME: '우간다',
                ENG_NAME: 'UGANDA',
            },
            {
                CODE: 'CMN58.UM',
                NAME: '미국령 군소 제도',
                ENG_NAME: 'UNITED STATES MINOR OUTLYING ISLANDS',
            },
            {
                CODE: 'CMN58.US',
                NAME: '미국',
                ENG_NAME: 'UNITED STATES',
            },
            {
                CODE: 'CMN58.UY',
                NAME: '우루과이',
                ENG_NAME: 'URUGUAY',
            },
            {
                CODE: 'CMN58.UZ',
                NAME: '우즈베키스탄',
                ENG_NAME: 'UZBEKISTAN',
            },
            {
                CODE: 'CMN58.VA',
                NAME: '바티칸 시국',
                ENG_NAME: 'HOLY SEE (VATICAN CITY STATE)',
            },
            {
                CODE: 'CMN58.VC',
                NAME: '세인트빈센트 그레나딘',
                ENG_NAME: 'SAINT VINCENT AND THE GRENADINES',
            },
            {
                CODE: 'CMN58.VE',
                NAME: '베네수엘라',
                ENG_NAME: 'VENEZUELA',
            },
            {
                CODE: 'CMN58.VG',
                NAME: '영국령 버진아일랜드',
                ENG_NAME: 'VIRGIN ISLANDS, BRITISH',
            },
            {
                CODE: 'CMN58.VI',
                NAME: '미국령 버진아일랜드',
                ENG_NAME: 'VIRGIN ISLANDS, U.S.',
            },
            {
                CODE: 'CMN58.VN',
                NAME: '베트남',
                ENG_NAME: 'VIETNAM',
            },
            {
                CODE: 'CMN58.VU',
                NAME: '바누아투',
                ENG_NAME: 'VANUATU',
            },
            {
                CODE: 'CMN58.WF',
                NAME: '왈리스 퓌튀나',
                ENG_NAME: 'WALLIS AND FUTUNA',
            },
            {
                CODE: 'CMN58.WS',
                NAME: '사모아',
                ENG_NAME: 'SAMOA',
            },
            {
                CODE: 'CMN58.YE',
                NAME: '예멘',
                ENG_NAME: 'YEMEN',
            },
            {
                CODE: 'CMN58.YT',
                NAME: '마요트',
                ENG_NAME: 'MAYOTTE',
            },
            {
                CODE: 'CMN58.ZA',
                NAME: '남아프리카 공화국',
                ENG_NAME: 'SOUTH AFRICA',
            },
            {
                CODE: 'CMN58.ZM',
                NAME: '잠비아',
                ENG_NAME: 'ZAMBIA',
            },
            {
                CODE: 'CMN58.ZW',
                NAME: '짐바브웨',
                ENG_NAME: 'ZIMBABWE',
            },
        ],
    },
    {
        NAME: '국내외구분',
        codeList: [
            {
                CODE: 'CMN40.1',
                NAME: '국내',
                ENG_NAME: 'Domestic',
            },
            {
                CODE: 'CMN40.2',
                NAME: '국외',
                ENG_NAME: 'International',
            },
        ],
    },
    {
        NAME: '기술분야분류코드',
        codeList: [
            {
                CODE: 'RPT21.001',
                NAME: '수학',
                ENG_NAME: '수학',
            },
            {
                CODE: 'RPT21.002',
                NAME: '물리학',
                ENG_NAME: '물리학',
            },
            {
                CODE: 'RPT21.003',
                NAME: '화학',
                ENG_NAME: '화학',
            },
            {
                CODE: 'RPT21.004',
                NAME: '지구과학',
                ENG_NAME: '지구과학',
            },
            {
                CODE: 'RPT21.005',
                NAME: '생명과학',
                ENG_NAME: '생명과학',
            },
            {
                CODE: 'RPT21.006',
                NAME: '농림수산식품',
                ENG_NAME: '농림수산식품',
            },
            {
                CODE: 'RPT21.007',
                NAME: '보건의료',
                ENG_NAME: '보건의료',
            },
            {
                CODE: 'RPT21.008',
                NAME: '기계',
                ENG_NAME: '기계',
            },
            {
                CODE: 'RPT21.009',
                NAME: '재료',
                ENG_NAME: '재료',
            },
            {
                CODE: 'RPT21.010',
                NAME: '화공',
                ENG_NAME: '화공',
            },
            {
                CODE: 'RPT21.011',
                NAME: '전기/전자',
                ENG_NAME: '전기/전자',
            },
            {
                CODE: 'RPT21.012',
                NAME: '정보/통신',
                ENG_NAME: '정보/통신',
            },
            {
                CODE: 'RPT21.013',
                NAME: '에너지/자원',
                ENG_NAME: '에너지/자원',
            },
            {
                CODE: 'RPT21.014',
                NAME: '원자력',
                ENG_NAME: '원자력',
            },
            {
                CODE: 'RPT21.015',
                NAME: '환경',
                ENG_NAME: '환경',
            },
            {
                CODE: 'RPT21.016',
                NAME: '건설/교통',
                ENG_NAME: '건설/교통',
            },
            {
                CODE: 'RPT21.017',
                NAME: '역사/고고학',
                ENG_NAME: '역사/고고학',
            },
            {
                CODE: 'RPT21.018',
                NAME: '철학/종교',
                ENG_NAME: '철학/종교',
            },
            {
                CODE: 'RPT21.019',
                NAME: '언어',
                ENG_NAME: '언어',
            },
            {
                CODE: 'RPT21.020',
                NAME: '문학',
                ENG_NAME: '문학',
            },
            {
                CODE: 'RPT21.021',
                NAME: '문화/예술/체육',
                ENG_NAME: '문화/예술/체육',
            },
            {
                CODE: 'RPT21.022',
                NAME: '법',
                ENG_NAME: '법',
            },
            {
                CODE: 'RPT21.023',
                NAME: '정치/행정',
                ENG_NAME: '정치/행정',
            },
            {
                CODE: 'RPT21.024',
                NAME: '경제/경영',
                ENG_NAME: '경제/경영',
            },
            {
                CODE: 'RPT21.025',
                NAME: '사회/인류/복지/여성',
                ENG_NAME: '사회/인류/복지/여성',
            },
            {
                CODE: 'RPT21.026',
                NAME: '생활',
                ENG_NAME: '생활',
            },
            {
                CODE: 'RPT21.027',
                NAME: '지리/지역/관광',
                ENG_NAME: '지리/지역/관광',
            },
            {
                CODE: 'RPT21.028',
                NAME: '심리',
                ENG_NAME: '심리',
            },
            {
                CODE: 'RPT21.029',
                NAME: '교육',
                ENG_NAME: '교육',
            },
            {
                CODE: 'RPT21.030',
                NAME: '미디어/커뮤니케이션/문헌정보',
                ENG_NAME: '미디어/커뮤니케이션/문헌정보',
            },
            {
                CODE: 'RPT21.031',
                NAME: '뇌과학',
                ENG_NAME: '뇌과학',
            },
            {
                CODE: 'RPT21.032',
                NAME: '인지/감성과학',
                ENG_NAME: '인지/감성과학',
            },
            {
                CODE: 'RPT21.033',
                NAME: '과학기술과 인문사회',
                ENG_NAME: '과학기술과 인문사회',
            },
            {
                CODE: 'RPT21.034',
                NAME: '인력 및 인프라',
                ENG_NAME: '인력 및 인프라',
            },
        ],
    },
    {
        NAME: '보안과제코드',
        codeList: [
            {
                CODE: 'RPT13.01',
                NAME: '일반과제',
                ENG_NAME: '일반과제',
            },
            {
                CODE: 'RPT13.02',
                NAME: '보안과제',
                ENG_NAME: '보안과제',
            },
        ],
    },
    {
        NAME: '사업구분2코드',
        codeList: [
            {
                CODE: 'RPT16.01',
                NAME: '주관',
                ENG_NAME: '주관',
            },
            {
                CODE: 'RPT16.02',
                NAME: '협동',
                ENG_NAME: '협동',
            },
            {
                CODE: 'RPT16.03',
                NAME: '위탁',
                ENG_NAME: '위탁',
            },
            {
                CODE: 'RPT16.04',
                NAME: '용역',
                ENG_NAME: '용역',
            },
        ],
    },
    {
        NAME: '연구분야코드',
        codeList: [
            {
                CODE: 'RPT11.001',
                NAME: '정보산업분야',
                ENG_NAME: '정보산업분야',
            },
            {
                CODE: 'RPT11.002',
                NAME: '기계설비분야',
                ENG_NAME: '기계설비분야',
            },
            {
                CODE: 'RPT11.003',
                NAME: '소재/정밀화학/공정분야',
                ENG_NAME: '소재/정밀화학/공정분야',
            },
            {
                CODE: 'RPT11.004',
                NAME: '생명과학분야',
                ENG_NAME: '생명과학분야',
            },
            {
                CODE: 'RPT11.005',
                NAME: '원자력/자원/에너지분야',
                ENG_NAME: '원자력/자원/에너지분야',
            },
            {
                CODE: 'RPT11.006',
                NAME: '항공/우주/해양/로봇기술',
                ENG_NAME: '항공/우주/해양/로봇기술',
            },
            {
                CODE: 'RPT11.007',
                NAME: '환경/보건/의료/건설/교통',
                ENG_NAME: '환경/보건/의료/건설/교통',
            },
            {
                CODE: 'RPT11.008',
                NAME: '기초/원천요소기술분야',
                ENG_NAME: '기초/원천요소기술분야',
            },
            {
                CODE: 'RPT11.009',
                NAME: '연구기획평가분야',
                ENG_NAME: '연구기획평가분야',
            },
            {
                CODE: 'RPT11.010',
                NAME: '인문/사회',
                ENG_NAME: '인문/사회',
            },
            {
                CODE: 'RPT11.ETC',
                NAME: '기타',
                ENG_NAME: '기타',
            },
        ],
    },
    {
        NAME: '연구사업구분코드',
        codeList: [
            {
                CODE: 'RPT08.01',
                NAME: '국가연구',
                ENG_NAME: '국가연구',
            },
            {
                CODE: 'RPT08.02',
                NAME: '민간수탁',
                ENG_NAME: '민간수탁',
            },
            {
                CODE: 'RPT08.03',
                NAME: '공공수탁',
                ENG_NAME: '공공수탁',
            },
            {
                CODE: 'RPT08.04',
                NAME: '자체연구',
                ENG_NAME: '자체연구',
            },
            {
                CODE: 'RPT08.05',
                NAME: '국외수탁',
                ENG_NAME: '국외수탁',
            },
            {
                CODE: 'RPT08.06',
                NAME: '자체(정부)',
                ENG_NAME: '자체(정부)',
            },
        ],
    },
    {
        NAME: '연구유형코드',
        codeList: [
            {
                CODE: 'RPT12.01',
                NAME: '기초연구',
                ENG_NAME: '기초연구',
            },
            {
                CODE: 'RPT12.02',
                NAME: '응용연구',
                ENG_NAME: '응용연구',
            },
            {
                CODE: 'RPT12.03',
                NAME: '개발연구',
                ENG_NAME: '개발연구',
            },
            {
                CODE: 'RPT12.04',
                NAME: '기업화준비',
                ENG_NAME: '기업화준비',
            },
            {
                CODE: 'RPT12.ETC',
                NAME: '기타',
                ENG_NAME: '기타',
            },
        ],
    },
    {
        NAME: '자금부처코드',
        codeList: [
            {
                CODE: 'RPT09.001',
                NAME: '과학기술부',
                ENG_NAME: '과학기술부',
            },
            {
                CODE: 'RPT09.002',
                NAME: '교육인적자원부',
                ENG_NAME: '교육부',
            },
            {
                CODE: 'RPT09.003',
                NAME: '정보통신부',
                ENG_NAME: '정통부',
            },
            {
                CODE: 'RPT09.004',
                NAME: '산업자원부',
                ENG_NAME: '산자부',
            },
            {
                CODE: 'RPT09.005',
                NAME: '보건복지부',
                ENG_NAME: '보복부',
            },
            {
                CODE: 'RPT09.006',
                NAME: '환경부',
                ENG_NAME: '환경부',
            },
            {
                CODE: 'RPT09.007',
                NAME: '해양수산부',
                ENG_NAME: '해수부',
            },
            {
                CODE: 'RPT09.008',
                NAME: '국방부',
                ENG_NAME: '국방부',
            },
            {
                CODE: 'RPT09.009',
                NAME: '농림부',
                ENG_NAME: '농림부',
            },
            {
                CODE: 'RPT09.010',
                NAME: '문화관광부',
                ENG_NAME: '문체부',
            },
            {
                CODE: 'RPT09.011',
                NAME: '건설교통부',
                ENG_NAME: '건교부',
            },
            {
                CODE: 'RPT09.012',
                NAME: '공공수탁',
                ENG_NAME: '공공수탁',
            },
            {
                CODE: 'RPT09.013',
                NAME: '기업체',
                ENG_NAME: '기업체',
            },
            {
                CODE: 'RPT09.014',
                NAME: '지방자치단체',
                ENG_NAME: '지방자치단체',
            },
            {
                CODE: 'RPT09.015',
                NAME: '중소기업청',
                ENG_NAME: '중기청',
            },
            {
                CODE: 'RPT09.016',
                NAME: '농촌진흥청',
                ENG_NAME: '농진청',
            },
            {
                CODE: 'RPT09.017',
                NAME: '광주과학기술원',
                ENG_NAME: 'GIST',
            },
            {
                CODE: 'RPT09.018',
                NAME: '식품의약품안전청',
                ENG_NAME: '식약청',
            },
            {
                CODE: 'RPT09.019',
                NAME: '교육과학기술부',
                ENG_NAME: '교육부',
            },
            {
                CODE: 'RPT09.020',
                NAME: '국토해양부',
                ENG_NAME: '국토부',
            },
            {
                CODE: 'RPT09.021',
                NAME: '지식경제부',
                ENG_NAME: '지경부',
            },
            {
                CODE: 'RPT09.022',
                NAME: '농림수산식품부',
                ENG_NAME: '농림부',
            },
            {
                CODE: 'RPT09.023',
                NAME: '보건복지가족부',
                ENG_NAME: '보복부',
            },
            {
                CODE: 'RPT09.024',
                NAME: '문화체육관광부',
                ENG_NAME: '문체부',
            },
            {
                CODE: 'RPT09.025',
                NAME: '기상청',
                ENG_NAME: '기상청',
            },
            {
                CODE: 'RPT09.026',
                NAME: '특허청',
                ENG_NAME: '특허청',
            },
            {
                CODE: 'RPT09.027',
                NAME: '한국과학창의재단',
                ENG_NAME: '창의재단',
            },
            {
                CODE: 'RPT09.028',
                NAME: '한국정보화진흥원',
                ENG_NAME: '정보화진흥원',
            },
            {
                CODE: 'RPT09.029',
                NAME: '미래창조과학부',
                ENG_NAME: '미래부',
            },
            {
                CODE: 'RPT09.030',
                NAME: '교육부',
                ENG_NAME: '교육부',
            },
            {
                CODE: 'RPT09.031',
                NAME: '농림축산식품부',
                ENG_NAME: '농림부',
            },
            {
                CODE: 'RPT09.032',
                NAME: '산업통상자원부',
                ENG_NAME: '산자부',
            },
            {
                CODE: 'RPT09.033',
                NAME: '국토교통부',
                ENG_NAME: '국토부',
            },
            {
                CODE: 'RPT09.034',
                NAME: '방송통신위원회',
                ENG_NAME: '방통위',
            },
            {
                CODE: 'RPT09.035',
                NAME: '과학기술정보통신부',
                ENG_NAME: '과기부',
            },
            {
                CODE: 'RPT09.ETC',
                NAME: '기타',
                ENG_NAME: '기타',
            },
        ],
    },
    {
        NAME: '자산구분코드',
        codeList: [
            {
                CODE: 'AAS01.A',
                NAME: '토지',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.B',
                NAME: '건물',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.C',
                NAME: '건물장비',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.D',
                NAME: '구축물',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.E',
                NAME: '기기장비',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.F',
                NAME: '공기구비품',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.G',
                NAME: '차량운반구',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.H',
                NAME: '특허권',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.J',
                NAME: '실용신안권',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.X',
                NAME: '소프트웨어',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.Y',
                NAME: '기타무형자산',
                ENG_NAME: null,
            },
            {
                CODE: 'AAS01.Z',
                NAME: '기타유형자산',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '자산상태코드',
        codeList: [
            {
                CODE: 'AAS02.1',
                NAME: '정상',
                ENG_NAME: '정상',
            },
            {
                CODE: 'AAS02.2',
                NAME: '매각',
                ENG_NAME: '매각',
            },
            {
                CODE: 'AAS02.3',
                NAME: '폐기',
                ENG_NAME: '폐기',
            },
            {
                CODE: 'AAS02.4',
                NAME: '불용',
                ENG_NAME: '불용',
            },
            {
                CODE: 'AAS02.5',
                NAME: '망실',
                ENG_NAME: '망실',
            },
            {
                CODE: 'AAS02.6',
                NAME: '양여',
                ENG_NAME: '양여',
            },
            {
                CODE: 'AAS02.7',
                NAME: '불용(재활용확인중)',
                ENG_NAME: '불용(재활용확인중)',
            },
            {
                CODE: 'AAS02.8',
                NAME: '반출',
                ENG_NAME: '반출',
            },
        ],
    },
    {
        NAME: '저자구분코드',
        codeList: [
            {
                CODE: 'RRM04.01',
                NAME: 'FA',
                ENG_NAME: 'FA',
            },
            {
                CODE: 'RRM04.02',
                NAME: 'CA',
                ENG_NAME: 'CA',
            },
            {
                CODE: 'RRM04.03',
                NAME: 'ETC',
                ENG_NAME: 'ETC',
            },
            {
                CODE: 'RRM04.04',
                NAME: 'FA/CA',
                ENG_NAME: 'FA/CA',
            },
        ],
    },
    {
        NAME: '조직레벨코드',
        codeList: [
            {
                CODE: 'CMN10.0',
                NAME: '최상위조직',
                ENG_NAME: '최상위조직',
            },
            {
                CODE: 'CMN10.1',
                NAME: '처/단대',
                ENG_NAME: '처/단대',
            },
            {
                CODE: 'CMN10.2',
                NAME: '과/학과',
                ENG_NAME: '과/학과',
            },
            {
                CODE: 'CMN10.3',
                NAME: '계/전공',
                ENG_NAME: '계/전공',
            },
            {
                CODE: 'CMN10.4',
                NAME: '세부전공',
                ENG_NAME: '세부전공',
            },
        ],
    },
    {
        NAME: '직급',
        codeList: [
            {
                CODE: 'APS08.10',
                NAME: '임원',
                ENG_NAME: '임원',
            },
            {
                CODE: 'APS08.21',
                NAME: '교수',
                ENG_NAME: '교수',
            },
            {
                CODE: 'APS08.22',
                NAME: '부교수',
                ENG_NAME: '부교수',
            },
            {
                CODE: 'APS08.23',
                NAME: '조교수',
                ENG_NAME: '조교수',
            },
            {
                CODE: 'APS08.24',
                NAME: '전임강사',
                ENG_NAME: '전임강사',
            },
            {
                CODE: 'APS08.26',
                NAME: '조교',
                ENG_NAME: '조교',
            },
            {
                CODE: 'APS08.27',
                NAME: '석좌교수',
                ENG_NAME: '석좌교수',
            },
            {
                CODE: 'APS08.28',
                NAME: '특별전임직',
                ENG_NAME: '특별전임직',
            },
            {
                CODE: 'APS08.29',
                NAME: '조교수(대우)',
                ENG_NAME: '조교수(대우)',
            },
            {
                CODE: 'APS08.31',
                NAME: '책임급',
                ENG_NAME: '책임급',
            },
            {
                CODE: 'APS08.32',
                NAME: '선임급',
                ENG_NAME: '선임급',
            },
            {
                CODE: 'APS08.33',
                NAME: '원급',
                ENG_NAME: '원급',
            },
            {
                CODE: 'APS08.37',
                NAME: '선임급(조정) - 급여용',
                ENG_NAME: '선임급(조정) - 급여용',
            },
            {
                CODE: 'APS08.38',
                NAME: '원급(조정) - 급여용',
                ENG_NAME: '원급(조정) - 급여용',
            },
            {
                CODE: 'APS08.41',
                NAME: '기능원',
                ENG_NAME: '기능원',
            },
            {
                CODE: 'APS08.42',
                NAME: '관리지원급',
                ENG_NAME: '관리지원급',
            },
            {
                CODE: 'APS08.43',
                NAME: '무기계약직',
                ENG_NAME: '무기계약직',
            },
            {
                CODE: 'APS08.44',
                NAME: '관리직급',
                ENG_NAME: '관리직급',
            },
            {
                CODE: 'APS08.45',
                NAME: '일반직급',
                ENG_NAME: '일반직급',
            },
            {
                CODE: 'APS08.50',
                NAME: '수석급(연구원)',
                ENG_NAME: '수석급(연구원)',
            },
            {
                CODE: 'APS08.51',
                NAME: '책임급(연구원)',
                ENG_NAME: '책임급(연구원)',
            },
            {
                CODE: 'APS08.52',
                NAME: '선임급(연구원)',
                ENG_NAME: '선임급(연구원)',
            },
            {
                CODE: 'APS08.53',
                NAME: '원급(연구원)',
                ENG_NAME: '원급(연구원)',
            },
            {
                CODE: 'APS08.54',
                NAME: '선임급(연구원 대우)',
                ENG_NAME: '선임급(연구원 대우)',
            },
            {
                CODE: 'APS08.71',
                NAME: '교원교직',
                ENG_NAME: '교원교직',
            },
            {
                CODE: 'APS08.72',
                NAME: '연구직급',
                ENG_NAME: '연구직급',
            },
            {
                CODE: 'APS08.73',
                NAME: '행정직급',
                ENG_NAME: '행정직급',
            },
            {
                CODE: 'APS08.74',
                NAME: '행정지원급',
                ENG_NAME: '행정지원급',
            },
            {
                CODE: 'APS08.81',
                NAME: '별정직',
                ENG_NAME: '별정직',
            },
            {
                CODE: 'APS08.90',
                NAME: '특별전임직(교수)',
                ENG_NAME: '특별전임직(교수)',
            },
            {
                CODE: 'APS08.91',
                NAME: '특별전임직(부교수)',
                ENG_NAME: '특별전임직(부교수)',
            },
            {
                CODE: 'APS08.92',
                NAME: '특별전임직(조교수)',
                ENG_NAME: '특별전임직(조교수)',
            },
            {
                CODE: 'APS08.93',
                NAME: '특별전임직(비영년직트랙-산학특임)',
                ENG_NAME: '특별전임직(비영년직트랙-산학특임)',
            },
        ],
    },
    {
        NAME: '참여구분코드',
        codeList: [
            {
                CODE: 'RPT22.01',
                NAME: '연구책임자',
                ENG_NAME: '연구책임자',
            },
            {
                CODE: 'RPT22.02',
                NAME: '공동연구원',
                ENG_NAME: '공동연구원',
            },
            {
                CODE: 'RPT22.03',
                NAME: '연구보조원',
                ENG_NAME: '연구보조원',
            },
        ],
    },
    {
        NAME: '학술지구분',
        codeList: [
            {
                CODE: 'RRM02.01',
                NAME: '국제SCI',
                ENG_NAME: 'International journal SCI',
            },
            {
                CODE: 'RRM02.ETC',
                NAME: 'SCI',
                ENG_NAME: 'SCI',
            },
            {
                CODE: 'RRM02.02',
                NAME: '국내SCI',
                ENG_NAME: 'Domestic journal SCI',
            },
            {
                CODE: 'RRM02.03',
                NAME: 'A&HCI or SSCI',
                ENG_NAME: 'A&HCI or SSCI',
            },
            {
                CODE: 'RRM02.04',
                NAME: 'KCI',
                ENG_NAME: 'KCI',
            },
            {
                CODE: 'RRM02.05',
                NAME: '국제저명PROCEEDING',
                ENG_NAME: 'International prominent proceeding',
            },
            {
                CODE: 'RRM02.06',
                NAME: '국제기타PROCEEDING',
                ENG_NAME: 'The other international proceeding',
            },
            {
                CODE: 'RRM02.07',
                NAME: '국내저명PROCEEDING',
                ENG_NAME: 'Domestic prominent proceeding',
            },
            {
                CODE: 'RRM02.08',
                NAME: '국내기타PROCEEDING',
                ENG_NAME: 'The other domestic proceeding',
            },
            {
                CODE: 'RRM02.09',
                NAME: '국내기타',
                ENG_NAME: 'Domestic etc.',
            },
            {
                CODE: 'RRM02.10',
                NAME: '국제기타',
                ENG_NAME: 'International etc.',
            },
            {
                CODE: 'RRM02.11',
                NAME: '인문기타',
                ENG_NAME: 'Liberal arts etc.',
            },
        ],
    },
    {
        NAME: '현재상태코드',
        codeList: [
            {
                CODE: 'CMN11.10',
                NAME: '재직/재학',
                ENG_NAME: '재직/재학',
            },
            {
                CODE: 'CMN11.20',
                NAME: '휴직/휴학',
                ENG_NAME: '휴직/휴학',
            },
            {
                CODE: 'CMN11.30',
                NAME: '정직/제적',
                ENG_NAME: '정직/제적',
            },
            {
                CODE: 'CMN11.40',
                NAME: '퇴직/졸업',
                ENG_NAME: '퇴직/졸업',
            },
        ],
    },
    {
        NAME: '휴대폰서비스코드',
        codeList: [
            {
                CODE: 'CMN38.010',
                NAME: '010',
                ENG_NAME: '010',
            },
            {
                CODE: 'CMN38.011',
                NAME: '011',
                ENG_NAME: '011',
            },
            {
                CODE: 'CMN38.016',
                NAME: '016',
                ENG_NAME: '016',
            },
            {
                CODE: 'CMN38.017',
                NAME: '017',
                ENG_NAME: '017',
            },
            {
                CODE: 'CMN38.018',
                NAME: '018',
                ENG_NAME: '018',
            },
            {
                CODE: 'CMN38.019',
                NAME: '019',
                ENG_NAME: '019',
            },
        ],
    },
    {
        NAME: '(신)시설.장비표준분류 코드',
        codeList: [
            {
                CODE: 'A',
                NAME: '광학/전자영상장비',
                ENG_NAME: 'Optical/Electric Image Equipment',
            },
            {
                CODE: 'A0',
                NAME: '달리 분류되지 않는 광학/전자영상장비',
                ENG_NAME: 'Other Optical/Electric Image Equipment',
            },
            {
                CODE: 'A1',
                NAME: '망원경',
                ENG_NAME: 'Telescope',
            },
            {
                CODE: 'A100',
                NAME: '달리 분류되지 않는 망원경',
                ENG_NAME: 'Other Telescopes',
            },
            {
                CODE: 'A101',
                NAME: '광학망원경',
                ENG_NAME: 'Optical Telescope',
            },
            {
                CODE: 'A102',
                NAME: '전파망원경',
                ENG_NAME: 'Radio Telescope',
            },
            {
                CODE: 'A2',
                NAME: '현미경',
                ENG_NAME: 'Microscope',
            },
            {
                CODE: 'A200',
                NAME: '달리 분류되지 않는 현미경',
                ENG_NAME: 'Other Microscope',
            },
            {
                CODE: 'A201',
                NAME: '광학현미경',
                ENG_NAME: 'Optical Microscope',
            },
            {
                CODE: 'A202',
                NAME: '공초점현미경',
                ENG_NAME: 'Confocal Microscope ',
            },
            {
                CODE: 'A203',
                NAME: '공구현미경',
                ENG_NAME: 'Tool Microscope',
            },
            {
                CODE: 'A204',
                NAME: '디지털현미경',
                ENG_NAME: 'Digital Microscope',
            },
            {
                CODE: 'A205',
                NAME: '투과전자현미경',
                ENG_NAME: 'Transmission Electron Microscope',
            },
            {
                CODE: 'A206',
                NAME: '주사전자현미경',
                ENG_NAME: 'Scanning Electron Microscope',
            },
            {
                CODE: 'A207',
                NAME: '전자현미원소분석기',
                ENG_NAME: 'Electron-Probe Micro Element Analyzer',
            },
            {
                CODE: 'A208',
                NAME: '주사탐침현미경',
                ENG_NAME: 'Scanning Probe Microscope',
            },
            {
                CODE: 'A3',
                NAME: '카메라/영상처리장비',
                ENG_NAME: 'Camera/Image Processing Equipment',
            },
            {
                CODE: 'A300',
                NAME: '달리 분류되지 않는 카메라/영상처리장비',
                ENG_NAME: 'Other Camera/Image Processing Equipment',
            },
            {
                CODE: 'A301',
                NAME: '디지털카메라',
                ENG_NAME: 'Digital Camera',
            },
            {
                CODE: 'A302',
                NAME: '3D카메라',
                ENG_NAME: '3D Camera',
            },
            {
                CODE: 'A303',
                NAME: '비디오카메라',
                ENG_NAME: 'Video Camera',
            },
            {
                CODE: 'A304',
                NAME: '3D비디오카메라',
                ENG_NAME: '3D Video Camera',
            },
            {
                CODE: 'A305',
                NAME: '폐쇄회로텔레비전',
                ENG_NAME: 'Closed-Circuit Television',
            },
            {
                CODE: 'A306',
                NAME: '수중카메라',
                ENG_NAME: 'Underwater Camera',
            },
            {
                CODE: 'A307',
                NAME: '고속카메라',
                ENG_NAME: 'High Speed Camera',
            },
            {
                CODE: 'A308',
                NAME: '모션캡쳐카메라',
                ENG_NAME: 'Motion Capture Camera',
            },
            {
                CODE: 'A309',
                NAME: '열화상카메라',
                ENG_NAME: 'Thermo-Graphic Camera',
            },
            {
                CODE: 'A310',
                NAME: '음향카메라',
                ENG_NAME: 'Acoustic Camera',
            },
            {
                CODE: 'A311',
                NAME: '전자증배형카메라',
                ENG_NAME: 'Electron Multiplier Camera',
            },
            {
                CODE: 'A312',
                NAME: 'X-선/자외선/적외선카메라',
                ENG_NAME: 'X-rays/Ultraviolet Rays/Infrared Rays Camera',
            },
            {
                CODE: 'A313',
                NAME: '기타특수카메라',
                ENG_NAME: 'Other Special Cameras',
            },
            {
                CODE: 'A314',
                NAME: '3D스캐너',
                ENG_NAME: '3DScanner',
            },
            {
                CODE: 'A315',
                NAME: '모니터',
                ENG_NAME: 'Monitor',
            },
            {
                CODE: 'A316',
                NAME: '프로젝터',
                ENG_NAME: 'Projector',
            },
            {
                CODE: 'A317',
                NAME: '화상회의시스템',
                ENG_NAME: 'Video Conference System',
            },
            {
                CODE: 'A318',
                NAME: '비디오인코더/디코더',
                ENG_NAME: 'Video Encoder/Decoder',
            },
            {
                CODE: 'A319',
                NAME: '편집장비',
                ENG_NAME: 'Edit Equipment',
            },
            {
                CODE: 'A4',
                NAME: '광파발생/측정장비',
                ENG_NAME: 'Light Wave Generator/Measuring Instrument',
            },
            {
                CODE: 'A400',
                NAME: '달리 분류되지 않는 광파발생/측정장비',
                ENG_NAME: 'Other Light Wave Generator/Measuring Instrument',
            },
            {
                CODE: 'A401',
                NAME: '배광기',
                ENG_NAME: 'Light Distributor',
            },
            {
                CODE: 'A402',
                NAME: '분광복사기',
                ENG_NAME: 'Spectroradiometer',
            },
            {
                CODE: 'A403',
                NAME: '휘도계/조도계',
                ENG_NAME: 'Luminance Meter/Illuminometer',
            },
            {
                CODE: 'A404',
                NAME: '일사계/광량계',
                ENG_NAME: 'Pyrheliometer/Actinometer',
            },
            {
                CODE: 'A405',
                NAME: '색도계/색차계/탁도계',
                ENG_NAME: 'Chromameter/Color-Difference Meter/Turbidimeter',
            },
            {
                CODE: 'A406',
                NAME: '굴절계',
                ENG_NAME: 'Refractometer',
            },
            {
                CODE: 'A407',
                NAME: '간섭계',
                ENG_NAME: 'Interferometer',
            },
            {
                CODE: 'A408',
                NAME: '타원계',
                ENG_NAME: 'Ellipsometer',
            },
            {
                CODE: 'A409',
                NAME: '광탄성시험기',
                ENG_NAME: 'Phtoelastic Analyzer',
            },
            {
                CODE: 'A410',
                NAME: '레이저발생장비',
                ENG_NAME: 'Laser Device',
            },
            {
                CODE: 'A5',
                NAME: '방사선발생/측정장비',
                ENG_NAME: 'Radiation Generator/Measuring Instrument',
            },
            {
                CODE: 'A500',
                NAME: '달리 분류되지 않는 방사선발생/측정장비',
                ENG_NAME: 'Other Radiation Generators/Measuring Instruments',
            },
            {
                CODE: 'A501',
                NAME: 'X-선발생기',
                ENG_NAME: 'X-rays Generator',
            },
            {
                CODE: 'A502',
                NAME: '감마선/베타선발생기/조사기',
                ENG_NAME: 'Gamma Rays/Beta Rays Generator/Irradiator',
            },
            {
                CODE: 'A503',
                NAME: '방사선물질측정기',
                ENG_NAME: 'Radiation Material Measuring Instrument',
            },
            {
                CODE: 'A504',
                NAME: '액체섬광계수기',
                ENG_NAME: 'Liquid Scintillation Counter',
            },
            {
                CODE: 'A505',
                NAME: '감마계수기',
                ENG_NAME: 'Gamma Counter',
            },
            {
                CODE: 'A506',
                NAME: '가속기',
                ENG_NAME: 'Accelerator',
            },
            {
                CODE: 'A6',
                NAME: '이미지분석장비',
                ENG_NAME: 'Image Analyzing Apparatus',
            },
            {
                CODE: 'A600',
                NAME: '달리 분류되지 않는 이미지분석장비',
                ENG_NAME: 'Other Image Analyzing Apparatus',
            },
            {
                CODE: 'A601',
                NAME: '생체내화학형광이미지분석기',
                ENG_NAME: 'In Vivo Chemical Fluorescene Image Analyzer',
            },
            {
                CODE: 'A602',
                NAME: '시험관내화학형광이미지분석기',
                ENG_NAME: 'Test Tube Chemical Fluorescene Image Analyzer',
            },
            {
                CODE: 'A603',
                NAME: '레이저형광이미지분석기',
                ENG_NAME: 'Laser Fluorescene Image Analyzer',
            },
            {
                CODE: 'B',
                NAME: '화합물전처리/분석장비',
                ENG_NAME: 'Compound Preprocessing/Analyzing Apparatus',
            },
            {
                CODE: 'B0',
                NAME: '달리 분류되지 않는 화합물전처리/분석장비',
                ENG_NAME: 'Other Compound Preprocessing/Analyzing Apparatus',
            },
            {
                CODE: 'B1',
                NAME: '반응/혼합/분쇄장비',
                ENG_NAME: 'Reaction/Mix/Comminution Equipment',
            },
            {
                CODE: 'B100',
                NAME: '달리 분류되지 않는 반응/혼합/분쇄장비',
                ENG_NAME: 'Other Reaction/Mix/Comminution Equipment',
            },
            {
                CODE: 'B101',
                NAME: '혼합기',
                ENG_NAME: 'Mixer',
            },
            {
                CODE: 'B102',
                NAME: '원심력혼합기',
                ENG_NAME: 'Centrifugal Force Mixer',
            },
            {
                CODE: 'B103',
                NAME: '교반기',
                ENG_NAME: 'Agitator',
            },
            {
                CODE: 'B104',
                NAME: '균질기',
                ENG_NAME: 'Homogenizer',
            },
            {
                CODE: 'B105',
                NAME: '분쇄/파쇄기',
                ENG_NAME: 'Grinder/Crusher',
            },
            {
                CODE: 'B106',
                NAME: '초음파분쇄기',
                ENG_NAME: 'Ultrasonic Waves Grinder',
            },
            {
                CODE: 'B107',
                NAME: '시료절편기',
                ENG_NAME: 'Specimen Section Machine',
            },
            {
                CODE: 'B108',
                NAME: '포집장비',
                ENG_NAME: 'Scavenging Equipment',
            },
            {
                CODE: 'B109',
                NAME: '반응장비',
                ENG_NAME: 'Reactor',
            },
            {
                CODE: 'B110',
                NAME: '포장장비',
                ENG_NAME: 'Packaging Equipment',
            },
            {
                CODE: 'B2',
                NAME: '바이오제조/분석장비',
                ENG_NAME: 'Bio Manufacturing Device/Analyzing Apparatus',
            },
            {
                CODE: 'B200',
                NAME: '달리 분류되지 않는 바이오제조/분석장비',
                ENG_NAME: 'Other Bio Manufacturing Devices/Analyzing Apparatus',
            },
            {
                CODE: 'B201',
                NAME: '유전자증폭장치',
                ENG_NAME: 'Genetic Mappers Thermal Cycler',
            },
            {
                CODE: 'B202',
                NAME: '단백질합성/분리분석장치',
                ENG_NAME: 'Protein Synthesis/Separation Analyzer',
            },
            {
                CODE: 'B203',
                NAME: '식물분석검사장치',
                ENG_NAME: 'Plants Analyzing Test Device',
            },
            {
                CODE: 'B204',
                NAME: '자동화분주장치',
                ENG_NAME: 'Automatized Demultiplier',
            },
            {
                CODE: 'B205',
                NAME: '배양장치',
                ENG_NAME: 'Culture Apparatus',
            },
            {
                CODE: 'B206',
                NAME: '배양분석장치',
                ENG_NAME: 'Cultivation Analyzer',
            },
            {
                CODE: 'B207',
                NAME: '미생물분석장치',
                ENG_NAME: 'Microbe Analyzer',
            },
            {
                CODE: 'B208',
                NAME: '세포조작/분석장치',
                ENG_NAME: 'Cellular Manipulation/Analyzing Apparatus',
            },
            {
                CODE: 'B209',
                NAME: '유세포분리/분석장치',
                ENG_NAME: 'Flow Cytometry/Separator',
            },
            {
                CODE: 'B210',
                NAME: '유전자합성/분석장치',
                ENG_NAME: 'Gene Synthesizer/Analyzer',
            },
            {
                CODE: 'B211',
                NAME: '마이크로어레이',
                ENG_NAME: 'Microarray',
            },
            {
                CODE: 'B212',
                NAME: '마이크로플레이트리더',
                ENG_NAME: 'Microplate Reader',
            },
            {
                CODE: 'B213',
                NAME: '유전자전달장치',
                ENG_NAME: 'Gene Transferring Device',
            },
            {
                CODE: 'B214',
                NAME: '유전자추출장치',
                ENG_NAME: 'Gene Extractor',
            },
            {
                CODE: 'B215',
                NAME: '바이오모델장치',
                ENG_NAME: 'Bio Model Device',
            },
            {
                CODE: 'B3',
                NAME: '분리정제장비',
                ENG_NAME: 'Separator and Refining Equipment',
            },
            {
                CODE: 'B300',
                NAME: '달리 분류되지 않는 분리정제장비',
                ENG_NAME: 'Other Separators and Refining Equipment',
            },
            {
                CODE: 'B301',
                NAME: '원심분리기',
                ENG_NAME: 'Centrifuge',
            },
            {
                CODE: 'B302',
                NAME: '증류/농축기',
                ENG_NAME: 'Distiller/Evaporator',
            },
            {
                CODE: 'B303',
                NAME: '결정화장치',
                ENG_NAME: 'Crystallization Device',
            },
            {
                CODE: 'B304',
                NAME: '승화장치',
                ENG_NAME: 'Sublimation Device',
            },
            {
                CODE: 'B305',
                NAME: '추출기',
                ENG_NAME: 'Extractor',
            },
            {
                CODE: 'B306',
                NAME: '여과기',
                ENG_NAME: 'Filter',
            },
            {
                CODE: 'B307',
                NAME: '선별/분급기',
                ENG_NAME: 'Grader/Classifier',
            },
            {
                CODE: 'B308',
                NAME: '전기정제장비',
                ENG_NAME: 'Electronic Refining Equipment',
            },
            {
                CODE: 'B309',
                NAME: '수처리장비',
                ENG_NAME: 'Water Treatment Device',
            },
            {
                CODE: 'B310',
                NAME: '흡착정제장비',
                ENG_NAME: 'Absorbing Refining Equipment',
            },
            {
                CODE: 'B4',
                NAME: '분리분석장비',
                ENG_NAME: 'Separating Analyzing Apparatus',
            },
            {
                CODE: 'B400',
                NAME: '달리 분류되지 않는 분리분석장비',
                ENG_NAME: 'Other Separating Analyzing Apparatus',
            },
            {
                CODE: 'B401',
                NAME: '가스크로마토그래피',
                ENG_NAME: 'Gas Chromatography',
            },
            {
                CODE: 'B402',
                NAME: '액체크로마토그래피',
                ENG_NAME: 'Liquid Chromatography',
            },
            {
                CODE: 'B403',
                NAME: '분취용크로마토그래피',
                ENG_NAME: 'Preparative Chromatography',
            },
            {
                CODE: 'B404',
                NAME: '이온크로마토그래피',
                ENG_NAME: 'Ion Chromatography',
            },
            {
                CODE: 'B405',
                NAME: '겔투과크로마토그래피',
                ENG_NAME: 'Gel-Permeation Chromatography',
            },
            {
                CODE: 'B406',
                NAME: '박막크로마토그래피',
                ENG_NAME: 'Thin Film Chromatography',
            },
            {
                CODE: 'B407',
                NAME: '전기영동장치',
                ENG_NAME: 'Electrophoresis Apparatus',
            },
            {
                CODE: 'B408',
                NAME: '아미노산분석기',
                ENG_NAME: 'Amino Acid Analyzer',
            },
            {
                CODE: 'B409',
                NAME: '원소분석기',
                ENG_NAME: 'Element Analyzer',
            },
            {
                CODE: 'B410',
                NAME: '자동수질분석기',
                ENG_NAME: 'Automatic Water-Quality Analyzer',
            },
            {
                CODE: 'B5',
                NAME: '분광분석장비',
                ENG_NAME: 'Spectrum Analyzing Apparatus',
            },
            {
                CODE: 'B500',
                NAME: '달리 분류되지 않는 분광분석장비',
                ENG_NAME: 'Other Spectrum Analyzing Apparatus',
            },
            {
                CODE: 'B501',
                NAME: '핵자기공명분광기',
                ENG_NAME: 'NMR: Nuclear Magnetic Resonance Spectrometer',
            },
            {
                CODE: 'B502',
                NAME: '푸리에변환적외선분광기',
                ENG_NAME: 'Fourier Transform Infrared Spectrometer',
            },
            {
                CODE: 'B503',
                NAME: '근적외선분광기',
                ENG_NAME: 'Near-Infrared Spectrometer',
            },
            {
                CODE: 'B504',
                NAME: '곡물입자분석기',
                ENG_NAME: 'Grain Particle Analyzer',
            },
            {
                CODE: 'B505',
                NAME: '가스성분분석기',
                ENG_NAME: 'gas Ingredient Analyzer',
            },
            {
                CODE: 'B506',
                NAME: '수은함량분석기',
                ENG_NAME: 'Mercury Level Analyzer',
            },
            {
                CODE: 'B507',
                NAME: '가시광분광기',
                ENG_NAME: 'Visible Light Spectrometer',
            },
            {
                CODE: 'B508',
                NAME: '형광분광광도계',
                ENG_NAME: 'Fluorescene Spectrophotometer',
            },
            {
                CODE: 'B509',
                NAME: '자외/가시광분광광도계',
                ENG_NAME: 'Ultraviolet/Visible Light Spectrophotometer',
            },
            {
                CODE: 'B510',
                NAME: '자외/가시광/적외선분광광도계',
                ENG_NAME: 'Ultraviolet/Visible Light/Infrared Rays Spectrophotometer',
            },
            {
                CODE: 'B511',
                NAME: '유도결합플라즈마원자방출분광기',
                ENG_NAME: 'Inductively Coupled Plasma-Atomic Emission Spectrometer',
            },
            {
                CODE: 'B512',
                NAME: '글로우방전방출분광기',
                ENG_NAME: 'Glow Discharge Emission Spectrometer',
            },
            {
                CODE: 'B513',
                NAME: '스파크/아크원자방출분광기',
                ENG_NAME: 'Spark/Arc Atomic Emission Spectrometer',
            },
            {
                CODE: 'B514',
                NAME: '레이저유도플라즈마분광기',
                ENG_NAME: 'Laser Induction Plasma Spectrometer',
            },
            {
                CODE: 'B515',
                NAME: '불꽃방출분광기',
                ENG_NAME: 'Flame Emission Spectrometer',
            },
            {
                CODE: 'B516',
                NAME: '원자흡광분광기',
                ENG_NAME: 'Atomic Absorption Spectrometer',
            },
            {
                CODE: 'B517',
                NAME: '라만분광기',
                ENG_NAME: 'Raman Spectrometer',
            },
            {
                CODE: 'B518',
                NAME: '발광분광기',
                ENG_NAME: 'Emission Spectrometer',
            },
            {
                CODE: 'B519',
                NAME: '전자스핀공명분광기',
                ENG_NAME: 'Electron Spin Resonance Spectrometer',
            },
            {
                CODE: 'B520',
                NAME: 'X-선회절분석기',
                ENG_NAME: 'X-Rays Diffraction Analyzer',
            },
            {
                CODE: 'B521',
                NAME: 'X-선광전자분광기',
                ENG_NAME: 'X-Rays Photoelectron Spectrometer',
            },
            {
                CODE: 'B522',
                NAME: 'X-선형광분석기',
                ENG_NAME: 'X-Rays Fluorescene Analyzer',
            },
            {
                CODE: 'B523',
                NAME: '탄소총량측정기',
                ENG_NAME: 'Carbon Gross Measuring Instrument',
            },
            {
                CODE: 'B6',
                NAME: '질량분석장비',
                ENG_NAME: 'Mass Analyzing Apparatus',
            },
            {
                CODE: 'B600',
                NAME: '달리 분류되지 않는 질량분석장비',
                ENG_NAME: 'Other Mass Analyzing Apparatus',
            },
            {
                CODE: 'B601',
                NAME: '기체크로마토그래피질량분석기',
                ENG_NAME: 'Gas Chromatography-Mass Spectrometer',
            },
            {
                CODE: 'B602',
                NAME: '액체크로마토그래피질량분석기',
                ENG_NAME: 'Liquid Chromatography-Mass Spectrometer',
            },
            {
                CODE: 'B603',
                NAME: '동위원소비질량분석기',
                ENG_NAME: 'Isotopic Ratio Mass Spectrometer',
            },
            {
                CODE: 'B604',
                NAME: '이차이온질량분석기',
                ENG_NAME: 'Secondary Ion Mass Spectrometer',
            },
            {
                CODE: 'B605',
                NAME: '메트릭스보조레이저탈착이온화질량분석기',
                ENG_NAME: 'Matrix Assisted Laser Desorption Ionization Mass Spectrometer',
            },
            {
                CODE: 'B606',
                NAME: '가속질량분석기',
                ENG_NAME: 'Accelerator Mass Spectrometer',
            },
            {
                CODE: 'B607',
                NAME: '미량가스질량분석기',
                ENG_NAME: 'Micro-Gas Mass Spectrometer',
            },
            {
                CODE: 'B608',
                NAME: '직접주입고분해능질량분석기',
                ENG_NAME: 'Direct Injection High Resolution Mass Spectrometer',
            },
            {
                CODE: 'B609',
                NAME: '열중량질량분석기',
                ENG_NAME: 'Thermogravimetric-Mass Analyzer',
            },
            {
                CODE: 'B7',
                NAME: '입자분석장비',
                ENG_NAME: 'Particle Analyzing Apparatus',
            },
            {
                CODE: 'B700',
                NAME: '달리 분류되지 않는 입자분석장비',
                ENG_NAME: 'Other Particle Analyzing Apparatus',
            },
            {
                CODE: 'B701',
                NAME: '제타전위측정기',
                ENG_NAME: 'Zeta-Potential Measuring Instrument',
            },
            {
                CODE: 'B702',
                NAME: '입도분석기',
                ENG_NAME: 'Grain Size Analyzer',
            },
            {
                CODE: 'B703',
                NAME: '입자계수기',
                ENG_NAME: 'Particle Counter',
            },
            {
                CODE: 'B704',
                NAME: '비표면적측정장비',
                ENG_NAME: 'Specific Surface Area Measuring Equipment',
            },
            {
                CODE: 'B705',
                NAME: '분산안정도분석기',
                ENG_NAME: 'Variance Stability Analyzer',
            },
            {
                CODE: 'C',
                NAME: '기계가공/시험장비',
                ENG_NAME: 'Machine Manufacturing/Testing Equipment',
            },
            {
                CODE: 'C0',
                NAME: '달리 분류되지 않는 기계가공/시험장비',
                ENG_NAME: 'Other Machine Manufacturing/Testing Equipment',
            },
            {
                CODE: 'C1',
                NAME: '절삭장비',
                ENG_NAME: 'Cutter',
            },
            {
                CODE: 'C100',
                NAME: '달리 분류되지 않는 절삭장비',
                ENG_NAME: 'Other Cutters',
            },
            {
                CODE: 'C101',
                NAME: '선반장비',
                ENG_NAME: 'Lathe Equipment',
            },
            {
                CODE: 'C102',
                NAME: '밀링장비',
                ENG_NAME: 'Milling Attachment',
            },
            {
                CODE: 'C103',
                NAME: '드릴링장비',
                ENG_NAME: 'Drilling Equipment',
            },
            {
                CODE: 'C104',
                NAME: '보링장비',
                ENG_NAME: 'Boring Equipment',
            },
            {
                CODE: 'C105',
                NAME: '연삭장비',
                ENG_NAME: 'Grinder',
            },
            {
                CODE: 'C106',
                NAME: '복합절삭장비',
                ENG_NAME: 'Complex Cutting Machine',
            },
            {
                CODE: 'C107',
                NAME: '절단장비',
                ENG_NAME: 'Cutting Machine',
            },
            {
                CODE: 'C108',
                NAME: '펀칭장비',
                ENG_NAME: 'Punching Machine',
            },
            {
                CODE: 'C2',
                NAME: '성형/가공장비',
                ENG_NAME: 'Molding/Processing Machine',
            },
            {
                CODE: 'C200',
                NAME: '달리 분류되지 않는 성형/가공장비',
                ENG_NAME: 'Other Molding/Processing Machines',
            },
            {
                CODE: 'C201',
                NAME: '프레스장비',
                ENG_NAME: 'Press Machine',
            },
            {
                CODE: 'C202',
                NAME: '절곡벤딩장비',
                ENG_NAME: 'Bending Machine',
            },
            {
                CODE: 'C203',
                NAME: '압연장비',
                ENG_NAME: 'Rolling Machine',
            },
            {
                CODE: 'C204',
                NAME: '주조장비',
                ENG_NAME: 'Casting Machine',
            },
            {
                CODE: 'C205',
                NAME: '사출장비',
                ENG_NAME: 'Ejection Machine',
            },
            {
                CODE: 'C206',
                NAME: '압출/인발장비',
                ENG_NAME: 'Extruding/Drawing Equipment',
            },
            {
                CODE: 'C207',
                NAME: '용접장비',
                ENG_NAME: 'Welding Machine',
            },
            {
                CODE: 'C208',
                NAME: '표면가공기',
                ENG_NAME: 'Surface Processor',
            },
            {
                CODE: 'C209',
                NAME: '코팅기',
                ENG_NAME: 'Coating Machine',
            },
            {
                CODE: 'C210',
                NAME: '레이저가공기',
                ENG_NAME: 'Laser Processor',
            },
            {
                CODE: 'C211',
                NAME: '3D프린터',
                ENG_NAME: '3DPrinter',
            },
            {
                CODE: 'C212',
                NAME: '스크린프린터',
                ENG_NAME: 'Screen Printer',
            },
            {
                CODE: 'C213',
                NAME: '금형',
                ENG_NAME: 'Mold',
            },
            {
                CODE: 'C214',
                NAME: '단조성형기',
                ENG_NAME: 'Forging Molding Machine',
            },
            {
                CODE: 'C215',
                NAME: '방전성형가공기',
                ENG_NAME: 'Electric-Hydraulic Forming Process Machine',
            },
            {
                CODE: 'C216',
                NAME: '접합조립장비',
                ENG_NAME: 'Connection Assembly Machine',
            },
            {
                CODE: 'C217',
                NAME: '복합/특수성형기',
                ENG_NAME: 'Composite/Special Molding Machine',
            },
            {
                CODE: 'C218',
                NAME: '성형공정측정검사장비',
                ENG_NAME: 'Molding Process Measurement Testing Machine',
            },
            {
                CODE: 'C219',
                NAME: '성형공정세척기',
                ENG_NAME: 'Molding Process Wash Equipment',
            },
            {
                CODE: 'C3',
                NAME: '자동화/이송장비',
                ENG_NAME: 'Automation/Carrying Equipment',
            },
            {
                CODE: 'C300',
                NAME: '달리 분류되지 않는 자동화/이송장비',
                ENG_NAME: 'Other Automation/Carrying Equipment',
            },
            {
                CODE: 'C301',
                NAME: '컨베이어',
                ENG_NAME: 'Conveyor',
            },
            {
                CODE: 'C302',
                NAME: '오버헤드크레인',
                ENG_NAME: 'Overhead Crane',
            },
            {
                CODE: 'C303',
                NAME: '이동크레인',
                ENG_NAME: 'Locomobile Crane',
            },
            {
                CODE: 'C304',
                NAME: '고정크레인',
                ENG_NAME: 'Fixed Crane',
            },
            {
                CODE: 'C305',
                NAME: '이송장치/차량',
                ENG_NAME: 'Carrying Machine/Car',
            },
            {
                CODE: 'C306',
                NAME: '농작업장비',
                ENG_NAME: 'Farm Working Machine',
            },
            {
                CODE: 'C307',
                NAME: '자동생산라인장비',
                ENG_NAME: 'Automatic Production Line Equipment',
            },
            {
                CODE: 'C308',
                NAME: '자동포장장비',
                ENG_NAME: 'Automatic Packaging Equipment',
            },
            {
                CODE: 'C309',
                NAME: '권선장비',
                ENG_NAME: 'Winding Device',
            },
            {
                CODE: 'C310',
                NAME: '로봇',
                ENG_NAME: 'Robot',
            },
            {
                CODE: 'C311',
                NAME: '위치제어장비',
                ENG_NAME: 'Position Control Unit',
            },
            {
                CODE: 'C312',
                NAME: '자동투입장치',
                ENG_NAME: 'Automatic Closing Device',
            },
            {
                CODE: 'C4',
                NAME: '섬유기계장비',
                ENG_NAME: 'Textile Machinery Equipment',
            },
            {
                CODE: 'C400',
                NAME: '달리 분류되지 않는 섬유기계장비',
                ENG_NAME: 'Other Textile Machinery Equipment',
            },
            {
                CODE: 'C401',
                NAME: '방적기',
                ENG_NAME: 'Spinning Machine',
            },
            {
                CODE: 'C402',
                NAME: '연사기',
                ENG_NAME: 'Twisting Machine',
            },
            {
                CODE: 'C403',
                NAME: '직기',
                ENG_NAME: 'Weaving Machine',
            },
            {
                CODE: 'C404',
                NAME: '염색가공기',
                ENG_NAME: 'Dyeing Processor',
            },
            {
                CODE: 'C405',
                NAME: '지거염색기',
                ENG_NAME: 'Jigger Dyeing Machine',
            },
            {
                CODE: 'C406',
                NAME: '제트염색기',
                ENG_NAME: 'Jet Dyeing machine',
            },
            {
                CODE: 'C407',
                NAME: '봉제장비',
                ENG_NAME: 'Sewing Equipment',
            },
            {
                CODE: 'C408',
                NAME: '자수기',
                ENG_NAME: 'Embroidering Machine',
            },
            {
                CODE: 'C409',
                NAME: '표면처리기',
                ENG_NAME: 'Surface Treatment Device',
            },
            {
                CODE: 'C410',
                NAME: '프리프레그가공설비',
                ENG_NAME: 'Prepreg Process Equipment',
            },
            {
                CODE: 'C5',
                NAME: '반도체장비',
                ENG_NAME: 'Semiconductor Equipment',
            },
            {
                CODE: 'C500',
                NAME: '달리 분류되지 않는 반도체장비',
                ENG_NAME: 'Other Semiconductor Equipment',
            },
            {
                CODE: 'C501',
                NAME: '리소그래픽장비',
                ENG_NAME: 'Lithography Device',
            },
            {
                CODE: 'C502',
                NAME: '트랙장비',
                ENG_NAME: 'Track Equipment',
            },
            {
                CODE: 'C503',
                NAME: '열증착기',
                ENG_NAME: 'Thermal Evaporator',
            },
            {
                CODE: 'C504',
                NAME: '전자빔증착기',
                ENG_NAME: 'Electron Beam Evaporator',
            },
            {
                CODE: 'C505',
                NAME: '분자선결정성장비',
                ENG_NAME: 'Molecular Beam Crystalline Equipment',
            },
            {
                CODE: 'C506',
                NAME: '스퍼터',
                ENG_NAME: 'Sputter',
            },
            {
                CODE: 'C507',
                NAME: '플라즈마기상화학증착장비',
                ENG_NAME: 'Plasma Enhanced Chemical Vapor Deposition Equipment',
            },
            {
                CODE: 'C508',
                NAME: '유기금속화학증착장비',
                ENG_NAME: 'Organometallic Chemical Deposition Equipment',
            },
            {
                CODE: 'C509',
                NAME: '원자층증착장비',
                ENG_NAME: 'Atom Layer Deposition Equipment',
            },
            {
                CODE: 'C510',
                NAME: '식각장비',
                ENG_NAME: 'Etching Machine',
            },
            {
                CODE: 'C511',
                NAME: '이온주입장치',
                ENG_NAME: 'Ion Injection Equipment',
            },
            {
                CODE: 'C512',
                NAME: '와이어본딩',
                ENG_NAME: 'Wire Bonding',
            },
            {
                CODE: 'C513',
                NAME: '다이본더',
                ENG_NAME: 'Die Bonder',
            },
            {
                CODE: 'C514',
                NAME: '프로브스테이션',
                ENG_NAME: 'Probe Station',
            },
            {
                CODE: 'C515',
                NAME: '칩검사기',
                ENG_NAME: 'Chip Tester',
            },
            {
                CODE: 'C516',
                NAME: '가공/리페어/절단장비',
                ENG_NAME: 'Processing/Repair/Cutting Machine',
            },
            {
                CODE: 'C517',
                NAME: '광학검사기',
                ENG_NAME: 'Optical Tester',
            },
            {
                CODE: 'C518',
                NAME: '스프레이장비',
                ENG_NAME: 'Spray Equipment',
            },
            {
                CODE: 'C519',
                NAME: '프린팅장비',
                ENG_NAME: 'Printing Equipment',
            },
            {
                CODE: 'C520',
                NAME: '라미네이터장비',
                ENG_NAME: 'Laminator Equipment',
            },
            {
                CODE: 'C521',
                NAME: '진공반송장비',
                ENG_NAME: 'Vacuum Carrier',
            },
            {
                CODE: 'C522',
                NAME: '펌프/쿨링시스템',
                ENG_NAME: 'Pump/Cooling System',
            },
            {
                CODE: 'C523',
                NAME: '퍼니스',
                ENG_NAME: 'Furnace',
            },
            {
                CODE: 'C524',
                NAME: '롤장비',
                ENG_NAME: 'Roll Device',
            },
            {
                CODE: 'C525',
                NAME: '전기도금장비',
                ENG_NAME: 'Electroplating Equipment',
            },
            {
                CODE: 'C526',
                NAME: '정밀기구시스템',
                ENG_NAME: 'Precision Instrument System',
            },
            {
                CODE: 'C527',
                NAME: '열처리장치',
                ENG_NAME: 'Heat Treatment Equipment',
            },
            {
                CODE: 'C528',
                NAME: '건조시스템',
                ENG_NAME: 'Drying System',
            },
            {
                CODE: 'C529',
                NAME: '가스공급장치',
                ENG_NAME: 'Gas Supply Device Repair',
            },
            {
                CODE: 'C530',
                NAME: '결정화장비',
                ENG_NAME: 'Crystallization Equipment',
            },
            {
                CODE: 'C531',
                NAME: '결정성장장치',
                ENG_NAME: 'Crystal Growth Equipment',
            },
            {
                CODE: 'C6',
                NAME: '열유체장비',
                ENG_NAME: 'Thermo-Fluid Device',
            },
            {
                CODE: 'C600',
                NAME: '달리 분류되지 않는 열유체장비',
                ENG_NAME: 'Other Thermo-Fluid Devices',
            },
            {
                CODE: 'C601',
                NAME: '전기/소결로',
                ENG_NAME: 'Electric/Sintering Furnace',
            },
            {
                CODE: 'C602',
                NAME: '오븐',
                ENG_NAME: 'Oven',
            },
            {
                CODE: 'C603',
                NAME: '건조기',
                ENG_NAME: 'Drying Machine',
            },
            {
                CODE: 'C604',
                NAME: '글로브박스',
                ENG_NAME: 'Globe Box',
            },
            {
                CODE: 'C605',
                NAME: '멸균기',
                ENG_NAME: 'Sterilizer',
            },
            {
                CODE: 'C606',
                NAME: '냉장고',
                ENG_NAME: 'Refrigerator',
            },
            {
                CODE: 'C607',
                NAME: '열교환기',
                ENG_NAME: 'Heat Exchanger',
            },
            {
                CODE: 'C608',
                NAME: '항온/항습장비',
                ENG_NAME: 'Isothermal/Isohumidity Equipment',
            },
            {
                CODE: 'C609',
                NAME: '유체정화기',
                ENG_NAME: 'Fluid Purification Apparatus',
            },
            {
                CODE: 'C610',
                NAME: '펌프',
                ENG_NAME: 'Pump',
            },
            {
                CODE: 'C611',
                NAME: '저장탱크',
                ENG_NAME: 'Storage Tank',
            },
            {
                CODE: 'C612',
                NAME: '압력장비',
                ENG_NAME: 'Pressure Device',
            },
            {
                CODE: 'C613',
                NAME: '유체발생장비',
                ENG_NAME: 'Fluid Producer',
            },
            {
                CODE: 'C614',
                NAME: '보일러',
                ENG_NAME: 'Boiler',
            },
            {
                CODE: 'C7',
                NAME: '재료물성시험장비',
                ENG_NAME: 'Material Property Testing Machine',
            },
            {
                CODE: 'C700',
                NAME: '달리 분류되지 않는 재료물성시험장비',
                ENG_NAME: 'Other Material Property Testing Machine',
            },
            {
                CODE: 'C701',
                NAME: '만능시험기',
                ENG_NAME: 'All-Purpose Tester',
            },
            {
                CODE: 'C702',
                NAME: '경도시험기',
                ENG_NAME: 'Longitude Tester',
            },
            {
                CODE: 'C703',
                NAME: '크리프시험기',
                ENG_NAME: 'Creep Tester',
            },
            {
                CODE: 'C704',
                NAME: '만능피로시험기',
                ENG_NAME: 'All-Purpose Fatigue Tester',
            },
            {
                CODE: 'C705',
                NAME: '작동내구시험기',
                ENG_NAME: 'Operation Duration Tester',
            },
            {
                CODE: 'C706',
                NAME: '마모시험기',
                ENG_NAME: 'Abrasion Tester',
            },
            {
                CODE: 'C707',
                NAME: '가속수명시험기',
                ENG_NAME: 'Accelerated Life Tester',
            },
            {
                CODE: 'C708',
                NAME: '초음파검사장비',
                ENG_NAME: 'Ultrasonic Waves Testing Machine',
            },
            {
                CODE: 'C709',
                NAME: '방사선투과검사장비',
                ENG_NAME: 'Radiographic Testing Machine',
            },
            {
                CODE: 'C710',
                NAME: '음향검사장비',
                ENG_NAME: 'Sound Testing Machine',
            },
            {
                CODE: 'C711',
                NAME: '와전류검사장비',
                ENG_NAME: 'Eddy Current Testing Machine',
            },
            {
                CODE: 'C712',
                NAME: '열충격시험기',
                ENG_NAME: 'Thermal Shock Tester',
            },
            {
                CODE: 'C713',
                NAME: '온습도시험기',
                ENG_NAME: 'Temperature-Humidity Tester',
            },
            {
                CODE: 'C714',
                NAME: '염수분무시험기',
                ENG_NAME: 'Salt Spray Tester',
            },
            {
                CODE: 'C715',
                NAME: '부식시험기',
                ENG_NAME: 'Corrosion Tester',
            },
            {
                CODE: 'C716',
                NAME: '분진시험기',
                ENG_NAME: 'Dust Tester',
            },
            {
                CODE: 'C717',
                NAME: '태양복사에너지시험기',
                ENG_NAME: 'Solar Radiation Energy Tester',
            },
            {
                CODE: 'C718',
                NAME: '자외선시험기',
                ENG_NAME: 'Ultraviolet Rays Tester',
            },
            {
                CODE: 'C719',
                NAME: '진동내구시험장비',
                ENG_NAME: 'Vibration Duration Testing Machine',
            },
            {
                CODE: 'C720',
                NAME: '특성평가시험기',
                ENG_NAME: 'Characteristic Evaluation Tester',
            },
            {
                CODE: 'C721',
                NAME: '특성평가부대장비',
                ENG_NAME: 'Characteristic Evaluation Additional Equipment',
            },
            {
                CODE: 'C722',
                NAME: '특성평가시스템',
                ENG_NAME: 'Characteristic Evaluation System',
            },
            {
                CODE: 'C723',
                NAME: '물성분석기',
                ENG_NAME: 'Property Analyzer',
            },
            {
                CODE: 'C724',
                NAME: '환경모사시험기',
                ENG_NAME: 'Environment Simulation Tester',
            },
            {
                CODE: 'D',
                NAME: '전기/전자장비',
                ENG_NAME: 'Electricity/Electron Equipment',
            },
            {
                CODE: 'D0',
                NAME: '달리 분류되지 않는 전기/전자장비',
                ENG_NAME: 'Other Electricity/Electron Equipment',
            },
            {
                CODE: 'D1',
                NAME: '측정시험장비',
                ENG_NAME: 'Measurement Testing Machine',
            },
            {
                CODE: 'D100',
                NAME: '달리 분류되지 않는 측정시험장비',
                ENG_NAME: 'Other Measurement Testing Machine',
            },
            {
                CODE: 'D101',
                NAME: '전압/전류/전력측정시험장비',
                ENG_NAME: 'Voltage/Current/Electricity Measurement Testing Machine',
            },
            {
                CODE: 'D102',
                NAME: '다기능임피던스측정시험장비',
                ENG_NAME: 'Multifunctional Impedance Measurement Testing Machine',
            },
            {
                CODE: 'D103',
                NAME: '절연/누설/정전기측정시험장비',
                ENG_NAME: 'Insulation/Leakage/Electrostatic Measurement Testing Machine',
            },
            {
                CODE: 'D104',
                NAME: '전지/충방전측정시험장비',
                ENG_NAME: 'Battery/Charge and Discharge Measurement Testing Machine',
            },
            {
                CODE: 'D105',
                NAME: '오실로스코프',
                ENG_NAME: 'Oscilloscope',
            },
            {
                CODE: 'D106',
                NAME: '전자파측정시험장비',
                ENG_NAME: 'Electromagnetic Measurement Testing Machine',
            },
            {
                CODE: 'D107',
                NAME: '광/LED/반도체/디스플레이측정시험장비',
                ENG_NAME: 'Optical/LED/Semiconductor/Display Measurement Testing Machine',
            },
            {
                CODE: 'D108',
                NAME: '무선시스템측정시험장비',
                ENG_NAME: 'Wireless System Measurement Testing Machine',
            },
            {
                CODE: 'D109',
                NAME: '유무선네트워크측정시험장비',
                ENG_NAME: 'Wire-Wireless Network Measurement Testing Machine',
            },
            {
                CODE: 'D110',
                NAME: '안테나측정시험장비',
                ENG_NAME: 'Antenna Measurement Testing Machine',
            },
            {
                CODE: 'D2',
                NAME: '분석장비',
                ENG_NAME: 'Analyzing Apparatus',
            },
            {
                CODE: 'D200',
                NAME: '달리 분류되지 않는 분석장비',
                ENG_NAME: 'Other Analyzing Apparatus',
            },
            {
                CODE: 'D201',
                NAME: '벡터네트워크분석기',
                ENG_NAME: 'Vector Network Analyzer',
            },
            {
                CODE: 'D202',
                NAME: '스펙트럼분석기',
                ENG_NAME: 'Spectrum Analyzer',
            },
            {
                CODE: 'D203',
                NAME: '신호분석기',
                ENG_NAME: 'Signal Analyzer',
            },
            {
                CODE: 'D204',
                NAME: '논리분석기',
                ENG_NAME: 'Logic Analyzer',
            },
            {
                CODE: 'D3',
                NAME: '신호발생장비',
                ENG_NAME: 'Signal Generator',
            },
            {
                CODE: 'D300',
                NAME: '달리 분류되지 않는 신호발생장비',
                ENG_NAME: 'Other Signal Generators',
            },
            {
                CODE: 'D301',
                NAME: '아날로그신호발생기',
                ENG_NAME: 'Analog Signal Generator',
            },
            {
                CODE: 'D302',
                NAME: '임의파형발생장비',
                ENG_NAME: 'Arbitrary Waveform Generator',
            },
            {
                CODE: 'D303',
                NAME: '펄스발생장비',
                ENG_NAME: 'Pulse Generator',
            },
            {
                CODE: 'D304',
                NAME: '영상음성신호발생기',
                ENG_NAME: 'Image Audio Signal Generator',
            },
            {
                CODE: 'D4',
                NAME: '전력발생장비',
                ENG_NAME: 'Electricity Generator',
            },
            {
                CODE: 'D400',
                NAME: '달리 분류되지 않는 전력발생장비',
                ENG_NAME: 'Other Electricity Generators',
            },
            {
                CODE: 'D401',
                NAME: '무정전전원공급장치',
                ENG_NAME: 'Uninterruptible Power Supply',
            },
            {
                CODE: 'D402',
                NAME: '직류전원공급장치',
                ENG_NAME: 'Direct Current Power Supply',
            },
            {
                CODE: 'D403',
                NAME: '교류전원공급장치',
                ENG_NAME: 'Alternating Current Power Supply',
            },
            {
                CODE: 'D404',
                NAME: '교류/직류전원공급장치',
                ENG_NAME: 'Alternating Current/Direct Current Power Supply',
            },
            {
                CODE: 'D405',
                NAME: '전압/전류변환장치',
                ENG_NAME: 'Voltage/Ampere Converter',
            },
            {
                CODE: 'D406',
                NAME: '자동전압조정장치',
                ENG_NAME: 'Automatic Voltage Regulator',
            },
            {
                CODE: 'D407',
                NAME: '신재생에너지발전기',
                ENG_NAME: 'New Renewable Energy Generator',
            },
            {
                CODE: 'D408',
                NAME: '에너지저장시스템',
                ENG_NAME: 'Energy Storage System',
            },
            {
                CODE: 'D5',
                NAME: '자기력발생/측정장비',
                ENG_NAME: 'Magnetic Force Generating/Measuring Device',
            },
            {
                CODE: 'D500',
                NAME: '달리 분류되지 않는 자기력발생/측정장비',
                ENG_NAME: 'Other Magnetic Force Generating/Measuring Devices',
            },
            {
                CODE: 'D501',
                NAME: '자기력측정장비',
                ENG_NAME: 'Magnetic Force Measuring Device',
            },
            {
                CODE: 'D502',
                NAME: '자기력발생장비',
                ENG_NAME: 'Magnetic Force Generator',
            },
            {
                CODE: 'D6',
                NAME: '교정장비',
                ENG_NAME: 'Calibration Equipment',
            },
            {
                CODE: 'D600',
                NAME: '달리 분류되지 않는 교정장비',
                ENG_NAME: 'Other Calibration Equipment',
            },
            {
                CODE: 'D601',
                NAME: '전류교정기',
                ENG_NAME: 'Current Calibrator',
            },
            {
                CODE: 'D602',
                NAME: '전압교정기',
                ENG_NAME: 'Voltage Calibrator',
            },
            {
                CODE: 'D603',
                NAME: '주파수교정기',
                ENG_NAME: 'Frequency Calibrator',
            },
            {
                CODE: 'D604',
                NAME: '다기능교정기',
                ENG_NAME: 'Multifunction Calibrator',
            },
            {
                CODE: 'E',
                NAME: '데이터처리장비',
                ENG_NAME: 'Data Disposal Equipment',
            },
            {
                CODE: 'E0',
                NAME: '달리 분류되지 않는 데이터처리장비',
                ENG_NAME: 'Other Data Disposal Equipment',
            },
            {
                CODE: 'E1',
                NAME: '하드웨어',
                ENG_NAME: 'Hardware',
            },
            {
                CODE: 'E100',
                NAME: '달리 분류되지 않는 하드웨어',
                ENG_NAME: 'Other Hardware',
            },
            {
                CODE: 'E101',
                NAME: '고성능컴퓨터',
                ENG_NAME: 'High Performance Computer',
            },
            {
                CODE: 'E102',
                NAME: '슈퍼컴퓨터',
                ENG_NAME: 'Super Computer',
            },
            {
                CODE: 'E103',
                NAME: '서버',
                ENG_NAME: 'Server',
            },
            {
                CODE: 'E104',
                NAME: '저장장치',
                ENG_NAME: 'Storage Device',
            },
            {
                CODE: 'E105',
                NAME: '입/출력장치',
                ENG_NAME: 'Input/output Device',
            },
            {
                CODE: 'E106',
                NAME: '네트워크장치',
                ENG_NAME: 'Network Device',
            },
            {
                CODE: 'E2',
                NAME: '장비소프트웨어',
                ENG_NAME: 'Equipment Software',
            },
            {
                CODE: 'E200',
                NAME: '달리 분류되지 않는 장비소프트웨어',
                ENG_NAME: 'Other Equipment Software',
            },
            {
                CODE: 'E201',
                NAME: '데이터처리장비기반소프트웨어',
                ENG_NAME: 'Data Disposal Equipment Foundation Software',
            },
            {
                CODE: 'E202',
                NAME: '연구장비기반소프트웨어',
                ENG_NAME: 'Research Equipment Foundation Software',
            },
            {
                CODE: 'F',
                NAME: '물리적측정장비',
                ENG_NAME: 'Physical Measuring Equipment',
            },
            {
                CODE: 'F0',
                NAME: '달리 분류되지 않는 물리적측정장비',
                ENG_NAME: 'Other Physical Measuring Equipment',
            },
            {
                CODE: 'F1',
                NAME: '온도/열/습도/수분측정장비',
                ENG_NAME: 'Temperature/Heat/Humidity/Water Measuring Equipment',
            },
            {
                CODE: 'F100',
                NAME: '달리 분류되지 않는 온도/열/습도/수분측정장비',
                ENG_NAME: 'Other Temperature/Heat/Humidity/Water Measuring Equipment',
            },
            {
                CODE: 'F101',
                NAME: '온도/습도/수분측정기',
                ENG_NAME: 'Temperature/Humidity/Water Measuring Instrument',
            },
            {
                CODE: 'F102',
                NAME: '열분석기',
                ENG_NAME: 'Thermal Analyzer',
            },
            {
                CODE: 'F103',
                NAME: '열전도도/열상수측정기',
                ENG_NAME: 'Thermal Conductivity/Constant Measuring Instrument',
            },
            {
                CODE: 'F104',
                NAME: '열탈착기',
                ENG_NAME: 'Thermodesorber',
            },
            {
                CODE: 'F105',
                NAME: '투습도측정기',
                ENG_NAME: 'Vapor Permeability Measuring Instrument',
            },
            {
                CODE: 'F2',
                NAME: '길이/위치측정장비',
                ENG_NAME: 'Length/Location Measuring Instrument',
            },
            {
                CODE: 'F200',
                NAME: '달리 분류되지 않는 길이/위치측정장비',
                ENG_NAME: 'Other Length/Location Measuring Instruments',
            },
            {
                CODE: 'F201',
                NAME: '길이측정장비',
                ENG_NAME: 'Length Measuring Instrument',
            },
            {
                CODE: 'F202',
                NAME: '위치측정장비',
                ENG_NAME: 'Location Measuring Instrument',
            },
            {
                CODE: 'F3',
                NAME: '시간/주파수/속도/회전수측정장비',
                ENG_NAME: 'Time/Frequency/Speed/Revolution Measuring Equipment',
            },
            {
                CODE: 'F300',
                NAME: '달리 분류되지 않는 시간/주파수/속도/회전수측정장비',
                ENG_NAME: 'Other Time/Frequency/Speed/Revolution Measuring Equipment',
            },
            {
                CODE: 'F301',
                NAME: '원자시계',
                ENG_NAME: 'Atomic Clock',
            },
            {
                CODE: 'F302',
                NAME: '주파수계수기',
                ENG_NAME: 'Frequency Counter',
            },
            {
                CODE: 'F303',
                NAME: '파장계',
                ENG_NAME: 'Wavemeter',
            },
            {
                CODE: 'F304',
                NAME: '속도/회전수측정장비',
                ENG_NAME: 'Speed/Revolution Measuring Equipment',
            },
            {
                CODE: 'F4',
                NAME: '질량/무게/부피/밀도측정장비',
                ENG_NAME: 'Mass/Weight/Volume/Density Measuring Equipment',
            },
            {
                CODE: 'F400',
                NAME: '달리 분류되지 않는 질량/무게/부피/밀도측정장비',
                ENG_NAME: 'Other Mass/Weight/Volume/Density Measuring Equipment',
            },
            {
                CODE: 'F401',
                NAME: '전자저울',
                ENG_NAME: 'Electronic Scale',
            },
            {
                CODE: 'F402',
                NAME: '부피/밀도측정장비',
                ENG_NAME: 'Volume/Density Measuring Equipment',
            },
            {
                CODE: 'F5',
                NAME: '힘/토크/압력/진공측정장비',
                ENG_NAME: 'Power/Torque/Pressure/Vacuum Measuring Equipment',
            },
            {
                CODE: 'F500',
                NAME: '달리 분류되지 않는 힘/토크/압력/진공측정장비',
                ENG_NAME: 'Other Power/Torque/Pressure/Vacuum Measuring Equipment',
            },
            {
                CODE: 'F501',
                NAME: '동력계',
                ENG_NAME: 'Dynamometer',
            },
            {
                CODE: 'F502',
                NAME: '토크계',
                ENG_NAME: 'Torquemeter',
            },
            {
                CODE: 'F503',
                NAME: '부하시험기',
                ENG_NAME: 'Load Tester',
            },
            {
                CODE: 'F504',
                NAME: '압력/진공측정장비',
                ENG_NAME: 'Pressure/Vacuum Measuring Equipment',
            },
            {
                CODE: 'F6',
                NAME: '음향/소음/진동/충격측정장비',
                ENG_NAME: 'Sound/Noise/Vibration/Impact Measuring Equipment',
            },
            {
                CODE: 'F600',
                NAME: '달리 분류되지 않는 음향/소음/진동/충격측정장비',
                ENG_NAME: 'Other Sound/Noise/Vibration/Impact Measuring Equipment',
            },
            {
                CODE: 'F601',
                NAME: '소음계/잡음지수분석장비',
                ENG_NAME: 'Noisemeter/Noise Factor Analyzing Apparatus',
            },
            {
                CODE: 'F602',
                NAME: '음향분석/음향표정장비',
                ENG_NAME: 'Acoustic Analysis/Acoustic Source Equipment',
            },
            {
                CODE: 'F603',
                NAME: '진동계',
                ENG_NAME: 'Vibrometer',
            },
            {
                CODE: 'F604',
                NAME: '지진계',
                ENG_NAME: 'Sesimometer',
            },
            {
                CODE: 'F605',
                NAME: '평형시험/충격시험기',
                ENG_NAME: 'Equilibrium Test/Impact Tester',
            },
            {
                CODE: 'F7',
                NAME: '유체유량역학측정장비',
                ENG_NAME: 'Fluid Flow Mechanics Measuring Equipment',
            },
            {
                CODE: 'F700',
                NAME: '달리 분류되지 않는 유체유량역학측정장비',
                ENG_NAME: 'Other Fluid Flow Mechanics Measuring Equipment',
            },
            {
                CODE: 'F701',
                NAME: '점도계',
                ENG_NAME: 'Viscometer',
            },
            {
                CODE: 'F702',
                NAME: '유속계',
                ENG_NAME: 'Hydrometer',
            },
            {
                CODE: 'F703',
                NAME: '풍향풍속계',
                ENG_NAME: 'Anemometer',
            },
            {
                CODE: 'F704',
                NAME: '유량계/수량계',
                ENG_NAME: 'Flowmeter/Water Meter',
            },
            {
                CODE: 'F8',
                NAME: '표면특성측정장비',
                ENG_NAME: 'Surface Property Measuring Equipment',
            },
            {
                CODE: 'F800',
                NAME: '달리 분류되지 않는 표면특성측정장비',
                ENG_NAME: 'Other Surface Property Measuring Equipment',
            },
            {
                CODE: 'F801',
                NAME: '표면장력/접촉각측정장비',
                ENG_NAME: 'Surface Tension/Contact Angle Measuring Equipment',
            },
            {
                CODE: 'F802',
                NAME: '비표면적/공극도측정장비',
                ENG_NAME: 'Specific Surface Area/Porosity Measuring Equipment',
            },
            {
                CODE: 'F803',
                NAME: '가스흡탈착측정장비',
                ENG_NAME: 'Gas Absorption Desorption Measuring Equipment',
            },
            {
                CODE: 'F804',
                NAME: '표면거칠기/미세구조측정장비',
                ENG_NAME: 'Surface Roughness/Microstructure Measuring Equipment',
            },
            {
                CODE: 'G',
                NAME: '임상의료장비',
                ENG_NAME: 'Clinical or Medical Equipment',
            },
            {
                CODE: 'G0',
                NAME: '달리 분류되지 않는 임상의료장비',
                ENG_NAME: 'Other Clinical or Medical Equipment',
            },
            {
                CODE: 'G1',
                NAME: '임상진단/영상장비',
                ENG_NAME: 'Clinical Diagnosis/Image Equipment',
            },
            {
                CODE: 'G100',
                NAME: '달리 분류되지 않는 임상진단/영상장비',
                ENG_NAME: 'Other Clinical Diagnosis /Image Equipment',
            },
            {
                CODE: 'G101',
                NAME: '임상진단용엑스선장비',
                ENG_NAME: 'X-ray Equipment for Clinical Diagnosis',
            },
            {
                CODE: 'G102',
                NAME: '임상진단용컴퓨터단층촬영장비',
                ENG_NAME: 'Computer Tomography (CT) Equipment for Clinical Diagnosis',
            },
            {
                CODE: 'G103',
                NAME: '임상진단용자기공명영상장비',
                ENG_NAME: 'Magnetic Resonance Imaging (MRI) Equipment for Clinical Diagnosis',
            },
            {
                CODE: 'G104',
                NAME: '임상진단용혈관조영술장비',
                ENG_NAME: 'Angiography Equipment for Clinical Diagnosis',
            },
            {
                CODE: 'G105',
                NAME: '임상진단용양전자/단일광자단층촬영장비',
                ENG_NAME: 'Positron/Single Proton Tomography Equipment for Clinical Diagnosis',
            },
            {
                CODE: 'G106',
                NAME: '임상진단용초음파장비',
                ENG_NAME: 'Ultrasonic Waves Equipment for Clinical Diagnosis',
            },
            {
                CODE: 'G107',
                NAME: '임상진단용방사선장비',
                ENG_NAME: 'Radiation Equipment for Clinical Diagnosis',
            },
            {
                CODE: 'G108',
                NAME: '임상진단용가속기',
                ENG_NAME: 'Accelerator for Clinical Diagnosis',
            },
            {
                CODE: 'G2',
                NAME: '생체측정/진단장비',
                ENG_NAME: 'Biometric/Biodiagnostic Equipment',
            },
            {
                CODE: 'G200',
                NAME: '달리 분류되지 않는 생체측정/진단장비',
                ENG_NAME: 'Other Biometric/Biodiagnostic Equipment',
            },
            {
                CODE: 'G201',
                NAME: '심혈관측정/진단장비',
                ENG_NAME: 'Cardiovascular Measurement/Diagnostic Equipment',
            },
            {
                CODE: 'G202',
                NAME: '호흡기측정/진단장비',
                ENG_NAME: 'Respiratory Measurement/Diagnostic Equipment',
            },
            {
                CODE: 'G203',
                NAME: '뇌신경측정/진단장비',
                ENG_NAME: 'Cranial Nerves Measurement/Diagnostic Equipment',
            },
            {
                CODE: 'G204',
                NAME: '근전도측정/진단장비',
                ENG_NAME: 'Electromyogram Measurement/Diagnostic Equipment',
            },
            {
                CODE: 'G205',
                NAME: '피부측정/진단장비',
                ENG_NAME: 'Skin Measurement/Diagnostic Equipment',
            },
            {
                CODE: 'G3',
                NAME: '임상진단/분석장비',
                ENG_NAME: 'Clinical Diagnosis/Analysis Apparatus',
            },
            {
                CODE: 'G300',
                NAME: '달리 분류되지 않는 임상진단/분석장비',
                ENG_NAME: 'Other Clinical Diagnosis/Analysis Apparatus',
            },
            {
                CODE: 'G301',
                NAME: '혈액검사/분석장비',
                ENG_NAME: 'Blood Test/ Analysis Apparatus',
            },
            {
                CODE: 'G302',
                NAME: '체액검사/분석장비',
                ENG_NAME: 'Body Fluids Test/ Analysis Apparatus',
            },
            {
                CODE: 'G4',
                NAME: '전문의학용특수장비',
                ENG_NAME: 'Special Equipment for Special Medicine',
            },
            {
                CODE: 'G400',
                NAME: '달리 분류되지 않는 전문의학용특수장비',
                ENG_NAME: 'Other Special Equipment for Special Medicine',
            },
            {
                CODE: 'G401',
                NAME: '치과용검사장비',
                ENG_NAME: 'Dentist Testing Machine ',
            },
            {
                CODE: 'G402',
                NAME: '안과용검사장비',
                ENG_NAME: 'Ophthalmology Testing Machine ',
            },
            {
                CODE: 'G403',
                NAME: '외과용검사장비',
                ENG_NAME: 'Surgery Testing Machine',
            },
            {
                CODE: 'G404',
                NAME: '이비인후과용검사장비',
                ENG_NAME: 'Otolaryngology Testing Machine ',
            },
            {
                CODE: 'G405',
                NAME: '비뇨기과용검사장비',
                ENG_NAME: 'Urology Testing Machine ',
            },
            {
                CODE: 'G406',
                NAME: '수의학/실험동물검사장비',
                ENG_NAME: 'Veterinary Science/Experimental Animal Testing Machine',
            },
            {
                CODE: 'G407',
                NAME: '산부인과용검사장비',
                ENG_NAME: 'Obstetrics and Gynecology Testing Machine',
            },
            {
                CODE: 'G408',
                NAME: '의료교육장비',
                ENG_NAME: 'Medical Education Equipment',
            },
            {
                CODE: 'H',
                NAME: '환경조성/생산/사육시설',
                ENG_NAME: 'Environment Development/<br>Production/Breeding Facility',
            },
            {
                CODE: 'H0',
                NAME: '달리 분류되지 않는 환경조성/생산/사육시설',
                ENG_NAME: 'Other Environment Development/Production/Breeding Facilities',
            },
            {
                CODE: 'H1',
                NAME: '환경조성형시설',
                ENG_NAME: 'Environment Development Facility',
            },
            {
                CODE: 'H100',
                NAME: '달리 분류되지 않는 환경조성형시설',
                ENG_NAME: 'Other Environment Development Facilities',
            },
            {
                CODE: 'H101',
                NAME: '진공/압력/밀폐시설',
                ENG_NAME: 'Vacuum/Pressure/Sealing Facility',
            },
            {
                CODE: 'H102',
                NAME: '고온/난방시설',
                ENG_NAME: 'High-Temperature/Heating Facility',
            },
            {
                CODE: 'H103',
                NAME: '저온/냉동/냉각시설',
                ENG_NAME: 'Low-Temperature/Freezing/Cooling Facility',
            },
            {
                CODE: 'H104',
                NAME: '무균/청정시설',
                ENG_NAME: 'Asepsis/Cleanliness Facility',
            },
            {
                CODE: 'H105',
                NAME: '무향/잔향/진동시설',
                ENG_NAME: 'Anechoic/Reverberation/Vibration Facility',
            },
            {
                CODE: 'H106',
                NAME: '항온/항습시설',
                ENG_NAME: 'Thermo/Hygrostat Facility',
            },
            {
                CODE: 'H107',
                NAME: '풍동/수조시설',
                ENG_NAME: 'Wind Tunnel/Water Tank Facility',
            },
            {
                CODE: 'H108',
                NAME: '충격/충돌/주행시험시설',
                ENG_NAME: 'Impact/Collision/Driving Test Facility',
            },
            {
                CODE: 'H109',
                NAME: '핵분열/핵융합시험시설',
                ENG_NAME: 'Nuclear Fission/ Nuclear Fusion Test Facility',
            },
            {
                CODE: 'H2',
                NAME: '이동형시설',
                ENG_NAME: 'Mobile Facility',
            },
            {
                CODE: 'H200',
                NAME: '달리 분류되지 않는 이동형시설',
                ENG_NAME: 'Other Mobile Facilities',
            },
            {
                CODE: 'H201',
                NAME: '연구용선박',
                ENG_NAME: 'Vessel for Research',
            },
            {
                CODE: 'H202',
                NAME: '연구용항공기',
                ENG_NAME: 'Aircraft for Research',
            },
            {
                CODE: 'H203',
                NAME: '연구용자동차',
                ENG_NAME: 'Car for Research',
            },
            {
                CODE: 'H3',
                NAME: '생물사육/실험시설',
                ENG_NAME: 'Living Organism Breeding/Experiment Facility',
            },
            {
                CODE: 'H300',
                NAME: '달리 분류되지 않는 생물사육/실험시설',
                ENG_NAME: 'Other Living Organism Breeding/Experiment Facilities',
            },
            {
                CODE: 'H301',
                NAME: '동물사육/실험시설',
                ENG_NAME: 'Animal Breeding/Experiment Facility',
            },
            {
                CODE: 'H302',
                NAME: '수생생물사육/실험시설',
                ENG_NAME: 'Aquarium Animal Breeding/Experiment Facility',
            },
            {
                CODE: 'H303',
                NAME: '식물생장/실험시설',
                ENG_NAME: 'Plant Growth/Experiment Facility',
            },
            {
                CODE: 'H304',
                NAME: '미생물생장/실험시설',
                ENG_NAME: 'Microbe Growth/Experiment Facility',
            },
            {
                CODE: 'H4',
                NAME: '생산시설',
                ENG_NAME: 'Manufacturing Facility',
            },
            {
                CODE: 'H400',
                NAME: '달리 분류되지 않는 생산시설',
                ENG_NAME: 'Other Manufacturing Facility',
            },
            {
                CODE: 'H401',
                NAME: '식품/의약품생산시설',
                ENG_NAME: 'Food/Drug Manufacturing Facility',
            },
            {
                CODE: 'H402',
                NAME: '동위원소생산시설',
                ENG_NAME: 'Isotope Manufacturing Facility',
            },
            {
                CODE: 'H403',
                NAME: '화합물생산시설',
                ENG_NAME: 'Compound Manufacturing Facility',
            },
            {
                CODE: 'H5',
                NAME: '방사능처리/차폐시설',
                ENG_NAME: 'Radioactivity Disposal/Incineration Facility',
            },
            {
                CODE: 'H500',
                NAME: '달리 분류되지 않는 방사능처리/차폐시설',
                ENG_NAME: 'Other Radioactivity Disposal/Incineration Facility',
            },
            {
                CODE: 'H501',
                NAME: '방사능폐기물처리시설',
                ENG_NAME: 'Radioactivity Waste Disposal Facility',
            },
            {
                CODE: 'H502',
                NAME: '방사능차폐시설',
                ENG_NAME: 'Radiation Shielding Facility',
            },
            {
                CODE: 'H6',
                NAME: '폐기물처리시설',
                ENG_NAME: 'Waste Disposal Facility',
            },
            {
                CODE: 'H600',
                NAME: '달리 분류되지 않는 폐기물처리시설',
                ENG_NAME: 'Other Waste Disposal Facility',
            },
            {
                CODE: 'H601',
                NAME: '폐기물소각시설',
                ENG_NAME: 'Waste Incineration Facility',
            },
            {
                CODE: 'H602',
                NAME: '페수처리/정화시설',
                ENG_NAME: 'Waste Water Disposal/Purifying Facility',
            },
        ],
    },
    {
        NAME: '5대중점투자분야코드',
        codeList: [
            {
                CODE: '01',
                NAME: '국가주도기술 핵심역량 확보',
                ENG_NAME: 'State-Dominated Development of Technology Core Ability',
            },
            {
                CODE: '02',
                NAME: '글로벌 이슈대응 연구개발 추진',
                ENG_NAME: 'Forwarding Research and Development of Global Issue Response',
            },
            {
                CODE: '03',
                NAME: '기초과학·융합기술 연구개발 활성화',
                ENG_NAME: 'Basic · Foundation · Fusion Technology Development Vitalization',
            },
            {
                CODE: '04',
                NAME: '신산업 창출 핵심기술개발강화',
                ENG_NAME: 'Core Technology Development Strengthening for Fresh Enterprise Creation',
            },
            {
                CODE: '05',
                NAME: '주력기간산업 기술 고도화',
                ENG_NAME: 'Key Basic Industry Acceleration',
            },
        ],
    },
    {
        NAME: '6T관련기술코드',
        codeList: [
            {
                CODE: '010100',
                NAME: '핵심부품',
                ENG_NAME: 'Key Component',
            },
            {
                CODE: '010000',
                NAME: 'IT분야',
                ENG_NAME: 'IT Field',
            },
            {
                CODE: '010111',
                NAME: '테라비트급 광통신 부품기술',
                ENG_NAME: 'Optical Technique of Terabit Component ',
            },
            {
                CODE: '010112',
                NAME: '집적회로기술',
                ENG_NAME: 'Integrated Circuit Technology',
            },
            {
                CODE: '010113',
                NAME: '차세대디스플레이기술',
                ENG_NAME: 'Next Generation Display Technology',
            },
            {
                CODE: '010114',
                NAME: '고밀도 정보저장장치 기술',
                ENG_NAME: 'High-Density Information Storage Unit Technology',
            },
            {
                CODE: '010115',
                NAME: '기타 정보통신 부품기술',
                ENG_NAME: 'Other Technology of Information and Communication Components ',
            },
            {
                CODE: '010200',
                NAME: '차세대 네트워크 기반',
                ENG_NAME: 'Next Generation Network Base',
            },
            {
                CODE: '010211',
                NAME: '4세대 이동통신',
                ENG_NAME: '4th Generation Mobile Communication System',
            },
            {
                CODE: '010212',
                NAME: '대용량 광전송 시스템기술',
                ENG_NAME: 'High-capacity Optical Transmission Technology',
            },
            {
                CODE: '010213',
                NAME: '고속인터넷 네트워킹기술',
                ENG_NAME: 'High-Speed Internet Networking Technology',
            },
            {
                CODE: '010214',
                NAME: '기타 네트워크기술',
                ENG_NAME: 'Other Network Technologies',
            },
            {
                CODE: '010300',
                NAME: '정보처리 시스템 및 S/W',
                ENG_NAME: 'Information Processing System and S/W',
            },
            {
                CODE: '010311',
                NAME: '멀티미디어 단말기 및 운영체계기술',
                ENG_NAME: 'Multimedia Terminal and Operating System Technology',
            },
            {
                CODE: '010312',
                NAME: '정보보안 및 암호기술',
                ENG_NAME: 'Information Security and Cryptographic Technique',
            },
            {
                CODE: '010313',
                NAME: '전자상거래 기술',
                ENG_NAME: 'E-commerce Technology',
            },
            {
                CODE: '010314',
                NAME: '신호처리기술(영상·음성처리·인식·합성)',
                ENG_NAME:
                    'Signal Processing Technology (Image·Speech Processing·Recognition·Composition)',
            },
            {
                CODE: '010315',
                NAME: '정보검색 및 DB기술',
                ENG_NAME: 'Information Search and DB Technology',
            },
            {
                CODE: '010316',
                NAME: '기타 정보처리시스템 및 S/W 기술',
                ENG_NAME: 'Other Information Processing System and S/W Technology',
            },
            {
                CODE: '010400',
                NAME: '기타 정보기술',
                ENG_NAME: 'Other Information Technologies',
            },
            {
                CODE: '010411',
                NAME: '기타 정보기술',
                ENG_NAME: 'Other Information Technologies',
            },
            {
                CODE: '020000',
                NAME: 'BT분야',
                ENG_NAME: 'BT Area',
            },
            {
                CODE: '020100',
                NAME: '기초·기반기술',
                ENG_NAME: 'Basic · Foundation Technology',
            },
            {
                CODE: '020111',
                NAME: '유전체기반 기술',
                ENG_NAME: 'Genome-based Technology',
            },
            {
                CODE: '020112',
                NAME: '단백질체 연구',
                ENG_NAME: 'Proteome Research',
            },
            {
                CODE: '020113',
                NAME: '생물정보학 기술',
                ENG_NAME: 'Bioinformatics Technology',
            },
            {
                CODE: '020114',
                NAME: '생명현상 및 기능연구',
                ENG_NAME: 'Vital Phenomenon and Function Research',
            },
            {
                CODE: '020115',
                NAME: '뇌신경과학 연구',
                ENG_NAME: 'Neuroscience Research',
            },
            {
                CODE: '020116',
                NAME: '생물공정 기술',
                ENG_NAME: 'Bioprocess Technology',
            },
            {
                CODE: '020117',
                NAME: '생명공학 산물 안전성 및 유효성 평가기술',
                ENG_NAME: 'Evaluation Technology of Biotechnology Products Safety and Validity ',
            },
            {
                CODE: '020118',
                NAME: '바이오칩 개발기술',
                ENG_NAME: 'Biochip Development Technology',
            },
            {
                CODE: '020119',
                NAME: '기타기초·기반기술',
                ENG_NAME: 'Other Basic · Foundation Technologies',
            },
            {
                CODE: '020200',
                NAME: '보건의료관련응용',
                ENG_NAME: 'Health and Medical Application',
            },
            {
                CODE: '020211',
                NAME: '바이오신약 개발기술',
                ENG_NAME: 'Bio New Medicine Development Technology',
            },
            {
                CODE: '020212',
                NAME: '난치성 질환 치료기술',
                ENG_NAME: 'Chronic Disease Treatment Technology',
            },
            {
                CODE: '020213',
                NAME: '생체조직 재생기술',
                ENG_NAME: 'Tissue Renewal Technology',
            },
            {
                CODE: '020214',
                NAME: '유전자 치료기술',
                ENG_NAME: 'Gene Therapy Technology',
            },
            {
                CODE: '020215',
                NAME: '기능성 바이오소재 기반기술',
                ENG_NAME: 'Functional Biomaterial Foundation Technology',
            },
            {
                CODE: '020216',
                NAME: '한방응용기술',
                ENG_NAME: 'Chinese Medicine Application Technology',
            },
            {
                CODE: '020217',
                NAME: '의과학·의공학 기술',
                ENG_NAME: 'Medical Science · Medical Engineering Technology',
            },
            {
                CODE: '020218',
                NAME: '식품생명공학기술',
                ENG_NAME: 'Food Biotechnology Technique',
            },
            {
                CODE: '020219',
                NAME: '기타 보건의료 관련 응용기술',
                ENG_NAME: 'Other Health and Medical Application Technology',
            },
            {
                CODE: '020300',
                NAME: '농업·해양·환경 관련 응용',
                ENG_NAME: 'Agriculture · Marine · Environment Application',
            },
            {
                CODE: '020311',
                NAME: '유전자 변형 생물체 개발기술',
                ENG_NAME: 'Genetically Modified Organism Development Technology',
            },
            {
                CODE: '020312',
                NAME: '농업·해양 생물자원의 보존 및 이용기술',
                ENG_NAME:
                    'Preservation and Utilization Technology of Agriculture · Marine Biological Resource ',
            },
            {
                CODE: '020313',
                NAME: '동식물 병해충 제어기술',
                ENG_NAME: 'Disease and Insect Pest Control Technique of Plants and Animals',
            },
            {
                CODE: '020314',
                NAME: '환경 생명공학기술',
                ENG_NAME: 'Environment Biotechnology Technique',
            },
            {
                CODE: '020315',
                NAME: '기타 농업·해양·환경 응용기술',
                ENG_NAME: 'Other Agriculture · Marine · Environment Application Technology',
            },
            {
                CODE: '030000',
                NAME: 'NT 분야',
                ENG_NAME: 'NT Area',
            },
            {
                CODE: '030100',
                NAME: '나노소자 및 시스템',
                ENG_NAME: 'Nano Device and System',
            },
            {
                CODE: '030111',
                NAME: '나노전자 소자기술',
                ENG_NAME: 'Nanoelectronic Element Technology',
            },
            {
                CODE: '030112',
                NAME: '나노정보 저장기술',
                ENG_NAME: 'Nano Information Storage Technology',
            },
            {
                CODE: '030113',
                NAME: '가변 파장 광소자기술',
                ENG_NAME: 'Tunable Optical Device Technology',
            },
            {
                CODE: '030114',
                NAME: '나노 photonics기술',
                ENG_NAME: 'Nano Photonics Technology',
            },
            {
                CODE: '030115',
                NAME: '기타 나노소자 및 시스템기술',
                ENG_NAME: 'Other Nano Devices and System Technologies',
            },
            {
                CODE: '030200',
                NAME: '나노소재',
                ENG_NAME: 'Nano Material',
            },
            {
                CODE: '030211',
                NAME:
                    '나노소재기술(나노분말소재, 광학용 나노소재, 고기능 시너지 소재, 촉매·환경·기능소재에 중점)',
                ENG_NAME:
                    'Nano Material Technology (Emphasis on Nanopowder Material, Optical Nano Material, High Functional Synergy Material, Catalyst · Environment · Function)',
            },
            {
                CODE: '030212',
                NAME: '기타 나노소재기술',
                ENG_NAME: 'Other Nano Material Technologies',
            },
            {
                CODE: '030300',
                NAME: '나노 바이오 보건',
                ENG_NAME: 'Nano Bio Health',
            },
            {
                CODE: '030311',
                NAME: '나노 바이오 물질 합성 및 분석기술',
                ENG_NAME: 'Nano Bio Material Synthesis and Analysis Technology',
            },
            {
                CODE: '030312',
                NAME: '의약 약물전달 시스템',
                ENG_NAME: 'Drug Delivery System',
            },
            {
                CODE: '030313',
                NAME: '기타 나노바이오보건기술',
                ENG_NAME: 'Other Nano Bio Health Technology',
            },
            {
                CODE: '030400',
                NAME: '나노기반·공정',
                ENG_NAME: 'Nano Foundation · Process',
            },
            {
                CODE: '030411',
                NAME: '원자·분자 레벨 물질 조작기술',
                ENG_NAME: 'Atom · Molecule Level Material Operating Technology',
            },
            {
                CODE: '030412',
                NAME: '나노 측정기술(100 nm이하)',
                ENG_NAME: 'Nano Measurement Technology (less than 100 nm)',
            },
            {
                CODE: '030413',
                NAME: '나노모사기술',
                ENG_NAME: 'Nano Simulation Technology',
            },
            {
                CODE: '030414',
                NAME: '계면 혹은 표면의 나노구조화기술',
                ENG_NAME: 'Nanostructured Technology of Interface or Surface',
            },
            {
                CODE: '030415',
                NAME: '나노 신기능 분자합성기술',
                ENG_NAME: 'Nano New Function Molecule Synthesis Technology',
            },
            {
                CODE: '030416',
                NAME: '나노패터닝 공정기술',
                ENG_NAME: 'Nano Patterning Process Technology',
            },
            {
                CODE: '030417',
                NAME: '나노화학 공정기술',
                ENG_NAME: 'Nanochemical Process Technology',
            },
            {
                CODE: '030418',
                NAME: '기타 나노기반 공정기술',
                ENG_NAME: 'Other Nano Foundation Process Technologies',
            },
            {
                CODE: '040000',
                NAME: 'ST 분야',
                ENG_NAME: 'ST Area',
            },
            {
                CODE: '040100',
                NAME: '위성기술',
                ENG_NAME: 'Satellite Technology',
            },
            {
                CODE: '040111',
                NAME: '위성설계 및 개발기술',
                ENG_NAME: 'Satellite Design and Development Technology',
            },
            {
                CODE: '040112',
                NAME: '위성관제기술',
                ENG_NAME: 'Satellite Control Technology',
            },
            {
                CODE: '040113',
                NAME: '차세대 통신위성 탑재체기술',
                ENG_NAME: 'Next Generation Communication Satellite Payload Technology',
            },
            {
                CODE: '040114',
                NAME: '기타 위성기술',
                ENG_NAME: 'Other Satellite Technology',
            },
            {
                CODE: '040200',
                NAME: '발사체 기술',
                ENG_NAME: 'Projectile Technology',
            },
            {
                CODE: '040211',
                NAME: '로켓추진 기관기술',
                ENG_NAME: 'Rocket Propulsion System Technology',
            },
            {
                CODE: '040212',
                NAME: '소형위성 발사체개발기술',
                ENG_NAME: 'Small Satellite Projectile Development Technology',
            },
            {
                CODE: '040213',
                NAME: '발사운용, 통제 및 관제기술',
                ENG_NAME: 'Launch Operation and Control Technology',
            },
            {
                CODE: '040214',
                NAME: '기타 발사체기술',
                ENG_NAME: 'Other Projectile Technology',
            },
            {
                CODE: '040300',
                NAME: '항공기 기술',
                ENG_NAME: 'Aircraft Technology',
            },
            {
                CODE: '040311',
                NAME: '항공기 체계종합 및 비행성능기반기술',
                ENG_NAME: 'Aircraft System  and Flight Performance Foundation Technology',
            },
            {
                CODE: '040312',
                NAME: '지능형 자율비행 무인비행기기 시스템(UAV)기술',
                ENG_NAME: 'Intelligent Auto Flight Unmanned Aerial Vehicle (UAV) Technology',
            },
            {
                CODE: '040313',
                NAME: '다목적 헬리콥터기술개발',
                ENG_NAME: 'Multi-Purpose Helicopter Technology Development',
            },
            {
                CODE: '040314',
                NAME: '기타항공기기술',
                ENG_NAME: 'Other Aircraft Technology',
            },
            {
                CODE: '040400',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
            {
                CODE: '040411',
                NAME: '기타 우주항공기술',
                ENG_NAME: 'Other Aerospace Technology',
            },
            {
                CODE: '050000',
                NAME: 'ET 분야',
                ENG_NAME: 'ET Area',
            },
            {
                CODE: '050100',
                NAME: '환경기반',
                ENG_NAME: 'Environment Foundation',
            },
            {
                CODE: '050111',
                NAME: '대기오염물질 저감 및 제거기술',
                ENG_NAME: 'Air Pollution Material Reduction and Carrying Technology',
            },
            {
                CODE: '050112',
                NAME: '자연환경·오염토양·지하수의 정화·복원기술',
                ENG_NAME:
                    'Cleanup and Remediation Technology of Natural Environment · Polluted Soil · Groundwater',
            },
            {
                CODE: '050113',
                NAME: '수질오염처리 및 재이용기술',
                ENG_NAME: 'Water Pollution Disposal and Reuse Technology',
            },
            {
                CODE: '050114',
                NAME: '폐기물 처리 및 활용기술',
                ENG_NAME: 'Waste Disposal and Use Technology',
            },
            {
                CODE: '050115',
                NAME: '환경관리·정보 및 시스템기술',
                ENG_NAME: 'Environment Management · Information and System Technology',
            },
            {
                CODE: '050116',
                NAME: '기타 환경기반기술',
                ENG_NAME: 'Other Environment Foundation Technology',
            },
            {
                CODE: '050200',
                NAME: '에너지',
                ENG_NAME: 'Energy',
            },
            {
                CODE: '050211',
                NAME: '에너지소재 기술',
                ENG_NAME: 'Energy Material Technology',
            },
            {
                CODE: '050212',
                NAME: '미활용 에너지 이용기술',
                ENG_NAME: 'Unused Energy Utilization Technology',
            },
            {
                CODE: '050213',
                NAME: '고효율 반응분리공정기술',
                ENG_NAME: 'High Efficiency Technology of Reactive Separation Process ',
            },
            {
                CODE: '050214',
                NAME: '연료전지기술',
                ENG_NAME: 'Fuel Cell Technology',
            },
            {
                CODE: '050215',
                NAME: '수소생산 이용기술',
                ENG_NAME: 'Hydrogen Production and Use Technology',
            },
            {
                CODE: '050216',
                NAME: '바이오에너지 기술',
                ENG_NAME: 'Bio Energy Technology',
            },
            {
                CODE: '050217',
                NAME: '에너지저장 이용기술',
                ENG_NAME: 'Energy Storage Use Technology',
            },
            {
                CODE: '050218',
                NAME: '기타 에너지기술',
                ENG_NAME: 'Other Energy Technology',
            },
            {
                CODE: '050300',
                NAME: '청정생산',
                ENG_NAME: 'Clean Production',
            },
            {
                CODE: '050311',
                NAME: '청정원천공정 기술',
                ENG_NAME: 'Clean Source Process Technology',
            },
            {
                CODE: '050312',
                NAME: '환경친화형소재(Eco-material)개발기술',
                ENG_NAME: 'Environment-Friendly Material (Eco-material) Development Technology',
            },
            {
                CODE: '050313',
                NAME: '유해성 원부재료 대체기술',
                ENG_NAME: 'Hazardous Raw Material Replacement Technology',
            },
            {
                CODE: '050314',
                NAME: '공정내재자원화(Internal Recycle) 기술',
                ENG_NAME: 'Process Internal Material (Internal Recycle) Technology',
            },
            {
                CODE: '050315',
                NAME: '기타 청정생산기술',
                ENG_NAME: 'Other Clean Production Technology',
            },
            {
                CODE: '050400',
                NAME: '해양환경',
                ENG_NAME: 'Marine Environment',
            },
            {
                CODE: '050411',
                NAME: '해양환경 관리기술',
                ENG_NAME: 'Marine Environment Management Technology',
            },
            {
                CODE: '050412',
                NAME: '연안생태계 복원기술',
                ENG_NAME: 'coastal Ecosystem Restoration Technology',
            },
            {
                CODE: '050413',
                NAME: '기타 해양환경기술',
                ENG_NAME: 'Other Marine Environment Technology',
            },
            {
                CODE: '060000',
                NAME: 'CT 분야',
                ENG_NAME: 'CT Area',
            },
            {
                CODE: '060100',
                NAME: '문화 컨텐츠',
                ENG_NAME: 'Cultural Contents',
            },
            {
                CODE: '060111',
                NAME: '가상현실 및 인공지능 응용기술',
                ENG_NAME: 'Virtual Reality and Artificial Intelligence Application Technology',
            },
            {
                CODE: '060112',
                NAME: '디지털영상·음향 및 디자인기술',
                ENG_NAME: 'Digital Image · Sound and Design Technology',
            },
            {
                CODE: '060113',
                NAME: '디지털 컨텐츠 저작도구',
                ENG_NAME: 'Digital Contents Authoring Tool',
            },
            {
                CODE: '060114',
                NAME: '게임엔진 제작 및 기반기술',
                ENG_NAME: 'Game Engine Production and Foundation Technology',
            },
            {
                CODE: '060115',
                NAME: '기타 문화컨텐츠기술',
                ENG_NAME: 'Other Cultural Contents Technology',
            },
            {
                CODE: '060200',
                NAME: '생활문화 (사이버 커뮤니케이션 등)',
                ENG_NAME: 'Living Culture (Cyber Communication, etc.)',
            },
            {
                CODE: '060211',
                NAME: '사이버 커뮤니케이션 기술',
                ENG_NAME: 'Cyber Communication Technology',
            },
            {
                CODE: '060212',
                NAME: '인터엑티브 미디어기술',
                ENG_NAME: 'Interactive Media Technology',
            },
            {
                CODE: '060213',
                NAME: '제품디자인기술',
                ENG_NAME: 'Product Design Technology',
            },
            {
                CODE: '060214',
                NAME: '기타 생활문화기술',
                ENG_NAME: 'Other Living Culture Technology',
            },
            {
                CODE: '060300',
                NAME: '문화유산',
                ENG_NAME: 'Cultural Heritage',
            },
            {
                CODE: '060311',
                NAME: '문화원형 복원기술',
                ENG_NAME: 'Cultural Archetype Restoration Technology',
            },
            {
                CODE: '060312',
                NAME: '기타 문화유산기술',
                ENG_NAME: 'Other Cultural Heritage Technologies',
            },
            {
                CODE: '070000',
                NAME: '위의 미래유망신기술(6T) 103개 세분류에 속하지 않는 기타 연구',
                ENG_NAME:
                    'Other Researches Not Included in 103 New Future Promising Technologies(6T) Above',
            },
        ],
    },
    {
        NAME: '계속과제여부구분',
        codeList: [
            {
                CODE: '1',
                NAME: '신규',
                ENG_NAME: 'New',
            },
            {
                CODE: '2',
                NAME: '계속',
                ENG_NAME: 'Continue',
            },
            {
                CODE: '3',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '공동활용 이용방법코드',
        codeList: [
            {
                CODE: '01',
                NAME: '이용자 직접사용',
                ENG_NAME: 'User Direct Utilization',
            },
            {
                CODE: '02',
                NAME: '분석시험 의뢰',
                ENG_NAME: 'Request Analysis Test',
            },
            {
                CODE: '03',
                NAME: '모두 가능',
                ENG_NAME: 'All Possible',
            },
            {
                CODE: '04',
                NAME: '대여',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '이용자 직접사용 + 분석ㆍ시험 의뢰',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '이용자 직접사용 + 대여',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '분석ㆍ시험 의뢰 + 대여',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '공동활용 허용범위코드',
        codeList: [
            {
                CODE: '01',
                NAME: '기관내부활용',
                ENG_NAME: 'Internal Utilization in Institution',
            },
            {
                CODE: '02',
                NAME: '기관외부활용',
                ENG_NAME: 'External Utilization in Institution',
            },
        ],
    },
    {
        NAME: '과제수행부처·청명',
        codeList: [
            {
                CODE: 'N05',
                NAME: '감사원',
                ENG_NAME: null,
            },
            {
                CODE: 'P08',
                NAME: '감사원',
                ENG_NAME: null,
            },
            {
                CODE: 'N37',
                NAME: '경찰청',
                ENG_NAME: null,
            },
            {
                CODE: 'P09',
                NAME: '국가정보원',
                ENG_NAME: null,
            },
            {
                CODE: 'N40',
                NAME: '공정거래위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P10',
                NAME: '국무조정실',
                ENG_NAME: null,
            },
            {
                CODE: 'N27',
                NAME: '관세청',
                ENG_NAME: null,
            },
            {
                CODE: 'P11',
                NAME: '기획재정부',
                ENG_NAME: null,
            },
            {
                CODE: 'N15',
                NAME: '교육과학기술부',
                ENG_NAME: null,
            },
            {
                CODE: 'P12',
                NAME: '미래창조과학부',
                ENG_NAME: null,
            },
            {
                CODE: 'N24',
                NAME: '국가보훈처',
                ENG_NAME: null,
            },
            {
                CODE: 'P13',
                NAME: '교육부',
                ENG_NAME: null,
            },
            {
                CODE: 'N56',
                NAME: '국가인권위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P14',
                NAME: '외교부',
                ENG_NAME: null,
            },
            {
                CODE: 'N04',
                NAME: '국가정보원',
                ENG_NAME: null,
            },
            {
                CODE: 'P15',
                NAME: '통일부',
                ENG_NAME: null,
            },
            {
                CODE: 'N10',
                NAME: '국무총리실',
                ENG_NAME: null,
            },
            {
                CODE: 'P16',
                NAME: '법무부',
                ENG_NAME: null,
            },
            {
                CODE: 'N57',
                NAME: '국민권익위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P17',
                NAME: '국방부',
                ENG_NAME: null,
            },
            {
                CODE: 'N14',
                NAME: '국방부',
                ENG_NAME: null,
            },
            {
                CODE: 'P18',
                NAME: '안전행정부',
                ENG_NAME: null,
            },
            {
                CODE: 'N26',
                NAME: '국세청',
                ENG_NAME: null,
            },
            {
                CODE: 'P19',
                NAME: '문화체육관광부',
                ENG_NAME: null,
            },
            {
                CODE: 'N17',
                NAME: '국토해양부',
                ENG_NAME: null,
            },
            {
                CODE: 'P20',
                NAME: '농림축산식품부',
                ENG_NAME: null,
            },
            {
                CODE: 'N06',
                NAME: '국회',
                ENG_NAME: null,
            },
            {
                CODE: 'P21',
                NAME: '산업통상자원부',
                ENG_NAME: null,
            },
            {
                CODE: 'N58',
                NAME: '금융위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P22',
                NAME: '보건복지부',
                ENG_NAME: null,
            },
            {
                CODE: 'N36',
                NAME: '기상청',
                ENG_NAME: null,
            },
            {
                CODE: 'P23',
                NAME: '환경부',
                ENG_NAME: null,
            },
            {
                CODE: 'N12',
                NAME: '기획재정부',
                ENG_NAME: null,
            },
            {
                CODE: 'P24',
                NAME: '고용노동부',
                ENG_NAME: null,
            },
            {
                CODE: 'N19',
                NAME: '노동부',
                ENG_NAME: null,
            },
            {
                CODE: 'P25',
                NAME: '여성가족부',
                ENG_NAME: null,
            },
            {
                CODE: 'N16',
                NAME: '농림수산식품부',
                ENG_NAME: null,
            },
            {
                CODE: 'P26',
                NAME: '국토교통부',
                ENG_NAME: null,
            },
            {
                CODE: 'N29',
                NAME: '농촌진흥청',
                ENG_NAME: null,
            },
            {
                CODE: 'P27',
                NAME: '해양수산부',
                ENG_NAME: null,
            },
            {
                CODE: 'N07',
                NAME: '대법원',
                ENG_NAME: null,
            },
            {
                CODE: 'P28',
                NAME: '법제처',
                ENG_NAME: null,
            },
            {
                CODE: 'N01',
                NAME: '대통령실',
                ENG_NAME: null,
            },
            {
                CODE: 'P29',
                NAME: '국가보훈처',
                ENG_NAME: null,
            },
            {
                CODE: 'N52',
                NAME: '문화재청',
                ENG_NAME: null,
            },
            {
                CODE: 'P31',
                NAME: '국가인권위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'N39',
                NAME: '문화체육관광부',
                ENG_NAME: null,
            },
            {
                CODE: 'P32',
                NAME: '방송통신위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'N48',
                NAME: '민주평화통일자문회의',
                ENG_NAME: null,
            },
            {
                CODE: 'P33',
                NAME: '공정거래위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P34',
                NAME: '금융위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'N54',
                NAME: '방송통신위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P35',
                NAME: '국민권익위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'N63',
                NAME: '방위사업청',
                ENG_NAME: null,
            },
            {
                CODE: 'P36',
                NAME: '원자력안전위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'N13',
                NAME: '법무부',
                ENG_NAME: null,
            },
            {
                CODE: 'P37',
                NAME: '국세청',
                ENG_NAME: null,
            },
            {
                CODE: 'N23',
                NAME: '법제처',
                ENG_NAME: null,
            },
            {
                CODE: 'P38',
                NAME: '관세청',
                ENG_NAME: null,
            },
            {
                CODE: 'N28',
                NAME: '병무청',
                ENG_NAME: null,
            },
            {
                CODE: 'P39',
                NAME: '조달청',
                ENG_NAME: null,
            },
            {
                CODE: 'N18',
                NAME: '보건복지부',
                ENG_NAME: null,
            },
            {
                CODE: 'P40',
                NAME: '통계청',
                ENG_NAME: null,
            },
            {
                CODE: 'N25',
                NAME: '산림청',
                ENG_NAME: null,
            },
            {
                CODE: 'P41',
                NAME: '병무청',
                ENG_NAME: null,
            },
            {
                CODE: 'N59',
                NAME: '소방방재청',
                ENG_NAME: null,
            },
            {
                CODE: 'P42',
                NAME: '방위사업청',
                ENG_NAME: null,
            },
            {
                CODE: 'N47',
                NAME: '식품의약품안전청',
                ENG_NAME: null,
            },
            {
                CODE: 'P43',
                NAME: '경찰청',
                ENG_NAME: null,
            },
            {
                CODE: 'N55',
                NAME: '여성부',
                ENG_NAME: null,
            },
            {
                CODE: 'P44',
                NAME: '소방방재청',
                ENG_NAME: null,
            },
            {
                CODE: 'N11',
                NAME: '외교통상부',
                ENG_NAME: null,
            },
            {
                CODE: 'P45',
                NAME: '문화재청',
                ENG_NAME: null,
            },
            {
                CODE: 'N33',
                NAME: '조달청',
                ENG_NAME: null,
            },
            {
                CODE: 'P46',
                NAME: '농촌진흥청',
                ENG_NAME: null,
            },
            {
                CODE: 'N30',
                NAME: '중소기업청',
                ENG_NAME: null,
            },
            {
                CODE: 'P47',
                NAME: '산림청',
                ENG_NAME: null,
            },
            {
                CODE: 'N09',
                NAME: '중앙선거관리위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P48',
                NAME: '중소기업청',
                ENG_NAME: null,
            },
            {
                CODE: 'N38',
                NAME: '지식경제부',
                ENG_NAME: null,
            },
            {
                CODE: 'P49',
                NAME: '특허청',
                ENG_NAME: null,
            },
            {
                CODE: 'N66',
                NAME: '진실·화해를위한과거사정리위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P50',
                NAME: '기상청',
                ENG_NAME: null,
            },
            {
                CODE: 'P51',
                NAME: '행정중심복합도시건설청',
                ENG_NAME: null,
            },
            {
                CODE: 'N61',
                NAME: '친일반민족행위진상규명위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P52',
                NAME: '해양경찰청',
                ENG_NAME: null,
            },
            {
                CODE: 'N35',
                NAME: '통계청',
                ENG_NAME: null,
            },
            {
                CODE: 'N22',
                NAME: '통일부',
                ENG_NAME: null,
            },
            {
                CODE: 'P60',
                NAME: '식품의약품안전처',
                ENG_NAME: null,
            },
            {
                CODE: 'P62',
                NAME: '국가안보실',
                ENG_NAME: null,
            },
            {
                CODE: 'N31',
                NAME: '특허청',
                ENG_NAME: null,
            },
            {
                CODE: 'N67',
                NAME: '한미FTA체결지원위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P98',
                NAME: '범부처사업',
                ENG_NAME: null,
            },
            {
                CODE: 'P68',
                NAME: '국민안전처',
                ENG_NAME: null,
            },
            {
                CODE: 'N42',
                NAME: '해양경찰청',
                ENG_NAME: null,
            },
            {
                CODE: 'N45',
                NAME: '행정안전부',
                ENG_NAME: null,
            },
            {
                CODE: 'P71',
                NAME: '과학기술정보통신부',
                ENG_NAME: null,
            },
            {
                CODE: 'P63',
                NAME: '새만금개발청',
                ENG_NAME: null,
            },
            {
                CODE: 'N65',
                NAME: '행정중심복합도시건설청',
                ENG_NAME: null,
            },
            {
                CODE: 'P74',
                NAME: '소방청',
                ENG_NAME: null,
            },
            {
                CODE: 'N08',
                NAME: '헌법재판소',
                ENG_NAME: null,
            },
            {
                CODE: 'N34',
                NAME: '환경부',
                ENG_NAME: null,
            },
            {
                CODE: 'P70',
                NAME: '인사혁신처',
                ENG_NAME: null,
            },
            {
                CODE: 'P73',
                NAME: '중소벤처기업부',
                ENG_NAME: null,
            },
            {
                CODE: 'N70',
                NAME: '국가과학기술위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P72',
                NAME: '행정안전부',
                ENG_NAME: null,
            },
            {
                CODE: 'N53',
                NAME: '원자력안전위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'P69',
                NAME: '행정자치부',
                ENG_NAME: null,
            },
            {
                CODE: '001',
                NAME: '대통령비서실',
                ENG_NAME: null,
            },
            {
                CODE: '002',
                NAME: '대통령경호실',
                ENG_NAME: null,
            },
            {
                CODE: '004',
                NAME: '국가정보원',
                ENG_NAME: null,
            },
            {
                CODE: '005',
                NAME: '감사원',
                ENG_NAME: null,
            },
            {
                CODE: '006',
                NAME: '국회',
                ENG_NAME: null,
            },
            {
                CODE: '007',
                NAME: '대법원',
                ENG_NAME: null,
            },
            {
                CODE: '008',
                NAME: '헌법재판소',
                ENG_NAME: null,
            },
            {
                CODE: '009',
                NAME: '중앙선거관리위원회',
                ENG_NAME: null,
            },
            {
                CODE: '011',
                NAME: '외교통상부',
                ENG_NAME: null,
            },
            {
                CODE: '012',
                NAME: '재정경제부',
                ENG_NAME: null,
            },
            {
                CODE: '013',
                NAME: '법무부',
                ENG_NAME: null,
            },
            {
                CODE: '014',
                NAME: '국방부',
                ENG_NAME: null,
            },
            {
                CODE: '015',
                NAME: '교육인적자원부',
                ENG_NAME: null,
            },
            {
                CODE: '016',
                NAME: '농림부',
                ENG_NAME: null,
            },
            {
                CODE: '017',
                NAME: '건설교통부',
                ENG_NAME: null,
            },
            {
                CODE: '018',
                NAME: '보건복지부',
                ENG_NAME: null,
            },
            {
                CODE: '019',
                NAME: '노동부',
                ENG_NAME: null,
            },
            {
                CODE: '020',
                NAME: '정보통신부',
                ENG_NAME: null,
            },
            {
                CODE: '021',
                NAME: '과학기술부',
                ENG_NAME: null,
            },
            {
                CODE: '022',
                NAME: '통일부',
                ENG_NAME: null,
            },
            {
                CODE: '023',
                NAME: '법제처',
                ENG_NAME: null,
            },
            {
                CODE: '024',
                NAME: '국가보훈처',
                ENG_NAME: null,
            },
            {
                CODE: '025',
                NAME: '산림청',
                ENG_NAME: null,
            },
            {
                CODE: '026',
                NAME: '국세청',
                ENG_NAME: null,
            },
            {
                CODE: '029',
                NAME: '농촌진흥청',
                ENG_NAME: null,
            },
            {
                CODE: '031',
                NAME: '특허청',
                ENG_NAME: null,
            },
            {
                CODE: '034',
                NAME: '환경부',
                ENG_NAME: null,
            },
            {
                CODE: '037',
                NAME: '경찰청',
                ENG_NAME: null,
            },
            {
                CODE: '039',
                NAME: '문화관광부',
                ENG_NAME: null,
            },
            {
                CODE: '041',
                NAME: '해양수산부',
                ENG_NAME: null,
            },
            {
                CODE: '043',
                NAME: '기획예산위원회',
                ENG_NAME: null,
            },
            {
                CODE: '045',
                NAME: '행정자치부',
                ENG_NAME: null,
            },
            {
                CODE: '048',
                NAME: '민주평화통일자문회의',
                ENG_NAME: null,
            },
            {
                CODE: '049',
                NAME: '기획예산처',
                ENG_NAME: null,
            },
            {
                CODE: '051',
                NAME: '국정홍보처',
                ENG_NAME: null,
            },
            {
                CODE: '055',
                NAME: '여성가족부',
                ENG_NAME: null,
            },
            {
                CODE: '057',
                NAME: '국가청렴위원회',
                ENG_NAME: null,
            },
            {
                CODE: '059',
                NAME: '소방방재청',
                ENG_NAME: null,
            },
            {
                CODE: '061',
                NAME: '친일반민족행위진상규명위원회',
                ENG_NAME: null,
            },
            {
                CODE: '064',
                NAME: '국민고충처리위원회',
                ENG_NAME: null,
            },
            {
                CODE: '066',
                NAME: '진실·화해를위한과거사정리위원회',
                ENG_NAME: null,
            },
            {
                CODE: '067',
                NAME: '한미FTA체결지원위원회',
                ENG_NAME: null,
            },
            {
                CODE: '010',
                NAME: '국무조정실',
                ENG_NAME: null,
            },
            {
                CODE: '027',
                NAME: '관세청',
                ENG_NAME: null,
            },
            {
                CODE: '028',
                NAME: '병무청',
                ENG_NAME: null,
            },
            {
                CODE: '030',
                NAME: '중소기업청',
                ENG_NAME: null,
            },
            {
                CODE: '032',
                NAME: '철도청',
                ENG_NAME: null,
            },
            {
                CODE: '033',
                NAME: '조달청',
                ENG_NAME: null,
            },
            {
                CODE: '035',
                NAME: '통계청',
                ENG_NAME: null,
            },
            {
                CODE: '036',
                NAME: '기상청',
                ENG_NAME: null,
            },
            {
                CODE: '038',
                NAME: '산업자원부',
                ENG_NAME: null,
            },
            {
                CODE: '040',
                NAME: '공정거래위원회',
                ENG_NAME: null,
            },
            {
                CODE: '042',
                NAME: '해양경찰청',
                ENG_NAME: null,
            },
            {
                CODE: '044',
                NAME: '여성특별위원회',
                ENG_NAME: null,
            },
            {
                CODE: '046',
                NAME: '예산청',
                ENG_NAME: null,
            },
            {
                CODE: '047',
                NAME: '식품의약품안전청',
                ENG_NAME: null,
            },
            {
                CODE: '050',
                NAME: '중앙인사위원회',
                ENG_NAME: null,
            },
            {
                CODE: '052',
                NAME: '문화재청',
                ENG_NAME: null,
            },
            {
                CODE: '054',
                NAME: '방송위원회',
                ENG_NAME: null,
            },
            {
                CODE: '056',
                NAME: '국가인권위원회',
                ENG_NAME: null,
            },
            {
                CODE: '058',
                NAME: '금융감독위원회',
                ENG_NAME: null,
            },
            {
                CODE: '060',
                NAME: '국가청소년위원회',
                ENG_NAME: null,
            },
            {
                CODE: '063',
                NAME: '방위사업청',
                ENG_NAME: null,
            },
            {
                CODE: '065',
                NAME: '행정중심복합도시건설청',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '과제정보_6T활용코드',
        codeList: [
            {
                CODE: '0BT',
                NAME: 'BT',
                ENG_NAME: 'BT',
            },
            {
                CODE: '0ET',
                NAME: 'ET',
                ENG_NAME: 'ET',
            },
            {
                CODE: '0IT',
                NAME: 'IT',
                ENG_NAME: 'IT',
            },
            {
                CODE: '0NT',
                NAME: 'NT',
                ENG_NAME: 'NT',
            },
            {
                CODE: '0ST',
                NAME: 'ST',
                ENG_NAME: 'ST',
            },
            {
                CODE: '0CT',
                NAME: 'CT',
                ENG_NAME: 'CT',
            },
            {
                CODE: '0TC',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '과제진행상태구분',
        codeList: [
            {
                CODE: '01',
                NAME: '접수',
                ENG_NAME: 'Receipt',
            },
            {
                CODE: '02',
                NAME: '선정평가',
                ENG_NAME: 'Selection Evaluation',
            },
            {
                CODE: '03',
                NAME: '선정확정',
                ENG_NAME: 'Selection Confirmation',
            },
            {
                CODE: '04',
                NAME: '선정탈락',
                ENG_NAME: 'Selection Fail',
            },
            {
                CODE: '05',
                NAME: '협약',
                ENG_NAME: 'Agreement',
            },
            {
                CODE: '06',
                NAME: '중단',
                ENG_NAME: 'Cease',
            },
            {
                CODE: '07',
                NAME: '수행',
                ENG_NAME: 'Execute',
            },
            {
                CODE: '08',
                NAME: '과제평가',
                ENG_NAME: 'Task Evaluation',
            },
            {
                CODE: '09',
                NAME: '종료',
                ENG_NAME: 'Stop',
            },
            {
                CODE: '10',
                NAME: '정산',
                ENG_NAME: 'Adjustment',
            },
            {
                CODE: '11',
                NAME: '사후관리',
                ENG_NAME: 'Post Management',
            },
            {
                CODE: '12',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '국가구분코드',
        codeList: [
            {
                CODE: 'AD',
                NAME: '안도라',
                ENG_NAME: 'ANDORRA',
            },
            {
                CODE: 'AE',
                NAME: '아랍에미리트',
                ENG_NAME: 'UNITED ARAB EMIRATES',
            },
            {
                CODE: 'AF',
                NAME: '아프가니스탄',
                ENG_NAME: 'AFGHANISTAN',
            },
            {
                CODE: 'AG',
                NAME: '앤티가 바부다',
                ENG_NAME: 'ANTIGUA AND BARBUDA',
            },
            {
                CODE: 'AI',
                NAME: '안길라',
                ENG_NAME: 'ANGUILLA',
            },
            {
                CODE: 'AL',
                NAME: '알바니아',
                ENG_NAME: 'ALBANIA',
            },
            {
                CODE: 'AM',
                NAME: '아르메니아',
                ENG_NAME: 'ARMENIA',
            },
            {
                CODE: 'AN',
                NAME: '네덜란드령 안틸레스',
                ENG_NAME: 'NETHERLANDS ANTILLES',
            },
            {
                CODE: 'AO',
                NAME: '앙골라',
                ENG_NAME: 'ANGOLA',
            },
            {
                CODE: 'AQ',
                NAME: '남극',
                ENG_NAME: 'ANTARCTICA',
            },
            {
                CODE: 'AR',
                NAME: '아르헨티나',
                ENG_NAME: 'ARGENTINA',
            },
            {
                CODE: 'AS',
                NAME: '미국령 사모아',
                ENG_NAME: 'AMERICAN SAMOA',
            },
            {
                CODE: 'AT',
                NAME: '오스트리아',
                ENG_NAME: 'AUSTRIA',
            },
            {
                CODE: 'AU',
                NAME: '오스트레일리아',
                ENG_NAME: 'AUSTRALIA',
            },
            {
                CODE: 'AW',
                NAME: '아루바',
                ENG_NAME: 'ARUBA',
            },
            {
                CODE: 'AX',
                NAME: '올란드 제도',
                ENG_NAME: 'ALAND ISLANDS',
            },
            {
                CODE: 'AZ',
                NAME: '아제르바이잔',
                ENG_NAME: 'AZERBAIJAN',
            },
            {
                CODE: 'BA',
                NAME: '보스니아 헤르체고비나',
                ENG_NAME: 'BOSNIA AND HERZEGOVINA',
            },
            {
                CODE: 'BB',
                NAME: '바베이도스',
                ENG_NAME: 'BARBADOS',
            },
            {
                CODE: 'BD',
                NAME: '방글라데시',
                ENG_NAME: 'BANGLADESH',
            },
            {
                CODE: 'BE',
                NAME: '벨기에',
                ENG_NAME: 'BELGIUM',
            },
            {
                CODE: 'BF',
                NAME: '부르키나 파소',
                ENG_NAME: 'BURKINA FASO',
            },
            {
                CODE: 'BG',
                NAME: '불가리아',
                ENG_NAME: 'BULGARIA',
            },
            {
                CODE: 'BH',
                NAME: '바레인',
                ENG_NAME: 'BAHRAIN',
            },
            {
                CODE: 'BI',
                NAME: '부룬디',
                ENG_NAME: 'BURUNDI',
            },
            {
                CODE: 'BJ',
                NAME: '베냉',
                ENG_NAME: 'BENIN',
            },
            {
                CODE: 'BM',
                NAME: '버뮤다',
                ENG_NAME: 'BERMUDA',
            },
            {
                CODE: 'BN',
                NAME: '브루나이',
                ENG_NAME: 'BRUNEI DARUSSALAM',
            },
            {
                CODE: 'BO',
                NAME: '볼리비아',
                ENG_NAME: 'BOLIVIA',
            },
            {
                CODE: 'BR',
                NAME: '브라질',
                ENG_NAME: 'BRAZIL',
            },
            {
                CODE: 'BS',
                NAME: '바하마',
                ENG_NAME: 'BAHAMAS',
            },
            {
                CODE: 'BT',
                NAME: '부탄',
                ENG_NAME: 'BHUTAN',
            },
            {
                CODE: 'BV',
                NAME: '부베도',
                ENG_NAME: 'BOUVET ISLAND',
            },
            {
                CODE: 'BW',
                NAME: '보츠와나',
                ENG_NAME: 'BOTSWANA',
            },
            {
                CODE: 'BY',
                NAME: '벨라루스',
                ENG_NAME: 'BELARUS',
            },
            {
                CODE: 'BZ',
                NAME: '벨리즈',
                ENG_NAME: 'BELIZE',
            },
            {
                CODE: 'CA',
                NAME: '캐나다',
                ENG_NAME: 'CANADA',
            },
            {
                CODE: 'CC',
                NAME: '코코스군도',
                ENG_NAME: 'COCOS (KEELING) ISLANDS',
            },
            {
                CODE: 'CF',
                NAME: '중앙아프리카공화국',
                ENG_NAME: 'CENTRAL AFRICAN REPUBLIC',
            },
            {
                CODE: 'CG',
                NAME: '콩고',
                ENG_NAME: 'CONGO',
            },
            {
                CODE: 'CH',
                NAME: '스위스',
                ENG_NAME: 'SWITZERLAND',
            },
            {
                CODE: 'CI',
                NAME: '코트디브아르',
                ENG_NAME: 'COTE D IVOIRE',
            },
            {
                CODE: 'CK',
                NAME: '쿠크군도',
                ENG_NAME: 'COOK ISLANDS',
            },
            {
                CODE: 'CL',
                NAME: '칠레',
                ENG_NAME: 'CHILE',
            },
            {
                CODE: 'CM',
                NAME: '카메룬',
                ENG_NAME: 'CAMEROON',
            },
            {
                CODE: 'CN',
                NAME: '중국',
                ENG_NAME: 'CHINA',
            },
            {
                CODE: 'CO',
                NAME: '콜롬비아',
                ENG_NAME: 'COLOMBIA',
            },
            {
                CODE: 'CR',
                NAME: '코스타리카',
                ENG_NAME: 'COSTA RICA',
            },
            {
                CODE: 'CU',
                NAME: '쿠바',
                ENG_NAME: 'CUBA',
            },
            {
                CODE: 'CV',
                NAME: '카보베르데',
                ENG_NAME: 'CAPE VERDE',
            },
            {
                CODE: 'CX',
                NAME: '크리스마스도',
                ENG_NAME: 'CHRISTMAS ISLAND',
            },
            {
                CODE: 'CY',
                NAME: '사이프러스',
                ENG_NAME: 'CYPRUS',
            },
            {
                CODE: 'CZ',
                NAME: '체코',
                ENG_NAME: 'CZECH REPUBLIC',
            },
            {
                CODE: 'DE',
                NAME: '독일',
                ENG_NAME: 'GERMANY',
            },
            {
                CODE: 'DJ',
                NAME: '지부티',
                ENG_NAME: 'DJIBOUTI',
            },
            {
                CODE: 'DK',
                NAME: '덴마크',
                ENG_NAME: 'DENMARK',
            },
            {
                CODE: 'DM',
                NAME: '도미니카연방',
                ENG_NAME: 'DOMINICA',
            },
            {
                CODE: 'DO',
                NAME: '도미니카 공화국',
                ENG_NAME: 'DOMINICAN REPUBLIC',
            },
            {
                CODE: 'DZ',
                NAME: '알제리',
                ENG_NAME: 'ALGERIA',
            },
            {
                CODE: 'EA',
                NAME: 'EA 유라시아(특허)',
                ENG_NAME: 'Eurasian?Patent?Organization',
            },
            {
                CODE: 'EC',
                NAME: '에콰도르',
                ENG_NAME: 'ECUADOR',
            },
            {
                CODE: 'EE',
                NAME: '에스토니아',
                ENG_NAME: 'ESTONIA',
            },
            {
                CODE: 'EG',
                NAME: '이집트',
                ENG_NAME: 'EGYPT',
            },
            {
                CODE: 'EH',
                NAME: '서사하라',
                ENG_NAME: 'WESTERN SAHARA',
            },
            {
                CODE: 'ER',
                NAME: '에리트리아',
                ENG_NAME: 'ERITREA',
            },
            {
                CODE: 'ES',
                NAME: '스페인',
                ENG_NAME: 'SPAIN',
            },
            {
                CODE: 'ET',
                NAME: '에티오피아',
                ENG_NAME: 'ETHIOPIA',
            },
            {
                CODE: 'FI',
                NAME: '핀란드',
                ENG_NAME: 'FINLAND',
            },
            {
                CODE: 'FJ',
                NAME: '피지',
                ENG_NAME: 'FIJI',
            },
            {
                CODE: 'FK',
                NAME: '포클랜드(말비나스)군도',
                ENG_NAME: 'FALKLAND ISLANDS (MALVINAS)',
            },
            {
                CODE: 'FM',
                NAME: '미크로네시아',
                ENG_NAME: 'MICRONESIA, FEDERATED STATES OF',
            },
            {
                CODE: 'FO',
                NAME: '파로에군도',
                ENG_NAME: 'FAROE ISLANDS',
            },
            {
                CODE: 'FR',
                NAME: '프랑스',
                ENG_NAME: 'FRANCE',
            },
            {
                CODE: 'FX',
                NAME: '프랑스 본국',
                ENG_NAME: 'FRANCE, METROPOLITAN',
            },
            {
                CODE: 'GA',
                NAME: '가봉',
                ENG_NAME: 'GABON',
            },
            {
                CODE: 'GB',
                NAME: '영국',
                ENG_NAME: 'UNITED KINGDOM',
            },
            {
                CODE: 'GD',
                NAME: '그레나다',
                ENG_NAME: 'GRENADA',
            },
            {
                CODE: 'GE',
                NAME: '그루지아',
                ENG_NAME: 'GEORGIA',
            },
            {
                CODE: 'GF',
                NAME: '프랑스령 기아나',
                ENG_NAME: 'FRENCH GUIANA',
            },
            {
                CODE: 'GG',
                NAME: '건지',
                ENG_NAME: 'GUERNSEY',
            },
            {
                CODE: 'GH',
                NAME: '가나',
                ENG_NAME: 'GHANA',
            },
            {
                CODE: 'GI',
                NAME: '지브롤터',
                ENG_NAME: 'GIBRALTAR',
            },
            {
                CODE: 'GL',
                NAME: '그린랜드',
                ENG_NAME: 'GREENLAND',
            },
            {
                CODE: 'GM',
                NAME: '감비아',
                ENG_NAME: 'GAMBIA',
            },
            {
                CODE: 'GN',
                NAME: '기니',
                ENG_NAME: 'GUINEA',
            },
            {
                CODE: 'GP',
                NAME: '과달루프',
                ENG_NAME: 'GUADELOUPE',
            },
            {
                CODE: 'GQ',
                NAME: '적도 기니',
                ENG_NAME: 'EQUATORIAL GUINEA',
            },
            {
                CODE: 'GR',
                NAME: '그리스',
                ENG_NAME: 'GREECE',
            },
            {
                CODE: 'GS',
                NAME: '남조지아·남샌드위치군도',
                ENG_NAME: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
            },
            {
                CODE: 'GT',
                NAME: '과테말라',
                ENG_NAME: 'GUATEMALA',
            },
            {
                CODE: 'GU',
                NAME: '괌',
                ENG_NAME: 'GUAM',
            },
            {
                CODE: 'GW',
                NAME: '기니비사우',
                ENG_NAME: 'GUINEA-BISSAU',
            },
            {
                CODE: 'GY',
                NAME: '가이아나',
                ENG_NAME: 'GUYANA',
            },
            {
                CODE: 'HK',
                NAME: '홍콩',
                ENG_NAME: 'HONG KONG',
            },
            {
                CODE: 'HM',
                NAME: '허드 맥도날드 제도',
                ENG_NAME: 'HEARD ISLAND AND MCDONALD ISLANDS',
            },
            {
                CODE: 'HN',
                NAME: '온두라스',
                ENG_NAME: 'HONDURAS',
            },
            {
                CODE: 'HR',
                NAME: '크로아티아',
                ENG_NAME: 'CROATIA (local name: Hrvatska)',
            },
            {
                CODE: 'HT',
                NAME: '아이티',
                ENG_NAME: 'HAITI',
            },
            {
                CODE: 'HU',
                NAME: '헝가리',
                ENG_NAME: 'HUNGARY',
            },
            {
                CODE: 'ID',
                NAME: '인도네시아',
                ENG_NAME: 'INDONESIA',
            },
            {
                CODE: 'IE',
                NAME: '아일랜드',
                ENG_NAME: 'IRELAND',
            },
            {
                CODE: 'IL',
                NAME: '이스라엘',
                ENG_NAME: 'ISRAEL',
            },
            {
                CODE: 'IM',
                NAME: '맨섬',
                ENG_NAME: 'ISLE OF MAN',
            },
            {
                CODE: 'IN',
                NAME: '인도',
                ENG_NAME: 'INDIA',
            },
            {
                CODE: 'IO',
                NAME: '영국령 인도양지역',
                ENG_NAME: 'BRITISH INDIAN OCEAN TERRITORY',
            },
            {
                CODE: 'IQ',
                NAME: '이라크',
                ENG_NAME: 'IRAQ',
            },
            {
                CODE: 'IR',
                NAME: '이란',
                ENG_NAME: 'IRAN, ISLAMIC REPUBLIC OF',
            },
            {
                CODE: 'IS',
                NAME: '아이슬란드',
                ENG_NAME: 'ICELAND',
            },
            {
                CODE: 'IT',
                NAME: '이탈리아',
                ENG_NAME: 'ITALY',
            },
            {
                CODE: 'JE',
                NAME: '저지',
                ENG_NAME: 'JERSEY',
            },
            {
                CODE: 'JM',
                NAME: '자메이카',
                ENG_NAME: 'JAMAICA',
            },
            {
                CODE: 'JO',
                NAME: '요르단',
                ENG_NAME: 'JORDAN',
            },
            {
                CODE: 'JP',
                NAME: '일본',
                ENG_NAME: 'JAPAN',
            },
            {
                CODE: 'KE',
                NAME: '케냐',
                ENG_NAME: 'KENYA',
            },
            {
                CODE: 'KG',
                NAME: '키르기스스탄',
                ENG_NAME: 'KYRGYZSTAN',
            },
            {
                CODE: 'KH',
                NAME: '캄보디아',
                ENG_NAME: 'CAMBODIA',
            },
            {
                CODE: 'KI',
                NAME: '키리바시',
                ENG_NAME: 'KIRIBATI',
            },
            {
                CODE: 'KM',
                NAME: '코모로',
                ENG_NAME: 'COMOROS',
            },
            {
                CODE: 'KN',
                NAME: '세인트 킷츠 네비스',
                ENG_NAME: 'SAINT KITTS AND NEVIS',
            },
            {
                CODE: 'LB',
                NAME: '레바논',
                ENG_NAME: 'LEBANON',
            },
            {
                CODE: 'LC',
                NAME: '세인트 루치아',
                ENG_NAME: 'SAINT LUCIA',
            },
            {
                CODE: 'LI',
                NAME: '리히텐슈타인',
                ENG_NAME: 'LIECHTENSTEIN',
            },
            {
                CODE: 'LK',
                NAME: '스리랑카',
                ENG_NAME: 'SRI LANKA',
            },
            {
                CODE: 'LR',
                NAME: '라이베리아',
                ENG_NAME: 'LIBERIA',
            },
            {
                CODE: 'LS',
                NAME: '레소토',
                ENG_NAME: 'LESOTHO',
            },
            {
                CODE: 'LT',
                NAME: '리투아니아',
                ENG_NAME: 'LITHUANIA',
            },
            {
                CODE: 'LU',
                NAME: '룩셈부르크',
                ENG_NAME: 'LUXEMBOURG',
            },
            {
                CODE: 'LV',
                NAME: '라트비아',
                ENG_NAME: 'LATVIA',
            },
            {
                CODE: 'LY',
                NAME: '리비아',
                ENG_NAME: 'LIBYAN ARAB JAMAHIRIYA',
            },
            {
                CODE: 'MA',
                NAME: '모로크',
                ENG_NAME: 'MOROCCO',
            },
            {
                CODE: 'MC',
                NAME: '모나코',
                ENG_NAME: 'MONACO',
            },
            {
                CODE: 'MD',
                NAME: '몰도바',
                ENG_NAME: 'MOLDOVA, REPUBLIC OF',
            },
            {
                CODE: 'ME',
                NAME: '몬테네그로',
                ENG_NAME: 'MONTENEGRO',
            },
            {
                CODE: 'MG',
                NAME: '마다가스카르',
                ENG_NAME: 'MADAGASCAR',
            },
            {
                CODE: 'MH',
                NAME: '마샬군도',
                ENG_NAME: 'MARSHALL ISLANDS',
            },
            {
                CODE: 'MK',
                NAME: '마케도니아 공화국',
                ENG_NAME: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF',
            },
            {
                CODE: 'ML',
                NAME: '말리',
                ENG_NAME: 'MALI',
            },
            {
                CODE: 'MM',
                NAME: '미얀마',
                ENG_NAME: 'MYANMAR',
            },
            {
                CODE: 'MN',
                NAME: '몽골',
                ENG_NAME: 'MONGOLIA',
            },
            {
                CODE: 'MO',
                NAME: '마카오',
                ENG_NAME: 'MACAO',
            },
            {
                CODE: 'MP',
                NAME: '북마리아나군도',
                ENG_NAME: 'NORTHERN MARIANA ISLANDS',
            },
            {
                CODE: 'MQ',
                NAME: '말티니크',
                ENG_NAME: 'MARTINIQUE',
            },
            {
                CODE: 'MR',
                NAME: '모리타니',
                ENG_NAME: 'MAURITANIA',
            },
            {
                CODE: 'MS',
                NAME: '몬트세라트',
                ENG_NAME: 'MONTSERRAT',
            },
            {
                CODE: 'MT',
                NAME: '몰타',
                ENG_NAME: 'MALTA',
            },
            {
                CODE: 'MU',
                NAME: '모리셔스',
                ENG_NAME: 'MAURITIUS',
            },
            {
                CODE: 'MV',
                NAME: '몰디브',
                ENG_NAME: 'MALDIVES',
            },
            {
                CODE: 'MW',
                NAME: '말라위',
                ENG_NAME: 'MALAWI',
            },
            {
                CODE: 'MX',
                NAME: '멕시코',
                ENG_NAME: 'MEXICO',
            },
            {
                CODE: 'MY',
                NAME: '말레이지아',
                ENG_NAME: 'MALAYSIA',
            },
            {
                CODE: 'MZ',
                NAME: '모잠비크',
                ENG_NAME: 'MOZAMBIQUE',
            },
            {
                CODE: 'NA',
                NAME: '나미비아',
                ENG_NAME: 'NAMIBIA',
            },
            {
                CODE: 'NC',
                NAME: '뉴칼레도니아',
                ENG_NAME: 'NEW CALEDONIA',
            },
            {
                CODE: 'NE',
                NAME: '니제르',
                ENG_NAME: 'NIGER',
            },
            {
                CODE: 'NF',
                NAME: '노퍽섬',
                ENG_NAME: 'NORFOLK ISLAND',
            },
            {
                CODE: 'NG',
                NAME: '나이지리아',
                ENG_NAME: 'NIGERIA',
            },
            {
                CODE: 'NI',
                NAME: '니카라과',
                ENG_NAME: 'NICARAGUA',
            },
            {
                CODE: 'NL',
                NAME: '네덜란드',
                ENG_NAME: 'NETHERLANDS',
            },
            {
                CODE: 'NO',
                NAME: '노르웨이',
                ENG_NAME: 'NORWAY',
            },
            {
                CODE: 'NP',
                NAME: '네팔',
                ENG_NAME: 'NEPAL',
            },
            {
                CODE: 'NR',
                NAME: '나우루',
                ENG_NAME: 'NAURU',
            },
            {
                CODE: 'NU',
                NAME: '니우에',
                ENG_NAME: 'NIUE',
            },
            {
                CODE: 'NZ',
                NAME: '뉴질랜드',
                ENG_NAME: 'NEW ZEALAND',
            },
            {
                CODE: 'OM',
                NAME: '오만',
                ENG_NAME: 'OMAN',
            },
            {
                CODE: 'PA',
                NAME: '파나마',
                ENG_NAME: 'PANAMA',
            },
            {
                CODE: 'PE',
                NAME: '페루',
                ENG_NAME: 'PERU',
            },
            {
                CODE: 'PF',
                NAME: '프랑스령 폴리네시아',
                ENG_NAME: 'FRENCH POLYNESIA',
            },
            {
                CODE: 'PG',
                NAME: '파푸아뉴기니',
                ENG_NAME: 'PAPUA NEW GUINEA',
            },
            {
                CODE: 'PH',
                NAME: '필리핀',
                ENG_NAME: 'PHILIPPINES',
            },
            {
                CODE: 'PK',
                NAME: '파키스탄',
                ENG_NAME: 'PAKISTAN',
            },
            {
                CODE: 'PL',
                NAME: '폴란드',
                ENG_NAME: 'POLAND',
            },
            {
                CODE: 'PM',
                NAME: '생피에르 미클롱',
                ENG_NAME: 'SAINT PIERRE AND MIQUELON',
            },
            {
                CODE: 'PN',
                NAME: '핏카인도',
                ENG_NAME: 'PITCAIRN',
            },
            {
                CODE: 'PR',
                NAME: '푸에토리코',
                ENG_NAME: 'PUERTO RICO',
            },
            {
                CODE: 'PS',
                NAME: '팔레스타인',
                ENG_NAME: 'PALESTINIAN TERRITORY, OCCUPIED',
            },
            {
                CODE: 'PT',
                NAME: '포르투갈',
                ENG_NAME: 'PORTUGAL',
            },
            {
                CODE: 'PW',
                NAME: '팔라우',
                ENG_NAME: 'PALAU',
            },
            {
                CODE: 'PY',
                NAME: '파라과이',
                ENG_NAME: 'PARAGUAY',
            },
            {
                CODE: 'QA',
                NAME: '카타르',
                ENG_NAME: 'QATAR',
            },
            {
                CODE: 'RE',
                NAME: '레위니옹',
                ENG_NAME: 'REUNION',
            },
            {
                CODE: 'RO',
                NAME: '루마니아',
                ENG_NAME: 'ROMANIA',
            },
            {
                CODE: 'RS',
                NAME: '세르비아',
                ENG_NAME: 'SERBIA',
            },
            {
                CODE: 'RU',
                NAME: '러시아',
                ENG_NAME: 'RUSSIAN FEDERATION',
            },
            {
                CODE: 'RW',
                NAME: '르완다',
                ENG_NAME: 'RWANDA',
            },
            {
                CODE: 'SA',
                NAME: '사우디아라비아',
                ENG_NAME: 'SAUDI ARABIA',
            },
            {
                CODE: 'SB',
                NAME: '솔로몬군도',
                ENG_NAME: 'SOLOMON ISLANDS',
            },
            {
                CODE: 'SC',
                NAME: '세이셸',
                ENG_NAME: 'SEYCHELLES',
            },
            {
                CODE: 'SD',
                NAME: '수단',
                ENG_NAME: 'SUDAN',
            },
            {
                CODE: 'SE',
                NAME: '스웨덴',
                ENG_NAME: 'SWEDEN',
            },
            {
                CODE: 'SG',
                NAME: '싱가포르',
                ENG_NAME: 'SINGAPORE',
            },
            {
                CODE: 'SH',
                NAME: '세인트헬레나',
                ENG_NAME: 'SAINT HELENA',
            },
            {
                CODE: 'SI',
                NAME: '슬로베니아',
                ENG_NAME: 'SLOVENIA',
            },
            {
                CODE: 'SJ',
                NAME: '스발바르 얀마옌',
                ENG_NAME: 'SVALBARD AND JAN MAYEN',
            },
            {
                CODE: 'SK',
                NAME: '슬로바키아',
                ENG_NAME: 'SLOVAKIA',
            },
            {
                CODE: 'SL',
                NAME: '시에라리온',
                ENG_NAME: 'SIERRA LEONE',
            },
            {
                CODE: 'SM',
                NAME: '산마리노',
                ENG_NAME: 'SAN MARINO',
            },
            {
                CODE: 'SN',
                NAME: '세네갈',
                ENG_NAME: 'SENEGAL',
            },
            {
                CODE: 'SO',
                NAME: '소말리아',
                ENG_NAME: 'SOMALIA',
            },
            {
                CODE: 'SR',
                NAME: '수리남',
                ENG_NAME: 'SURINAME',
            },
            {
                CODE: 'ST',
                NAME: '상투메 프린시페',
                ENG_NAME: 'SAO TOME AND PRINCIPE',
            },
            {
                CODE: 'SV',
                NAME: '엘살바도르',
                ENG_NAME: 'EL SALVADOR',
            },
            {
                CODE: 'SY',
                NAME: '시리아',
                ENG_NAME: 'SYRIAN ARAB REPUBLIC',
            },
            {
                CODE: 'SZ',
                NAME: '스와질랜드',
                ENG_NAME: 'SWAZILAND',
            },
            {
                CODE: 'TC',
                NAME: '터크스·카이코스군도',
                ENG_NAME: 'TURKS AND CAICOS ISLANDS',
            },
            {
                CODE: 'TD',
                NAME: '차드',
                ENG_NAME: 'CHAD',
            },
            {
                CODE: 'TF',
                NAME: '프랑스령 극남군도',
                ENG_NAME: 'FRENCH SOUTHERN TERRITORIES',
            },
            {
                CODE: 'TG',
                NAME: '토고',
                ENG_NAME: 'TOGO',
            },
            {
                CODE: 'TH',
                NAME: '태국',
                ENG_NAME: 'THAILAND',
            },
            {
                CODE: 'TJ',
                NAME: '타지키스탄',
                ENG_NAME: 'TAJIKISTAN',
            },
            {
                CODE: 'TK',
                NAME: '토켈라우',
                ENG_NAME: 'TOKELAU',
            },
            {
                CODE: 'TL',
                NAME: '동티모르',
                ENG_NAME: 'TIMOR-LESTE',
            },
            {
                CODE: 'TM',
                NAME: '투르크메니스탄',
                ENG_NAME: 'TURKMENISTAN',
            },
            {
                CODE: 'TN',
                NAME: '튀니지',
                ENG_NAME: 'TUNISIA',
            },
            {
                CODE: 'TO',
                NAME: '통가',
                ENG_NAME: 'TONGA',
            },
            {
                CODE: 'TR',
                NAME: '터키',
                ENG_NAME: 'TURKEY',
            },
            {
                CODE: 'TT',
                NAME: '트리니다드·토바고',
                ENG_NAME: 'TRINIDAD AND TOBAGO',
            },
            {
                CODE: 'TV',
                NAME: '투발루',
                ENG_NAME: 'TUVALU',
            },
            {
                CODE: 'TW',
                NAME: '대만',
                ENG_NAME: 'TAIWAN, PROVINCE OF CHINA',
            },
            {
                CODE: 'TZ',
                NAME: '탄자니아',
                ENG_NAME: 'TANZANIA, UNITED REPUBLIC OF',
            },
            {
                CODE: 'UA',
                NAME: '우크라이나',
                ENG_NAME: 'UKRAINE',
            },
            {
                CODE: 'UG',
                NAME: '우간다',
                ENG_NAME: 'UGANDA',
            },
            {
                CODE: 'UM',
                NAME: '미국령 태평양군도',
                ENG_NAME: 'UNITED STATES MINOR OUTLYING ISLANDS',
            },
            {
                CODE: 'US',
                NAME: '미국',
                ENG_NAME: 'UNITED STATES',
            },
            {
                CODE: 'UY',
                NAME: '우르과이',
                ENG_NAME: 'URUGUAY',
            },
            {
                CODE: 'UZ',
                NAME: '우즈베키스탄',
                ENG_NAME: 'UZBEKISTAN',
            },
            {
                CODE: 'VA',
                NAME: '바티칸 시국',
                ENG_NAME: 'HOLY SEE (VATICAN CITY STATE)',
            },
            {
                CODE: 'VC',
                NAME: '세인트 빈센트 그레나딘',
                ENG_NAME: 'SAINT VINCENT AND THE GRENADINES',
            },
            {
                CODE: 'VE',
                NAME: '베네수엘라',
                ENG_NAME: 'VENEZUELA',
            },
            {
                CODE: 'VG',
                NAME: '영국령 버진아일랜드',
                ENG_NAME: 'VIRGIN ISLANDS, BRITISH',
            },
            {
                CODE: 'VI',
                NAME: '미국령 버진아일랜드',
                ENG_NAME: 'VIRGIN ISLANDS, U.S.',
            },
            {
                CODE: 'VN',
                NAME: '베트남',
                ENG_NAME: 'VIET NAM',
            },
            {
                CODE: 'VU',
                NAME: '바누아투',
                ENG_NAME: 'VANUATU',
            },
            {
                CODE: 'WF',
                NAME: '월리스 푸투나',
                ENG_NAME: 'WALLIS AND FUTUNA',
            },
            {
                CODE: 'WS',
                NAME: '서사모아',
                ENG_NAME: 'SAMOA',
            },
            {
                CODE: 'XA',
                NAME: '아셴션제도',
                ENG_NAME: 'Ascension Island',
            },
            {
                CODE: 'XC',
                NAME: '콩고민주공화국',
                ENG_NAME: 'Congo, The Democratic Republic of the',
            },
            {
                CODE: 'XI',
                NAME: '국제',
                ENG_NAME: 'INTERNATIONAL',
            },
            {
                CODE: 'XS',
                NAME: '체코슬로바키아',
                ENG_NAME: 'Czechoslovakia',
            },
            {
                CODE: 'XU',
                NAME: '유럽연합',
                ENG_NAME: 'European Union',
            },
            {
                CODE: 'YE',
                NAME: '예멘',
                ENG_NAME: 'YEMEN',
            },
            {
                CODE: 'YT',
                NAME: '마요티',
                ENG_NAME: 'MAYOTTE',
            },
            {
                CODE: 'YU',
                NAME: '유고슬라비아',
                ENG_NAME: 'YUGOSLAVIA',
            },
            {
                CODE: 'ZA',
                NAME: '남아프리카공화국',
                ENG_NAME: 'SOUTH AFRICA',
            },
            {
                CODE: 'ZM',
                NAME: '잠비아',
                ENG_NAME: 'ZAMBIA',
            },
            {
                CODE: 'ZR',
                NAME: '자이르',
                ENG_NAME: 'ZAIRE',
            },
            {
                CODE: 'ZW',
                NAME: '짐바브웨',
                ENG_NAME: 'ZIMBABWE',
            },
        ],
    },
    {
        NAME: '국내외구분',
        codeList: [
            {
                CODE: '1',
                NAME: '국내',
                ENG_NAME: 'Domestic',
            },
            {
                CODE: '2',
                NAME: '국외',
                ENG_NAME: 'Foreign',
            },
        ],
    },
    {
        NAME: '기관구분(장비기자재)',
        codeList: [
            {
                CODE: '1',
                NAME: '주관기관',
                ENG_NAME: 'Supervising Institution',
            },
            {
                CODE: '2',
                NAME: '협동기관',
                ENG_NAME: 'Cooperative Institution',
            },
            {
                CODE: '3',
                NAME: '위탁기관',
                ENG_NAME: 'Commissioning Institution',
            },
        ],
    },
    {
        NAME: '기관유형',
        codeList: [
            {
                CODE: '01',
                NAME: '국/공립 대학(4년제)',
                ENG_NAME: '4-Year National College',
            },
            {
                CODE: '02',
                NAME: '국/공립 대학(2년제)',
                ENG_NAME: '2-Year National College',
            },
            {
                CODE: '03',
                NAME: '사립 대학(4년제)',
                ENG_NAME: '4-Year Private College',
            },
            {
                CODE: '04',
                NAME: '사립 대학(2년제)',
                ENG_NAME: '2-Year Private College',
            },
            {
                CODE: '05',
                NAME: '특정연구기관',
                ENG_NAME: 'Specific Research Institution',
            },
            {
                CODE: '06',
                NAME: '정부출연기관',
                ENG_NAME: 'Government-Funded Institution',
            },
            {
                CODE: '07',
                NAME: '국/공립기관',
                ENG_NAME: 'National Institution',
            },
            {
                CODE: '08',
                NAME: '기업(부설연구소 포함)',
                ENG_NAME: 'Company(Affiliated Laboratory Included)',
            },
            {
                CODE: '09',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
            {
                CODE: '10',
                NAME: 'DGIST 연구단',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기관유형코드',
        codeList: [
            {
                CODE: '01',
                NAME: '국공립연구기관',
                ENG_NAME: 'National Research Institution',
            },
            {
                CODE: '02',
                NAME: '정부출연연구기관',
                ENG_NAME: 'Government-Funded Research Institution',
            },
            {
                CODE: '03',
                NAME: '지방자치단체출연연구기관',
                ENG_NAME: 'Research Institution Funded by a Local Autonomous Entity',
            },
            {
                CODE: '04',
                NAME: '연구조합',
                ENG_NAME: 'Research Association',
            },
            {
                CODE: '05',
                NAME: '기타공공기관',
                ENG_NAME: 'Other Public Institution',
            },
            {
                CODE: '06',
                NAME: '4년제 국공립대학',
                ENG_NAME: '4-Year National College',
            },
            {
                CODE: '07',
                NAME: '2년제 국공립대학',
                ENG_NAME: '2-Year National College',
            },
            {
                CODE: '08',
                NAME: '4년제 사립대학',
                ENG_NAME: '4-Year Private College',
            },
            {
                CODE: '09',
                NAME: '2년제 사립대학',
                ENG_NAME: '2-Year Private College',
            },
            {
                CODE: '10',
                NAME: '국공립의료기관',
                ENG_NAME: 'National Medical Institution',
            },
            {
                CODE: '11',
                NAME: '사립의료기관',
                ENG_NAME: 'Private Medical Institution',
            },
            {
                CODE: '12',
                NAME: '국공립대학부속병원',
                ENG_NAME: 'National College Hospital',
            },
            {
                CODE: '13',
                NAME: '사립대학부속병원',
                ENG_NAME: 'Private College Hospital',
            },
            {
                CODE: '14',
                NAME: '민간기업',
                ENG_NAME: 'Private Enterprise',
            },
            {
                CODE: '15',
                NAME: '시장형공기업',
                ENG_NAME: 'Market Public Enterprise',
            },
            {
                CODE: '16',
                NAME: '준시장형공기업',
                ENG_NAME: 'Quasimarket Public Enterprise',
            },
            {
                CODE: '17',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '단독이용사유코드',
        codeList: [
            {
                CODE: '01',
                NAME:
                    '자체 수요가 많아 내부 활용도가 매우 높은 장비(장비가동률 100%, 년간 2000시간 이상 장비)',
                ENG_NAME:
                    'Self-Contained Equipment with Much Internal Utilization (operation rate 100%, more than 2000 hours per year)',
            },
            {
                CODE: '02',
                NAME:
                    '시작품 시제품 수준으로 아직 시험운영중이거나 요소 부품 및 기술 개발중인 장비',
                ENG_NAME:
                    'Equipment in Test Operation at Trial Product or Test Product Level or Equipment Developing in Component and Technology',
            },
            {
                CODE: '03',
                NAME: '특수목적용 장비로서 반드시 자체 특화된 연구에만 전용되어야 하는 장비',
                ENG_NAME: 'Equipment Only for Specific Object as Specialized Research',
            },
            {
                CODE: '04',
                NAME: '상시 모니터링 및 계측용으로 연중 실시간 또는 지속적으로 활용되어지는 장비',
                ENG_NAME:
                    'Equipment for Year-Round Monitoring and Measurement that Operates Consistently All the Year Round',
            },
            {
                CODE: '05',
                NAME: '국가안보, 기술유출 등으로 보안 및 기밀유지가 요구되는 장비',
                ENG_NAME:
                    'Equipment Requiring Security Maintenance for National Security and Prevention of Technology Leakage',
            },
            {
                CODE: '06',
                NAME: '위험물질 및 고위험성으로 인하여 이용이 제한되어 있는 장비',
                ENG_NAME:
                    'High-Risk Equipment with Usage Limit for Protection from Hazardous Material',
            },
            {
                CODE: '07',
                NAME: '초고감도 정밀장비로 오염 및 손상시 복구가 불가능한 장비',
                ENG_NAME:
                    'Supersensitive Equipment with Restoration Impossible When Contaminated or Damaged',
            },
            {
                CODE: '08',
                NAME: '라이선스 계약에 묶여있어 타이용자가 사용이 불가능한 장비',
                ENG_NAME: 'Equipment Unavailable to other Users with License Contract',
            },
        ],
    },
    {
        NAME: '보고서종류구분',
        codeList: [
            {
                CODE: '1',
                NAME: '진도보고서',
                ENG_NAME: 'Progress Report',
            },
            {
                CODE: '2',
                NAME: '중간보고서',
                ENG_NAME: 'Interim Report',
            },
            {
                CODE: '3',
                NAME: '연차실적보고서',
                ENG_NAME: 'Annual Performance Report',
            },
            {
                CODE: '4',
                NAME: '단계보고서',
                ENG_NAME: 'Step Report',
            },
            {
                CODE: '5',
                NAME: '최종요약보고서',
                ENG_NAME: 'Final Summary Report',
            },
            {
                CODE: '6',
                NAME: '최종보고서',
                ENG_NAME: 'Final Report',
            },
            {
                CODE: '7',
                NAME: '연구개발결과활용보고서',
                ENG_NAME: 'Application Report of Research Development Result',
            },
            {
                CODE: '8',
                NAME: '수시보고서',
                ENG_NAME: 'Spot Report',
            },
            {
                CODE: '9',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '불용상태구분코드',
        codeList: [
            {
                CODE: '01',
                NAME: '매각',
                ENG_NAME: 'Sale',
            },
            {
                CODE: '02',
                NAME: '재활용',
                ENG_NAME: 'Recycling',
            },
            {
                CODE: '03',
                NAME: '폐기',
                ENG_NAME: 'Disuse',
            },
            {
                CODE: '04',
                NAME: '양여',
                ENG_NAME: 'Transfer',
            },
        ],
    },
    {
        NAME: '산업(지식)재산권종류구분',
        codeList: [
            {
                CODE: '01',
                NAME: '특허',
                ENG_NAME: 'Patent',
            },
            {
                CODE: '02',
                NAME: '실용신안',
                ENG_NAME: 'Utility Model',
            },
            {
                CODE: '03',
                NAME: '디자인',
                ENG_NAME: 'Design',
            },
            {
                CODE: '04',
                NAME: '상표',
                ENG_NAME: 'Trademark',
            },
            {
                CODE: '99',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '시설.장비구축 소요재원 구분',
        codeList: [
            {
                CODE: 'Y',
                NAME: 'R&D',
                ENG_NAME: 'R&D Task',
            },
            {
                CODE: 'N',
                NAME: '비R&D과제',
                ENG_NAME: 'Non-R&D Task',
            },
        ],
    },
    {
        NAME: '시설.장비분류',
        codeList: [
            {
                CODE: '01',
                NAME: '장비',
                ENG_NAME: 'Equipment',
            },
            {
                CODE: '02',
                NAME: '시설',
                ENG_NAME: 'Facility',
            },
            {
                CODE: '03',
                NAME: '대형시설',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설장비구성요소코드',
        codeList: [
            {
                CODE: '01',
                NAME: '장비기반형',
                ENG_NAME: 'Equipment Foundation',
            },
            {
                CODE: '02',
                NAME: '환경조성형',
                ENG_NAME: 'Environment Composition',
            },
        ],
    },
    {
        NAME: '시설장비여부코드',
        codeList: [
            {
                CODE: '01',
                NAME: '주장비',
                ENG_NAME: 'Major Equipment',
            },
            {
                CODE: '02',
                NAME: '부대장비',
                ENG_NAME: 'Additional Equipment',
            },
        ],
    },
    {
        NAME: '신예산부처코드',
        codeList: [
            {
                CODE: 'P08',
                NAME: '감사원',
                ENG_NAME: 'the Board of Audit and Inspection',
            },
            {
                CODE: 'P09',
                NAME: '국가정보원',
                ENG_NAME: 'National Intelligence Service',
            },
            {
                CODE: 'P10',
                NAME: '국무조정실',
                ENG_NAME: 'Office for Government Policy Coordination',
            },
            {
                CODE: 'P11',
                NAME: '기획재정부',
                ENG_NAME: 'Ministry of Strategy and Finance',
            },
            {
                CODE: 'P12',
                NAME: '미래창조과학부',
                ENG_NAME: 'Ministry of Science, ICT and Future Planning',
            },
            {
                CODE: 'P13',
                NAME: '교육부',
                ENG_NAME: 'Ministry of Education',
            },
            {
                CODE: 'P14',
                NAME: '외교부',
                ENG_NAME: 'Ministry of Foreign Affairs',
            },
            {
                CODE: 'P15',
                NAME: '통일부',
                ENG_NAME: 'Ministry of Unification',
            },
            {
                CODE: 'P16',
                NAME: '법무부',
                ENG_NAME: 'Ministry of Justice',
            },
            {
                CODE: 'P17',
                NAME: '국방부',
                ENG_NAME: 'Ministry of National Defense',
            },
            {
                CODE: 'P18',
                NAME: '안전행정부',
                ENG_NAME: 'Ministry of Security and Public Administration ',
            },
            {
                CODE: 'P19',
                NAME: '문화체육관광부',
                ENG_NAME: 'Ministry of Culture, Sports and Tourism',
            },
            {
                CODE: 'P20',
                NAME: '농림축산식품부',
                ENG_NAME: 'Ministry of Agriculture, Food and Rural Affairs',
            },
            {
                CODE: 'P21',
                NAME: '산업통상자원부',
                ENG_NAME: 'Ministry of Trade, Industry and Energy',
            },
            {
                CODE: 'P22',
                NAME: '보건복지부',
                ENG_NAME: 'Ministry of Health and Welfare',
            },
            {
                CODE: 'P23',
                NAME: '환경부',
                ENG_NAME: 'Ministry of Environment',
            },
            {
                CODE: 'P24',
                NAME: '고용노동부',
                ENG_NAME: 'Ministry of Employment and Labor',
            },
            {
                CODE: 'P25',
                NAME: '여성가족부',
                ENG_NAME: 'Ministry of Gender Equality & Familv',
            },
            {
                CODE: 'P26',
                NAME: '국토교통부',
                ENG_NAME: 'Ministry of Land, Infrastructure and Transport',
            },
            {
                CODE: 'P27',
                NAME: '해양수산부',
                ENG_NAME: 'Ministry of Maritime Affairs and Fisheries',
            },
            {
                CODE: 'P28',
                NAME: '법제처',
                ENG_NAME: 'Korea Ministry of Government Legislation',
            },
            {
                CODE: 'P29',
                NAME: '국가보훈처',
                ENG_NAME: 'Ministry of Patriots & Veterans Affairs',
            },
            {
                CODE: 'P31',
                NAME: '국가인권위원회',
                ENG_NAME: 'The National Human Rights Commission',
            },
            {
                CODE: 'P32',
                NAME: '방송통신위원회',
                ENG_NAME: 'Korea Communications Commission',
            },
            {
                CODE: 'P33',
                NAME: '공정거래위원회',
                ENG_NAME: 'The Fair Trade Commission',
            },
            {
                CODE: 'P34',
                NAME: '금융위원회',
                ENG_NAME: 'The Financial Services Commission',
            },
            {
                CODE: 'P35',
                NAME: '국민권익위원회',
                ENG_NAME: 'Anti-Corruption and Civil Rights Commission',
            },
            {
                CODE: 'P36',
                NAME: '원자력안전위원회',
                ENG_NAME: 'Nuclear Safety And Security Commission',
            },
            {
                CODE: 'P37',
                NAME: '국세청',
                ENG_NAME: 'National Tax Service',
            },
            {
                CODE: 'P38',
                NAME: '관세청',
                ENG_NAME: 'Korea Customs Service',
            },
            {
                CODE: 'P39',
                NAME: '조달청',
                ENG_NAME: 'Public Procurement Service',
            },
            {
                CODE: 'P40',
                NAME: '통계청',
                ENG_NAME: 'Statistics Korea',
            },
            {
                CODE: 'P41',
                NAME: '병무청',
                ENG_NAME: 'Military Manpower Administration',
            },
            {
                CODE: 'P42',
                NAME: '방위사업청',
                ENG_NAME: 'Defense Acquisition Program Administration',
            },
            {
                CODE: 'P43',
                NAME: '경찰청',
                ENG_NAME: 'Korea National Police Agency',
            },
            {
                CODE: 'P44',
                NAME: '소방방재청',
                ENG_NAME: 'National Emergency Management Agency',
            },
            {
                CODE: 'P45',
                NAME: '문화재청',
                ENG_NAME: 'Cultural Heritage Administration',
            },
            {
                CODE: 'P46',
                NAME: '농촌진흥청',
                ENG_NAME: 'Rural Development Administration',
            },
            {
                CODE: 'P47',
                NAME: '산림청',
                ENG_NAME: 'Korea Forest Service',
            },
            {
                CODE: 'P48',
                NAME: '중소기업청',
                ENG_NAME: 'Small and Medium Business Administration',
            },
            {
                CODE: 'P49',
                NAME: '특허청',
                ENG_NAME: 'Korean Intellectual Property Office',
            },
            {
                CODE: 'P50',
                NAME: '기상청',
                ENG_NAME: 'Korea Meteorological Administration',
            },
            {
                CODE: 'P51',
                NAME: '행정중심복합도시건설청',
                ENG_NAME: 'National Agency for Administrative City Construction',
            },
            {
                CODE: 'P52',
                NAME: '해양경찰청',
                ENG_NAME: 'Korea Coast Guard',
            },
            {
                CODE: 'P60',
                NAME: '식품의약품안전처',
                ENG_NAME: 'Ministry of Food and Drug Safety',
            },
            {
                CODE: 'P62',
                NAME: '국가안보실',
                ENG_NAME: 'National Security Office',
            },
            {
                CODE: 'P63',
                NAME: '새만금개발청',
                ENG_NAME: 'Korea Agency for Saemangeum Development and Investment',
            },
            {
                CODE: 'P68',
                NAME: '국민안전처',
                ENG_NAME: 'Ministry of Public Safety and Security',
            },
            {
                CODE: 'P69',
                NAME: '행정자치부',
                ENG_NAME: 'The Ministry of Government Administration and Home Affairs',
            },
            {
                CODE: 'P98',
                NAME: '범부처사업',
                ENG_NAME: 'Pan-Department Business',
            },
            {
                CODE: 'N15',
                NAME: '교육과학기술부',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연구개발성격구분',
        codeList: [
            {
                CODE: '1',
                NAME: '아이디어개발',
                ENG_NAME: 'Idea Development',
            },
            {
                CODE: '2',
                NAME: '시작품개발',
                ENG_NAME: 'Trial Products Development',
            },
            {
                CODE: '3',
                NAME: '제품 또는 공정개발',
                ENG_NAME: 'Product or Process Development',
            },
            {
                CODE: '4',
                NAME: '기타개발',
                ENG_NAME: 'Other Development',
            },
        ],
    },
    {
        NAME: '연구개발재원',
        codeList: [
            {
                CODE: '11',
                NAME: '일반회계',
                ENG_NAME: 'General Account',
            },
            {
                CODE: '12',
                NAME: '특별회계',
                ENG_NAME: 'Special Account',
            },
            {
                CODE: '13',
                NAME: '기금',
                ENG_NAME: 'Funds',
            },
        ],
    },
    {
        NAME: '요청구분코드',
        codeList: [
            {
                CODE: '1',
                NAME: '등록요청',
                ENG_NAME: 'Request Register',
            },
            {
                CODE: '2',
                NAME: '수정요청',
                ENG_NAME: 'Request Edit',
            },
            {
                CODE: '3',
                NAME: '삭제요청',
                ENG_NAME: 'Request Delete',
            },
        ],
    },
    {
        NAME: '유휴불용여부',
        codeList: [
            {
                CODE: '1',
                NAME: '유휴',
                ENG_NAME: 'Idleness',
            },
            {
                CODE: '2',
                NAME: '불용',
                ENG_NAME: 'Inutility',
            },
            {
                CODE: '3',
                NAME: '해당없음',
                ENG_NAME: 'N/A',
            },
        ],
    },
    {
        NAME: '유휴불용여부구분코드',
        codeList: [
            {
                CODE: '1',
                NAME: '활용',
                ENG_NAME: 'Utilization',
            },
            {
                CODE: '2',
                NAME: '유휴',
                ENG_NAME: 'Idleness',
            },
            {
                CODE: '3',
                NAME: '저활용',
                ENG_NAME: 'Low-Utilization',
            },
            {
                CODE: '4',
                NAME: '불용',
                ENG_NAME: 'Inutility',
            },
        ],
    },
    {
        NAME: '이용범위',
        codeList: [
            {
                CODE: '1',
                NAME: '부서단독활용',
                ENG_NAME: 'Exclusive Utilization in Department ',
            },
            {
                CODE: '2',
                NAME: '기관내부활용',
                ENG_NAME: 'Internal Utilization in Institution',
            },
            {
                CODE: '3',
                NAME: '외부공동활용',
                ENG_NAME: 'External Mutual Utilization',
            },
            {
                CODE: '4',
                NAME: '협의후 결정',
                ENG_NAME: 'Decided after Consultation',
            },
        ],
    },
    {
        NAME: '이용범위구분코드',
        codeList: [
            {
                CODE: '1',
                NAME: '단독활용',
                ENG_NAME: 'Exclusive Utilization',
            },
            {
                CODE: '2',
                NAME: '공동활용허용',
                ENG_NAME: 'Mutual Utilization Approved',
            },
            {
                CODE: '3',
                NAME: '공동활용서비스',
                ENG_NAME: 'Mutual Utilization Service',
            },
        ],
    },
    {
        NAME: '장비모델명존재여부',
        codeList: [
            {
                CODE: '1',
                NAME: '모델명있음',
                ENG_NAME: 'Model Name Available',
            },
            {
                CODE: '2',
                NAME: '모델명없음',
                ENG_NAME: 'Model Name Unavailable',
            },
        ],
    },
    {
        NAME: '장비심의여부코드',
        codeList: [
            {
                CODE: '01',
                NAME: '연구장비예산심의위원회',
                ENG_NAME: 'Research Equipment Budget Deliberation Committee',
            },
            {
                CODE: '02',
                NAME: '장비도입심사평가단',
                ENG_NAME: 'Equipment Introduction Judgment Evaluation Group',
            },
            {
                CODE: '03',
                NAME: '받지않음',
                ENG_NAME: 'No Receipt',
            },
        ],
    },
    {
        NAME: '장비용도코드',
        codeList: [
            {
                CODE: '01',
                NAME: '시험용',
                ENG_NAME: 'For Test',
            },
            {
                CODE: '02',
                NAME: '분석용',
                ENG_NAME: 'For Analysis',
            },
            {
                CODE: '03',
                NAME: '교육용',
                ENG_NAME: 'For Education',
            },
            {
                CODE: '04',
                NAME: '계측용',
                ENG_NAME: 'For Measurement',
            },
            {
                CODE: '05',
                NAME: '생산용',
                ENG_NAME: 'For Production',
            },
            {
                CODE: '06',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '저역서구분',
        codeList: [
            {
                CODE: '1',
                NAME: '저서',
                ENG_NAME: 'Books',
            },
            {
                CODE: '2',
                NAME: '역서',
                ENG_NAME: 'Translations',
            },
        ],
    },
    {
        NAME: '저자역할구분',
        codeList: [
            {
                CODE: '1',
                NAME: '단독',
                ENG_NAME: 'Exclusive',
            },
            {
                CODE: '2',
                NAME: '공동제1,주저자',
                ENG_NAME: 'Lead Author',
            },
            {
                CODE: '3',
                NAME: '공저자',
                ENG_NAME: 'Co-author',
            },
            {
                CODE: '4',
                NAME: '교신(책임)저자',
                ENG_NAME: 'Corresponding Author',
            },
        ],
    },
    {
        NAME: '주시설장비와 부대시설장비, 보조장치의 구분',
        codeList: [
            {
                CODE: '1',
                NAME: '주시설장비',
                ENG_NAME: 'Major Facility Equipment',
            },
            {
                CODE: '2',
                NAME: '부대시설장비',
                ENG_NAME: 'Additional Facility Equipment',
            },
            {
                CODE: '3',
                NAME: '보조장치',
                ENG_NAME: 'Subsidiary Equipment',
            },
        ],
    },
    {
        NAME: '지역구분(장비기자재)',
        codeList: [
            {
                CODE: '01',
                NAME: '강원',
                ENG_NAME: 'Gangwon-do',
            },
            {
                CODE: '02',
                NAME: '경기',
                ENG_NAME: 'Gyeonggi-do',
            },
            {
                CODE: '03',
                NAME: '경남',
                ENG_NAME: 'Gyeongsangnam-do',
            },
            {
                CODE: '04',
                NAME: '경북',
                ENG_NAME: 'Gyeongsangbuk-do',
            },
            {
                CODE: '05',
                NAME: '광주',
                ENG_NAME: 'Gwangju',
            },
            {
                CODE: '06',
                NAME: '대구',
                ENG_NAME: 'Daegu',
            },
            {
                CODE: '07',
                NAME: '대전',
                ENG_NAME: 'Daejeon',
            },
            {
                CODE: '08',
                NAME: '부산',
                ENG_NAME: 'Busan',
            },
            {
                CODE: '09',
                NAME: '서울',
                ENG_NAME: 'Seoul',
            },
            {
                CODE: '10',
                NAME: '울산',
                ENG_NAME: 'Ulsan',
            },
            {
                CODE: '11',
                NAME: '인천',
                ENG_NAME: 'Incheon',
            },
            {
                CODE: '12',
                NAME: '전남',
                ENG_NAME: 'Jeollanam-do',
            },
            {
                CODE: '13',
                NAME: '전북',
                ENG_NAME: 'Jeollabuk-do',
            },
            {
                CODE: '14',
                NAME: '제주',
                ENG_NAME: 'Jeju',
            },
            {
                CODE: '15',
                NAME: '충남',
                ENG_NAME: 'Chungcheongnam-do',
            },
            {
                CODE: '16',
                NAME: '충북',
                ENG_NAME: 'Chungcheongbuk-do',
            },
            {
                CODE: '18',
                NAME: '세종',
                ENG_NAME: 'Sejong-si',
            },
            {
                CODE: '17',
                NAME: '해외',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '처리구분코드',
        codeList: [
            {
                CODE: '11',
                NAME: '등록승인처리',
                ENG_NAME: 'Register Approved',
            },
            {
                CODE: '12',
                NAME: '등록반려처리',
                ENG_NAME: 'Register Rejected',
            },
            {
                CODE: '21',
                NAME: '수정승인처리',
                ENG_NAME: 'Edit Approved',
            },
            {
                CODE: '22',
                NAME: '수정반려처리',
                ENG_NAME: 'Edit Rejected',
            },
            {
                CODE: '31',
                NAME: '삭제승인처리',
                ENG_NAME: 'Delete Approved',
            },
            {
                CODE: '32',
                NAME: '삭제반려처리',
                ENG_NAME: 'Delete Rejected',
            },
        ],
    },
    {
        NAME: '취득금액구분코드',
        codeList: [
            {
                CODE: '01',
                NAME: '3000만원 이하',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '3000만원 이상',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '1억원 이상',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '10억원 이상',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '50억원 이상',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '취득방법',
        codeList: [
            {
                CODE: '1',
                NAME: '구입',
                ENG_NAME: 'Purchase',
            },
            {
                CODE: '2',
                NAME: '임차',
                ENG_NAME: 'Lease',
            },
            {
                CODE: '3',
                NAME: '기증',
                ENG_NAME: 'Donation',
            },
            {
                CODE: '4',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '취득방법구분코드',
        codeList: [
            {
                CODE: '1',
                NAME: '구매',
                ENG_NAME: 'Purchase',
            },
            {
                CODE: '2',
                NAME: '개발',
                ENG_NAME: 'Development',
            },
        ],
    },
    {
        NAME: '투자우선순위코드',
        codeList: [
            {
                CODE: 'A',
                NAME: '중점지원분야',
                ENG_NAME: 'Major Application Field',
            },
            {
                CODE: 'B',
                NAME: '현행유지분야',
                ENG_NAME: 'Current State Maintenance Field',
            },
            {
                CODE: 'C',
                NAME: '지원감축분야',
                ENG_NAME: 'Support Reduction Field',
            },
        ],
    },
    {
        NAME: '평가결과구분',
        codeList: [
            {
                CODE: '01',
                NAME: '미평가(취소)',
                ENG_NAME: 'Revaluation(Cancel)',
            },
            {
                CODE: '02',
                NAME: '탈락',
                ENG_NAME: 'Fail',
            },
            {
                CODE: '03',
                NAME: '선정',
                ENG_NAME: 'Selection',
            },
            {
                CODE: '04',
                NAME: '재평가대상',
                ENG_NAME: 'Revaluation Target',
            },
            {
                CODE: '05',
                NAME: '계속',
                ENG_NAME: 'Continue',
            },
            {
                CODE: '06',
                NAME: '중단',
                ENG_NAME: 'Cease',
            },
            {
                CODE: '07',
                NAME: '최우수',
                ENG_NAME: 'Excellent',
            },
            {
                CODE: '08',
                NAME: '우수',
                ENG_NAME: 'Great',
            },
            {
                CODE: '09',
                NAME: '보통',
                ENG_NAME: 'Average',
            },
            {
                CODE: '10',
                NAME: '미흡',
                ENG_NAME: 'Bad',
            },
            {
                CODE: '11',
                NAME: '불량',
                ENG_NAME: 'Failing',
            },
            {
                CODE: '12',
                NAME: '완결',
                ENG_NAME: 'Complete',
            },
        ],
    },
    {
        NAME: '평가구분',
        codeList: [
            {
                CODE: '1',
                NAME: '선정평가',
                ENG_NAME: 'Selection Evaluation',
            },
            {
                CODE: '2',
                NAME: '진도평가',
                ENG_NAME: 'Progress Evaluation',
            },
            {
                CODE: '3',
                NAME: '중간평가',
                ENG_NAME: 'Interim Evaluation',
            },
            {
                CODE: '4',
                NAME: '연차평가',
                ENG_NAME: 'Annual Evaluation',
            },
            {
                CODE: '5',
                NAME: '단계평가',
                ENG_NAME: 'Step Evaluation',
            },
            {
                CODE: '6',
                NAME: '최종평가',
                ENG_NAME: 'Final Evaluation',
            },
            {
                CODE: '7',
                NAME: '추적평가',
                ENG_NAME: 'Follow-up Evaluation',
            },
            {
                CODE: '8',
                NAME: '기타·수시평가',
                ENG_NAME: 'Other · Spot Evaluation',
            },
        ],
    },
    {
        NAME: '학술지구분(논문구분)',
        codeList: [
            {
                CODE: '01',
                NAME: '국외전문학술지',
                ENG_NAME: 'Foreign Expert Journal',
            },
            {
                CODE: '02',
                NAME: '국외학술대회발표논문집',
                ENG_NAME: 'Foreign Collection of Conference Dissertations',
            },
            {
                CODE: '03',
                NAME: '국내전문학술지',
                ENG_NAME: 'Domestic Expert Journal',
            },
            {
                CODE: '04',
                NAME: '국내학술대회발표논문집',
                ENG_NAME: 'Domestic Collection of Conference Dissertations',
            },
            {
                CODE: '05',
                NAME: '국외기타논문집',
                ENG_NAME: 'Foreign Collection of Other Dissertations',
            },
            {
                CODE: '06',
                NAME: '국내기타논문집',
                ENG_NAME: 'Domestic Collection of Other Dissertations',
            },
        ],
    },
    {
        NAME: '활용분야',
        codeList: [
            {
                CODE: '01',
                NAME: '시험',
                ENG_NAME: 'Test',
            },
            {
                CODE: '02',
                NAME: '연구',
                ENG_NAME: 'Research',
            },
            {
                CODE: '03',
                NAME: '분석',
                ENG_NAME: 'Analysis',
            },
            {
                CODE: '04',
                NAME: '검사',
                ENG_NAME: 'Examination',
            },
            {
                CODE: '05',
                NAME: '조사',
                ENG_NAME: 'Research',
            },
            {
                CODE: '06',
                NAME: '실습',
                ENG_NAME: 'Practice',
            },
            {
                CODE: '07',
                NAME: '교육',
                ENG_NAME: 'Education',
            },
            {
                CODE: '08',
                NAME: '훈련',
                ENG_NAME: 'Training',
            },
            {
                CODE: '09',
                NAME: '검정',
                ENG_NAME: 'Screening',
            },
            {
                CODE: '10',
                NAME: '감정',
                ENG_NAME: 'Appraise',
            },
            {
                CODE: '11',
                NAME: '측정',
                ENG_NAME: 'Measurement',
            },
            {
                CODE: '12',
                NAME: '관측',
                ENG_NAME: 'Observation',
            },
            {
                CODE: '13',
                NAME: '시추',
                ENG_NAME: 'Drilling',
            },
            {
                CODE: '14',
                NAME: '탐사',
                ENG_NAME: 'Exploration',
            },
            {
                CODE: '15',
                NAME: '측량',
                ENG_NAME: 'Survey',
            },
            {
                CODE: '16',
                NAME: '검교정',
                ENG_NAME: 'Calibration',
            },
            {
                CODE: '17',
                NAME: '가공',
                ENG_NAME: 'Manufacture',
            },
            {
                CODE: '18',
                NAME: '시생산',
                ENG_NAME: 'Test Production',
            },
            {
                CODE: '19',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '활용분야구분코드',
        codeList: [
            {
                CODE: '01',
                NAME: '분석',
                ENG_NAME: 'Analysis',
            },
            {
                CODE: '02',
                NAME: '시험',
                ENG_NAME: 'Test',
            },
            {
                CODE: '03',
                NAME: '교육',
                ENG_NAME: 'Education',
            },
            {
                CODE: '04',
                NAME: '계측',
                ENG_NAME: 'Measurement',
            },
            {
                CODE: '05',
                NAME: '생산',
                ENG_NAME: 'Production',
            },
            {
                CODE: '06',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '활용상태',
        codeList: [
            {
                CODE: '1',
                NAME: '양호',
                ENG_NAME: 'Fine',
            },
            {
                CODE: '2',
                NAME: 'Up-grade 필요',
                ENG_NAME: 'Up-grade Needed',
            },
            {
                CODE: '3',
                NAME: '수리/보수 필요',
                ENG_NAME: 'Maintenance and Repair Needed',
            },
            {
                CODE: '4',
                NAME: '재도입 필요',
                ENG_NAME: 'Reintroduction Needed',
            },
            {
                CODE: '5',
                NAME: '작동 불능',
                ENG_NAME: 'Operation Impossible',
            },
        ],
    },
    {
        NAME: 'ID상태구분코드',
        codeList: [
            {
                CODE: 'CMN15.USE',
                NAME: '사용',
                ENG_NAME: 'In Use',
            },
            {
                CODE: 'CMN15.STOP',
                NAME: '중지',
                ENG_NAME: 'Paused',
            },
            {
                CODE: 'CMN15.TERM',
                NAME: '해지',
                ENG_NAME: 'Terminated',
            },
            {
                CODE: 'CMN15.RESV',
                NAME: '예약',
                ENG_NAME: 'Reserved',
            },
        ],
    },
    {
        NAME: '거래처구분',
        codeList: [
            {
                CODE: 'CMN81.2',
                NAME: '법인사업자',
                ENG_NAME: 'Corporation',
            },
            {
                CODE: 'CMN81.3',
                NAME: '개인',
                ENG_NAME: null,
            },
            {
                CODE: 'CMN81.1',
                NAME: '개인사업자',
                ENG_NAME: 'Sole Proprietorship',
            },
        ],
    },
    {
        NAME: '건물번호',
        codeList: [
            {
                CODE: 'H402',
                NAME: '비슬빌리지 402동',
                ENG_NAME: 'Biseul Village-402',
            },
            {
                CODE: 'R1',
                NAME: '연구행정동',
                ENG_NAME: 'Research Administration B/D',
            },
            {
                CODE: 'R2',
                NAME: 'R2',
                ENG_NAME: 'NanoBio Research B/D',
            },
            {
                CODE: 'R3',
                NAME: 'R3',
                ENG_NAME: 'Energy Research B/D',
            },
            {
                CODE: 'R4',
                NAME: 'R4',
                ENG_NAME: 'Robot System/IT Convergence Research B/D',
            },
            {
                CODE: 'R5',
                NAME: 'R5',
                ENG_NAME: 'Advanced Convergence Research Center',
            },
            {
                CODE: 'R6',
                NAME: '중앙기기/FAB지원센터',
                ENG_NAME: 'Core Research Facilities Ⅰ/FAB Support Center ',
            },
            {
                CODE: 'R7',
                NAME: '산학협력관',
                ENG_NAME: 'University-Industry Cooperation Center',
            },
            {
                CODE: 'E1',
                NAME: '대학본부',
                ENG_NAME: 'Headquarter Complex',
            },
            {
                CODE: 'H101',
                NAME: '비슬빌리지 101동',
                ENG_NAME: 'Biseul Village-101',
            },
            {
                CODE: 'E2',
                NAME: 'E2',
                ENG_NAME: 'Emerging Materials Science B/D',
            },
            {
                CODE: 'E3',
                NAME: 'E3',
                ENG_NAME: 'IT Convergence Engineering B/D',
            },
            {
                CODE: 'E4',
                NAME: 'E4',
                ENG_NAME: 'Brain Science B/D',
            },
            {
                CODE: 'E5',
                NAME: 'E5',
                ENG_NAME: 'Robotics Engineering B/D',
            },
            {
                CODE: 'E6',
                NAME: 'E6',
                ENG_NAME: 'Energy System Engineering B/D',
            },
            {
                CODE: 'E7',
                NAME: 'E7',
                ENG_NAME: 'Consilience Hall',
            },
            {
                CODE: 'E8',
                NAME: 'E8',
                ENG_NAME: 'Central Library',
            },
            {
                CODE: 'E9',
                NAME: '실험동물센터',
                ENG_NAME: 'Animal Experimentation Center',
            },
            {
                CODE: 'S1',
                NAME: '종합 체육관',
                ENG_NAME: 'Sports Complex',
            },
            {
                CODE: 'H201',
                NAME: '비슬빌리지 201동',
                ENG_NAME: 'Biseul Village-201',
            },
            {
                CODE: 'E11',
                NAME: '가압장',
                ENG_NAME: 'Water-pressurizing Station',
            },
            {
                CODE: 'H202',
                NAME: '비슬빌리지 202동',
                ENG_NAME: 'Biseul Village-202',
            },
            {
                CODE: 'E12',
                NAME: '파워플랜트',
                ENG_NAME: 'Power Plant',
            },
            {
                CODE: 'E13',
                NAME: '지하주차장',
                ENG_NAME: 'Underground Parking Lot',
            },
            {
                CODE: 'E14',
                NAME: '온실',
                ENG_NAME: 'Greenhouse',
            },
            {
                CODE: 'E15',
                NAME: '야외음악당',
                ENG_NAME: 'Outdoor Concert Hall',
            },
            {
                CODE: 'H203',
                NAME: '비슬빌리지 203동',
                ENG_NAME: 'Biseul Village-203',
            },
            {
                CODE: 'H204',
                NAME: '비슬빌리지 204동',
                ENG_NAME: 'Biseul Village-204',
            },
            {
                CODE: '생',
                NAME: '생활관',
                ENG_NAME: null,
            },
            {
                CODE: '중',
                NAME: '중앙로 사무소',
                ENG_NAME: null,
            },
            {
                CODE: '총',
                NAME: '총장 공관',
                ENG_NAME: null,
            },
            {
                CODE: '부',
                NAME: '부총장 공관',
                ENG_NAME: null,
            },
            {
                CODE: '서',
                NAME: '서울홍보센터',
                ENG_NAME: 'Seoul Office',
            },
            {
                CODE: 'E10',
                NAME: '중앙기기센터 ',
                ENG_NAME: 'Center for Core Research Facilities Ⅱ',
            },
            {
                CODE: 'H207',
                NAME: '비슬빌리지 207동',
                ENG_NAME: 'Biseul Village-207',
            },
            {
                CODE: 'H301',
                NAME: '비슬빌리지 301동',
                ENG_NAME: 'Biseul Village-301',
            },
            {
                CODE: 'H205',
                NAME: '비슬빌리지 205동',
                ENG_NAME: 'Biseul Village-205',
            },
            {
                CODE: 'H206',
                NAME: '비슬빌리지 206동',
                ENG_NAME: 'Biseul Village-206',
            },
            {
                CODE: 'E8P',
                NAME: 'E8 야외주차장',
                ENG_NAME: 'E8 Parking Lot',
            },
            {
                CODE: 'H302',
                NAME: '비슬빌리지 302동',
                ENG_NAME: 'Biseul Village-302',
            },
            {
                CODE: 'H401',
                NAME: '비슬빌리지 401동',
                ENG_NAME: 'Biseul Village-401',
            },
        ],
    },
    {
        NAME: '계약방법',
        codeList: [
            {
                CODE: 'APC02.01',
                NAME: '소액수의(견적)',
                ENG_NAME: 'Small Value Sole Source Contract (Estimate)',
            },
            {
                CODE: 'APC02.02',
                NAME: '특정수의',
                ENG_NAME: 'Single Source Contract',
            },
            {
                CODE: 'APC02.03',
                NAME: '일반경쟁',
                ENG_NAME: 'Open Tendering',
            },
            {
                CODE: 'APC02.04',
                NAME: '제한경쟁',
                ENG_NAME: 'Limited Tendering',
            },
            {
                CODE: 'APC02.05',
                NAME: '조달의뢰',
                ENG_NAME: 'Procurement Request',
            },
            {
                CODE: 'APC02.06',
                NAME: '나라장터',
                ENG_NAME: 'Korea On-line e-Procurement System',
            },
            {
                CODE: 'APC02.07',
                NAME: '소액수의(G2B)',
                ENG_NAME: 'Small Value Sole Source Contract (G2B)',
            },
            {
                CODE: 'APC02.08',
                NAME: '협상계약',
                ENG_NAME: 'Negotiated Contract',
            },
            {
                CODE: 'APC02.09',
                NAME: '유찰수의',
                ENG_NAME: 'No-bid Sole Source Contract',
            },
            {
                CODE: 'APC02.10',
                NAME: '지명경쟁',
                ENG_NAME: 'Selective Tendering',
            },
            {
                CODE: 'APC02.11',
                NAME: '2단계입찰',
                ENG_NAME: 'Two-stage Tendering',
            },
            {
                CODE: 'APC02.99',
                NAME: '기타',
                ENG_NAME: 'Other',
            },
        ],
    },
    {
        NAME: '과제구분코드',
        codeList: [
            {
                CODE: 'RND006.06',
                NAME: '용역',
                ENG_NAME: 'Human Service',
            },
            {
                CODE: 'RND006.05',
                NAME: '자문',
                ENG_NAME: 'Advice',
            },
            {
                CODE: 'RND006.04',
                NAME: '참여',
                ENG_NAME: 'Participation',
            },
            {
                CODE: 'RND006.03',
                NAME: '위탁',
                ENG_NAME: 'Consignment',
            },
            {
                CODE: 'RND006.01',
                NAME: '주관',
                ENG_NAME: 'Administration',
            },
            {
                CODE: 'RND006.02',
                NAME: '공동',
                ENG_NAME: 'Joint',
            },
        ],
    },
    {
        NAME: '과제분류구분코드',
        codeList: [
            {
                CODE: 'RND007.01',
                NAME: '기관고유',
                ENG_NAME: 'Intramural Research Project',
            },
            {
                CODE: 'RND007.06',
                NAME: '민간수탁',
                ENG_NAME: 'Extramural Research Project',
            },
            {
                CODE: 'RND007.02',
                NAME: '일반(지정)',
                ENG_NAME: 'Intramural Research Project',
            },
            {
                CODE: 'RND007.05',
                NAME: '정부수탁',
                ENG_NAME: 'Extramural Research Project',
            },
            {
                CODE: 'RND007.04',
                NAME: '자체사업',
                ENG_NAME: 'Intramural Research Project',
            },
            {
                CODE: 'RND007.03',
                NAME: '일반(공모)',
                ENG_NAME: 'Intramural Research Project',
            },
            {
                CODE: 'RND007.07',
                NAME: '기타',
                ENG_NAME: 'Other',
            },
        ],
    },
    {
        NAME: '과제분류기타구분코드',
        codeList: [
            {
                CODE: 'RND261.01',
                NAME: '[교원]Start-up',
                ENG_NAME: '[Faculty] Start-up',
            },
            {
                CODE: 'RND261.02',
                NAME: '[연구원]Start-up',
                ENG_NAME: '[Researcher] Start-up',
            },
            {
                CODE: 'RND261.03',
                NAME: '[석학]Start-up',
                ENG_NAME: '[Postgraduate] Start-up',
            },
            {
                CODE: 'RND261.04',
                NAME: '[기초학부]Start-up',
                ENG_NAME: '[Undergraduate Basic] Start-up',
            },
            {
                CODE: 'RND261.05',
                NAME: 'IPCR사업',
                ENG_NAME: 'IPCR Project',
            },
            {
                CODE: 'RND261.06',
                NAME: '대형사업 유치지원사업',
                ENG_NAME: 'Grand-scale Project Attraction Support Project',
            },
            {
                CODE: 'RND261.08',
                NAME: '시장수요맞춤기술 Up-grade',
                ENG_NAME: 'Market Demand Customized Technology Upgrade',
            },
            {
                CODE: 'RND261.09',
                NAME: '출자기술 Customizing',
                ENG_NAME: 'Customizing Investment Technology',
            },
            {
                CODE: 'RND261.10',
                NAME: '[급여]비R&D사업',
                ENG_NAME: null,
            },
            {
                CODE: 'RND261.11',
                NAME: 'MIREBraiN 중점연구분야지원사업',
                ENG_NAME: null,
            },
            {
                CODE: 'RND261.12',
                NAME: '[기초학부]교육혁신활동',
                ENG_NAME: null,
            },
            {
                CODE: 'RND261.07',
                NAME: 'Matching Fund',
                ENG_NAME: 'Matching Fund',
            },
        ],
    },
    {
        NAME: '과제진행구분코드',
        codeList: [
            {
                CODE: 'RND009.01',
                NAME: '등록',
                ENG_NAME: 'Register',
            },
            {
                CODE: 'RND009.02',
                NAME: '승인',
                ENG_NAME: 'Approve',
            },
            {
                CODE: 'RND009.03',
                NAME: '종료',
                ENG_NAME: 'Terminate',
            },
            {
                CODE: 'RND009.04',
                NAME: '취소',
                ENG_NAME: 'Cancel',
            },
            {
                CODE: 'RND009.05',
                NAME: '중단',
                ENG_NAME: 'Suspension',
            },
            {
                CODE: 'RND009.07',
                NAME: '결재진행중',
                ENG_NAME: 'Approval in Progress',
            },
            {
                CODE: 'RND009.06',
                NAME: '전자결재승인',
                ENG_NAME: 'Approve e-Approval ',
            },
            {
                CODE: 'RND009.08',
                NAME: '반려',
                ENG_NAME: 'Reject',
            },
            {
                CODE: 'RND009.09',
                NAME: '회수',
                ENG_NAME: 'Retrieve',
            },
        ],
    },
    {
        NAME: '과제형태구분코드',
        codeList: [
            {
                CODE: 'RND010.05',
                NAME: '공동',
                ENG_NAME: 'Joint',
            },
            {
                CODE: 'RND010.02',
                NAME: '세부',
                ENG_NAME: 'Detailed',
            },
            {
                CODE: 'RND010.04',
                NAME: '위탁',
                ENG_NAME: 'Consigned',
            },
            {
                CODE: 'RND010.01',
                NAME: '총괄',
                ENG_NAME: 'Comprehensive',
            },
            {
                CODE: 'RND010.03',
                NAME: '단독',
                ENG_NAME: 'Sole',
            },
        ],
    },
    {
        NAME: '관리상태',
        codeList: [
            {
                CODE: 'AAS01.1',
                NAME: '정상(사용중)',
                ENG_NAME: 'Normal (In Use)',
            },
            {
                CODE: 'AAS01.11',
                NAME: '수리중',
                ENG_NAME: 'Under Repair',
            },
            {
                CODE: 'AAS01.21',
                NAME: '이관중',
                ENG_NAME: 'Under Transfer',
            },
            {
                CODE: 'AAS01.31',
                NAME: '반출중(일반)',
                ENG_NAME: 'Under Export (General)',
            },
            {
                CODE: 'AAS01.32',
                NAME: '반출중(대여)',
                ENG_NAME: 'Under Export (Loan)',
            },
            {
                CODE: 'AAS01.59',
                NAME: '처분',
                ENG_NAME: 'Disposed',
            },
            {
                CODE: 'AAS01.41',
                NAME: '반입중',
                ENG_NAME: 'Under Import',
            },
            {
                CODE: 'AAS01.51',
                NAME: '처분중',
                ENG_NAME: 'Under Disposal',
            },
        ],
    },
    {
        NAME: '구매구분',
        codeList: [
            {
                CODE: 'AAS34.1',
                NAME: '내자',
                ENG_NAME: 'Domestic Capital',
            },
            {
                CODE: 'AAS34.2',
                NAME: '외자',
                ENG_NAME: 'Foreign Capital',
            },
        ],
    },
    {
        NAME: '국가코드(DGIST)',
        codeList: [
            {
                CODE: 'CMN52.410',
                NAME: '대한민국',
                ENG_NAME: 'KOREA(REP.OF)',
            },
            {
                CODE: 'CMN52.840',
                NAME: '미국',
                ENG_NAME: 'UNITEDSTATES',
            },
            {
                CODE: 'CMN52.392',
                NAME: '일본',
                ENG_NAME: 'JAPAN',
            },
            {
                CODE: 'CMN52.276',
                NAME: '독일',
                ENG_NAME: 'GERMANY',
            },
            {
                CODE: 'CMN52.250',
                NAME: '프랑스',
                ENG_NAME: 'FRANCE',
            },
            {
                CODE: 'CMN52.156',
                NAME: '중국',
                ENG_NAME: 'CHINA',
            },
            {
                CODE: 'CMN52.997',
                NAME: 'EPO',
                ENG_NAME: 'EPO',
            },
            {
                CODE: 'CMN52.998',
                NAME: 'PCT',
                ENG_NAME: 'PCT',
            },
            {
                CODE: 'CMN52.288',
                NAME: '가나',
                ENG_NAME: 'GHANA',
            },
            {
                CODE: 'CMN52.266',
                NAME: '가봉',
                ENG_NAME: 'GABON',
            },
            {
                CODE: 'CMN52.328',
                NAME: '가이아나',
                ENG_NAME: 'GUYANA',
            },
            {
                CODE: 'CMN52.270',
                NAME: '감비아',
                ENG_NAME: 'GAMBIA',
            },
            {
                CODE: 'CMN52.312',
                NAME: '과들루프',
                ENG_NAME: 'GUADELOUPE',
            },
            {
                CODE: 'CMN52.320',
                NAME: '과테말라',
                ENG_NAME: 'GUATEMALA',
            },
            {
                CODE: 'CMN52.316',
                NAME: '괌',
                ENG_NAME: 'GUAM',
            },
            {
                CODE: 'CMN52.308',
                NAME: '그레나다',
                ENG_NAME: 'GRENADA',
            },
            {
                CODE: 'CMN52.268',
                NAME: '그루지야',
                ENG_NAME: 'GEORGIA',
            },
            {
                CODE: 'CMN52.300',
                NAME: '그리스',
                ENG_NAME: 'GREECE',
            },
            {
                CODE: 'CMN52.304',
                NAME: '그린란드',
                ENG_NAME: 'GREENLAND',
            },
            {
                CODE: 'CMN52.324',
                NAME: '기니',
                ENG_NAME: 'GUINEA',
            },
            {
                CODE: 'CMN52.624',
                NAME: '기니비사우',
                ENG_NAME: 'GUINEA-BISSAU',
            },
            {
                CODE: 'CMN52.516',
                NAME: '나미비아',
                ENG_NAME: 'NAMIBIA',
            },
            {
                CODE: 'CMN52.520',
                NAME: '나우루',
                ENG_NAME: 'NAURU',
            },
            {
                CODE: 'CMN52.566',
                NAME: '나이지리아',
                ENG_NAME: 'NIGERIA',
            },
            {
                CODE: 'CMN52.010',
                NAME: '남극',
                ENG_NAME: 'ANTARCTICA',
            },
            {
                CODE: 'CMN52.710',
                NAME: '남아프리카공화국',
                ENG_NAME: 'SOUTH AFRICA',
            },
            {
                CODE: 'CMN52.528',
                NAME: '네덜란드',
                ENG_NAME: 'NETHERLANDS',
            },
            {
                CODE: 'CMN52.530',
                NAME: '네덜란드령 안틸레스',
                ENG_NAME: 'NETHERLANSDS ANTILLES',
            },
            {
                CODE: 'CMN52.524',
                NAME: '네팔',
                ENG_NAME: 'NEPAL',
            },
            {
                CODE: 'CMN52.578',
                NAME: '노르웨이',
                ENG_NAME: 'NORWAY',
            },
            {
                CODE: 'CMN52.574',
                NAME: '노퍽 섬',
                ENG_NAME: 'NORFOLK ISLAND',
            },
            {
                CODE: 'CMN52.540',
                NAME: '누벨칼레도니',
                ENG_NAME: 'NEW CALEDONIA',
            },
            {
                CODE: 'CMN52.554',
                NAME: '뉴질랜드',
                ENG_NAME: 'NEWZEALAND',
            },
            {
                CODE: 'CMN52.570',
                NAME: '니우에',
                ENG_NAME: 'NIUE',
            },
            {
                CODE: 'CMN52.562',
                NAME: '니제르',
                ENG_NAME: 'NIGER',
            },
            {
                CODE: 'CMN52.558',
                NAME: '니카라과',
                ENG_NAME: 'NICARAGUA',
            },
            {
                CODE: 'CMN52.158',
                NAME: '대만(중화민국)',
                ENG_NAME: 'TAIWAN',
            },
            {
                CODE: 'CMN52.208',
                NAME: '덴마크',
                ENG_NAME: 'DENMARK',
            },
            {
                CODE: 'CMN52.212',
                NAME: '도미니카',
                ENG_NAME: 'DOMINICA',
            },
            {
                CODE: 'CMN52.214',
                NAME: '도미니카 공화국',
                ENG_NAME: 'DOMINICAN REPUBLIC',
            },
            {
                CODE: 'CMN52.626',
                NAME: '동티모르',
                ENG_NAME: 'EASTTIMOR',
            },
            {
                CODE: 'CMN52.418',
                NAME: '라오스',
                ENG_NAME: "LAOPEOPLE'SDEMOCRATICREPUBLIC",
            },
            {
                CODE: 'CMN52.430',
                NAME: '라이베리아',
                ENG_NAME: 'LIBERIA',
            },
            {
                CODE: 'CMN52.428',
                NAME: '라트비아',
                ENG_NAME: 'LATVIA',
            },
            {
                CODE: 'CMN52.643',
                NAME: '러시아',
                ENG_NAME: 'RUSSIANFEDERATION',
            },
            {
                CODE: 'CMN52.422',
                NAME: '레바논',
                ENG_NAME: 'LEBANON',
            },
            {
                CODE: 'CMN52.426',
                NAME: '레소토',
                ENG_NAME: 'LESOTHO',
            },
            {
                CODE: 'CMN52.638',
                NAME: '레위니옹',
                ENG_NAME: 'REUNION',
            },
            {
                CODE: 'CMN52.642',
                NAME: '루마니아',
                ENG_NAME: 'ROMANIA',
            },
            {
                CODE: 'CMN52.442',
                NAME: '룩셈부르크',
                ENG_NAME: 'LUXEMBOURG',
            },
            {
                CODE: 'CMN52.646',
                NAME: '르완다',
                ENG_NAME: 'RWANDA',
            },
            {
                CODE: 'CMN52.434',
                NAME: '리비아',
                ENG_NAME: 'LIBYANARABJAMAHIRIYA',
            },
            {
                CODE: 'CMN52.440',
                NAME: '리투아니아',
                ENG_NAME: 'LITHUANIA',
            },
            {
                CODE: 'CMN52.438',
                NAME: '리히텐슈타인',
                ENG_NAME: 'LIECHTENSTEIN',
            },
            {
                CODE: 'CMN52.450',
                NAME: '마다가스카르',
                ENG_NAME: 'MADAGASCAR',
            },
            {
                CODE: 'CMN52.474',
                NAME: '마르티니크',
                ENG_NAME: 'MARTINIQUE',
            },
            {
                CODE: 'CMN52.584',
                NAME: '마셜제도',
                ENG_NAME: 'THE MARSHALL ISLANDS',
            },
            {
                CODE: 'CMN52.175',
                NAME: '마요트',
                ENG_NAME: 'MAYOTTE',
            },
            {
                CODE: 'CMN52.446',
                NAME: '마카오',
                ENG_NAME: 'MACAU',
            },
            {
                CODE: 'CMN52.807',
                NAME: '마케도니아',
                ENG_NAME: 'REPUBLIC OF MACEDONIA',
            },
            {
                CODE: 'CMN52.454',
                NAME: '말라위',
                ENG_NAME: 'MALAWI',
            },
            {
                CODE: 'CMN52.458',
                NAME: '말레이시아',
                ENG_NAME: 'MALAYSIA',
            },
            {
                CODE: 'CMN52.466',
                NAME: '말리',
                ENG_NAME: 'MALI',
            },
            {
                CODE: 'CMN52.484',
                NAME: '멕시코',
                ENG_NAME: 'MEXICO',
            },
            {
                CODE: 'CMN52.492',
                NAME: '모나코',
                ENG_NAME: 'MONACO',
            },
            {
                CODE: 'CMN52.504',
                NAME: '모로코',
                ENG_NAME: 'MOROCCO',
            },
            {
                CODE: 'CMN52.480',
                NAME: '모리셔스',
                ENG_NAME: 'MAURITIUS',
            },
            {
                CODE: 'CMN52.478',
                NAME: '모리타니',
                ENG_NAME: 'MAURITANIE',
            },
            {
                CODE: 'CMN52.508',
                NAME: '모잠비크',
                ENG_NAME: 'MOZAMBIQUE',
            },
            {
                CODE: 'CMN52.500',
                NAME: '몬트세라트',
                ENG_NAME: 'MONTSERRAT ISLAND',
            },
            {
                CODE: 'CMN52.498',
                NAME: '몰도바',
                ENG_NAME: 'MOLDOVA,REPUBLICOF',
            },
            {
                CODE: 'CMN52.462',
                NAME: '몰디브',
                ENG_NAME: 'MALDIVES',
            },
            {
                CODE: 'CMN52.470',
                NAME: '몰타',
                ENG_NAME: 'MALTA',
            },
            {
                CODE: 'CMN52.496',
                NAME: '몽골',
                ENG_NAME: 'MONGOLIA',
            },
            {
                CODE: 'CMN52.581',
                NAME: '미국령 군소 제도',
                ENG_NAME: 'UNITED STATES MINOR OUTLYING ISLANDS',
            },
            {
                CODE: 'CMN52.104',
                NAME: '미얀마',
                ENG_NAME: 'MYANMAR',
            },
            {
                CODE: 'CMN52.583',
                NAME: '미크로네시아 연방',
                ENG_NAME: 'FEDERATED STATE OF MICRONESIA',
            },
            {
                CODE: 'CMN52.548',
                NAME: '바누아투',
                ENG_NAME: 'VANUATU',
            },
            {
                CODE: 'CMN52.048',
                NAME: '바레인',
                ENG_NAME: 'BAHRAIN',
            },
            {
                CODE: 'CMN52.052',
                NAME: '바베이도스',
                ENG_NAME: 'BARBADOS',
            },
            {
                CODE: 'CMN52.336',
                NAME: '바티칸 시국',
                ENG_NAME: 'VATICAN CITY',
            },
            {
                CODE: 'CMN52.044',
                NAME: '바하마',
                ENG_NAME: 'BAHAMAS',
            },
            {
                CODE: 'CMN52.050',
                NAME: '방글라데시',
                ENG_NAME: 'BANGLADESH',
            },
            {
                CODE: 'CMN52.060',
                NAME: '버뮤다',
                ENG_NAME: 'BERMUDA',
            },
            {
                CODE: 'CMN52.204',
                NAME: '베냉',
                ENG_NAME: 'BENIN',
            },
            {
                CODE: 'CMN52.862',
                NAME: '베네수엘라',
                ENG_NAME: 'VENEZUELA',
            },
            {
                CODE: 'CMN52.704',
                NAME: '베트남',
                ENG_NAME: 'VIETNAM',
            },
            {
                CODE: 'CMN52.056',
                NAME: '벨기에',
                ENG_NAME: 'BELGIUM',
            },
            {
                CODE: 'CMN52.112',
                NAME: '벨라루스',
                ENG_NAME: 'BELARUS',
            },
            {
                CODE: 'CMN52.084',
                NAME: '벨리즈',
                ENG_NAME: 'BELIZE',
            },
            {
                CODE: 'CMN52.070',
                NAME: '보스니아',
                ENG_NAME: 'BOSNIA HERZEGOVINA',
            },
            {
                CODE: 'CMN52.072',
                NAME: '보츠와나',
                ENG_NAME: 'BOTSWANA',
            },
            {
                CODE: 'CMN52.068',
                NAME: '볼리비아',
                ENG_NAME: 'BOLIVIA',
            },
            {
                CODE: 'CMN52.108',
                NAME: '부룬디',
                ENG_NAME: 'BURUNDI',
            },
            {
                CODE: 'CMN52.854',
                NAME: '부르키나파소',
                ENG_NAME: 'BURKINAFASO',
            },
            {
                CODE: 'CMN52.074',
                NAME: '부베 섬',
                ENG_NAME: 'BOUVET ISLAND',
            },
            {
                CODE: 'CMN52.064',
                NAME: '부탄',
                ENG_NAME: 'BHUTAN',
            },
            {
                CODE: 'CMN52.580',
                NAME: '북마리아나제도',
                ENG_NAME: 'NORTHERN MARIANA ISLANDS',
            },
            {
                CODE: 'CMN52.408',
                NAME: '북한',
                ENG_NAME: "DEM.PEOPLE'S REP.OF KOREA",
            },
            {
                CODE: 'CMN52.100',
                NAME: '불가리아',
                ENG_NAME: 'BULGARIA',
            },
            {
                CODE: 'CMN52.076',
                NAME: '브라질',
                ENG_NAME: 'BRAZIL',
            },
            {
                CODE: 'CMN52.096',
                NAME: '브루나이',
                ENG_NAME: 'BRUNEIDARUSSALAM',
            },
            {
                CODE: 'CMN52.882',
                NAME: '사모아',
                ENG_NAME: 'SAMOA',
            },
            {
                CODE: 'CMN52.682',
                NAME: '사우디아라비아',
                ENG_NAME: 'SAUDIARABIA',
            },
            {
                CODE: 'CMN52.239',
                NAME: '사우스조지아 사우스샌드위치 제도',
                ENG_NAME: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
            },
            {
                CODE: 'CMN52.674',
                NAME: '산마리노',
                ENG_NAME: 'SANMARINO',
            },
            {
                CODE: 'CMN52.678',
                NAME: '상투메 프린시페',
                ENG_NAME: 'SAO TOME AND PRINCIPE',
            },
            {
                CODE: 'CMN52.666',
                NAME: '생피에르 미클롱',
                ENG_NAME: 'SAINT-PIERRE AND MIQUELON',
            },
            {
                CODE: 'CMN52.732',
                NAME: '서사하라',
                ENG_NAME: 'WESTERN SAHARA',
            },
            {
                CODE: 'CMN52.686',
                NAME: '세네갈',
                ENG_NAME: 'SENEGAL',
            },
            {
                CODE: 'CMN52.891',
                NAME: '세르비아 몬테네그로',
                ENG_NAME: 'SERBIA AND MONTENEGRO',
            },
            {
                CODE: 'CMN52.690',
                NAME: '세이셸',
                ENG_NAME: 'SEYCHELLES',
            },
            {
                CODE: 'CMN52.662',
                NAME: '세인트루시아',
                ENG_NAME: 'SAINTLUCIA',
            },
            {
                CODE: 'CMN52.670',
                NAME: '세인트빈센트 그레나딘',
                ENG_NAME: 'SAINT VINCENT AND THE GRENADINES',
            },
            {
                CODE: 'CMN52.659',
                NAME: '세인트키츠 네비스',
                ENG_NAME: 'SAINT KITTS AND NEVIS',
            },
            {
                CODE: 'CMN52.654',
                NAME: '세인트헬레나',
                ENG_NAME: 'ST.HELENA',
            },
            {
                CODE: 'CMN52.706',
                NAME: '소말리아',
                ENG_NAME: 'SOMALIA',
            },
            {
                CODE: 'CMN52.090',
                NAME: '솔로몬 제도',
                ENG_NAME: 'THE SOLOMON ISLANDS',
            },
            {
                CODE: 'CMN52.736',
                NAME: '수단',
                ENG_NAME: 'SUDAN',
            },
            {
                CODE: 'CMN52.740',
                NAME: '수리남',
                ENG_NAME: 'SURINAME',
            },
            {
                CODE: 'CMN52.144',
                NAME: '스리랑카',
                ENG_NAME: 'SRILANKA',
            },
            {
                CODE: 'CMN52.744',
                NAME: '스발바르 얀마옌',
                ENG_NAME: 'SVALBARD AND JAN MAYEN ISLANDS',
            },
            {
                CODE: 'CMN52.748',
                NAME: '스와질란드',
                ENG_NAME: 'SWAZILAND',
            },
            {
                CODE: 'CMN52.752',
                NAME: '스웨덴',
                ENG_NAME: 'SWEDEN',
            },
            {
                CODE: 'CMN52.756',
                NAME: '스위스',
                ENG_NAME: 'SWITZERLAND',
            },
            {
                CODE: 'CMN52.724',
                NAME: '스페인',
                ENG_NAME: 'SPAIN',
            },
            {
                CODE: 'CMN52.703',
                NAME: '슬로바키아',
                ENG_NAME: 'SLOVAKIA',
            },
            {
                CODE: 'CMN52.705',
                NAME: '슬로베니아',
                ENG_NAME: 'SLOVENIA',
            },
            {
                CODE: 'CMN52.760',
                NAME: '시리아',
                ENG_NAME: 'SYRIANARABREPUBLIC',
            },
            {
                CODE: 'CMN52.694',
                NAME: '시에라리온',
                ENG_NAME: 'SIERRALEONE',
            },
            {
                CODE: 'CMN52.702',
                NAME: '싱가포르',
                ENG_NAME: 'SINGAPORE',
            },
            {
                CODE: 'CMN52.784',
                NAME: '아랍에미리트',
                ENG_NAME: 'UNITEDARABEMIRATES',
            },
            {
                CODE: 'CMN52.533',
                NAME: '아루바',
                ENG_NAME: 'ARUBA',
            },
            {
                CODE: 'CMN52.051',
                NAME: '아르메니아',
                ENG_NAME: 'ARMENIA',
            },
            {
                CODE: 'CMN52.032',
                NAME: '아르헨티나',
                ENG_NAME: 'ARGENTINA',
            },
            {
                CODE: 'CMN52.016',
                NAME: '아메리칸사모아',
                ENG_NAME: 'AMERICAN SAMOA',
            },
            {
                CODE: 'CMN52.352',
                NAME: '아이슬란드',
                ENG_NAME: 'ICELAND',
            },
            {
                CODE: 'CMN52.332',
                NAME: '아이티',
                ENG_NAME: 'HAITI',
            },
            {
                CODE: 'CMN52.372',
                NAME: '아일랜드',
                ENG_NAME: 'IRELAND',
            },
            {
                CODE: 'CMN52.031',
                NAME: '아제르바이잔',
                ENG_NAME: 'AZERBAIJAN',
            },
            {
                CODE: 'CMN52.004',
                NAME: '아프가니스탄',
                ENG_NAME: 'AFGHANISTAN',
            },
            {
                CODE: 'CMN52.020',
                NAME: '안도라',
                ENG_NAME: 'ANDORRA',
            },
            {
                CODE: 'CMN52.008',
                NAME: '알바니아',
                ENG_NAME: 'ALBANIA',
            },
            {
                CODE: 'CMN52.012',
                NAME: '알제리',
                ENG_NAME: 'ALGERIA',
            },
            {
                CODE: 'CMN52.024',
                NAME: '앙골라',
                ENG_NAME: 'ANGOLA',
            },
            {
                CODE: 'CMN52.028',
                NAME: '앤티가 바부다',
                ENG_NAME: 'ANTIGUA AND BARBUDA',
            },
            {
                CODE: 'CMN52.660',
                NAME: '앵귈라',
                ENG_NAME: 'ANGUILLA',
            },
            {
                CODE: 'CMN52.232',
                NAME: '에리트레아',
                ENG_NAME: 'ERITREA',
            },
            {
                CODE: 'CMN52.233',
                NAME: '에스토니아',
                ENG_NAME: 'ESTONIA',
            },
            {
                CODE: 'CMN52.218',
                NAME: '에콰도르',
                ENG_NAME: 'ECUADOR',
            },
            {
                CODE: 'CMN52.231',
                NAME: '에티오피아',
                ENG_NAME: 'ETHIOPIA',
            },
            {
                CODE: 'CMN52.222',
                NAME: '엘살바도르',
                ENG_NAME: 'ELSALVADOR',
            },
            {
                CODE: 'CMN52.826',
                NAME: '영국',
                ENG_NAME: 'UNITEDKINGDOM',
            },
            {
                CODE: 'CMN52.092',
                NAME: '영국령 버진아일랜드',
                ENG_NAME: 'BRITISH VIRGIN ISLANDS',
            },
            {
                CODE: 'CMN52.086',
                NAME: '영국령 인도양 지역',
                ENG_NAME: 'BRITISH INDIAN OCEAN TERRITORY',
            },
            {
                CODE: 'CMN52.887',
                NAME: '예멘',
                ENG_NAME: 'YEMEN,REPUBLICOF',
            },
            {
                CODE: 'CMN52.512',
                NAME: '오만',
                ENG_NAME: 'OMAN',
            },
            {
                CODE: 'CMN52.036',
                NAME: '오스트레일리아',
                ENG_NAME: 'AUSTRALIA',
            },
            {
                CODE: 'CMN52.040',
                NAME: '오스트리아',
                ENG_NAME: 'AUSTRIA',
            },
            {
                CODE: 'CMN52.340',
                NAME: '온두라스',
                ENG_NAME: 'HONDURAS',
            },
            {
                CODE: 'CMN52.248',
                NAME: '올란드 제도',
                ENG_NAME: 'ALAND ISLAND',
            },
            {
                CODE: 'CMN52.400',
                NAME: '요르단',
                ENG_NAME: 'JORDAN',
            },
            {
                CODE: 'CMN52.800',
                NAME: '우간다',
                ENG_NAME: 'UGANDA',
            },
            {
                CODE: 'CMN52.858',
                NAME: '우루과이',
                ENG_NAME: 'URUGUAY',
            },
            {
                CODE: 'CMN52.860',
                NAME: '우즈베키스탄',
                ENG_NAME: 'UZBEKISTAN',
            },
            {
                CODE: 'CMN52.804',
                NAME: '우크라이나',
                ENG_NAME: 'UKRAINE',
            },
            {
                CODE: 'CMN52.876',
                NAME: '월리스 푸투나',
                ENG_NAME: 'TERRITORY OF THE WALLIS AND FUTUNA ISLANDS',
            },
            {
                CODE: 'CMN52.368',
                NAME: '이라크',
                ENG_NAME: 'IRAQ',
            },
            {
                CODE: 'CMN52.364',
                NAME: '이란',
                ENG_NAME: 'IRAN',
            },
            {
                CODE: 'CMN52.376',
                NAME: '이스라엘',
                ENG_NAME: 'ISRAEL',
            },
            {
                CODE: 'CMN52.818',
                NAME: '이집트',
                ENG_NAME: 'EGYPT',
            },
            {
                CODE: 'CMN52.380',
                NAME: '이탈리아',
                ENG_NAME: 'ITALY',
            },
            {
                CODE: 'CMN52.356',
                NAME: '인도',
                ENG_NAME: 'INDIA',
            },
            {
                CODE: 'CMN52.360',
                NAME: '인도네시아',
                ENG_NAME: 'INDONESIA',
            },
            {
                CODE: 'CMN52.388',
                NAME: '자메이카',
                ENG_NAME: 'JAMAICA',
            },
            {
                CODE: 'CMN52.894',
                NAME: '잠비아',
                ENG_NAME: 'ZAMBIA',
            },
            {
                CODE: 'CMN52.226',
                NAME: '적도 기니',
                ENG_NAME: 'EQUATORIAL GUINEA',
            },
            {
                CODE: 'CMN52.140',
                NAME: '중앙아프리카 공화국',
                ENG_NAME: 'THE CENTRAL AFRICAN REPUBLIC',
            },
            {
                CODE: 'CMN52.262',
                NAME: '지부티',
                ENG_NAME: 'DJIBOUTI',
            },
            {
                CODE: 'CMN52.292',
                NAME: '지브롤터',
                ENG_NAME: 'GIBRALTAR',
            },
            {
                CODE: 'CMN52.716',
                NAME: '짐바브웨',
                ENG_NAME: 'ZIMBABWE',
            },
            {
                CODE: 'CMN52.148',
                NAME: '차드',
                ENG_NAME: 'CHAD',
            },
            {
                CODE: 'CMN52.203',
                NAME: '체코',
                ENG_NAME: 'CZECHREPUBLIC',
            },
            {
                CODE: 'CMN52.152',
                NAME: '칠레',
                ENG_NAME: 'CHILE',
            },
            {
                CODE: 'CMN52.120',
                NAME: '카메룬',
                ENG_NAME: 'CAMEROON',
            },
            {
                CODE: 'CMN52.132',
                NAME: '카보베르데',
                ENG_NAME: 'CAPE VERDE',
            },
            {
                CODE: 'CMN52.398',
                NAME: '카자흐스탄',
                ENG_NAME: 'KAZAKHSTAN',
            },
            {
                CODE: 'CMN52.634',
                NAME: '카타르',
                ENG_NAME: 'QATAR',
            },
            {
                CODE: 'CMN52.116',
                NAME: '캄보디아',
                ENG_NAME: 'CAMBODIA',
            },
            {
                CODE: 'CMN52.124',
                NAME: '캐나다',
                ENG_NAME: 'CANADA',
            },
            {
                CODE: 'CMN52.404',
                NAME: '케냐',
                ENG_NAME: 'KENYA',
            },
            {
                CODE: 'CMN52.136',
                NAME: '케이맨 제도',
                ENG_NAME: 'CAYMAN ISLANDS',
            },
            {
                CODE: 'CMN52.174',
                NAME: '코모로',
                ENG_NAME: 'CMNOROS',
            },
            {
                CODE: 'CMN52.188',
                NAME: '코스타리카',
                ENG_NAME: 'COSTARICA',
            },
            {
                CODE: 'CMN52.166',
                NAME: '코코스 제도',
                ENG_NAME: 'COCOS ISLANDS',
            },
            {
                CODE: 'CMN52.384',
                NAME: '코트디부아르',
                ENG_NAME: "COTE D'IVOIRE",
            },
            {
                CODE: 'CMN52.170',
                NAME: '콜롬비아',
                ENG_NAME: 'COLOMBIA',
            },
            {
                CODE: 'CMN52.178',
                NAME: '콩고 공화국',
                ENG_NAME: 'REPUBLIC OF THE CONGO',
            },
            {
                CODE: 'CMN52.180',
                NAME: '콩고 민주 공화국',
                ENG_NAME: 'DEMOCRATIC REPUBLIC OF THE CONGO',
            },
            {
                CODE: 'CMN52.192',
                NAME: '쿠바',
                ENG_NAME: 'CUBA',
            },
            {
                CODE: 'CMN52.414',
                NAME: '쿠웨이트',
                ENG_NAME: 'KUWAIT',
            },
            {
                CODE: 'CMN52.184',
                NAME: '쿡 제도',
                ENG_NAME: 'COOK ISLANDS',
            },
            {
                CODE: 'CMN52.191',
                NAME: '크로아티아',
                ENG_NAME: 'CROATIA',
            },
            {
                CODE: 'CMN52.162',
                NAME: '크리스마스 섬',
                ENG_NAME: 'CHRISTMAS ISLAND',
            },
            {
                CODE: 'CMN52.417',
                NAME: '키르기스스탄',
                ENG_NAME: 'KYRGYZSTAN',
            },
            {
                CODE: 'CMN52.296',
                NAME: '키리바시',
                ENG_NAME: 'KIRIBATI',
            },
            {
                CODE: 'CMN52.196',
                NAME: '키프로스',
                ENG_NAME: 'CYPRUS',
            },
            {
                CODE: 'CMN52.762',
                NAME: '타지키스탄',
                ENG_NAME: 'TAJIKISTAN',
            },
            {
                CODE: 'CMN52.834',
                NAME: '탄자니아',
                ENG_NAME: 'TANZANIA,UNITEDREPUBLICOF',
            },
            {
                CODE: 'CMN52.764',
                NAME: '태국(타이)',
                ENG_NAME: 'THAILAND',
            },
            {
                CODE: 'CMN52.796',
                NAME: '터크스 케이커스 제도',
                ENG_NAME: 'TURKS AND CAICOS ISLANDS',
            },
            {
                CODE: 'CMN52.792',
                NAME: '터키',
                ENG_NAME: 'TURKEY',
            },
            {
                CODE: 'CMN52.768',
                NAME: '토고',
                ENG_NAME: 'TOGO',
            },
            {
                CODE: 'CMN52.772',
                NAME: '토켈라우 제도',
                ENG_NAME: 'TOKELAU ISLANDS',
            },
            {
                CODE: 'CMN52.776',
                NAME: '통가',
                ENG_NAME: 'TONGA',
            },
            {
                CODE: 'CMN52.795',
                NAME: '투르크메니스탄',
                ENG_NAME: 'TURKMENISTAN',
            },
            {
                CODE: 'CMN52.798',
                NAME: '투발루',
                ENG_NAME: 'TUVALU',
            },
            {
                CODE: 'CMN52.788',
                NAME: '튀니지',
                ENG_NAME: 'TUNISIA',
            },
            {
                CODE: 'CMN52.780',
                NAME: '트리니다드 토바고',
                ENG_NAME: 'TRINIDAD AND TOBAGO',
            },
            {
                CODE: 'CMN52.591',
                NAME: '파나마',
                ENG_NAME: 'PANAMA',
            },
            {
                CODE: 'CMN52.600',
                NAME: '파라과이',
                ENG_NAME: 'PARAGUAY',
            },
            {
                CODE: 'CMN52.586',
                NAME: '파키스탄',
                ENG_NAME: 'PAKISTAN',
            },
            {
                CODE: 'CMN52.598',
                NAME: '파푸아 뉴기니',
                ENG_NAME: 'PAPUA NEW GUINEA',
            },
            {
                CODE: 'CMN52.585',
                NAME: '팔라우',
                ENG_NAME: 'PALAU',
            },
            {
                CODE: 'CMN52.275',
                NAME: '팔레스타인',
                ENG_NAME: 'PALESTINE',
            },
            {
                CODE: 'CMN52.234',
                NAME: '페로 제도',
                ENG_NAME: 'FAROE ISLANDS',
            },
            {
                CODE: 'CMN52.604',
                NAME: '페루',
                ENG_NAME: 'PERU',
            },
            {
                CODE: 'CMN52.620',
                NAME: '포르투갈',
                ENG_NAME: 'PORTUGAL',
            },
            {
                CODE: 'CMN52.238',
                NAME: '포클랜드 제도',
                ENG_NAME: 'FALKLAND ISLANDS',
            },
            {
                CODE: 'CMN52.616',
                NAME: '폴란드',
                ENG_NAME: 'POLAND',
            },
            {
                CODE: 'CMN52.630',
                NAME: '푸에르토리코',
                ENG_NAME: 'PUERTORICO',
            },
            {
                CODE: 'CMN52.254',
                NAME: '프랑스령 기아나',
                ENG_NAME: 'FRENCH GUIANA',
            },
            {
                CODE: 'CMN52.260',
                NAME: '프랑스령 남부 지역',
                ENG_NAME: 'FRENCH SOUTHERN TERRITORIES',
            },
            {
                CODE: 'CMN52.258',
                NAME: '프랑스령 폴리네시아',
                ENG_NAME: 'FRENCH POLYNESIA',
            },
            {
                CODE: 'CMN52.242',
                NAME: '피지',
                ENG_NAME: 'FIJI',
            },
            {
                CODE: 'CMN52.246',
                NAME: '핀란드',
                ENG_NAME: 'FINLAND',
            },
            {
                CODE: 'CMN52.608',
                NAME: '필리핀',
                ENG_NAME: 'PHILIPPINES',
            },
            {
                CODE: 'CMN52.612',
                NAME: '핏케언 섬',
                ENG_NAME: 'PITCAIRN ISLANDS',
            },
            {
                CODE: 'CMN52.334',
                NAME: '허드 맥도날드 제도',
                ENG_NAME: 'HEARD AND MCDONALD ISLANDS',
            },
            {
                CODE: 'CMN52.348',
                NAME: '헝가리',
                ENG_NAME: 'HUNGARY',
            },
            {
                CODE: 'CMN52.344',
                NAME: '홍콩',
                ENG_NAME: 'HONGKONG',
            },
            {
                CODE: 'CMN52.999',
                NAME: '기타',
                ENG_NAME: 'ETC',
            },
        ],
    },
    {
        NAME: '내외부구분코드',
        codeList: [
            {
                CODE: 'REM01.1',
                NAME: '내부',
                ENG_NAME: '내부',
            },
            {
                CODE: 'REM01.2',
                NAME: '외부',
                ENG_NAME: '외부',
            },
        ],
    },
    {
        NAME: '부서레벨구분코드',
        codeList: [
            {
                CODE: 'CMN62.4',
                NAME: '세부전공',
                ENG_NAME: 'Sub-majors (Detailed Majors)',
            },
            {
                CODE: 'CMN62.0',
                NAME: '최상위조직',
                ENG_NAME: 'Top Level Organization',
            },
            {
                CODE: 'CMN62.1',
                NAME: '처/부/단대',
                ENG_NAME: 'Office/Division/College',
            },
            {
                CODE: 'CMN62.2',
                NAME: '실/학과',
                ENG_NAME: 'Division/Major',
            },
            {
                CODE: 'CMN62.3',
                NAME: '팀/전공',
                ENG_NAME: 'Team/Department',
            },
        ],
    },
    {
        NAME: '상각계정구분',
        codeList: [
            {
                CODE: 'AAS26.1',
                NAME: '비용',
                ENG_NAME: 'Cost',
            },
            {
                CODE: 'AAS26.2',
                NAME: '특별',
                ENG_NAME: 'Special',
            },
            {
                CODE: 'AAS26.3',
                NAME: '시설잉여금',
                ENG_NAME: 'Facility Surplus',
            },
            {
                CODE: 'AAS26.4',
                NAME: '연구시설잉여금',
                ENG_NAME: 'Research Facility Surplus',
            },
        ],
    },
    {
        NAME: '상각법',
        codeList: [
            {
                CODE: 'AAS10.1',
                NAME: '정액법',
                ENG_NAME: 'Straight-line Depreciation Method',
            },
            {
                CODE: 'AAS10.2',
                NAME: '정율법',
                ENG_NAME: 'Fixed-rate Depreciation Method',
            },
        ],
    },
    {
        NAME: '수행방법구분코드',
        codeList: [
            {
                CODE: 'REM02.1',
                NAME: '의뢰',
                ENG_NAME: '의뢰',
            },
            {
                CODE: 'REM02.2',
                NAME: '직접',
                ENG_NAME: '직접',
            },
            {
                CODE: 'REM02.3',
                NAME: '재료비',
                ENG_NAME: '재료비',
            },
            {
                CODE: 'REM02.4',
                NAME: '교육비',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '신분분류코드',
        codeList: [
            {
                CODE: 'CMN06.01',
                NAME: '교원',
                ENG_NAME: 'Faculty',
            },
            {
                CODE: 'CMN06.03',
                NAME: '대우교수',
                ENG_NAME: 'Instructor',
            },
            {
                CODE: 'CMN06.02',
                NAME: '직원',
                ENG_NAME: 'Staff',
            },
            {
                CODE: 'CMN06.04',
                NAME: '조교',
                ENG_NAME: 'Teaching Assistant',
            },
            {
                CODE: 'CMN06.05',
                NAME: '연구원',
                ENG_NAME: 'Researcher',
            },
            {
                CODE: 'CMN06.11',
                NAME: '외부연구원',
                ENG_NAME: 'External Researcher',
            },
            {
                CODE: 'CMN06.06',
                NAME: '학부생',
                ENG_NAME: 'Student (Undergraduate)',
            },
            {
                CODE: 'CMN06.07',
                NAME: '대학원생',
                ENG_NAME: 'Student (Postgraduate)',
            },
            {
                CODE: 'CMN06.10',
                NAME: '타교생(교류대학원생)',
                ENG_NAME: 'Exchange Student (Postgraduate)',
            },
            {
                CODE: 'CMN06.09',
                NAME: '타교생(교류학부생)',
                ENG_NAME: 'Other School Students (Exchange Undergraduate Student)',
            },
            {
                CODE: 'CMN06.99',
                NAME: '관리자',
                ENG_NAME: 'Manager',
            },
            {
                CODE: 'CMN06.13',
                NAME: '파견직원',
                ENG_NAME: 'Dispatch Staff',
            },
            {
                CODE: 'CMN06.14',
                NAME: '유관기관직원',
                ENG_NAME: 'Related Organization Staff',
            },
            {
                CODE: 'CMN06.15',
                NAME: '전공아르바이트',
                ENG_NAME: 'Major Part-time Job ',
            },
            {
                CODE: 'CMN06.16',
                NAME: '외부업체(상주)',
                ENG_NAME: 'External Enterprise (Stationed)',
            },
            {
                CODE: 'CMN06.17',
                NAME: '전공인턴',
                ENG_NAME: 'Major Intern',
            },
            {
                CODE: 'CMN06.18',
                NAME: '수업조교',
                ENG_NAME: 'Teaching Assistant',
            },
            {
                CODE: 'CMN06.19',
                NAME: '외부감사',
                ENG_NAME: 'External Audit',
            },
            {
                CODE: 'CMN06.20',
                NAME: '외부평가위원',
                ENG_NAME: 'External Evaluation Committee',
            },
            {
                CODE: 'CMN06.21',
                NAME: '테스트계정',
                ENG_NAME: 'Test Account',
            },
            {
                CODE: 'CMN06.22',
                NAME: '아르바이트',
                ENG_NAME: 'Part-time Job',
            },
            {
                CODE: 'CMN06.23',
                NAME: '방문자',
                ENG_NAME: 'Visitor',
            },
            {
                CODE: 'CMN06.24',
                NAME: '외부',
                ENG_NAME: 'External',
            },
            {
                CODE: 'CMN06.12',
                NAME: '창업리더과정',
                ENG_NAME: 'Venture Leaders Course',
            },
        ],
    },
    {
        NAME: '위탁구분',
        codeList: [
            {
                CODE: 'RND197.01',
                NAME: '지정위탁',
                ENG_NAME: 'Designated Consignment',
            },
            {
                CODE: 'RND197.02',
                NAME: '공모위탁',
                ENG_NAME: 'Public Proposal Consignment ',
            },
        ],
    },
    {
        NAME: '위탁기관구분',
        codeList: [
            {
                CODE: 'RND196.01',
                NAME: '정부출연연구소',
                ENG_NAME: 'Government-funded Research Institute',
            },
            {
                CODE: 'RND196.02',
                NAME: '민간업체',
                ENG_NAME: 'Private Company',
            },
            {
                CODE: 'RND196.03',
                NAME: '대학교',
                ENG_NAME: 'University',
            },
            {
                CODE: 'RND196.04',
                NAME: '기타',
                ENG_NAME: 'Other',
            },
        ],
    },
    {
        NAME: '인프라구분코드',
        codeList: [
            {
                CODE: 'REM04.1',
                NAME: '기기가공실',
                ENG_NAME: '기기가공실',
            },
            {
                CODE: 'REM04.2',
                NAME: '소자클린룸',
                ENG_NAME: '소자클린룸',
            },
            {
                CODE: 'REM04.3',
                NAME: '소자클린룸(시설이용료)',
                ENG_NAME: '소자클린룸(시설이용료)',
            },
            {
                CODE: 'REM04.4',
                NAME: '재료분석실',
                ENG_NAME: '재료분석실',
            },
            {
                CODE: 'REM04.5',
                NAME: '첨단바이오분석',
                ENG_NAME: '첨단바이오분석',
            },
            {
                CODE: 'REM04.6',
                NAME: '측정 및 시물레이션',
                ENG_NAME: '측정 및 시물레이션',
            },
            {
                CODE: 'REM04.7',
                NAME: 'E9 실험동물센터',
                ENG_NAME: 'E9 실험동물센터',
            },
            {
                CODE: 'REM04.8',
                NAME: 'E9 실험동물센터(시설이용료)',
                ENG_NAME: 'E9 실험동물센터(시설이용료)',
            },
            {
                CODE: 'REM04.9',
                NAME: 'R2 동물공동실험실',
                ENG_NAME: 'R2 동물공동실험실',
            },
            {
                CODE: 'REM04.10',
                NAME: 'R2 동물공동실험실(시설이용료)',
                ENG_NAME: 'R2 동물공동실험실(시설이용료)',
            },
            {
                CODE: 'REM04.11',
                NAME: '동물공동실험실',
                ENG_NAME: '동물공동실험실',
            },
            {
                CODE: 'REM04.12',
                NAME: '슈퍼컴퓨팅',
                ENG_NAME: '슈퍼컴퓨팅',
            },
        ],
    },
    {
        NAME: '자산관리역할구분',
        codeList: [
            {
                CODE: 'AAS30.1',
                NAME: '사용자',
                ENG_NAME: 'User',
            },
            {
                CODE: 'AAS30.2',
                NAME: '책임자',
                ENG_NAME: 'Director',
            },
        ],
    },
    {
        NAME: '자산분류',
        codeList: [
            {
                CODE: 'A',
                NAME: '토지(A)',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '건물(C)',
                ENG_NAME: null,
            },
            {
                CODE: 'H',
                NAME: '차량운반구(H)',
                ENG_NAME: null,
            },
            {
                CODE: 'G',
                NAME: '공기구비품(G)',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '조원(B)',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '장서(I)',
                ENG_NAME: null,
            },
            {
                CODE: 'J',
                NAME: '건설중인 자산(J)',
                ENG_NAME: null,
            },
            {
                CODE: 'K',
                NAME: '미착장비(K)',
                ENG_NAME: null,
            },
            {
                CODE: 'L',
                NAME: '기타유형자산(L)',
                ENG_NAME: null,
            },
            {
                CODE: 'S',
                NAME: 'S/W(S)',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '구축물(D)',
                ENG_NAME: null,
            },
            {
                CODE: 'E',
                NAME: '연구기본시설(E)',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '연구기술장비(F)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '자산원가구분',
        codeList: [
            {
                CODE: 'AAS32.1',
                NAME: '원가',
                ENG_NAME: 'Cost Price',
            },
            {
                CODE: 'AAS32.2',
                NAME: '비원가',
                ENG_NAME: 'Non Cost Price',
            },
        ],
    },
    {
        NAME: '자산유무형구분',
        codeList: [
            {
                CODE: 'AAS33.1',
                NAME: '유형',
                ENG_NAME: 'Tangible',
            },
            {
                CODE: 'AAS33.2',
                NAME: '무형',
                ENG_NAME: 'Intangible',
            },
        ],
    },
    {
        NAME: '재원구분',
        codeList: [
            {
                CODE: 'AAS11.1',
                NAME: '교비',
                ENG_NAME: 'School Fund',
            },
            {
                CODE: 'AAS11.2',
                NAME: '국고',
                ENG_NAME: 'Government Subsidies',
            },
            {
                CODE: 'AAS11.3',
                NAME: '교비+국고',
                ENG_NAME: 'School Fund +Government Subsidies',
            },
        ],
    },
    {
        NAME: '전화지역번호',
        codeList: [
            {
                CODE: 'CMN57.02',
                NAME: '(02)서울',
                ENG_NAME: '(02)Seoul',
            },
            {
                CODE: 'CMN57.031',
                NAME: '(031)경기도',
                ENG_NAME: '(031)Gyeonggi-do',
            },
            {
                CODE: 'CMN57.032',
                NAME: '(032)인천광역시',
                ENG_NAME: '(032)Incheon Metropolitan City',
            },
            {
                CODE: 'CMN57.033',
                NAME: '(033)강원도',
                ENG_NAME: '(033)Gangwon-do',
            },
            {
                CODE: 'CMN57.041',
                NAME: '(041)충청남도',
                ENG_NAME: '(041)Chungcheongnam-do',
            },
            {
                CODE: 'CMN57.042',
                NAME: '(042)대전광역시',
                ENG_NAME: '(042)Daejeon Metropolitan City',
            },
            {
                CODE: 'CMN57.043',
                NAME: '(043)충청북도',
                ENG_NAME: '(043)Chungcheongbuk-do',
            },
            {
                CODE: 'CMN57.044',
                NAME: '(044)세종특별자치시',
                ENG_NAME: '(044)Sejong Metropolitan Autonomous City',
            },
            {
                CODE: 'CMN57.051',
                NAME: '(051)부산광역시',
                ENG_NAME: '(051)Busan Metropolitan City',
            },
            {
                CODE: 'CMN57.052',
                NAME: '(052)울산광역시',
                ENG_NAME: '(052)Ulsan Metropolitan City',
            },
            {
                CODE: 'CMN57.053',
                NAME: '(053)대구광역시',
                ENG_NAME: '(053)Daegu Metropolitan City',
            },
            {
                CODE: 'CMN57.054',
                NAME: '(054)경상북도',
                ENG_NAME: '(054)Gyeongsangbuk-do',
            },
            {
                CODE: 'CMN57.055',
                NAME: '(055)경상남도',
                ENG_NAME: '(055)Gyeongsangnam-do',
            },
            {
                CODE: 'CMN57.061',
                NAME: '(061)전라남도',
                ENG_NAME: '(061)Jeollanam-do',
            },
            {
                CODE: 'CMN57.062',
                NAME: '(062)광주광역시',
                ENG_NAME: '(062)Gwangju Metropolitan City',
            },
            {
                CODE: 'CMN57.063',
                NAME: '(063)전라북도',
                ENG_NAME: '(063)Jeollabuk-do',
            },
            {
                CODE: 'CMN57.064',
                NAME: '(064)제주도',
                ENG_NAME: '(064)Jeju-do',
            },
            {
                CODE: 'CMN57.070',
                NAME: '070',
                ENG_NAME: '070',
            },
        ],
    },
    {
        NAME: '조직분류구분코드',
        codeList: [
            {
                CODE: 'CMN12.02',
                NAME: '대학원',
                ENG_NAME: 'Graduate school',
            },
            {
                CODE: 'CMN12.03',
                NAME: '대학',
                ENG_NAME: 'University',
            },
            {
                CODE: 'CMN12.07',
                NAME: '센터',
                ENG_NAME: 'Center',
            },
            {
                CODE: 'CMN12.09',
                NAME: '창업리더과정',
                ENG_NAME: 'Venture Leaders Course',
            },
            {
                CODE: 'CMN12.05',
                NAME: '부설연구원',
                ENG_NAME: 'Affiliated Research Institute',
            },
            {
                CODE: 'CMN12.04',
                NAME: '연구본부',
                ENG_NAME: 'Research Headquarters',
            },
            {
                CODE: 'CMN12.06',
                NAME: '추진단',
                ENG_NAME: 'Promotion Team',
            },
            {
                CODE: 'CMN12.01',
                NAME: '행정본부',
                ENG_NAME: 'Administrative Headquarters',
            },
        ],
    },
    {
        NAME: '진행상태구분코드',
        codeList: [
            {
                CODE: 'REM03.1',
                NAME: '작성중',
                ENG_NAME: '작성중',
            },
            {
                CODE: 'REM03.10',
                NAME: '청구완료',
                ENG_NAME: '청구완료',
            },
        ],
    },
    {
        NAME: '층',
        codeList: [
            {
                CODE: '1',
                NAME: '1',
                ENG_NAME: '1',
            },
            {
                CODE: '2',
                NAME: '2',
                ENG_NAME: '2',
            },
            {
                CODE: '3',
                NAME: '3',
                ENG_NAME: '3',
            },
            {
                CODE: '4',
                NAME: '4',
                ENG_NAME: '4',
            },
            {
                CODE: '5',
                NAME: '5',
                ENG_NAME: '5',
            },
            {
                CODE: '6',
                NAME: '6',
                ENG_NAME: '6',
            },
            {
                CODE: '7',
                NAME: '7',
                ENG_NAME: '7',
            },
            {
                CODE: '8',
                NAME: '8',
                ENG_NAME: '8',
            },
            {
                CODE: '9',
                NAME: '9',
                ENG_NAME: '9',
            },
            {
                CODE: 'B1',
                NAME: 'B1',
                ENG_NAME: 'B1',
            },
            {
                CODE: 'B2',
                NAME: 'B2',
                ENG_NAME: 'B2',
            },
            {
                CODE: 'B3',
                NAME: 'B3',
                ENG_NAME: 'B3',
            },
            {
                CODE: 'B4',
                NAME: 'B4',
                ENG_NAME: 'B4',
            },
        ],
    },
    {
        NAME: '카드구분코드',
        codeList: [
            {
                CODE: 'RND054.07',
                NAME: '이지바로',
                ENG_NAME: 'EZbaro',
            },
            {
                CODE: 'RND054.01',
                NAME: '기업카드',
                ENG_NAME: 'Corporate Card',
            },
            {
                CODE: 'RND054.02',
                NAME: '신한카드',
                ENG_NAME: 'Shinhan Card',
            },
            {
                CODE: 'RND054.03',
                NAME: 'RCMS',
                ENG_NAME: 'RCMS',
            },
            {
                CODE: 'RND054.04',
                NAME: '삼성카드',
                ENG_NAME: 'Samsung Card',
            },
            {
                CODE: 'RND054.05',
                NAME: '기타카드',
                ENG_NAME: 'Other Card',
            },
        ],
    },
    {
        NAME: '호실',
        codeList: [
            {
                CODE: '1',
                NAME: '101호',
                ENG_NAME: '101호',
            },
            {
                CODE: '2',
                NAME: '102호',
                ENG_NAME: '102호',
            },
            {
                CODE: '3',
                NAME: '103호',
                ENG_NAME: '103호',
            },
            {
                CODE: '4',
                NAME: '1층복도',
                ENG_NAME: '1층복도',
            },
            {
                CODE: '5',
                NAME: '1층남편계단',
                ENG_NAME: '1층남편계단',
            },
            {
                CODE: '6',
                NAME: '1층북편계단',
                ENG_NAME: '1층북편계단',
            },
            {
                CODE: '7',
                NAME: '1층남화장실',
                ENG_NAME: '1층남화장실',
            },
            {
                CODE: '8',
                NAME: '1층여화장실',
                ENG_NAME: '1층여화장실',
            },
            {
                CODE: '9',
                NAME: '1층',
                ENG_NAME: '1층',
            },
            {
                CODE: '10',
                NAME: '201호',
                ENG_NAME: '201호',
            },
            {
                CODE: '11',
                NAME: '202호',
                ENG_NAME: '202호',
            },
            {
                CODE: '12',
                NAME: '국제회의장',
                ENG_NAME: '국제회의장',
            },
            {
                CODE: '13',
                NAME: '대강당',
                ENG_NAME: '대강당',
            },
            {
                CODE: '14',
                NAME: '2층복도',
                ENG_NAME: '2층복도',
            },
            {
                CODE: '15',
                NAME: '2층북편계단',
                ENG_NAME: '2층북편계단',
            },
            {
                CODE: '16',
                NAME: '2층남화장실',
                ENG_NAME: '2층남화장실',
            },
            {
                CODE: '17',
                NAME: '2층여화장실',
                ENG_NAME: '2층여화장실',
            },
            {
                CODE: '18',
                NAME: '301호',
                ENG_NAME: '301호',
            },
            {
                CODE: '19',
                NAME: '조정실',
                ENG_NAME: '조정실',
            },
            {
                CODE: '20',
                NAME: '3층복도',
                ENG_NAME: '3층복도',
            },
            {
                CODE: '21',
                NAME: '3층북편계단',
                ENG_NAME: '3층북편계단',
            },
            {
                CODE: '22',
                NAME: '3층남화장실',
                ENG_NAME: '3층남화장실',
            },
            {
                CODE: '23',
                NAME: '3층여화장실',
                ENG_NAME: '3층여화장실',
            },
            {
                CODE: '24',
                NAME: '401호',
                ENG_NAME: '401호',
            },
            {
                CODE: '27',
                NAME: '404호',
                ENG_NAME: '404호',
            },
            {
                CODE: '28',
                NAME: '4층복도',
                ENG_NAME: '4층복도',
            },
            {
                CODE: '29',
                NAME: '4층북편계단',
                ENG_NAME: '4층북편계단',
            },
            {
                CODE: '30',
                NAME: '4층남화장실',
                ENG_NAME: '4층남화장실',
            },
            {
                CODE: '31',
                NAME: '4층여화장실',
                ENG_NAME: '4층여화장실',
            },
            {
                CODE: '32',
                NAME: '501호',
                ENG_NAME: '501호',
            },
            {
                CODE: '33',
                NAME: '5층복도',
                ENG_NAME: '5층복도',
            },
            {
                CODE: '34',
                NAME: '5층북편계단',
                ENG_NAME: '5층북편계단',
            },
            {
                CODE: '35',
                NAME: '5층남화장실',
                ENG_NAME: '5층남화장실',
            },
            {
                CODE: '36',
                NAME: '5층여화장실',
                ENG_NAME: '5층여화장실',
            },
            {
                CODE: '37',
                NAME: '601호',
                ENG_NAME: '601호',
            },
            {
                CODE: '38',
                NAME: '602호',
                ENG_NAME: '602호',
            },
            {
                CODE: '39',
                NAME: '603호',
                ENG_NAME: '603호',
            },
            {
                CODE: '40',
                NAME: '604호',
                ENG_NAME: '604호',
            },
            {
                CODE: '41',
                NAME: '605호',
                ENG_NAME: '605호',
            },
            {
                CODE: '42',
                NAME: '606호',
                ENG_NAME: '606호',
            },
            {
                CODE: '43',
                NAME: '처장비서실',
                ENG_NAME: '처장비서실',
            },
            {
                CODE: '44',
                NAME: '탕비실',
                ENG_NAME: '탕비실',
            },
            {
                CODE: '45',
                NAME: '부총장비서실',
                ENG_NAME: '부총장비서실',
            },
            {
                CODE: '46',
                NAME: '6층복도',
                ENG_NAME: '6층복도',
            },
            {
                CODE: '47',
                NAME: '6층북편계단',
                ENG_NAME: '6층북편계단',
            },
            {
                CODE: '48',
                NAME: '6층남화장실',
                ENG_NAME: '6층남화장실',
            },
            {
                CODE: '49',
                NAME: '6층여화장실',
                ENG_NAME: '6층여화장실',
            },
            {
                CODE: '50',
                NAME: '704호',
                ENG_NAME: '704호',
            },
            {
                CODE: '51',
                NAME: '703호',
                ENG_NAME: '703호',
            },
            {
                CODE: '52',
                NAME: '702호',
                ENG_NAME: '702호',
            },
            {
                CODE: '53',
                NAME: '701호',
                ENG_NAME: '701호',
            },
            {
                CODE: '54',
                NAME: '비서실',
                ENG_NAME: '비서실',
            },
            {
                CODE: '55',
                NAME: '7층복도',
                ENG_NAME: '7층복도',
            },
            {
                CODE: '56',
                NAME: '7층북편계단',
                ENG_NAME: '7층북편계단',
            },
            {
                CODE: '57',
                NAME: '7층남화장실',
                ENG_NAME: '7층남화장실',
            },
            {
                CODE: '58',
                NAME: '7층여화장실',
                ENG_NAME: '7층여화장실',
            },
            {
                CODE: '59',
                NAME: '101호',
                ENG_NAME: '101호',
            },
            {
                CODE: '60',
                NAME: '102호',
                ENG_NAME: '102호',
            },
            {
                CODE: '61',
                NAME: '103호',
                ENG_NAME: '103호',
            },
            {
                CODE: '62',
                NAME: '104호',
                ENG_NAME: '104호',
            },
            {
                CODE: '63',
                NAME: '105호',
                ENG_NAME: '105호',
            },
            {
                CODE: '64',
                NAME: '106-A호',
                ENG_NAME: '106-A호',
            },
            {
                CODE: '65',
                NAME: '107호',
                ENG_NAME: '107호',
            },
            {
                CODE: '66',
                NAME: '1층복도',
                ENG_NAME: '1층복도',
            },
            {
                CODE: '67',
                NAME: '1층동편계단',
                ENG_NAME: '1층동편계단',
            },
            {
                CODE: '68',
                NAME: '1층서편계단',
                ENG_NAME: '1층서편계단',
            },
            {
                CODE: '69',
                NAME: '1층남화장실',
                ENG_NAME: '1층남화장실',
            },
            {
                CODE: '70',
                NAME: '1층여화장실',
                ENG_NAME: '1층여화장실',
            },
            {
                CODE: '71',
                NAME: '201호',
                ENG_NAME: '201호',
            },
            {
                CODE: '72',
                NAME: '202호',
                ENG_NAME: '202호',
            },
            {
                CODE: '73',
                NAME: '203호',
                ENG_NAME: '203호',
            },
            {
                CODE: '74',
                NAME: '204호',
                ENG_NAME: '204호',
            },
            {
                CODE: '75',
                NAME: '205호',
                ENG_NAME: '205호',
            },
            {
                CODE: '76',
                NAME: '206호',
                ENG_NAME: '206호',
            },
            {
                CODE: '77',
                NAME: '207호',
                ENG_NAME: '207호',
            },
            {
                CODE: '78',
                NAME: '208호',
                ENG_NAME: '208호',
            },
            {
                CODE: '79',
                NAME: '209호',
                ENG_NAME: '209호',
            },
            {
                CODE: '80',
                NAME: '210호',
                ENG_NAME: '210호',
            },
            {
                CODE: '81',
                NAME: '211호',
                ENG_NAME: '211호',
            },
            {
                CODE: '82',
                NAME: '212호',
                ENG_NAME: '212호',
            },
            {
                CODE: '83',
                NAME: '2층복도',
                ENG_NAME: '2층복도',
            },
            {
                CODE: '84',
                NAME: '2층동편계단',
                ENG_NAME: '2층동편계단',
            },
            {
                CODE: '85',
                NAME: '2층서편계단',
                ENG_NAME: '2층서편계단',
            },
            {
                CODE: '86',
                NAME: '2층남화장실',
                ENG_NAME: '2층남화장실',
            },
            {
                CODE: '87',
                NAME: '2층여화장실',
                ENG_NAME: '2층여화장실',
            },
            {
                CODE: '88',
                NAME: '301호',
                ENG_NAME: '301호',
            },
            {
                CODE: '89',
                NAME: '302호',
                ENG_NAME: '302호',
            },
            {
                CODE: '90',
                NAME: '303호',
                ENG_NAME: '303호',
            },
            {
                CODE: '91',
                NAME: '304호',
                ENG_NAME: '304호',
            },
            {
                CODE: '92',
                NAME: '305호',
                ENG_NAME: '305호',
            },
            {
                CODE: '93',
                NAME: '306호',
                ENG_NAME: '306호',
            },
            {
                CODE: '94',
                NAME: '307호',
                ENG_NAME: '307호',
            },
            {
                CODE: '95',
                NAME: '308호',
                ENG_NAME: '308호',
            },
            {
                CODE: '96',
                NAME: '309호',
                ENG_NAME: '309호',
            },
            {
                CODE: '97',
                NAME: '310호',
                ENG_NAME: '310호',
            },
            {
                CODE: '98',
                NAME: '311호',
                ENG_NAME: '311호',
            },
            {
                CODE: '99',
                NAME: '312호',
                ENG_NAME: '312호',
            },
            {
                CODE: '100',
                NAME: '313호',
                ENG_NAME: '313호',
            },
            {
                CODE: '101',
                NAME: '3층복도',
                ENG_NAME: '3층복도',
            },
            {
                CODE: '102',
                NAME: '3층동편계단',
                ENG_NAME: '3층동편계단',
            },
            {
                CODE: '103',
                NAME: '3층서편계단',
                ENG_NAME: '3층서편계단',
            },
            {
                CODE: '104',
                NAME: '3층남화장실',
                ENG_NAME: '3층남화장실',
            },
            {
                CODE: '105',
                NAME: '3층여화장실',
                ENG_NAME: '3층여화장실',
            },
            {
                CODE: '106',
                NAME: '401호',
                ENG_NAME: '401호',
            },
            {
                CODE: '107',
                NAME: '402호',
                ENG_NAME: '402호',
            },
            {
                CODE: '108',
                NAME: '403호',
                ENG_NAME: '403호',
            },
            {
                CODE: '109',
                NAME: '404호',
                ENG_NAME: '404호',
            },
            {
                CODE: '110',
                NAME: '405호',
                ENG_NAME: '405호',
            },
            {
                CODE: '111',
                NAME: '406호',
                ENG_NAME: '406호',
            },
            {
                CODE: '112',
                NAME: '407호',
                ENG_NAME: '407호',
            },
            {
                CODE: '113',
                NAME: '408호',
                ENG_NAME: '408호',
            },
            {
                CODE: '114',
                NAME: '409호',
                ENG_NAME: '409호',
            },
            {
                CODE: '115',
                NAME: '410호',
                ENG_NAME: '410호',
            },
            {
                CODE: '116',
                NAME: '411호',
                ENG_NAME: '411호',
            },
            {
                CODE: '117',
                NAME: '412호',
                ENG_NAME: '412호',
            },
            {
                CODE: '118',
                NAME: '4층복도',
                ENG_NAME: '4층복도',
            },
            {
                CODE: '119',
                NAME: '4층동편계단',
                ENG_NAME: '4층동편계단',
            },
            {
                CODE: '120',
                NAME: '4층서편계단',
                ENG_NAME: '4층서편계단',
            },
            {
                CODE: '121',
                NAME: '4층남화장실',
                ENG_NAME: '4층남화장실',
            },
            {
                CODE: '122',
                NAME: '4층여화장실',
                ENG_NAME: '4층여화장실',
            },
            {
                CODE: '123',
                NAME: '501호',
                ENG_NAME: '501호',
            },
            {
                CODE: '124',
                NAME: '502호',
                ENG_NAME: '502호',
            },
            {
                CODE: '125',
                NAME: '503호',
                ENG_NAME: '503호',
            },
            {
                CODE: '126',
                NAME: '504호',
                ENG_NAME: '504호',
            },
            {
                CODE: '127',
                NAME: '505호',
                ENG_NAME: '505호',
            },
            {
                CODE: '128',
                NAME: '506호',
                ENG_NAME: '506호',
            },
            {
                CODE: '129',
                NAME: '507호',
                ENG_NAME: '507호',
            },
            {
                CODE: '130',
                NAME: '508호',
                ENG_NAME: '508호',
            },
            {
                CODE: '131',
                NAME: '509호',
                ENG_NAME: '509호',
            },
            {
                CODE: '132',
                NAME: '510호',
                ENG_NAME: '510호',
            },
            {
                CODE: '133',
                NAME: '511호',
                ENG_NAME: '511호',
            },
            {
                CODE: '134',
                NAME: '512호',
                ENG_NAME: '512호',
            },
            {
                CODE: '135',
                NAME: '5층복도',
                ENG_NAME: '5층복도',
            },
            {
                CODE: '136',
                NAME: '5층동편계단',
                ENG_NAME: '5층동편계단',
            },
            {
                CODE: '137',
                NAME: '5층서편계단',
                ENG_NAME: '5층서편계단',
            },
            {
                CODE: '138',
                NAME: '5층남화장실',
                ENG_NAME: '5층남화장실',
            },
            {
                CODE: '139',
                NAME: '5층여화장실',
                ENG_NAME: '5층여화장실',
            },
            {
                CODE: '140',
                NAME: '601호',
                ENG_NAME: '601호',
            },
            {
                CODE: '141',
                NAME: '602호',
                ENG_NAME: '602호',
            },
            {
                CODE: '142',
                NAME: '603호',
                ENG_NAME: '603호',
            },
            {
                CODE: '143',
                NAME: '604호',
                ENG_NAME: '604호',
            },
            {
                CODE: '144',
                NAME: '605호',
                ENG_NAME: '605호',
            },
            {
                CODE: '145',
                NAME: '606호',
                ENG_NAME: '606호',
            },
            {
                CODE: '146',
                NAME: '607호',
                ENG_NAME: '607호',
            },
            {
                CODE: '147',
                NAME: '608호',
                ENG_NAME: '608호',
            },
            {
                CODE: '148',
                NAME: '609호',
                ENG_NAME: '609호',
            },
            {
                CODE: '149',
                NAME: '610호',
                ENG_NAME: '610호',
            },
            {
                CODE: '150',
                NAME: '611호',
                ENG_NAME: '611호',
            },
            {
                CODE: '151',
                NAME: '612호',
                ENG_NAME: '612호',
            },
            {
                CODE: '152',
                NAME: '613호',
                ENG_NAME: '613호',
            },
            {
                CODE: '153',
                NAME: '614호',
                ENG_NAME: '614호',
            },
            {
                CODE: '154',
                NAME: '615호',
                ENG_NAME: '615호',
            },
            {
                CODE: '155',
                NAME: '6층복도',
                ENG_NAME: '6층복도',
            },
            {
                CODE: '156',
                NAME: '6층동편계단',
                ENG_NAME: '6층동편계단',
            },
            {
                CODE: '157',
                NAME: '6층서편계단',
                ENG_NAME: '6층서편계단',
            },
            {
                CODE: '158',
                NAME: '6층남화장실',
                ENG_NAME: '6층남화장실',
            },
            {
                CODE: '159',
                NAME: '6층여화장실',
                ENG_NAME: '6층여화장실',
            },
            {
                CODE: '160',
                NAME: '나노바이오연구동 옥상',
                ENG_NAME: '나노바이오연구동 옥상',
            },
            {
                CODE: '161',
                NAME: '101호',
                ENG_NAME: '101호',
            },
            {
                CODE: '162',
                NAME: '102호',
                ENG_NAME: '102호',
            },
            {
                CODE: '163',
                NAME: '103호',
                ENG_NAME: '103호',
            },
            {
                CODE: '164',
                NAME: '104호',
                ENG_NAME: '104호',
            },
            {
                CODE: '165',
                NAME: '105호',
                ENG_NAME: '105호',
            },
            {
                CODE: '166',
                NAME: '106호',
                ENG_NAME: '106호',
            },
            {
                CODE: '167',
                NAME: '107호',
                ENG_NAME: '107호',
            },
            {
                CODE: '168',
                NAME: '1층복도',
                ENG_NAME: '1층복도',
            },
            {
                CODE: '169',
                NAME: '1층동편계단',
                ENG_NAME: '1층동편계단',
            },
            {
                CODE: '170',
                NAME: '1층서편계단',
                ENG_NAME: '1층서편계단',
            },
            {
                CODE: '171',
                NAME: '1층남화장실',
                ENG_NAME: '1층남화장실',
            },
            {
                CODE: '172',
                NAME: '1층여화장실',
                ENG_NAME: '1층여화장실',
            },
            {
                CODE: '173',
                NAME: '201호',
                ENG_NAME: '201호',
            },
            {
                CODE: '174',
                NAME: '202호',
                ENG_NAME: '202호',
            },
            {
                CODE: '175',
                NAME: '203호',
                ENG_NAME: '203호',
            },
            {
                CODE: '176',
                NAME: '204호',
                ENG_NAME: '204호',
            },
            {
                CODE: '177',
                NAME: '205호',
                ENG_NAME: '205호',
            },
            {
                CODE: '178',
                NAME: '206호',
                ENG_NAME: '206호',
            },
            {
                CODE: '179',
                NAME: '207호',
                ENG_NAME: '207호',
            },
            {
                CODE: '180',
                NAME: '208호',
                ENG_NAME: '208호',
            },
            {
                CODE: '181',
                NAME: '209호',
                ENG_NAME: '209호',
            },
            {
                CODE: '182',
                NAME: '210호',
                ENG_NAME: '210호',
            },
            {
                CODE: '183',
                NAME: '211A호',
                ENG_NAME: '211A호',
            },
            {
                CODE: '184',
                NAME: '211B호',
                ENG_NAME: '211B호',
            },
            {
                CODE: '185',
                NAME: '212호',
                ENG_NAME: '212호',
            },
            {
                CODE: '186',
                NAME: '213호',
                ENG_NAME: '213호',
            },
            {
                CODE: '187',
                NAME: '2층복도',
                ENG_NAME: '2층복도',
            },
            {
                CODE: '188',
                NAME: '2층동편계단',
                ENG_NAME: '2층동편계단',
            },
            {
                CODE: '189',
                NAME: '2층서편계단',
                ENG_NAME: '2층서편계단',
            },
            {
                CODE: '190',
                NAME: '2층남화장실',
                ENG_NAME: '2층남화장실',
            },
            {
                CODE: '191',
                NAME: '2층여화장실',
                ENG_NAME: '2층여화장실',
            },
            {
                CODE: '192',
                NAME: '301호',
                ENG_NAME: '301호',
            },
            {
                CODE: '193',
                NAME: '302호',
                ENG_NAME: '302호',
            },
            {
                CODE: '194',
                NAME: '303호',
                ENG_NAME: '303호',
            },
            {
                CODE: '195',
                NAME: '304호',
                ENG_NAME: '304호',
            },
            {
                CODE: '196',
                NAME: '305호',
                ENG_NAME: '305호',
            },
            {
                CODE: '197',
                NAME: '306호',
                ENG_NAME: '306호',
            },
            {
                CODE: '198',
                NAME: '307호',
                ENG_NAME: '307호',
            },
            {
                CODE: '199',
                NAME: '308호',
                ENG_NAME: '308호',
            },
            {
                CODE: '200',
                NAME: '309호',
                ENG_NAME: '309호',
            },
            {
                CODE: '201',
                NAME: '310호',
                ENG_NAME: '310호',
            },
            {
                CODE: '202',
                NAME: '311호',
                ENG_NAME: '311호',
            },
            {
                CODE: '203',
                NAME: '312호',
                ENG_NAME: '312호',
            },
            {
                CODE: '204',
                NAME: '313호',
                ENG_NAME: '313호',
            },
            {
                CODE: '205',
                NAME: '3층복도',
                ENG_NAME: '3층복도',
            },
            {
                CODE: '206',
                NAME: '3층동편계단',
                ENG_NAME: '3층동편계단',
            },
            {
                CODE: '207',
                NAME: '3층서편계단',
                ENG_NAME: '3층서편계단',
            },
            {
                CODE: '208',
                NAME: '3층남화장실',
                ENG_NAME: '3층남화장실',
            },
            {
                CODE: '209',
                NAME: '3층여화장실',
                ENG_NAME: '3층여화장실',
            },
            {
                CODE: '210',
                NAME: '401호',
                ENG_NAME: '401호',
            },
            {
                CODE: '211',
                NAME: '402호',
                ENG_NAME: '402호',
            },
            {
                CODE: '212',
                NAME: '403호',
                ENG_NAME: '403호',
            },
            {
                CODE: '213',
                NAME: '404호',
                ENG_NAME: '404호',
            },
            {
                CODE: '214',
                NAME: '405호',
                ENG_NAME: '405호',
            },
            {
                CODE: '215',
                NAME: '406호',
                ENG_NAME: '406호',
            },
            {
                CODE: '216',
                NAME: '407호',
                ENG_NAME: '407호',
            },
            {
                CODE: '217',
                NAME: '408호',
                ENG_NAME: '408호',
            },
            {
                CODE: '218',
                NAME: '409호',
                ENG_NAME: '409호',
            },
            {
                CODE: '219',
                NAME: '410-1호',
                ENG_NAME: '410-1호',
            },
            {
                CODE: '220',
                NAME: '410-2호',
                ENG_NAME: '410-2호',
            },
            {
                CODE: '221',
                NAME: '411호',
                ENG_NAME: '411호',
            },
            {
                CODE: '222',
                NAME: '412호',
                ENG_NAME: '412호',
            },
            {
                CODE: '223',
                NAME: '4층복도',
                ENG_NAME: '4층복도',
            },
            {
                CODE: '224',
                NAME: '4층동편계단',
                ENG_NAME: '4층동편계단',
            },
            {
                CODE: '225',
                NAME: '4층서편계단',
                ENG_NAME: '4층서편계단',
            },
            {
                CODE: '226',
                NAME: '4층남화장실',
                ENG_NAME: '4층남화장실',
            },
            {
                CODE: '227',
                NAME: '4층여화장실',
                ENG_NAME: '4층여화장실',
            },
            {
                CODE: '228',
                NAME: '501호',
                ENG_NAME: '501호',
            },
            {
                CODE: '229',
                NAME: '502호',
                ENG_NAME: '502호',
            },
            {
                CODE: '230',
                NAME: '503호',
                ENG_NAME: '503호',
            },
            {
                CODE: '231',
                NAME: '504호',
                ENG_NAME: '504호',
            },
            {
                CODE: '232',
                NAME: '505호',
                ENG_NAME: '505호',
            },
            {
                CODE: '233',
                NAME: '506호',
                ENG_NAME: '506호',
            },
            {
                CODE: '234',
                NAME: '507호',
                ENG_NAME: '507호',
            },
            {
                CODE: '235',
                NAME: '508호',
                ENG_NAME: '508호',
            },
            {
                CODE: '236',
                NAME: '509호',
                ENG_NAME: '509호',
            },
            {
                CODE: '237',
                NAME: '510호',
                ENG_NAME: '510호',
            },
            {
                CODE: '238',
                NAME: '511호',
                ENG_NAME: '511호',
            },
            {
                CODE: '239',
                NAME: '512호',
                ENG_NAME: '512호',
            },
            {
                CODE: '240',
                NAME: '5층복도',
                ENG_NAME: '5층복도',
            },
            {
                CODE: '241',
                NAME: '5층동편계단',
                ENG_NAME: '5층동편계단',
            },
            {
                CODE: '242',
                NAME: '5층서편계단',
                ENG_NAME: '5층서편계단',
            },
            {
                CODE: '243',
                NAME: '5층남화장실',
                ENG_NAME: '5층남화장실',
            },
            {
                CODE: '244',
                NAME: '5층여화장실',
                ENG_NAME: '5층여화장실',
            },
            {
                CODE: '245',
                NAME: '601호',
                ENG_NAME: '601호',
            },
            {
                CODE: '246',
                NAME: '602호',
                ENG_NAME: '602호',
            },
            {
                CODE: '247',
                NAME: '603호',
                ENG_NAME: '603호',
            },
            {
                CODE: '248',
                NAME: '604호',
                ENG_NAME: '604호',
            },
            {
                CODE: '249',
                NAME: '605호',
                ENG_NAME: '605호',
            },
            {
                CODE: '250',
                NAME: '606호',
                ENG_NAME: '606호',
            },
            {
                CODE: '251',
                NAME: '607호',
                ENG_NAME: '607호',
            },
            {
                CODE: '252',
                NAME: '608호',
                ENG_NAME: '608호',
            },
            {
                CODE: '253',
                NAME: '609호',
                ENG_NAME: '609호',
            },
            {
                CODE: '254',
                NAME: '610호',
                ENG_NAME: '610호',
            },
            {
                CODE: '257',
                NAME: '612호',
                ENG_NAME: '612호',
            },
            {
                CODE: '258',
                NAME: '6층복도',
                ENG_NAME: '6층복도',
            },
            {
                CODE: '259',
                NAME: '6층동편계단',
                ENG_NAME: '6층동편계단',
            },
            {
                CODE: '260',
                NAME: '6층서편계단',
                ENG_NAME: '6층서편계단',
            },
            {
                CODE: '261',
                NAME: '6층남화장실',
                ENG_NAME: '6층남화장실',
            },
            {
                CODE: '262',
                NAME: '6층여화장실',
                ENG_NAME: '6층여화장실',
            },
            {
                CODE: '263',
                NAME: '701호',
                ENG_NAME: '701호',
            },
            {
                CODE: '264',
                NAME: '702호',
                ENG_NAME: '702호',
            },
            {
                CODE: '265',
                NAME: '703호',
                ENG_NAME: '703호',
            },
            {
                CODE: '266',
                NAME: '704호',
                ENG_NAME: '704호',
            },
            {
                CODE: '267',
                NAME: '705호',
                ENG_NAME: '705호',
            },
            {
                CODE: '268',
                NAME: '706호',
                ENG_NAME: '706호',
            },
            {
                CODE: '269',
                NAME: '707호',
                ENG_NAME: '707호',
            },
            {
                CODE: '270',
                NAME: '708호',
                ENG_NAME: '708호',
            },
            {
                CODE: '271',
                NAME: '709호',
                ENG_NAME: '709호',
            },
            {
                CODE: '272',
                NAME: '710호',
                ENG_NAME: '710호',
            },
            {
                CODE: '273',
                NAME: '711호',
                ENG_NAME: '711호',
            },
            {
                CODE: '274',
                NAME: '712호',
                ENG_NAME: '712호',
            },
            {
                CODE: '275',
                NAME: '7층복도',
                ENG_NAME: '7층복도',
            },
            {
                CODE: '276',
                NAME: '7층동편계단',
                ENG_NAME: '7층동편계단',
            },
            {
                CODE: '277',
                NAME: '7층서편계단',
                ENG_NAME: '7층서편계단',
            },
            {
                CODE: '278',
                NAME: '7층남화장실',
                ENG_NAME: '7층남화장실',
            },
            {
                CODE: '279',
                NAME: '7층여화장실',
                ENG_NAME: '7층여화장실',
            },
            {
                CODE: '280',
                NAME: '801호',
                ENG_NAME: '801호',
            },
            {
                CODE: '281',
                NAME: '802호',
                ENG_NAME: '802호',
            },
            {
                CODE: '282',
                NAME: '803호',
                ENG_NAME: '803호',
            },
            {
                CODE: '283',
                NAME: '804호',
                ENG_NAME: '804호',
            },
            {
                CODE: '284',
                NAME: '805호',
                ENG_NAME: '805호',
            },
            {
                CODE: '285',
                NAME: '806호',
                ENG_NAME: '806호',
            },
            {
                CODE: '286',
                NAME: '807호',
                ENG_NAME: '807호',
            },
            {
                CODE: '287',
                NAME: '808호',
                ENG_NAME: '808호',
            },
            {
                CODE: '288',
                NAME: '809호',
                ENG_NAME: '809호',
            },
            {
                CODE: '289',
                NAME: '810호',
                ENG_NAME: '810호',
            },
            {
                CODE: '290',
                NAME: '811호',
                ENG_NAME: '811호',
            },
            {
                CODE: '291',
                NAME: '8층복도',
                ENG_NAME: '8층복도',
            },
            {
                CODE: '292',
                NAME: '8층동편계단',
                ENG_NAME: '8층동편계단',
            },
            {
                CODE: '293',
                NAME: '8층서편계단',
                ENG_NAME: '8층서편계단',
            },
            {
                CODE: '294',
                NAME: '8층남화장실',
                ENG_NAME: '8층남화장실',
            },
            {
                CODE: '295',
                NAME: '8층여화장실',
                ENG_NAME: '8층여화장실',
            },
            {
                CODE: '296',
                NAME: '옥상',
                ENG_NAME: '옥상',
            },
            {
                CODE: '297',
                NAME: '101호',
                ENG_NAME: '101호',
            },
            {
                CODE: '298',
                NAME: '102호',
                ENG_NAME: '102호',
            },
            {
                CODE: '299',
                NAME: '103호',
                ENG_NAME: '103호',
            },
            {
                CODE: '300',
                NAME: '104호',
                ENG_NAME: '104호',
            },
            {
                CODE: '301',
                NAME: '105호',
                ENG_NAME: '105호',
            },
            {
                CODE: '302',
                NAME: '1층복도',
                ENG_NAME: '1층복도',
            },
            {
                CODE: '303',
                NAME: '1층동편계단',
                ENG_NAME: '1층동편계단',
            },
            {
                CODE: '304',
                NAME: '1층서편계단',
                ENG_NAME: '1층서편계단',
            },
            {
                CODE: '305',
                NAME: '1층남화장실',
                ENG_NAME: '1층남화장실',
            },
            {
                CODE: '306',
                NAME: '1층여화장실',
                ENG_NAME: '1층여화장실',
            },
            {
                CODE: '307',
                NAME: '201호',
                ENG_NAME: '201호',
            },
            {
                CODE: '308',
                NAME: '202호',
                ENG_NAME: '202호',
            },
            {
                CODE: '309',
                NAME: '203호',
                ENG_NAME: '203호',
            },
            {
                CODE: '310',
                NAME: '204호',
                ENG_NAME: '204호',
            },
            {
                CODE: '311',
                NAME: '205호',
                ENG_NAME: '205호',
            },
            {
                CODE: '312',
                NAME: '206호',
                ENG_NAME: '206호',
            },
            {
                CODE: '313',
                NAME: '2층복도',
                ENG_NAME: '2층복도',
            },
            {
                CODE: '314',
                NAME: '2층동편계단',
                ENG_NAME: '2층동편계단',
            },
            {
                CODE: '315',
                NAME: '2층서편계단',
                ENG_NAME: '2층서편계단',
            },
            {
                CODE: '316',
                NAME: '2층남화장실',
                ENG_NAME: '2층남화장실',
            },
            {
                CODE: '317',
                NAME: '2층여화장실',
                ENG_NAME: '2층여화장실',
            },
            {
                CODE: '318',
                NAME: '301호',
                ENG_NAME: '301호',
            },
            {
                CODE: '319',
                NAME: '302호',
                ENG_NAME: '302호',
            },
            {
                CODE: '320',
                NAME: '303호',
                ENG_NAME: '303호',
            },
            {
                CODE: '321',
                NAME: '304호',
                ENG_NAME: '304호',
            },
            {
                CODE: '322',
                NAME: '305호',
                ENG_NAME: '305호',
            },
            {
                CODE: '323',
                NAME: '306호',
                ENG_NAME: '306호',
            },
            {
                CODE: '324',
                NAME: '307호',
                ENG_NAME: '307호',
            },
            {
                CODE: '325',
                NAME: '308호',
                ENG_NAME: '308호',
            },
            {
                CODE: '326',
                NAME: '309호',
                ENG_NAME: '309호',
            },
            {
                CODE: '327',
                NAME: '310호',
                ENG_NAME: '310호',
            },
            {
                CODE: '328',
                NAME: '311호',
                ENG_NAME: '311호',
            },
            {
                CODE: '329',
                NAME: '312호',
                ENG_NAME: '312호',
            },
            {
                CODE: '330',
                NAME: '313호',
                ENG_NAME: '313호',
            },
            {
                CODE: '331',
                NAME: '314호',
                ENG_NAME: '314호',
            },
            {
                CODE: '334',
                NAME: '316호',
                ENG_NAME: '316호',
            },
            {
                CODE: '335',
                NAME: '3층복도',
                ENG_NAME: '3층복도',
            },
            {
                CODE: '336',
                NAME: '3층동편계단',
                ENG_NAME: '3층동편계단',
            },
            {
                CODE: '337',
                NAME: '3층서편계단',
                ENG_NAME: '3층서편계단',
            },
            {
                CODE: '338',
                NAME: '3층남화장실',
                ENG_NAME: '3층남화장실',
            },
            {
                CODE: '339',
                NAME: '3층여화장실',
                ENG_NAME: '3층여화장실',
            },
            {
                CODE: '340',
                NAME: '401호',
                ENG_NAME: '401호',
            },
            {
                CODE: '341',
                NAME: '402호',
                ENG_NAME: '402호',
            },
            {
                CODE: '342',
                NAME: '403호',
                ENG_NAME: '403호',
            },
            {
                CODE: '343',
                NAME: '404호',
                ENG_NAME: '404호',
            },
            {
                CODE: '344',
                NAME: '405호',
                ENG_NAME: '405호',
            },
            {
                CODE: '345',
                NAME: '406호',
                ENG_NAME: '406호',
            },
            {
                CODE: '346',
                NAME: '407호',
                ENG_NAME: '407호',
            },
            {
                CODE: '347',
                NAME: '408호',
                ENG_NAME: '408호',
            },
            {
                CODE: '348',
                NAME: '409호',
                ENG_NAME: '409호',
            },
            {
                CODE: '349',
                NAME: '410호',
                ENG_NAME: '410호',
            },
            {
                CODE: '350',
                NAME: '411호',
                ENG_NAME: '411호',
            },
            {
                CODE: '351',
                NAME: '412호',
                ENG_NAME: '412호',
            },
            {
                CODE: '352',
                NAME: '413호',
                ENG_NAME: '413호',
            },
            {
                CODE: '353',
                NAME: '414호',
                ENG_NAME: '414호',
            },
            {
                CODE: '354',
                NAME: '415호',
                ENG_NAME: '415호',
            },
            {
                CODE: '355',
                NAME: '4층복도',
                ENG_NAME: '4층복도',
            },
            {
                CODE: '356',
                NAME: '4층동편계단',
                ENG_NAME: '4층동편계단',
            },
            {
                CODE: '357',
                NAME: '4층서편계단',
                ENG_NAME: '4층서편계단',
            },
            {
                CODE: '358',
                NAME: '4층남화장실',
                ENG_NAME: '4층남화장실',
            },
            {
                CODE: '359',
                NAME: '4층여화장실',
                ENG_NAME: '4층여화장실',
            },
            {
                CODE: '360',
                NAME: '501호',
                ENG_NAME: '501호',
            },
            {
                CODE: '361',
                NAME: '502호',
                ENG_NAME: '502호',
            },
            {
                CODE: '362',
                NAME: '503호',
                ENG_NAME: '503호',
            },
            {
                CODE: '363',
                NAME: '504호',
                ENG_NAME: '504호',
            },
            {
                CODE: '364',
                NAME: '505호',
                ENG_NAME: '505호',
            },
            {
                CODE: '365',
                NAME: '506호',
                ENG_NAME: '506호',
            },
            {
                CODE: '366',
                NAME: '507호',
                ENG_NAME: '507호',
            },
            {
                CODE: '367',
                NAME: '508호',
                ENG_NAME: '508호',
            },
            {
                CODE: '368',
                NAME: '509호',
                ENG_NAME: '509호',
            },
            {
                CODE: '369',
                NAME: '510호',
                ENG_NAME: '510호',
            },
            {
                CODE: '370',
                NAME: '511호',
                ENG_NAME: '511호',
            },
            {
                CODE: '371',
                NAME: '512호',
                ENG_NAME: '512호',
            },
            {
                CODE: '374',
                NAME: '514호',
                ENG_NAME: '514호',
            },
            {
                CODE: '375',
                NAME: '515호',
                ENG_NAME: '515호',
            },
            {
                CODE: '376',
                NAME: '5층복도',
                ENG_NAME: '5층복도',
            },
            {
                CODE: '377',
                NAME: '5층동편계단',
                ENG_NAME: '5층동편계단',
            },
            {
                CODE: '378',
                NAME: '5층서편계단',
                ENG_NAME: '5층서편계단',
            },
            {
                CODE: '379',
                NAME: '5층남화장실',
                ENG_NAME: '5층남화장실',
            },
            {
                CODE: '380',
                NAME: '5층여화장실',
                ENG_NAME: '5층여화장실',
            },
            {
                CODE: '381',
                NAME: '601호',
                ENG_NAME: '601호',
            },
            {
                CODE: '382',
                NAME: '602호',
                ENG_NAME: '602호',
            },
            {
                CODE: '383',
                NAME: '603호',
                ENG_NAME: '603호',
            },
            {
                CODE: '384',
                NAME: '604호',
                ENG_NAME: '604호',
            },
            {
                CODE: '385',
                NAME: '605호',
                ENG_NAME: '605호',
            },
            {
                CODE: '386',
                NAME: '606호',
                ENG_NAME: '606호',
            },
            {
                CODE: '387',
                NAME: '607호',
                ENG_NAME: '607호',
            },
            {
                CODE: '388',
                NAME: '608호',
                ENG_NAME: '608호',
            },
            {
                CODE: '389',
                NAME: '609호',
                ENG_NAME: '609호',
            },
            {
                CODE: '390',
                NAME: '610호',
                ENG_NAME: '610호',
            },
            {
                CODE: '391',
                NAME: '611호',
                ENG_NAME: '611호',
            },
            {
                CODE: '392',
                NAME: '612호',
                ENG_NAME: '612호',
            },
            {
                CODE: '393',
                NAME: '613호',
                ENG_NAME: '613호',
            },
            {
                CODE: '394',
                NAME: '614호',
                ENG_NAME: '614호',
            },
            {
                CODE: '395',
                NAME: '615호',
                ENG_NAME: '615호',
            },
            {
                CODE: '396',
                NAME: '6층복도',
                ENG_NAME: '6층복도',
            },
            {
                CODE: '397',
                NAME: '6층동편계단',
                ENG_NAME: '6층동편계단',
            },
            {
                CODE: '398',
                NAME: '6층서편계단',
                ENG_NAME: '6층서편계단',
            },
            {
                CODE: '399',
                NAME: '6층남화장실',
                ENG_NAME: '6층남화장실',
            },
            {
                CODE: '400',
                NAME: '6층여화장실',
                ENG_NAME: '6층여화장실',
            },
            {
                CODE: '401',
                NAME: '701호',
                ENG_NAME: '701호',
            },
            {
                CODE: '402',
                NAME: '702호',
                ENG_NAME: '702호',
            },
            {
                CODE: '403',
                NAME: '703호',
                ENG_NAME: '703호',
            },
            {
                CODE: '404',
                NAME: '704호',
                ENG_NAME: '704호',
            },
            {
                CODE: '405',
                NAME: '705호',
                ENG_NAME: '705호',
            },
            {
                CODE: '406',
                NAME: '706호',
                ENG_NAME: '706호',
            },
            {
                CODE: '407',
                NAME: '707호',
                ENG_NAME: '707호',
            },
            {
                CODE: '408',
                NAME: '708호',
                ENG_NAME: '708호',
            },
            {
                CODE: '409',
                NAME: '709호',
                ENG_NAME: '709호',
            },
            {
                CODE: '410',
                NAME: '710호',
                ENG_NAME: '710호',
            },
            {
                CODE: '411',
                NAME: '711호',
                ENG_NAME: '711호',
            },
            {
                CODE: '412',
                NAME: '712호',
                ENG_NAME: '712호',
            },
            {
                CODE: '414',
                NAME: '713호',
                ENG_NAME: '713호',
            },
            {
                CODE: '415',
                NAME: '714호',
                ENG_NAME: '714호',
            },
            {
                CODE: '416',
                NAME: '715호',
                ENG_NAME: '715호',
            },
            {
                CODE: '417',
                NAME: '7층복도',
                ENG_NAME: '7층복도',
            },
            {
                CODE: '418',
                NAME: '7층동편계단',
                ENG_NAME: '7층동편계단',
            },
            {
                CODE: '419',
                NAME: '7층서편계단',
                ENG_NAME: '7층서편계단',
            },
            {
                CODE: '420',
                NAME: '7층남화장실',
                ENG_NAME: '7층남화장실',
            },
            {
                CODE: '421',
                NAME: '7층여화장실',
                ENG_NAME: '7층여화장실',
            },
            {
                CODE: '422',
                NAME: '801호',
                ENG_NAME: '801호',
            },
            {
                CODE: '423',
                NAME: '802호',
                ENG_NAME: '802호',
            },
            {
                CODE: '424',
                NAME: '803호',
                ENG_NAME: '803호',
            },
            {
                CODE: '425',
                NAME: '804호',
                ENG_NAME: '804호',
            },
            {
                CODE: '426',
                NAME: '805호',
                ENG_NAME: '805호',
            },
            {
                CODE: '427',
                NAME: '806호',
                ENG_NAME: '806호',
            },
            {
                CODE: '428',
                NAME: '807호',
                ENG_NAME: '807호',
            },
            {
                CODE: '429',
                NAME: '808호',
                ENG_NAME: '808호',
            },
            {
                CODE: '430',
                NAME: '809호',
                ENG_NAME: '809호',
            },
            {
                CODE: '431',
                NAME: '810호',
                ENG_NAME: '810호',
            },
            {
                CODE: '432',
                NAME: '811호',
                ENG_NAME: '811호',
            },
            {
                CODE: '433',
                NAME: '812호',
                ENG_NAME: '812호',
            },
            {
                CODE: '434',
                NAME: '813호',
                ENG_NAME: '813호',
            },
            {
                CODE: '435',
                NAME: '814호',
                ENG_NAME: '814호',
            },
            {
                CODE: '436',
                NAME: '815호',
                ENG_NAME: '815호',
            },
            {
                CODE: '437',
                NAME: '816호',
                ENG_NAME: '816호',
            },
            {
                CODE: '438',
                NAME: '817호',
                ENG_NAME: '817호',
            },
            {
                CODE: '439',
                NAME: '8층복도',
                ENG_NAME: '8층복도',
            },
            {
                CODE: '440',
                NAME: '8층동편계단',
                ENG_NAME: '8층동편계단',
            },
            {
                CODE: '441',
                NAME: '8층서편계단',
                ENG_NAME: '8층서편계단',
            },
            {
                CODE: '442',
                NAME: '8층남화장실',
                ENG_NAME: '8층남화장실',
            },
            {
                CODE: '443',
                NAME: '8층여화장실',
                ENG_NAME: '8층여화장실',
            },
            {
                CODE: '444',
                NAME: '로봇시스템/IT융합연구동 옥상',
                ENG_NAME: '로봇시스템/IT융합연구동 옥상',
            },
            {
                CODE: '445',
                NAME: '101호',
                ENG_NAME: '101호',
            },
            {
                CODE: '446',
                NAME: '102호',
                ENG_NAME: '102호',
            },
            {
                CODE: '447',
                NAME: '103호',
                ENG_NAME: '103호',
            },
            {
                CODE: '448',
                NAME: '104호',
                ENG_NAME: '104호',
            },
            {
                CODE: '449',
                NAME: '105호',
                ENG_NAME: '105호',
            },
            {
                CODE: '450',
                NAME: '106호',
                ENG_NAME: '106호',
            },
            {
                CODE: '451',
                NAME: '107호',
                ENG_NAME: '107호',
            },
            {
                CODE: '452',
                NAME: '108호',
                ENG_NAME: '108호',
            },
            {
                CODE: '453',
                NAME: '1층복도',
                ENG_NAME: '1층복도',
            },
            {
                CODE: '454',
                NAME: '1층서편계단',
                ENG_NAME: '1층서편계단',
            },
            {
                CODE: '455',
                NAME: '1층남화장실',
                ENG_NAME: '1층남화장실',
            },
            {
                CODE: '456',
                NAME: '1층여화장실',
                ENG_NAME: '1층여화장실',
            },
            {
                CODE: '457',
                NAME: '1층',
                ENG_NAME: '1층',
            },
            {
                CODE: '458',
                NAME: '201호',
                ENG_NAME: '201호',
            },
            {
                CODE: '459',
                NAME: '202호',
                ENG_NAME: '202호',
            },
            {
                CODE: '460',
                NAME: '203호',
                ENG_NAME: '203호',
            },
            {
                CODE: '461',
                NAME: '204호',
                ENG_NAME: '204호',
            },
            {
                CODE: '462',
                NAME: '205호',
                ENG_NAME: '205호',
            },
            {
                CODE: '463',
                NAME: '206호',
                ENG_NAME: '206호',
            },
            {
                CODE: '464',
                NAME: '207호',
                ENG_NAME: '207호',
            },
            {
                CODE: '465',
                NAME: '208호',
                ENG_NAME: '208호',
            },
            {
                CODE: '466',
                NAME: '209호',
                ENG_NAME: '209호',
            },
            {
                CODE: '467',
                NAME: '210호',
                ENG_NAME: '210호',
            },
            {
                CODE: '468',
                NAME: '211호',
                ENG_NAME: '211호',
            },
            {
                CODE: '469',
                NAME: '212호',
                ENG_NAME: '212호',
            },
            {
                CODE: '470',
                NAME: '213호',
                ENG_NAME: '213호',
            },
            {
                CODE: '471',
                NAME: '2층복도',
                ENG_NAME: '2층복도',
            },
            {
                CODE: '472',
                NAME: '2층서편계단',
                ENG_NAME: '2층서편계단',
            },
            {
                CODE: '473',
                NAME: '2층남화장실',
                ENG_NAME: '2층남화장실',
            },
            {
                CODE: '474',
                NAME: '2층여화장실',
                ENG_NAME: '2층여화장실',
            },
            {
                CODE: '475',
                NAME: '301호',
                ENG_NAME: '301호',
            },
            {
                CODE: '476',
                NAME: '302호',
                ENG_NAME: '302호',
            },
            {
                CODE: '477',
                NAME: '303호',
                ENG_NAME: '303호',
            },
            {
                CODE: '478',
                NAME: '304호',
                ENG_NAME: '304호',
            },
            {
                CODE: '479',
                NAME: '305호',
                ENG_NAME: '305호',
            },
            {
                CODE: '480',
                NAME: '306호',
                ENG_NAME: '306호',
            },
            {
                CODE: '481',
                NAME: '307호',
                ENG_NAME: '307호',
            },
            {
                CODE: '482',
                NAME: '308호',
                ENG_NAME: '308호',
            },
            {
                CODE: '483',
                NAME: '309호',
                ENG_NAME: '309호',
            },
            {
                CODE: '484',
                NAME: '310호',
                ENG_NAME: '310호',
            },
            {
                CODE: '485',
                NAME: '311호',
                ENG_NAME: '311호',
            },
            {
                CODE: '486',
                NAME: '312호',
                ENG_NAME: '312호',
            },
            {
                CODE: '487',
                NAME: '3층복도',
                ENG_NAME: '3층복도',
            },
            {
                CODE: '488',
                NAME: '3층서편계단',
                ENG_NAME: '3층서편계단',
            },
            {
                CODE: '489',
                NAME: '3층남화장실',
                ENG_NAME: '3층남화장실',
            },
            {
                CODE: '490',
                NAME: '3층여화장실',
                ENG_NAME: '3층여화장실',
            },
            {
                CODE: '491',
                NAME: '401호',
                ENG_NAME: '401호',
            },
            {
                CODE: '492',
                NAME: '402호',
                ENG_NAME: '402호',
            },
            {
                CODE: '493',
                NAME: '403호',
                ENG_NAME: '403호',
            },
            {
                CODE: '494',
                NAME: '404호',
                ENG_NAME: '404호',
            },
            {
                CODE: '495',
                NAME: '405호',
                ENG_NAME: '405호',
            },
            {
                CODE: '496',
                NAME: '406호',
                ENG_NAME: '406호',
            },
            {
                CODE: '497',
                NAME: '407호',
                ENG_NAME: '407호',
            },
            {
                CODE: '498',
                NAME: '408호',
                ENG_NAME: '408호',
            },
            {
                CODE: '499',
                NAME: '409호',
                ENG_NAME: '409호',
            },
            {
                CODE: '500',
                NAME: '410호',
                ENG_NAME: '410호',
            },
            {
                CODE: '501',
                NAME: '411호',
                ENG_NAME: '411호',
            },
            {
                CODE: '502',
                NAME: '412호',
                ENG_NAME: '412호',
            },
            {
                CODE: '503',
                NAME: '4층복도',
                ENG_NAME: '4층복도',
            },
            {
                CODE: '504',
                NAME: '4층서편계단',
                ENG_NAME: '4층서편계단',
            },
            {
                CODE: '505',
                NAME: '4층남화장실',
                ENG_NAME: '4층남화장실',
            },
            {
                CODE: '506',
                NAME: '4층여화장실',
                ENG_NAME: '4층여화장실',
            },
            {
                CODE: '507',
                NAME: '5층복도',
                ENG_NAME: '5층복도',
            },
            {
                CODE: '508',
                NAME: '5층서편계단',
                ENG_NAME: '5층서편계단',
            },
            {
                CODE: '509',
                NAME: '5층남화장실',
                ENG_NAME: '5층남화장실',
            },
            {
                CODE: '510',
                NAME: '5층여화장실',
                ENG_NAME: '5층여화장실',
            },
            {
                CODE: '511',
                NAME: '101호',
                ENG_NAME: '101호',
            },
            {
                CODE: '512',
                NAME: '기계실1',
                ENG_NAME: '기계실1',
            },
            {
                CODE: '513',
                NAME: '1층서편계단',
                ENG_NAME: '1층서편계단',
            },
            {
                CODE: '514',
                NAME: '1층남화장실',
                ENG_NAME: '1층남화장실',
            },
            {
                CODE: '515',
                NAME: '1층여화장실',
                ENG_NAME: '1층여화장실',
            },
            {
                CODE: '516',
                NAME: '201-A',
                ENG_NAME: '201-A',
            },
            {
                CODE: '517',
                NAME: '202호',
                ENG_NAME: '202호',
            },
            {
                CODE: '518',
                NAME: '203호',
                ENG_NAME: '203호',
            },
            {
                CODE: '519',
                NAME: '204호',
                ENG_NAME: '204호',
            },
            {
                CODE: '520',
                NAME: '205호',
                ENG_NAME: '205호',
            },
            {
                CODE: '521',
                NAME: '기계실2',
                ENG_NAME: '기계실2',
            },
            {
                CODE: '522',
                NAME: '2층서편계단',
                ENG_NAME: '2층서편계단',
            },
            {
                CODE: '523',
                NAME: '2층남화장실',
                ENG_NAME: '2층남화장실',
            },
            {
                CODE: '524',
                NAME: '2층여화장실',
                ENG_NAME: '2층여화장실',
            },
            {
                CODE: '525',
                NAME: '301호',
                ENG_NAME: '301호',
            },
            {
                CODE: '526',
                NAME: '302호',
                ENG_NAME: '302호',
            },
            {
                CODE: '527',
                NAME: '303호',
                ENG_NAME: '303호',
            },
            {
                CODE: '528',
                NAME: '304호',
                ENG_NAME: '304호',
            },
            {
                CODE: '529',
                NAME: '305호',
                ENG_NAME: '305호',
            },
            {
                CODE: '530',
                NAME: '기계실3',
                ENG_NAME: '기계실3',
            },
            {
                CODE: '531',
                NAME: '3층서편계단',
                ENG_NAME: '3층서편계단',
            },
            {
                CODE: '532',
                NAME: '3층남화장실',
                ENG_NAME: '3층남화장실',
            },
            {
                CODE: '533',
                NAME: '3층여화장실',
                ENG_NAME: '3층여화장실',
            },
            {
                CODE: '681',
                NAME: '106-B호',
                ENG_NAME: '106-B호',
            },
            {
                CODE: '1000',
                NAME: '공통',
                ENG_NAME: '공통',
            },
            {
                CODE: '1001',
                NAME: '대회의실',
                ENG_NAME: '대회의실',
            },
            {
                CODE: '1002',
                NAME: '사무실',
                ENG_NAME: '사무실',
            },
            {
                CODE: '1003',
                NAME: '소회의실',
                ENG_NAME: '소회의실',
            },
            {
                CODE: '1004',
                NAME: '총장실',
                ENG_NAME: '총장실',
            },
            {
                CODE: '1005',
                NAME: '공관',
                ENG_NAME: '공관',
            },
            {
                CODE: '1006',
                NAME: '공관',
                ENG_NAME: '공관',
            },
            {
                CODE: '1011',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1012',
                NAME: '1층',
                ENG_NAME: '1층',
            },
            {
                CODE: '1013',
                NAME: '201B',
                ENG_NAME: '201B',
            },
            {
                CODE: '1014',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '1015',
                NAME: '214호',
                ENG_NAME: '214호',
            },
            {
                CODE: '1016',
                NAME: '1층 ',
                ENG_NAME: '1층 ',
            },
            {
                CODE: '1018',
                NAME: '215호 ',
                ENG_NAME: '215호 ',
            },
            {
                CODE: '1019',
                NAME: '518',
                ENG_NAME: '518',
            },
            {
                CODE: '1020',
                NAME: '106A',
                ENG_NAME: '106A',
            },
            {
                CODE: '1021',
                NAME: '106B',
                ENG_NAME: '106B',
            },
            {
                CODE: '1022',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1023',
                NAME: '1층',
                ENG_NAME: '1층',
            },
            {
                CODE: '1024',
                NAME: '106B',
                ENG_NAME: '106B',
            },
            {
                CODE: '1025',
                NAME: '410',
                ENG_NAME: '410',
            },
            {
                CODE: '1026',
                NAME: 'B1',
                ENG_NAME: 'B1',
            },
            {
                CODE: '1027',
                NAME: '611',
                ENG_NAME: '611',
            },
            {
                CODE: '1028',
                NAME: '1층',
                ENG_NAME: '1층',
            },
            {
                CODE: '1030',
                NAME: '315호',
                ENG_NAME: '315호',
            },
            {
                CODE: '1031',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '1032',
                NAME: '513호',
                ENG_NAME: '513호',
            },
            {
                CODE: '1033',
                NAME: '513',
                ENG_NAME: '513',
            },
            {
                CODE: '1034',
                NAME: '700',
                ENG_NAME: '700',
            },
            {
                CODE: '1035',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '1036',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1037',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1038',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '1039',
                NAME: '600',
                ENG_NAME: '600',
            },
            {
                CODE: '1040',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '1041',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '1042',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '1043',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '1044',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '1045',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '1046',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '1047',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '1048',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '1049',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '1050',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '1051',
                NAME: '212',
                ENG_NAME: '212',
            },
            {
                CODE: '1052',
                NAME: '213',
                ENG_NAME: '213',
            },
            {
                CODE: '1053',
                NAME: '214',
                ENG_NAME: '214',
            },
            {
                CODE: '1054',
                NAME: '218',
                ENG_NAME: '218',
            },
            {
                CODE: '1055',
                NAME: '219',
                ENG_NAME: '219',
            },
            {
                CODE: '1056',
                NAME: '220',
                ENG_NAME: '220',
            },
            {
                CODE: '1057',
                NAME: '221',
                ENG_NAME: '221',
            },
            {
                CODE: '1058',
                NAME: '224',
                ENG_NAME: '224',
            },
            {
                CODE: '1059',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '1060',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1061',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '1062',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '1063',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '1064',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '1065',
                NAME: '215',
                ENG_NAME: '215',
            },
            {
                CODE: '1066',
                NAME: '216',
                ENG_NAME: '216',
            },
            {
                CODE: '1067',
                NAME: '217',
                ENG_NAME: '217',
            },
            {
                CODE: '1068',
                NAME: '222',
                ENG_NAME: '222',
            },
            {
                CODE: '1069',
                NAME: '223',
                ENG_NAME: '223',
            },
            {
                CODE: '1070',
                NAME: '로비',
                ENG_NAME: '로비',
            },
            {
                CODE: '1071',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1072',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '1073',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1074',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '1075',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '1076',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1077',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '1078',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '1079',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '1080',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '1081',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '1082',
                NAME: '114',
                ENG_NAME: '114',
            },
            {
                CODE: '1083',
                NAME: '115',
                ENG_NAME: '115',
            },
            {
                CODE: '1084',
                NAME: '116',
                ENG_NAME: '116',
            },
            {
                CODE: '1085',
                NAME: '117',
                ENG_NAME: '117',
            },
            {
                CODE: '1086',
                NAME: '118',
                ENG_NAME: '118',
            },
            {
                CODE: '1087',
                NAME: '119',
                ENG_NAME: '119',
            },
            {
                CODE: '1088',
                NAME: '120',
                ENG_NAME: '120',
            },
            {
                CODE: '1089',
                NAME: '121',
                ENG_NAME: '121',
            },
            {
                CODE: '1090',
                NAME: '122',
                ENG_NAME: '122',
            },
            {
                CODE: '1092',
                NAME: '503',
                ENG_NAME: '503',
            },
            {
                CODE: '1093',
                NAME: '5층 로',
                ENG_NAME: '5층 로',
            },
            {
                CODE: '1094',
                NAME: '506',
                ENG_NAME: '506',
            },
            {
                CODE: '1095',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '1096',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '1097',
                NAME: '318',
                ENG_NAME: '318',
            },
            {
                CODE: '1098',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '1099',
                NAME: '324',
                ENG_NAME: '324',
            },
            {
                CODE: '1100',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '1101',
                NAME: '809',
                ENG_NAME: '809',
            },
            {
                CODE: '1102',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '1103',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '1104',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '1105',
                NAME: '319',
                ENG_NAME: '319',
            },
            {
                CODE: '1106',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '1107',
                NAME: '314',
                ENG_NAME: '314',
            },
            {
                CODE: '1108',
                NAME: '320',
                ENG_NAME: '320',
            },
            {
                CODE: '1109',
                NAME: '315',
                ENG_NAME: '315',
            },
            {
                CODE: '1110',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '1111',
                NAME: '317',
                ENG_NAME: '317',
            },
            {
                CODE: '1112',
                NAME: '321',
                ENG_NAME: '321',
            },
            {
                CODE: '1113',
                NAME: '322',
                ENG_NAME: '322',
            },
            {
                CODE: '1114',
                NAME: '323',
                ENG_NAME: '323',
            },
            {
                CODE: '1115',
                NAME: '5층 로렌',
                ENG_NAME: '5층 로렌',
            },
            {
                CODE: '1116',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1117',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '1118',
                NAME: '5 로',
                ENG_NAME: '5 로',
            },
            {
                CODE: '1119',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '1120',
                NAME: '500',
                ENG_NAME: '500',
            },
            {
                CODE: '1121',
                NAME: '212A',
                ENG_NAME: '212A',
            },
            {
                CODE: '1122',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '1123',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '1124',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1125',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '1126',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '1127',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '1128',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1129',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '1130',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '1131',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '1132',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '1133',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '1134',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '1135',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1136',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '1137',
                NAME: '304A',
                ENG_NAME: '304A',
            },
            {
                CODE: '1138',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '1139',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '1140',
                NAME: '307A',
                ENG_NAME: '307A',
            },
            {
                CODE: '1141',
                NAME: '401',
                ENG_NAME: '401',
            },
            {
                CODE: '1142',
                NAME: '402',
                ENG_NAME: '402',
            },
            {
                CODE: '1143',
                NAME: '403',
                ENG_NAME: '403',
            },
            {
                CODE: '1144',
                NAME: '404',
                ENG_NAME: '404',
            },
            {
                CODE: '1145',
                NAME: '405',
                ENG_NAME: '405',
            },
            {
                CODE: '1146',
                NAME: '406',
                ENG_NAME: '406',
            },
            {
                CODE: '1147',
                NAME: '407',
                ENG_NAME: '407',
            },
            {
                CODE: '1148',
                NAME: '501',
                ENG_NAME: '501',
            },
            {
                CODE: '1149',
                NAME: '504',
                ENG_NAME: '504',
            },
            {
                CODE: '1150',
                NAME: '505',
                ENG_NAME: '505',
            },
            {
                CODE: '1151',
                NAME: '507A',
                ENG_NAME: '507A',
            },
            {
                CODE: '1152',
                NAME: '508A',
                ENG_NAME: '508A',
            },
            {
                CODE: '1153',
                NAME: '509',
                ENG_NAME: '509',
            },
            {
                CODE: '1154',
                NAME: '103호',
                ENG_NAME: '103호',
            },
            {
                CODE: '1155',
                NAME: '104호',
                ENG_NAME: '104호',
            },
            {
                CODE: '1156',
                NAME: '303호',
                ENG_NAME: '303호',
            },
            {
                CODE: '1157',
                NAME: '304호',
                ENG_NAME: '304호',
            },
            {
                CODE: '1158',
                NAME: '305호',
                ENG_NAME: '305호',
            },
            {
                CODE: '1159',
                NAME: '306호',
                ENG_NAME: '306호',
            },
            {
                CODE: '1160',
                NAME: '307호',
                ENG_NAME: '307호',
            },
            {
                CODE: '1161',
                NAME: '501호',
                ENG_NAME: '501호',
            },
            {
                CODE: '1162',
                NAME: '502호',
                ENG_NAME: '502호',
            },
            {
                CODE: '1163',
                NAME: '503호',
                ENG_NAME: '503호',
            },
            {
                CODE: '1164',
                NAME: '504호',
                ENG_NAME: '504호',
            },
            {
                CODE: '1165',
                NAME: '505호',
                ENG_NAME: '505호',
            },
            {
                CODE: '1166',
                NAME: '506호',
                ENG_NAME: '506호',
            },
            {
                CODE: '1167',
                NAME: '507호',
                ENG_NAME: '507호',
            },
            {
                CODE: '1168',
                NAME: '101호',
                ENG_NAME: '101호',
            },
            {
                CODE: '1169',
                NAME: '102호',
                ENG_NAME: '102호',
            },
            {
                CODE: '1170',
                NAME: '103호',
                ENG_NAME: '103호',
            },
            {
                CODE: '1171',
                NAME: '104호',
                ENG_NAME: '104호',
            },
            {
                CODE: '1172',
                NAME: '105호',
                ENG_NAME: '105호',
            },
            {
                CODE: '1173',
                NAME: '201호',
                ENG_NAME: '201호',
            },
            {
                CODE: '1174',
                NAME: '202호',
                ENG_NAME: '202호',
            },
            {
                CODE: '1175',
                NAME: '1001호',
                ENG_NAME: '1001호',
            },
            {
                CODE: '1176',
                NAME: '1002호',
                ENG_NAME: '1002호',
            },
            {
                CODE: '1177',
                NAME: '1003호',
                ENG_NAME: '1003호',
            },
            {
                CODE: '1178',
                NAME: '1004호',
                ENG_NAME: '1004호',
            },
            {
                CODE: '1179',
                NAME: '105호',
                ENG_NAME: '105호',
            },
            {
                CODE: '1180',
                NAME: '321호',
                ENG_NAME: '321호',
            },
            {
                CODE: '1181',
                NAME: '321',
                ENG_NAME: '321',
            },
            {
                CODE: '1182',
                NAME: '1층',
                ENG_NAME: '1층',
            },
            {
                CODE: '1183',
                NAME: '2층',
                ENG_NAME: '2층',
            },
            {
                CODE: '1187',
                NAME: '1층 세탁실',
                ENG_NAME: '1층 세탁실',
            },
            {
                CODE: '1188',
                NAME: '109호',
                ENG_NAME: '109호',
            },
            {
                CODE: '1189',
                NAME: 'B101',
                ENG_NAME: 'B101',
            },
            {
                CODE: '1189',
                NAME: '501',
                ENG_NAME: '501',
            },
            {
                CODE: '1190',
                NAME: 'B102',
                ENG_NAME: 'B102',
            },
            {
                CODE: '1190',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '1191',
                NAME: 'B103',
                ENG_NAME: 'B103',
            },
            {
                CODE: '1191',
                NAME: '503',
                ENG_NAME: '503',
            },
            {
                CODE: '1192',
                NAME: 'B104',
                ENG_NAME: 'B104',
            },
            {
                CODE: '1192',
                NAME: '504',
                ENG_NAME: '504',
            },
            {
                CODE: '1193',
                NAME: 'B105',
                ENG_NAME: 'B105',
            },
            {
                CODE: '1193',
                NAME: '505',
                ENG_NAME: '505',
            },
            {
                CODE: '1194',
                NAME: 'B106',
                ENG_NAME: 'B106',
            },
            {
                CODE: '1194',
                NAME: '506',
                ENG_NAME: '506',
            },
            {
                CODE: '1195',
                NAME: 'B107',
                ENG_NAME: 'B107',
            },
            {
                CODE: '1195',
                NAME: '507',
                ENG_NAME: '507',
            },
            {
                CODE: '1196',
                NAME: 'B108',
                ENG_NAME: 'B108',
            },
            {
                CODE: '1196',
                NAME: '508',
                ENG_NAME: '508',
            },
            {
                CODE: '1197',
                NAME: 'B109',
                ENG_NAME: 'B109',
            },
            {
                CODE: '1197',
                NAME: '509',
                ENG_NAME: '509',
            },
            {
                CODE: '1198',
                NAME: 'B110',
                ENG_NAME: 'B110',
            },
            {
                CODE: '1198',
                NAME: '510',
                ENG_NAME: '510',
            },
            {
                CODE: '1199',
                NAME: 'B111',
                ENG_NAME: 'B111',
            },
            {
                CODE: '1199',
                NAME: '511',
                ENG_NAME: '511',
            },
            {
                CODE: '1200',
                NAME: 'B112',
                ENG_NAME: 'B112',
            },
            {
                CODE: '1200',
                NAME: '512',
                ENG_NAME: '512',
            },
            {
                CODE: '1201',
                NAME: 'B113',
                ENG_NAME: 'B113',
            },
            {
                CODE: '1201',
                NAME: '513',
                ENG_NAME: '513',
            },
            {
                CODE: '1202',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '1202',
                NAME: '514',
                ENG_NAME: '514',
            },
            {
                CODE: '1203',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1203',
                NAME: '515',
                ENG_NAME: '515',
            },
            {
                CODE: '1204',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '1204',
                NAME: '516',
                ENG_NAME: '516',
            },
            {
                CODE: '1205',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1205',
                NAME: '517',
                ENG_NAME: '517',
            },
            {
                CODE: '1206',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '1206',
                NAME: '518',
                ENG_NAME: '518',
            },
            {
                CODE: '1207',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '1207',
                NAME: '519',
                ENG_NAME: '519',
            },
            {
                CODE: '1208',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '1208',
                NAME: '520',
                ENG_NAME: '520',
            },
            {
                CODE: '1209',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1209',
                NAME: '521',
                ENG_NAME: '521',
            },
            {
                CODE: '1210',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '1210',
                NAME: '522',
                ENG_NAME: '522',
            },
            {
                CODE: '1211',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '1211',
                NAME: '523',
                ENG_NAME: '523',
            },
            {
                CODE: '1212',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '1213',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '1214',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '1215',
                NAME: '114',
                ENG_NAME: '114',
            },
            {
                CODE: '1216',
                NAME: '115',
                ENG_NAME: '115',
            },
            {
                CODE: '1218',
                NAME: '116',
                ENG_NAME: '116',
            },
            {
                CODE: '1221',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '1222',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '1223',
                NAME: '508B',
                ENG_NAME: '508B',
            },
            {
                CODE: '1223',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '1224',
                NAME: '507B',
                ENG_NAME: '507B',
            },
            {
                CODE: '1224',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '1225',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '1226',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '1227',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '1228',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '1229',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '1230',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '1231',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '1232',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '1233',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1234',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '1235',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '1236',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '1237',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '1238',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '1239',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '1240',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '1241',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '1242',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '1243',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '1244',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '1245',
                NAME: '401',
                ENG_NAME: '401',
            },
            {
                CODE: '1246',
                NAME: '402',
                ENG_NAME: '402',
            },
            {
                CODE: '1247',
                NAME: '403',
                ENG_NAME: '403',
            },
            {
                CODE: '1248',
                NAME: '404',
                ENG_NAME: '404',
            },
            {
                CODE: '1249',
                NAME: '405',
                ENG_NAME: '405',
            },
            {
                CODE: '1250',
                NAME: '406',
                ENG_NAME: '406',
            },
            {
                CODE: '1251',
                NAME: '407',
                ENG_NAME: '407',
            },
            {
                CODE: '1252',
                NAME: '501',
                ENG_NAME: '501',
            },
            {
                CODE: '1253',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '1255',
                NAME: '504',
                ENG_NAME: '504',
            },
            {
                CODE: '1256',
                NAME: '505',
                ENG_NAME: '505',
            },
            {
                CODE: '1258',
                NAME: '506',
                ENG_NAME: '506',
            },
            {
                CODE: '1259',
                NAME: '507',
                ENG_NAME: '507',
            },
            {
                CODE: '1261',
                NAME: '601',
                ENG_NAME: '601',
            },
            {
                CODE: '1262',
                NAME: '602',
                ENG_NAME: '602',
            },
            {
                CODE: '1263',
                NAME: '603',
                ENG_NAME: '603',
            },
            {
                CODE: '1264',
                NAME: '604',
                ENG_NAME: '604',
            },
            {
                CODE: '1265',
                NAME: '605',
                ENG_NAME: '605',
            },
            {
                CODE: '1266',
                NAME: '606',
                ENG_NAME: '606',
            },
            {
                CODE: '1267',
                NAME: '701',
                ENG_NAME: '701',
            },
            {
                CODE: '1268',
                NAME: '702',
                ENG_NAME: '702',
            },
            {
                CODE: '1269',
                NAME: '703',
                ENG_NAME: '703',
            },
            {
                CODE: '1270',
                NAME: '704',
                ENG_NAME: '704',
            },
            {
                CODE: '1271',
                NAME: '705',
                ENG_NAME: '705',
            },
            {
                CODE: '1273',
                NAME: '707',
                ENG_NAME: '707',
            },
            {
                CODE: '1274',
                NAME: '801',
                ENG_NAME: '801',
            },
            {
                CODE: '1275',
                NAME: '802',
                ENG_NAME: '802',
            },
            {
                CODE: '1276',
                NAME: '803',
                ENG_NAME: '803',
            },
            {
                CODE: '1277',
                NAME: '804',
                ENG_NAME: '804',
            },
            {
                CODE: '1278',
                NAME: '805',
                ENG_NAME: '805',
            },
            {
                CODE: '1279',
                NAME: '806',
                ENG_NAME: '806',
            },
            {
                CODE: '1280',
                NAME: '807',
                ENG_NAME: '807',
            },
            {
                CODE: '1281',
                NAME: '901',
                ENG_NAME: '901',
            },
            {
                CODE: '1282',
                NAME: '902',
                ENG_NAME: '902',
            },
            {
                CODE: '1283',
                NAME: '903',
                ENG_NAME: '903',
            },
            {
                CODE: '1284',
                NAME: '904',
                ENG_NAME: '904',
            },
            {
                CODE: '1286',
                NAME: '906',
                ENG_NAME: '906',
            },
            {
                CODE: '1287',
                NAME: '907',
                ENG_NAME: '907',
            },
            {
                CODE: '1288',
                NAME: '908',
                ENG_NAME: '908',
            },
            {
                CODE: '1289',
                NAME: '1001',
                ENG_NAME: '1001',
            },
            {
                CODE: '1290',
                NAME: '1002',
                ENG_NAME: '1002',
            },
            {
                CODE: '1291',
                NAME: '1003',
                ENG_NAME: '1003',
            },
            {
                CODE: '1292',
                NAME: '1004',
                ENG_NAME: '1004',
            },
            {
                CODE: '1293',
                NAME: '1005',
                ENG_NAME: '1005',
            },
            {
                CODE: '1294',
                NAME: '1006',
                ENG_NAME: '1006',
            },
            {
                CODE: '1295',
                NAME: '1007',
                ENG_NAME: '1007',
            },
            {
                CODE: '1296',
                NAME: '1008',
                ENG_NAME: '1008',
            },
            {
                CODE: '1297',
                NAME: 'B01',
                ENG_NAME: 'B01',
            },
            {
                CODE: '1298',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '1299',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1300',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '1301',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1302',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '1303',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '1304',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '1305',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1306',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '1307',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '1308',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '1309',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '1310',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '1311',
                NAME: '114',
                ENG_NAME: '114',
            },
            {
                CODE: '1312',
                NAME: '115',
                ENG_NAME: '115',
            },
            {
                CODE: '1313',
                NAME: '116',
                ENG_NAME: '116',
            },
            {
                CODE: '1314',
                NAME: '117',
                ENG_NAME: '117',
            },
            {
                CODE: '1315',
                NAME: '118',
                ENG_NAME: '118',
            },
            {
                CODE: '1316',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '1317',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '1318',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '1319',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '1320',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '1321',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '1322',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '1323',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '1324',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '1325',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '1326',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '1327',
                NAME: '212',
                ENG_NAME: '212',
            },
            {
                CODE: '1328',
                NAME: '213',
                ENG_NAME: '213',
            },
            {
                CODE: '1329',
                NAME: '214',
                ENG_NAME: '214',
            },
            {
                CODE: '1330',
                NAME: '215',
                ENG_NAME: '215',
            },
            {
                CODE: '1331',
                NAME: '216',
                ENG_NAME: '216',
            },
            {
                CODE: '1332',
                NAME: '217',
                ENG_NAME: '217',
            },
            {
                CODE: '1333',
                NAME: '218',
                ENG_NAME: '218',
            },
            {
                CODE: '1334',
                NAME: '219',
                ENG_NAME: '219',
            },
            {
                CODE: '1335',
                NAME: '220',
                ENG_NAME: '220',
            },
            {
                CODE: '1336',
                NAME: '221',
                ENG_NAME: '221',
            },
            {
                CODE: '1337',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '1338',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1339',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '1340',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '1341',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '1342',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '1343',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '1344',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '1345',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '1346',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '1347',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '1348',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '1349',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '1350',
                NAME: '314',
                ENG_NAME: '314',
            },
            {
                CODE: '1351',
                NAME: '315',
                ENG_NAME: '315',
            },
            {
                CODE: '1352',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '1353',
                NAME: '317',
                ENG_NAME: '317',
            },
            {
                CODE: '1354',
                NAME: '318',
                ENG_NAME: '318',
            },
            {
                CODE: '1355',
                NAME: '319',
                ENG_NAME: '319',
            },
            {
                CODE: '1356',
                NAME: '320',
                ENG_NAME: '320',
            },
            {
                CODE: '1357',
                NAME: '321',
                ENG_NAME: '321',
            },
            {
                CODE: '1358',
                NAME: '322',
                ENG_NAME: '322',
            },
            {
                CODE: '1359',
                NAME: '323',
                ENG_NAME: '323',
            },
            {
                CODE: '1360',
                NAME: '324',
                ENG_NAME: '324',
            },
            {
                CODE: '1361',
                NAME: '401',
                ENG_NAME: '401',
            },
            {
                CODE: '1362',
                NAME: '402',
                ENG_NAME: '402',
            },
            {
                CODE: '1363',
                NAME: '403',
                ENG_NAME: '403',
            },
            {
                CODE: '1364',
                NAME: '404',
                ENG_NAME: '404',
            },
            {
                CODE: '1365',
                NAME: '405',
                ENG_NAME: '405',
            },
            {
                CODE: '1366',
                NAME: '406',
                ENG_NAME: '406',
            },
            {
                CODE: '1367',
                NAME: '407',
                ENG_NAME: '407',
            },
            {
                CODE: '1368',
                NAME: '408',
                ENG_NAME: '408',
            },
            {
                CODE: '1369',
                NAME: '409',
                ENG_NAME: '409',
            },
            {
                CODE: '1370',
                NAME: '410',
                ENG_NAME: '410',
            },
            {
                CODE: '1371',
                NAME: '411',
                ENG_NAME: '411',
            },
            {
                CODE: '1372',
                NAME: '412',
                ENG_NAME: '412',
            },
            {
                CODE: '1373',
                NAME: '413',
                ENG_NAME: '413',
            },
            {
                CODE: '1374',
                NAME: '414',
                ENG_NAME: '414',
            },
            {
                CODE: '1375',
                NAME: '415',
                ENG_NAME: '415',
            },
            {
                CODE: '1376',
                NAME: '416',
                ENG_NAME: '416',
            },
            {
                CODE: '1377',
                NAME: '417',
                ENG_NAME: '417',
            },
            {
                CODE: '1378',
                NAME: '418',
                ENG_NAME: '418',
            },
            {
                CODE: '1379',
                NAME: '419',
                ENG_NAME: '419',
            },
            {
                CODE: '1380',
                NAME: '420',
                ENG_NAME: '420',
            },
            {
                CODE: '1381',
                NAME: '421',
                ENG_NAME: '421',
            },
            {
                CODE: '1382',
                NAME: '422',
                ENG_NAME: '422',
            },
            {
                CODE: '1383',
                NAME: '423',
                ENG_NAME: '423',
            },
            {
                CODE: '1384',
                NAME: '424',
                ENG_NAME: '424',
            },
            {
                CODE: '1385',
                NAME: '501',
                ENG_NAME: '501',
            },
            {
                CODE: '1386',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '1387',
                NAME: '503',
                ENG_NAME: '503',
            },
            {
                CODE: '1388',
                NAME: '504',
                ENG_NAME: '504',
            },
            {
                CODE: '1389',
                NAME: '505',
                ENG_NAME: '505',
            },
            {
                CODE: '1390',
                NAME: '506',
                ENG_NAME: '506',
            },
            {
                CODE: '1391',
                NAME: '507',
                ENG_NAME: '507',
            },
            {
                CODE: '1392',
                NAME: '508',
                ENG_NAME: '508',
            },
            {
                CODE: '1393',
                NAME: '509',
                ENG_NAME: '509',
            },
            {
                CODE: '1394',
                NAME: '510',
                ENG_NAME: '510',
            },
            {
                CODE: '1395',
                NAME: '511',
                ENG_NAME: '511',
            },
            {
                CODE: '1396',
                NAME: '512',
                ENG_NAME: '512',
            },
            {
                CODE: '1397',
                NAME: '513',
                ENG_NAME: '513',
            },
            {
                CODE: '1398',
                NAME: '514',
                ENG_NAME: '514',
            },
            {
                CODE: '1399',
                NAME: '515',
                ENG_NAME: '515',
            },
            {
                CODE: '1400',
                NAME: '516',
                ENG_NAME: '516',
            },
            {
                CODE: '1401',
                NAME: '517',
                ENG_NAME: '517',
            },
            {
                CODE: '1402',
                NAME: '518',
                ENG_NAME: '518',
            },
            {
                CODE: '1403',
                NAME: '519',
                ENG_NAME: '519',
            },
            {
                CODE: '1404',
                NAME: '520',
                ENG_NAME: '520',
            },
            {
                CODE: '1405',
                NAME: '521',
                ENG_NAME: '521',
            },
            {
                CODE: '1406',
                NAME: '522',
                ENG_NAME: '522',
            },
            {
                CODE: '1407',
                NAME: '523',
                ENG_NAME: '523',
            },
            {
                CODE: '1408',
                NAME: '524',
                ENG_NAME: '524',
            },
            {
                CODE: '1409',
                NAME: '525',
                ENG_NAME: '525',
            },
            {
                CODE: '1410',
                NAME: '601',
                ENG_NAME: '601',
            },
            {
                CODE: '1411',
                NAME: '602',
                ENG_NAME: '602',
            },
            {
                CODE: '1412',
                NAME: '603',
                ENG_NAME: '603',
            },
            {
                CODE: '1413',
                NAME: '604',
                ENG_NAME: '604',
            },
            {
                CODE: '1414',
                NAME: '605',
                ENG_NAME: '605',
            },
            {
                CODE: '1415',
                NAME: '606',
                ENG_NAME: '606',
            },
            {
                CODE: '1416',
                NAME: '607',
                ENG_NAME: '607',
            },
            {
                CODE: '1417',
                NAME: '608',
                ENG_NAME: '608',
            },
            {
                CODE: '1418',
                NAME: '609',
                ENG_NAME: '609',
            },
            {
                CODE: '1419',
                NAME: '610',
                ENG_NAME: '610',
            },
            {
                CODE: '1420',
                NAME: '611',
                ENG_NAME: '611',
            },
            {
                CODE: '1421',
                NAME: '612',
                ENG_NAME: '612',
            },
            {
                CODE: '1422',
                NAME: '613',
                ENG_NAME: '613',
            },
            {
                CODE: '1423',
                NAME: '614',
                ENG_NAME: '614',
            },
            {
                CODE: '1424',
                NAME: '615',
                ENG_NAME: '615',
            },
            {
                CODE: '1425',
                NAME: '616',
                ENG_NAME: '616',
            },
            {
                CODE: '1426',
                NAME: '617',
                ENG_NAME: '617',
            },
            {
                CODE: '1427',
                NAME: '618',
                ENG_NAME: '618',
            },
            {
                CODE: '1428',
                NAME: '619',
                ENG_NAME: '619',
            },
            {
                CODE: '1429',
                NAME: '620',
                ENG_NAME: '620',
            },
            {
                CODE: '1430',
                NAME: '621',
                ENG_NAME: '621',
            },
            {
                CODE: '1431',
                NAME: '622',
                ENG_NAME: '622',
            },
            {
                CODE: '1432',
                NAME: '623',
                ENG_NAME: '623',
            },
            {
                CODE: '1433',
                NAME: '624',
                ENG_NAME: '624',
            },
            {
                CODE: '1434',
                NAME: '625',
                ENG_NAME: '625',
            },
            {
                CODE: '1435',
                NAME: '701',
                ENG_NAME: '701',
            },
            {
                CODE: '1436',
                NAME: '702',
                ENG_NAME: '702',
            },
            {
                CODE: '1437',
                NAME: '703',
                ENG_NAME: '703',
            },
            {
                CODE: '1438',
                NAME: '704',
                ENG_NAME: '704',
            },
            {
                CODE: '1439',
                NAME: 'B01',
                ENG_NAME: 'B01',
            },
            {
                CODE: '1440',
                NAME: 'B02',
                ENG_NAME: 'B02',
            },
            {
                CODE: '1441',
                NAME: 'B03',
                ENG_NAME: 'B03',
            },
            {
                CODE: '1442',
                NAME: 'B04',
                ENG_NAME: 'B04',
            },
            {
                CODE: '1443',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '1444',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1445',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '1446',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1447',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '1448',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '1449',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '1450',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1451',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '1452',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '1453',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '1454',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '1455',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '1456',
                NAME: '114',
                ENG_NAME: '114',
            },
            {
                CODE: '1457',
                NAME: '115',
                ENG_NAME: '115',
            },
            {
                CODE: '1458',
                NAME: '116',
                ENG_NAME: '116',
            },
            {
                CODE: '1459',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '1460',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '1461',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '1462',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '1463',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '1464',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '1465',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '1466',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '1467',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '1468',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '1469',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '1470',
                NAME: '212',
                ENG_NAME: '212',
            },
            {
                CODE: '1471',
                NAME: '213',
                ENG_NAME: '213',
            },
            {
                CODE: '1472',
                NAME: '214',
                ENG_NAME: '214',
            },
            {
                CODE: '1473',
                NAME: '215',
                ENG_NAME: '215',
            },
            {
                CODE: '1474',
                NAME: '216',
                ENG_NAME: '216',
            },
            {
                CODE: '1475',
                NAME: '217',
                ENG_NAME: '217',
            },
            {
                CODE: '1476',
                NAME: '218',
                ENG_NAME: '218',
            },
            {
                CODE: '1477',
                NAME: '219',
                ENG_NAME: '219',
            },
            {
                CODE: '1478',
                NAME: '220',
                ENG_NAME: '220',
            },
            {
                CODE: '1479',
                NAME: '221',
                ENG_NAME: '221',
            },
            {
                CODE: '1480',
                NAME: '222',
                ENG_NAME: '222',
            },
            {
                CODE: '1481',
                NAME: '223',
                ENG_NAME: '223',
            },
            {
                CODE: '1482',
                NAME: '224',
                ENG_NAME: '224',
            },
            {
                CODE: '1483',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '1484',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1485',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '1486',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '1487',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '1488',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '1489',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '1490',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '1491',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '1492',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '1493',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '1494',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '1495',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '1496',
                NAME: '314',
                ENG_NAME: '314',
            },
            {
                CODE: '1497',
                NAME: '315',
                ENG_NAME: '315',
            },
            {
                CODE: '1498',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '1499',
                NAME: '317',
                ENG_NAME: '317',
            },
            {
                CODE: '1500',
                NAME: '318',
                ENG_NAME: '318',
            },
            {
                CODE: '1501',
                NAME: '319',
                ENG_NAME: '319',
            },
            {
                CODE: '1502',
                NAME: '320',
                ENG_NAME: '320',
            },
            {
                CODE: '1503',
                NAME: '321',
                ENG_NAME: '321',
            },
            {
                CODE: '1504',
                NAME: '322',
                ENG_NAME: '322',
            },
            {
                CODE: '1505',
                NAME: '323',
                ENG_NAME: '323',
            },
            {
                CODE: '1506',
                NAME: '401',
                ENG_NAME: '401',
            },
            {
                CODE: '1507',
                NAME: '402',
                ENG_NAME: '402',
            },
            {
                CODE: '1508',
                NAME: '403',
                ENG_NAME: '403',
            },
            {
                CODE: '1509',
                NAME: '404',
                ENG_NAME: '404',
            },
            {
                CODE: '1510',
                NAME: '405',
                ENG_NAME: '405',
            },
            {
                CODE: '1511',
                NAME: '406',
                ENG_NAME: '406',
            },
            {
                CODE: '1512',
                NAME: '407',
                ENG_NAME: '407',
            },
            {
                CODE: '1513',
                NAME: '408',
                ENG_NAME: '408',
            },
            {
                CODE: '1514',
                NAME: '409',
                ENG_NAME: '409',
            },
            {
                CODE: '1515',
                NAME: '410',
                ENG_NAME: '410',
            },
            {
                CODE: '1516',
                NAME: '411',
                ENG_NAME: '411',
            },
            {
                CODE: '1517',
                NAME: '412',
                ENG_NAME: '412',
            },
            {
                CODE: '1518',
                NAME: '413',
                ENG_NAME: '413',
            },
            {
                CODE: '1519',
                NAME: '414',
                ENG_NAME: '414',
            },
            {
                CODE: '1520',
                NAME: '415',
                ENG_NAME: '415',
            },
            {
                CODE: '1521',
                NAME: '416',
                ENG_NAME: '416',
            },
            {
                CODE: '1522',
                NAME: '417',
                ENG_NAME: '417',
            },
            {
                CODE: '1523',
                NAME: '418',
                ENG_NAME: '418',
            },
            {
                CODE: '1524',
                NAME: '419',
                ENG_NAME: '419',
            },
            {
                CODE: '1525',
                NAME: '420',
                ENG_NAME: '420',
            },
            {
                CODE: '1526',
                NAME: '421',
                ENG_NAME: '421',
            },
            {
                CODE: '1527',
                NAME: '422',
                ENG_NAME: '422',
            },
            {
                CODE: '1528',
                NAME: '423',
                ENG_NAME: '423',
            },
            {
                CODE: '1529',
                NAME: '424',
                ENG_NAME: '424',
            },
            {
                CODE: '1530',
                NAME: '501',
                ENG_NAME: '501',
            },
            {
                CODE: '1531',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '1532',
                NAME: '503',
                ENG_NAME: '503',
            },
            {
                CODE: '1533',
                NAME: '504',
                ENG_NAME: '504',
            },
            {
                CODE: '1534',
                NAME: '505',
                ENG_NAME: '505',
            },
            {
                CODE: '1535',
                NAME: '506',
                ENG_NAME: '506',
            },
            {
                CODE: '1536',
                NAME: '507',
                ENG_NAME: '507',
            },
            {
                CODE: '1537',
                NAME: '508',
                ENG_NAME: '508',
            },
            {
                CODE: '1538',
                NAME: '509',
                ENG_NAME: '509',
            },
            {
                CODE: '1539',
                NAME: '510',
                ENG_NAME: '510',
            },
            {
                CODE: '1540',
                NAME: '511',
                ENG_NAME: '511',
            },
            {
                CODE: '1541',
                NAME: '512',
                ENG_NAME: '512',
            },
            {
                CODE: '1542',
                NAME: '513',
                ENG_NAME: '513',
            },
            {
                CODE: '1543',
                NAME: '514',
                ENG_NAME: '514',
            },
            {
                CODE: '1544',
                NAME: '515',
                ENG_NAME: '515',
            },
            {
                CODE: '1545',
                NAME: '516',
                ENG_NAME: '516',
            },
            {
                CODE: '1546',
                NAME: '517',
                ENG_NAME: '517',
            },
            {
                CODE: '1547',
                NAME: '518',
                ENG_NAME: '518',
            },
            {
                CODE: '1548',
                NAME: '519',
                ENG_NAME: '519',
            },
            {
                CODE: '1549',
                NAME: '520',
                ENG_NAME: '520',
            },
            {
                CODE: '1550',
                NAME: '521',
                ENG_NAME: '521',
            },
            {
                CODE: '1551',
                NAME: '522',
                ENG_NAME: '522',
            },
            {
                CODE: '1552',
                NAME: '523',
                ENG_NAME: '523',
            },
            {
                CODE: '1553',
                NAME: '524',
                ENG_NAME: '524',
            },
            {
                CODE: '1554',
                NAME: '525',
                ENG_NAME: '525',
            },
            {
                CODE: '1555',
                NAME: '526',
                ENG_NAME: '526',
            },
            {
                CODE: '1556',
                NAME: '601',
                ENG_NAME: '601',
            },
            {
                CODE: '1557',
                NAME: '602',
                ENG_NAME: '602',
            },
            {
                CODE: '1558',
                NAME: '603',
                ENG_NAME: '603',
            },
            {
                CODE: '1559',
                NAME: '604',
                ENG_NAME: '604',
            },
            {
                CODE: '1560',
                NAME: '605',
                ENG_NAME: '605',
            },
            {
                CODE: '1561',
                NAME: '606',
                ENG_NAME: '606',
            },
            {
                CODE: '1562',
                NAME: '607',
                ENG_NAME: '607',
            },
            {
                CODE: '1563',
                NAME: '608',
                ENG_NAME: '608',
            },
            {
                CODE: '1564',
                NAME: '609',
                ENG_NAME: '609',
            },
            {
                CODE: '1565',
                NAME: '610',
                ENG_NAME: '610',
            },
            {
                CODE: '1566',
                NAME: '611',
                ENG_NAME: '611',
            },
            {
                CODE: '1567',
                NAME: '612',
                ENG_NAME: '612',
            },
            {
                CODE: '1568',
                NAME: '613',
                ENG_NAME: '613',
            },
            {
                CODE: '1569',
                NAME: '614',
                ENG_NAME: '614',
            },
            {
                CODE: '1570',
                NAME: '615',
                ENG_NAME: '615',
            },
            {
                CODE: '1571',
                NAME: '616',
                ENG_NAME: '616',
            },
            {
                CODE: '1572',
                NAME: '617',
                ENG_NAME: '617',
            },
            {
                CODE: '1573',
                NAME: '618',
                ENG_NAME: '618',
            },
            {
                CODE: '1574',
                NAME: '619',
                ENG_NAME: '619',
            },
            {
                CODE: '1575',
                NAME: '620',
                ENG_NAME: '620',
            },
            {
                CODE: '1576',
                NAME: '621',
                ENG_NAME: '621',
            },
            {
                CODE: '1577',
                NAME: '622',
                ENG_NAME: '622',
            },
            {
                CODE: '1578',
                NAME: '623',
                ENG_NAME: '623',
            },
            {
                CODE: '1579',
                NAME: '624',
                ENG_NAME: '624',
            },
            {
                CODE: '1580',
                NAME: '625',
                ENG_NAME: '625',
            },
            {
                CODE: '1581',
                NAME: '626',
                ENG_NAME: '626',
            },
            {
                CODE: '1582',
                NAME: '701',
                ENG_NAME: '701',
            },
            {
                CODE: '1583',
                NAME: '702',
                ENG_NAME: '702',
            },
            {
                CODE: '1584',
                NAME: '703',
                ENG_NAME: '703',
            },
            {
                CODE: '1585',
                NAME: '704',
                ENG_NAME: '704',
            },
            {
                CODE: '1586',
                NAME: 'B101',
                ENG_NAME: 'B101',
            },
            {
                CODE: '1587',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '1588',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1589',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '1590',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1591',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '1592',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '1593',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '1594',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1595',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '1596',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '1597',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '1598',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '1599',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '1600',
                NAME: '114',
                ENG_NAME: '114',
            },
            {
                CODE: '1601',
                NAME: '115',
                ENG_NAME: '115',
            },
            {
                CODE: '1602',
                NAME: '116',
                ENG_NAME: '116',
            },
            {
                CODE: '1603',
                NAME: '117',
                ENG_NAME: '117',
            },
            {
                CODE: '1604',
                NAME: '118',
                ENG_NAME: '118',
            },
            {
                CODE: '1605',
                NAME: '119',
                ENG_NAME: '119',
            },
            {
                CODE: '1606',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '1607',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '1608',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '1609',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '1610',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '1611',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '1612',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '1613',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '1614',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '1615',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '1616',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '1617',
                NAME: '212',
                ENG_NAME: '212',
            },
            {
                CODE: '1618',
                NAME: '213',
                ENG_NAME: '213',
            },
            {
                CODE: '1619',
                NAME: '214',
                ENG_NAME: '214',
            },
            {
                CODE: '1620',
                NAME: '215',
                ENG_NAME: '215',
            },
            {
                CODE: '1621',
                NAME: '216',
                ENG_NAME: '216',
            },
            {
                CODE: '1622',
                NAME: '217',
                ENG_NAME: '217',
            },
            {
                CODE: '1623',
                NAME: '218',
                ENG_NAME: '218',
            },
            {
                CODE: '1624',
                NAME: '219',
                ENG_NAME: '219',
            },
            {
                CODE: '1625',
                NAME: '220',
                ENG_NAME: '220',
            },
            {
                CODE: '1626',
                NAME: '221',
                ENG_NAME: '221',
            },
            {
                CODE: '1627',
                NAME: '222',
                ENG_NAME: '222',
            },
            {
                CODE: '1628',
                NAME: '223',
                ENG_NAME: '223',
            },
            {
                CODE: '1629',
                NAME: '224',
                ENG_NAME: '224',
            },
            {
                CODE: '1630',
                NAME: '225',
                ENG_NAME: '225',
            },
            {
                CODE: '1631',
                NAME: '226',
                ENG_NAME: '226',
            },
            {
                CODE: '1632',
                NAME: '227',
                ENG_NAME: '227',
            },
            {
                CODE: '1633',
                NAME: '228',
                ENG_NAME: '228',
            },
            {
                CODE: '1634',
                NAME: '229',
                ENG_NAME: '229',
            },
            {
                CODE: '1635',
                NAME: '230',
                ENG_NAME: '230',
            },
            {
                CODE: '1636',
                NAME: '231',
                ENG_NAME: '231',
            },
            {
                CODE: '1637',
                NAME: '232',
                ENG_NAME: '232',
            },
            {
                CODE: '1638',
                NAME: '233',
                ENG_NAME: '233',
            },
            {
                CODE: '1639',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '1640',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1641',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '1642',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '1643',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '1644',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '1645',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '1646',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '1647',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '1648',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '1649',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '1650',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '1651',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '1652',
                NAME: '314',
                ENG_NAME: '314',
            },
            {
                CODE: '1653',
                NAME: '315',
                ENG_NAME: '315',
            },
            {
                CODE: '1654',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '1655',
                NAME: '317',
                ENG_NAME: '317',
            },
            {
                CODE: '1656',
                NAME: '318',
                ENG_NAME: '318',
            },
            {
                CODE: '1657',
                NAME: '319',
                ENG_NAME: '319',
            },
            {
                CODE: '1658',
                NAME: '320',
                ENG_NAME: '320',
            },
            {
                CODE: '1659',
                NAME: '321',
                ENG_NAME: '321',
            },
            {
                CODE: '1660',
                NAME: '322',
                ENG_NAME: '322',
            },
            {
                CODE: '1661',
                NAME: '323',
                ENG_NAME: '323',
            },
            {
                CODE: '1662',
                NAME: '324',
                ENG_NAME: '324',
            },
            {
                CODE: '1663',
                NAME: '325',
                ENG_NAME: '325',
            },
            {
                CODE: '1664',
                NAME: '326',
                ENG_NAME: '326',
            },
            {
                CODE: '1665',
                NAME: '327',
                ENG_NAME: '327',
            },
            {
                CODE: '1666',
                NAME: '401',
                ENG_NAME: '401',
            },
            {
                CODE: '1667',
                NAME: '402',
                ENG_NAME: '402',
            },
            {
                CODE: '1668',
                NAME: '403',
                ENG_NAME: '403',
            },
            {
                CODE: '1669',
                NAME: '404',
                ENG_NAME: '404',
            },
            {
                CODE: '1670',
                NAME: '405',
                ENG_NAME: '405',
            },
            {
                CODE: '1671',
                NAME: '406',
                ENG_NAME: '406',
            },
            {
                CODE: '1672',
                NAME: '407',
                ENG_NAME: '407',
            },
            {
                CODE: '1673',
                NAME: '408',
                ENG_NAME: '408',
            },
            {
                CODE: '1674',
                NAME: '409',
                ENG_NAME: '409',
            },
            {
                CODE: '1675',
                NAME: '410',
                ENG_NAME: '410',
            },
            {
                CODE: '1676',
                NAME: '411',
                ENG_NAME: '411',
            },
            {
                CODE: '1677',
                NAME: '412',
                ENG_NAME: '412',
            },
            {
                CODE: '1678',
                NAME: '413',
                ENG_NAME: '413',
            },
            {
                CODE: '1679',
                NAME: '414',
                ENG_NAME: '414',
            },
            {
                CODE: '1680',
                NAME: '415',
                ENG_NAME: '415',
            },
            {
                CODE: '1681',
                NAME: '416',
                ENG_NAME: '416',
            },
            {
                CODE: '1682',
                NAME: '417',
                ENG_NAME: '417',
            },
            {
                CODE: '1683',
                NAME: '418',
                ENG_NAME: '418',
            },
            {
                CODE: '1684',
                NAME: '419',
                ENG_NAME: '419',
            },
            {
                CODE: '1685',
                NAME: '420',
                ENG_NAME: '420',
            },
            {
                CODE: '1686',
                NAME: '421',
                ENG_NAME: '421',
            },
            {
                CODE: '1687',
                NAME: '422',
                ENG_NAME: '422',
            },
            {
                CODE: '1688',
                NAME: '423',
                ENG_NAME: '423',
            },
            {
                CODE: '1689',
                NAME: '424',
                ENG_NAME: '424',
            },
            {
                CODE: '1690',
                NAME: '425',
                ENG_NAME: '425',
            },
            {
                CODE: '1691',
                NAME: '426',
                ENG_NAME: '426',
            },
            {
                CODE: '1692',
                NAME: '427',
                ENG_NAME: '427',
            },
            {
                CODE: '1693',
                NAME: '428',
                ENG_NAME: '428',
            },
            {
                CODE: '1694',
                NAME: '501',
                ENG_NAME: '501',
            },
            {
                CODE: '1695',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '1696',
                NAME: '503',
                ENG_NAME: '503',
            },
            {
                CODE: '1697',
                NAME: '504',
                ENG_NAME: '504',
            },
            {
                CODE: '1698',
                NAME: '505',
                ENG_NAME: '505',
            },
            {
                CODE: '1699',
                NAME: '506',
                ENG_NAME: '506',
            },
            {
                CODE: '1700',
                NAME: '507',
                ENG_NAME: '507',
            },
            {
                CODE: '1701',
                NAME: '508',
                ENG_NAME: '508',
            },
            {
                CODE: '1702',
                NAME: '509',
                ENG_NAME: '509',
            },
            {
                CODE: '1703',
                NAME: '510',
                ENG_NAME: '510',
            },
            {
                CODE: '1704',
                NAME: '511',
                ENG_NAME: '511',
            },
            {
                CODE: '1705',
                NAME: '512',
                ENG_NAME: '512',
            },
            {
                CODE: '1706',
                NAME: '513',
                ENG_NAME: '513',
            },
            {
                CODE: '1707',
                NAME: '514',
                ENG_NAME: '514',
            },
            {
                CODE: '1708',
                NAME: '515',
                ENG_NAME: '515',
            },
            {
                CODE: '1709',
                NAME: '516',
                ENG_NAME: '516',
            },
            {
                CODE: '1710',
                NAME: '517',
                ENG_NAME: '517',
            },
            {
                CODE: '1711',
                NAME: '518',
                ENG_NAME: '518',
            },
            {
                CODE: '1712',
                NAME: '519',
                ENG_NAME: '519',
            },
            {
                CODE: '1713',
                NAME: '520',
                ENG_NAME: '520',
            },
            {
                CODE: '1714',
                NAME: '521',
                ENG_NAME: '521',
            },
            {
                CODE: '1715',
                NAME: '522',
                ENG_NAME: '522',
            },
            {
                CODE: '1716',
                NAME: '523',
                ENG_NAME: '523',
            },
            {
                CODE: '1717',
                NAME: '524',
                ENG_NAME: '524',
            },
            {
                CODE: '1718',
                NAME: '525',
                ENG_NAME: '525',
            },
            {
                CODE: '1719',
                NAME: '526',
                ENG_NAME: '526',
            },
            {
                CODE: '1720',
                NAME: '527',
                ENG_NAME: '527',
            },
            {
                CODE: '1721',
                NAME: '601',
                ENG_NAME: '601',
            },
            {
                CODE: '1722',
                NAME: '602',
                ENG_NAME: '602',
            },
            {
                CODE: '1723',
                NAME: '603',
                ENG_NAME: '603',
            },
            {
                CODE: '1724',
                NAME: '604',
                ENG_NAME: '604',
            },
            {
                CODE: '1725',
                NAME: '605',
                ENG_NAME: '605',
            },
            {
                CODE: '1726',
                NAME: '606',
                ENG_NAME: '606',
            },
            {
                CODE: '1727',
                NAME: '607',
                ENG_NAME: '607',
            },
            {
                CODE: '1728',
                NAME: '608',
                ENG_NAME: '608',
            },
            {
                CODE: '1729',
                NAME: '609',
                ENG_NAME: '609',
            },
            {
                CODE: '1730',
                NAME: '610',
                ENG_NAME: '610',
            },
            {
                CODE: '1731',
                NAME: '611',
                ENG_NAME: '611',
            },
            {
                CODE: '1732',
                NAME: '612',
                ENG_NAME: '612',
            },
            {
                CODE: '1733',
                NAME: '613',
                ENG_NAME: '613',
            },
            {
                CODE: '1734',
                NAME: '614',
                ENG_NAME: '614',
            },
            {
                CODE: '1735',
                NAME: '615',
                ENG_NAME: '615',
            },
            {
                CODE: '1736',
                NAME: '616',
                ENG_NAME: '616',
            },
            {
                CODE: '1737',
                NAME: '617',
                ENG_NAME: '617',
            },
            {
                CODE: '1738',
                NAME: '618',
                ENG_NAME: '618',
            },
            {
                CODE: '1739',
                NAME: '619',
                ENG_NAME: '619',
            },
            {
                CODE: '1740',
                NAME: '620',
                ENG_NAME: '620',
            },
            {
                CODE: '1741',
                NAME: '621',
                ENG_NAME: '621',
            },
            {
                CODE: '1742',
                NAME: '622',
                ENG_NAME: '622',
            },
            {
                CODE: '1743',
                NAME: '623',
                ENG_NAME: '623',
            },
            {
                CODE: '1744',
                NAME: '624',
                ENG_NAME: '624',
            },
            {
                CODE: '1745',
                NAME: '625',
                ENG_NAME: '625',
            },
            {
                CODE: '1746',
                NAME: '626',
                ENG_NAME: '626',
            },
            {
                CODE: '1747',
                NAME: '627',
                ENG_NAME: '627',
            },
            {
                CODE: '1748',
                NAME: '628',
                ENG_NAME: '628',
            },
            {
                CODE: '1749',
                NAME: '701',
                ENG_NAME: '701',
            },
            {
                CODE: '1750',
                NAME: '702',
                ENG_NAME: '702',
            },
            {
                CODE: '1751',
                NAME: '702',
                ENG_NAME: '702',
            },
            {
                CODE: '1752',
                NAME: '703',
                ENG_NAME: '703',
            },
            {
                CODE: '1753',
                NAME: 'B01',
                ENG_NAME: 'B01',
            },
            {
                CODE: '1754',
                NAME: 'B02',
                ENG_NAME: 'B02',
            },
            {
                CODE: '1755',
                NAME: 'B03',
                ENG_NAME: 'B03',
            },
            {
                CODE: '1756',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '1757',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1758',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '1759',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1760',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '1761',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '1762',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '1763',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1764',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '1765',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '1766',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '1767',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '1768',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '1769',
                NAME: '114',
                ENG_NAME: '114',
            },
            {
                CODE: '1770',
                NAME: '115',
                ENG_NAME: '115',
            },
            {
                CODE: '1771',
                NAME: '116',
                ENG_NAME: '116',
            },
            {
                CODE: '1772',
                NAME: '117',
                ENG_NAME: '117',
            },
            {
                CODE: '1773',
                NAME: '118',
                ENG_NAME: '118',
            },
            {
                CODE: '1774',
                NAME: '119',
                ENG_NAME: '119',
            },
            {
                CODE: '1775',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '1776',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '1777',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '1778',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '1779',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '1780',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '1781',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '1782',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '1783',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '1784',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '1785',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '1786',
                NAME: '212',
                ENG_NAME: '212',
            },
            {
                CODE: '1787',
                NAME: '213',
                ENG_NAME: '213',
            },
            {
                CODE: '1788',
                NAME: '214',
                ENG_NAME: '214',
            },
            {
                CODE: '1789',
                NAME: '215',
                ENG_NAME: '215',
            },
            {
                CODE: '1790',
                NAME: '216',
                ENG_NAME: '216',
            },
            {
                CODE: '1791',
                NAME: '217',
                ENG_NAME: '217',
            },
            {
                CODE: '1792',
                NAME: '218',
                ENG_NAME: '218',
            },
            {
                CODE: '1793',
                NAME: '219',
                ENG_NAME: '219',
            },
            {
                CODE: '1794',
                NAME: '220',
                ENG_NAME: '220',
            },
            {
                CODE: '1795',
                NAME: '221',
                ENG_NAME: '221',
            },
            {
                CODE: '1796',
                NAME: '222',
                ENG_NAME: '222',
            },
            {
                CODE: '1797',
                NAME: '223',
                ENG_NAME: '223',
            },
            {
                CODE: '1798',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '1799',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1800',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '1801',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '1802',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '1803',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '1804',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '1805',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '1806',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '1807',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '1808',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '1809',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '1810',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '1811',
                NAME: '314',
                ENG_NAME: '314',
            },
            {
                CODE: '1812',
                NAME: '315',
                ENG_NAME: '315',
            },
            {
                CODE: '1813',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '1814',
                NAME: '317',
                ENG_NAME: '317',
            },
            {
                CODE: '1815',
                NAME: '318',
                ENG_NAME: '318',
            },
            {
                CODE: '1816',
                NAME: '319',
                ENG_NAME: '319',
            },
            {
                CODE: '1817',
                NAME: '320',
                ENG_NAME: '320',
            },
            {
                CODE: '1818',
                NAME: '321',
                ENG_NAME: '321',
            },
            {
                CODE: '1819',
                NAME: '322',
                ENG_NAME: '322',
            },
            {
                CODE: '1820',
                NAME: '323',
                ENG_NAME: '323',
            },
            {
                CODE: '1821',
                NAME: '324',
                ENG_NAME: '324',
            },
            {
                CODE: '1822',
                NAME: '325',
                ENG_NAME: '325',
            },
            {
                CODE: '1823',
                NAME: '401',
                ENG_NAME: '401',
            },
            {
                CODE: '1824',
                NAME: '402',
                ENG_NAME: '402',
            },
            {
                CODE: '1825',
                NAME: '403',
                ENG_NAME: '403',
            },
            {
                CODE: '1826',
                NAME: '404',
                ENG_NAME: '404',
            },
            {
                CODE: '1827',
                NAME: '405',
                ENG_NAME: '405',
            },
            {
                CODE: '1828',
                NAME: '406',
                ENG_NAME: '406',
            },
            {
                CODE: '1829',
                NAME: '407',
                ENG_NAME: '407',
            },
            {
                CODE: '1830',
                NAME: '408',
                ENG_NAME: '408',
            },
            {
                CODE: '1831',
                NAME: '409',
                ENG_NAME: '409',
            },
            {
                CODE: '1832',
                NAME: '410',
                ENG_NAME: '410',
            },
            {
                CODE: '1833',
                NAME: '411',
                ENG_NAME: '411',
            },
            {
                CODE: '1834',
                NAME: '412',
                ENG_NAME: '412',
            },
            {
                CODE: '1835',
                NAME: '413',
                ENG_NAME: '413',
            },
            {
                CODE: '1836',
                NAME: '414',
                ENG_NAME: '414',
            },
            {
                CODE: '1837',
                NAME: '415',
                ENG_NAME: '415',
            },
            {
                CODE: '1838',
                NAME: '416',
                ENG_NAME: '416',
            },
            {
                CODE: '1839',
                NAME: '417',
                ENG_NAME: '417',
            },
            {
                CODE: '1840',
                NAME: '418',
                ENG_NAME: '418',
            },
            {
                CODE: '1841',
                NAME: '419',
                ENG_NAME: '419',
            },
            {
                CODE: '1842',
                NAME: '420',
                ENG_NAME: '420',
            },
            {
                CODE: '1843',
                NAME: '421',
                ENG_NAME: '421',
            },
            {
                CODE: '1844',
                NAME: '422',
                ENG_NAME: '422',
            },
            {
                CODE: '1845',
                NAME: '423',
                ENG_NAME: '423',
            },
            {
                CODE: '1846',
                NAME: '424',
                ENG_NAME: '424',
            },
            {
                CODE: '1847',
                NAME: '425',
                ENG_NAME: '425',
            },
            {
                CODE: '1848',
                NAME: '501',
                ENG_NAME: '501',
            },
            {
                CODE: '1849',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '1850',
                NAME: '503',
                ENG_NAME: '503',
            },
            {
                CODE: '1851',
                NAME: '504',
                ENG_NAME: '504',
            },
            {
                CODE: '1852',
                NAME: '505',
                ENG_NAME: '505',
            },
            {
                CODE: '1853',
                NAME: '506',
                ENG_NAME: '506',
            },
            {
                CODE: '1854',
                NAME: '507',
                ENG_NAME: '507',
            },
            {
                CODE: '1855',
                NAME: '508',
                ENG_NAME: '508',
            },
            {
                CODE: '1856',
                NAME: '509',
                ENG_NAME: '509',
            },
            {
                CODE: '1857',
                NAME: '510',
                ENG_NAME: '510',
            },
            {
                CODE: '1858',
                NAME: '511',
                ENG_NAME: '511',
            },
            {
                CODE: '1859',
                NAME: '512',
                ENG_NAME: '512',
            },
            {
                CODE: '1860',
                NAME: '513',
                ENG_NAME: '513',
            },
            {
                CODE: '1861',
                NAME: '514',
                ENG_NAME: '514',
            },
            {
                CODE: '1862',
                NAME: '515',
                ENG_NAME: '515',
            },
            {
                CODE: '1863',
                NAME: '516',
                ENG_NAME: '516',
            },
            {
                CODE: '1864',
                NAME: '517',
                ENG_NAME: '517',
            },
            {
                CODE: '1865',
                NAME: '518',
                ENG_NAME: '518',
            },
            {
                CODE: '1866',
                NAME: '519',
                ENG_NAME: '519',
            },
            {
                CODE: '1867',
                NAME: '520',
                ENG_NAME: '520',
            },
            {
                CODE: '1868',
                NAME: '521',
                ENG_NAME: '521',
            },
            {
                CODE: '1869',
                NAME: '522',
                ENG_NAME: '522',
            },
            {
                CODE: '1870',
                NAME: '523',
                ENG_NAME: '523',
            },
            {
                CODE: '1871',
                NAME: '524',
                ENG_NAME: '524',
            },
            {
                CODE: '1872',
                NAME: '525',
                ENG_NAME: '525',
            },
            {
                CODE: '1873',
                NAME: '526',
                ENG_NAME: '526',
            },
            {
                CODE: '1874',
                NAME: '601',
                ENG_NAME: '601',
            },
            {
                CODE: '1875',
                NAME: '602',
                ENG_NAME: '602',
            },
            {
                CODE: '1876',
                NAME: '603',
                ENG_NAME: '603',
            },
            {
                CODE: '1877',
                NAME: '604',
                ENG_NAME: '604',
            },
            {
                CODE: '1878',
                NAME: '605',
                ENG_NAME: '605',
            },
            {
                CODE: '1879',
                NAME: '606',
                ENG_NAME: '606',
            },
            {
                CODE: '1880',
                NAME: '607',
                ENG_NAME: '607',
            },
            {
                CODE: '1881',
                NAME: '608',
                ENG_NAME: '608',
            },
            {
                CODE: '1882',
                NAME: '609',
                ENG_NAME: '609',
            },
            {
                CODE: '1883',
                NAME: '610',
                ENG_NAME: '610',
            },
            {
                CODE: '1884',
                NAME: '611',
                ENG_NAME: '611',
            },
            {
                CODE: '1885',
                NAME: '612',
                ENG_NAME: '612',
            },
            {
                CODE: '1886',
                NAME: '613',
                ENG_NAME: '613',
            },
            {
                CODE: '1887',
                NAME: '614',
                ENG_NAME: '614',
            },
            {
                CODE: '1888',
                NAME: '615',
                ENG_NAME: '615',
            },
            {
                CODE: '1889',
                NAME: '616',
                ENG_NAME: '616',
            },
            {
                CODE: '1890',
                NAME: '617',
                ENG_NAME: '617',
            },
            {
                CODE: '1891',
                NAME: '618',
                ENG_NAME: '618',
            },
            {
                CODE: '1892',
                NAME: '619',
                ENG_NAME: '619',
            },
            {
                CODE: '1893',
                NAME: '620',
                ENG_NAME: '620',
            },
            {
                CODE: '1894',
                NAME: '621',
                ENG_NAME: '621',
            },
            {
                CODE: '1895',
                NAME: '622',
                ENG_NAME: '622',
            },
            {
                CODE: '1896',
                NAME: '623',
                ENG_NAME: '623',
            },
            {
                CODE: '1897',
                NAME: '624',
                ENG_NAME: '624',
            },
            {
                CODE: '1898',
                NAME: '627',
                ENG_NAME: '627',
            },
            {
                CODE: '1899',
                NAME: '625',
                ENG_NAME: '625',
            },
            {
                CODE: '1900',
                NAME: '626',
                ENG_NAME: '626',
            },
            {
                CODE: '1901',
                NAME: '701',
                ENG_NAME: '701',
            },
            {
                CODE: '1902',
                NAME: '702',
                ENG_NAME: '702',
            },
            {
                CODE: '1903',
                NAME: '703',
                ENG_NAME: '703',
            },
            {
                CODE: '1904',
                NAME: '704',
                ENG_NAME: '704',
            },
            {
                CODE: '1905',
                NAME: 'B01',
                ENG_NAME: 'B01',
            },
            {
                CODE: '1906',
                NAME: 'B02',
                ENG_NAME: 'B02',
            },
            {
                CODE: '1907',
                NAME: 'B03',
                ENG_NAME: 'B03',
            },
            {
                CODE: '1908',
                NAME: 'B04',
                ENG_NAME: 'B04',
            },
            {
                CODE: '1909',
                NAME: 'B05',
                ENG_NAME: 'B05',
            },
            {
                CODE: '1910',
                NAME: 'B06',
                ENG_NAME: 'B06',
            },
            {
                CODE: '1911',
                NAME: 'B07',
                ENG_NAME: 'B07',
            },
            {
                CODE: '1912',
                NAME: 'B08',
                ENG_NAME: 'B08',
            },
            {
                CODE: '1913',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '1914',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '1915',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '1916',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '1917',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '1918',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '1919',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '1920',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '1921',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '1922',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '1923',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '1924',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '1925',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '1926',
                NAME: '114',
                ENG_NAME: '114',
            },
            {
                CODE: '1927',
                NAME: '115',
                ENG_NAME: '115',
            },
            {
                CODE: '1928',
                NAME: '116',
                ENG_NAME: '116',
            },
            {
                CODE: '1929',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '1930',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '1931',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '1932',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '1933',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '1934',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '1935',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '1936',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '1937',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '1938',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '1939',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '1940',
                NAME: '212',
                ENG_NAME: '212',
            },
            {
                CODE: '1941',
                NAME: '213',
                ENG_NAME: '213',
            },
            {
                CODE: '1942',
                NAME: '214',
                ENG_NAME: '214',
            },
            {
                CODE: '1943',
                NAME: '215',
                ENG_NAME: '215',
            },
            {
                CODE: '1944',
                NAME: '216',
                ENG_NAME: '216',
            },
            {
                CODE: '1945',
                NAME: '217',
                ENG_NAME: '217',
            },
            {
                CODE: '1946',
                NAME: '218',
                ENG_NAME: '218',
            },
            {
                CODE: '1947',
                NAME: '218A',
                ENG_NAME: '218A',
            },
            {
                CODE: '1948',
                NAME: '218B',
                ENG_NAME: '218B',
            },
            {
                CODE: '1949',
                NAME: '218C',
                ENG_NAME: '218C',
            },
            {
                CODE: '1950',
                NAME: '219',
                ENG_NAME: '219',
            },
            {
                CODE: '1951',
                NAME: '220',
                ENG_NAME: '220',
            },
            {
                CODE: '1952',
                NAME: '221',
                ENG_NAME: '221',
            },
            {
                CODE: '1953',
                NAME: '222',
                ENG_NAME: '222',
            },
            {
                CODE: '1954',
                NAME: '223',
                ENG_NAME: '223',
            },
            {
                CODE: '1955',
                NAME: '224',
                ENG_NAME: '224',
            },
            {
                CODE: '1956',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '1957',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '1958',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '1959',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '1960',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '1961',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '1962',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '1963',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '1964',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '1965',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '1966',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '1967',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '1968',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '1969',
                NAME: '314',
                ENG_NAME: '314',
            },
            {
                CODE: '1970',
                NAME: '315',
                ENG_NAME: '315',
            },
            {
                CODE: '1971',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '1972',
                NAME: '317',
                ENG_NAME: '317',
            },
            {
                CODE: '1973',
                NAME: '318',
                ENG_NAME: '318',
            },
            {
                CODE: '1974',
                NAME: '319',
                ENG_NAME: '319',
            },
            {
                CODE: '1975',
                NAME: '320',
                ENG_NAME: '320',
            },
            {
                CODE: '1976',
                NAME: '321',
                ENG_NAME: '321',
            },
            {
                CODE: '1977',
                NAME: '322',
                ENG_NAME: '322',
            },
            {
                CODE: '1978',
                NAME: '323',
                ENG_NAME: '323',
            },
            {
                CODE: '1979',
                NAME: '324',
                ENG_NAME: '324',
            },
            {
                CODE: '1980',
                NAME: '401',
                ENG_NAME: '401',
            },
            {
                CODE: '1981',
                NAME: '402',
                ENG_NAME: '402',
            },
            {
                CODE: '1982',
                NAME: '403',
                ENG_NAME: '403',
            },
            {
                CODE: '1983',
                NAME: '404',
                ENG_NAME: '404',
            },
            {
                CODE: '1984',
                NAME: '405',
                ENG_NAME: '405',
            },
            {
                CODE: '1985',
                NAME: '406',
                ENG_NAME: '406',
            },
            {
                CODE: '1986',
                NAME: '407',
                ENG_NAME: '407',
            },
            {
                CODE: '1987',
                NAME: '408',
                ENG_NAME: '408',
            },
            {
                CODE: '1988',
                NAME: '409',
                ENG_NAME: '409',
            },
            {
                CODE: '1989',
                NAME: '410',
                ENG_NAME: '410',
            },
            {
                CODE: '1990',
                NAME: '411',
                ENG_NAME: '411',
            },
            {
                CODE: '1991',
                NAME: '412',
                ENG_NAME: '412',
            },
            {
                CODE: '1992',
                NAME: '413',
                ENG_NAME: '413',
            },
            {
                CODE: '1993',
                NAME: '414',
                ENG_NAME: '414',
            },
            {
                CODE: '1994',
                NAME: '415',
                ENG_NAME: '415',
            },
            {
                CODE: '1995',
                NAME: '416',
                ENG_NAME: '416',
            },
            {
                CODE: '1996',
                NAME: '417',
                ENG_NAME: '417',
            },
            {
                CODE: '1997',
                NAME: '418',
                ENG_NAME: '418',
            },
            {
                CODE: '1998',
                NAME: '419',
                ENG_NAME: '419',
            },
            {
                CODE: '1999',
                NAME: '420',
                ENG_NAME: '420',
            },
            {
                CODE: '2000',
                NAME: '421',
                ENG_NAME: '421',
            },
            {
                CODE: '2001',
                NAME: '422',
                ENG_NAME: '422',
            },
            {
                CODE: '2002',
                NAME: '423',
                ENG_NAME: '423',
            },
            {
                CODE: '2003',
                NAME: '424',
                ENG_NAME: '424',
            },
            {
                CODE: '2004',
                NAME: '425',
                ENG_NAME: '425',
            },
            {
                CODE: '2005',
                NAME: '426',
                ENG_NAME: '426',
            },
            {
                CODE: '2006',
                NAME: '601',
                ENG_NAME: '601',
            },
            {
                CODE: '2007',
                NAME: '602',
                ENG_NAME: '602',
            },
            {
                CODE: '2008',
                NAME: '603',
                ENG_NAME: '603',
            },
            {
                CODE: '2009',
                NAME: '604',
                ENG_NAME: '604',
            },
            {
                CODE: '2010',
                NAME: '605',
                ENG_NAME: '605',
            },
            {
                CODE: '2011',
                NAME: '606',
                ENG_NAME: '606',
            },
            {
                CODE: '2012',
                NAME: '607',
                ENG_NAME: '607',
            },
            {
                CODE: '2013',
                NAME: '608',
                ENG_NAME: '608',
            },
            {
                CODE: '2014',
                NAME: '609',
                ENG_NAME: '609',
            },
            {
                CODE: '2015',
                NAME: '610',
                ENG_NAME: '610',
            },
            {
                CODE: '2016',
                NAME: '611',
                ENG_NAME: '611',
            },
            {
                CODE: '2017',
                NAME: '612',
                ENG_NAME: '612',
            },
            {
                CODE: '2018',
                NAME: '613',
                ENG_NAME: '613',
            },
            {
                CODE: '2019',
                NAME: '614',
                ENG_NAME: '614',
            },
            {
                CODE: '2020',
                NAME: '615',
                ENG_NAME: '615',
            },
            {
                CODE: '2021',
                NAME: '616',
                ENG_NAME: '616',
            },
            {
                CODE: '2022',
                NAME: '617',
                ENG_NAME: '617',
            },
            {
                CODE: '2023',
                NAME: '618',
                ENG_NAME: '618',
            },
            {
                CODE: '2024',
                NAME: '619',
                ENG_NAME: '619',
            },
            {
                CODE: '2025',
                NAME: '620',
                ENG_NAME: '620',
            },
            {
                CODE: '2026',
                NAME: '621',
                ENG_NAME: '621',
            },
            {
                CODE: '2027',
                NAME: '622',
                ENG_NAME: '622',
            },
            {
                CODE: '2028',
                NAME: '623',
                ENG_NAME: '623',
            },
            {
                CODE: '2029',
                NAME: '624',
                ENG_NAME: '624',
            },
            {
                CODE: '2030',
                NAME: '625',
                ENG_NAME: '625',
            },
            {
                CODE: '2031',
                NAME: '626',
                ENG_NAME: '626',
            },
            {
                CODE: '2032',
                NAME: '701',
                ENG_NAME: '701',
            },
            {
                CODE: '2033',
                NAME: '702',
                ENG_NAME: '702',
            },
            {
                CODE: '2034',
                NAME: '703',
                ENG_NAME: '703',
            },
            {
                CODE: '2035',
                NAME: '704',
                ENG_NAME: '704',
            },
            {
                CODE: '2036',
                NAME: 'B101',
                ENG_NAME: 'B101',
            },
            {
                CODE: '2037',
                NAME: 'B102',
                ENG_NAME: 'B102',
            },
            {
                CODE: '2038',
                NAME: 'B103',
                ENG_NAME: 'B103',
            },
            {
                CODE: '2039',
                NAME: 'B104',
                ENG_NAME: 'B104',
            },
            {
                CODE: '2040',
                NAME: 'G01',
                ENG_NAME: 'G01',
            },
            {
                CODE: '2041',
                NAME: 'G02',
                ENG_NAME: 'G02',
            },
            {
                CODE: '2042',
                NAME: 'G03',
                ENG_NAME: 'G03',
            },
            {
                CODE: '2043',
                NAME: 'G04',
                ENG_NAME: 'G04',
            },
            {
                CODE: '2044',
                NAME: 'G05',
                ENG_NAME: 'G05',
            },
            {
                CODE: '2045',
                NAME: 'G06',
                ENG_NAME: 'G06',
            },
            {
                CODE: '2046',
                NAME: 'G07',
                ENG_NAME: 'G07',
            },
            {
                CODE: '2047',
                NAME: 'G08',
                ENG_NAME: 'G08',
            },
            {
                CODE: '2048',
                NAME: 'G09',
                ENG_NAME: 'G09',
            },
            {
                CODE: '2049',
                NAME: 'G10',
                ENG_NAME: 'G10',
            },
            {
                CODE: '2050',
                NAME: 'G11',
                ENG_NAME: 'G11',
            },
            {
                CODE: '2051',
                NAME: 'G12',
                ENG_NAME: 'G12',
            },
            {
                CODE: '2052',
                NAME: 'L01',
                ENG_NAME: 'L01',
            },
            {
                CODE: '2053',
                NAME: 'L02',
                ENG_NAME: 'L02',
            },
            {
                CODE: '2054',
                NAME: 'L03',
                ENG_NAME: 'L03',
            },
            {
                CODE: '2055',
                NAME: 'L04',
                ENG_NAME: 'L04',
            },
            {
                CODE: '2056',
                NAME: 'L05',
                ENG_NAME: 'L05',
            },
            {
                CODE: '2057',
                NAME: 'L06',
                ENG_NAME: 'L06',
            },
            {
                CODE: '2058',
                NAME: 'L07',
                ENG_NAME: 'L07',
            },
            {
                CODE: '2059',
                NAME: 'L08',
                ENG_NAME: 'L08',
            },
            {
                CODE: '2060',
                NAME: 'L09',
                ENG_NAME: 'L09',
            },
            {
                CODE: '2061',
                NAME: 'L10',
                ENG_NAME: 'L10',
            },
            {
                CODE: '2062',
                NAME: 'L11',
                ENG_NAME: 'L11',
            },
            {
                CODE: '2063',
                NAME: 'L12',
                ENG_NAME: 'L12',
            },
            {
                CODE: '2064',
                NAME: 'L13',
                ENG_NAME: 'L13',
            },
            {
                CODE: '2065',
                NAME: 'L14',
                ENG_NAME: 'L14',
            },
            {
                CODE: '2066',
                NAME: 'L15',
                ENG_NAME: 'L15',
            },
            {
                CODE: '2067',
                NAME: 'L16',
                ENG_NAME: 'L16',
            },
            {
                CODE: '2068',
                NAME: 'L17',
                ENG_NAME: 'L17',
            },
            {
                CODE: '2069',
                NAME: 'L18',
                ENG_NAME: 'L18',
            },
            {
                CODE: '2070',
                NAME: 'L19',
                ENG_NAME: 'L19',
            },
            {
                CODE: '2071',
                NAME: 'L20',
                ENG_NAME: 'L20',
            },
            {
                CODE: '2072',
                NAME: 'L21',
                ENG_NAME: 'L21',
            },
            {
                CODE: '2073',
                NAME: 'L22',
                ENG_NAME: 'L22',
            },
            {
                CODE: '2074',
                NAME: 'L23',
                ENG_NAME: 'L23',
            },
            {
                CODE: '2075',
                NAME: 'L24',
                ENG_NAME: 'L24',
            },
            {
                CODE: '2076',
                NAME: 'L25',
                ENG_NAME: 'L25',
            },
            {
                CODE: '2077',
                NAME: 'L26',
                ENG_NAME: 'L26',
            },
            {
                CODE: '2078',
                NAME: 'L27',
                ENG_NAME: 'L27',
            },
            {
                CODE: '2079',
                NAME: 'L28',
                ENG_NAME: 'L28',
            },
            {
                CODE: '2080',
                NAME: 'L29',
                ENG_NAME: 'L29',
            },
            {
                CODE: '2081',
                NAME: 'L30',
                ENG_NAME: 'L30',
            },
            {
                CODE: '2082',
                NAME: 'L31',
                ENG_NAME: 'L31',
            },
            {
                CODE: '2083',
                NAME: 'L32',
                ENG_NAME: 'L32',
            },
            {
                CODE: '2084',
                NAME: 'L33',
                ENG_NAME: 'L33',
            },
            {
                CODE: '2085',
                NAME: 'L34',
                ENG_NAME: 'L34',
            },
            {
                CODE: '2086',
                NAME: 'L35',
                ENG_NAME: 'L35',
            },
            {
                CODE: '2087',
                NAME: 'L36',
                ENG_NAME: 'L36',
            },
            {
                CODE: '2088',
                NAME: 'L37',
                ENG_NAME: 'L37',
            },
            {
                CODE: '2089',
                NAME: 'L38',
                ENG_NAME: 'L38',
            },
            {
                CODE: '2090',
                NAME: 'L39',
                ENG_NAME: 'L39',
            },
            {
                CODE: '2091',
                NAME: 'L40',
                ENG_NAME: 'L40',
            },
            {
                CODE: '2092',
                NAME: 'L41',
                ENG_NAME: 'L41',
            },
            {
                CODE: '2093',
                NAME: 'L42',
                ENG_NAME: 'L42',
            },
            {
                CODE: '2094',
                NAME: 'L43',
                ENG_NAME: 'L43',
            },
            {
                CODE: '2095',
                NAME: 'L44',
                ENG_NAME: 'L44',
            },
            {
                CODE: '2096',
                NAME: '201호',
                ENG_NAME: '201호',
            },
            {
                CODE: '2097',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '2098',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '2099',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '2100',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '2101',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '2102',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '2103',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '2104',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '2105',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '2106',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '2107',
                NAME: '212',
                ENG_NAME: '212',
            },
            {
                CODE: '2108',
                NAME: '213',
                ENG_NAME: '213',
            },
            {
                CODE: '2109',
                NAME: '214',
                ENG_NAME: '214',
            },
            {
                CODE: '2110',
                NAME: '215',
                ENG_NAME: '215',
            },
            {
                CODE: '2111',
                NAME: '216',
                ENG_NAME: '216',
            },
            {
                CODE: '2112',
                NAME: '217',
                ENG_NAME: '217',
            },
            {
                CODE: '2113',
                NAME: '218',
                ENG_NAME: '218',
            },
            {
                CODE: '2114',
                NAME: '219',
                ENG_NAME: '219',
            },
            {
                CODE: '2115',
                NAME: '220',
                ENG_NAME: '220',
            },
            {
                CODE: '2116',
                NAME: '221',
                ENG_NAME: '221',
            },
            {
                CODE: '2117',
                NAME: '222',
                ENG_NAME: '222',
            },
            {
                CODE: '2118',
                NAME: '223',
                ENG_NAME: '223',
            },
            {
                CODE: '2119',
                NAME: '224',
                ENG_NAME: '224',
            },
            {
                CODE: '2120',
                NAME: '225',
                ENG_NAME: '225',
            },
            {
                CODE: '2121',
                NAME: '226',
                ENG_NAME: '226',
            },
            {
                CODE: '2122',
                NAME: '227',
                ENG_NAME: '227',
            },
            {
                CODE: '2123',
                NAME: '228',
                ENG_NAME: '228',
            },
            {
                CODE: '2124',
                NAME: '229',
                ENG_NAME: '229',
            },
            {
                CODE: '2125',
                NAME: '230',
                ENG_NAME: '230',
            },
            {
                CODE: '2126',
                NAME: '231',
                ENG_NAME: '231',
            },
            {
                CODE: '2127',
                NAME: '232',
                ENG_NAME: '232',
            },
            {
                CODE: '2128',
                NAME: '233',
                ENG_NAME: '233',
            },
            {
                CODE: '2129',
                NAME: '234',
                ENG_NAME: '234',
            },
            {
                CODE: '2130',
                NAME: '235',
                ENG_NAME: '235',
            },
            {
                CODE: '2131',
                NAME: '236',
                ENG_NAME: '236',
            },
            {
                CODE: '2132',
                NAME: '237',
                ENG_NAME: '237',
            },
            {
                CODE: '2133',
                NAME: '238',
                ENG_NAME: '238',
            },
            {
                CODE: '2134',
                NAME: '239',
                ENG_NAME: '239',
            },
            {
                CODE: '2135',
                NAME: '240',
                ENG_NAME: '240',
            },
            {
                CODE: '2136',
                NAME: '241',
                ENG_NAME: '241',
            },
            {
                CODE: '2137',
                NAME: '242',
                ENG_NAME: '242',
            },
            {
                CODE: '2138',
                NAME: '243',
                ENG_NAME: '243',
            },
            {
                CODE: '2139',
                NAME: '244',
                ENG_NAME: '244',
            },
            {
                CODE: '2140',
                NAME: '245',
                ENG_NAME: '245',
            },
            {
                CODE: '2141',
                NAME: '246',
                ENG_NAME: '246',
            },
            {
                CODE: '2142',
                NAME: '247',
                ENG_NAME: '247',
            },
            {
                CODE: '2143',
                NAME: '248',
                ENG_NAME: '248',
            },
            {
                CODE: '2144',
                NAME: '249',
                ENG_NAME: '249',
            },
            {
                CODE: '2145',
                NAME: '250',
                ENG_NAME: '250',
            },
            {
                CODE: '2146',
                NAME: '251',
                ENG_NAME: '251',
            },
            {
                CODE: '2147',
                NAME: '252',
                ENG_NAME: '252',
            },
            {
                CODE: '2148',
                NAME: '253',
                ENG_NAME: '253',
            },
            {
                CODE: '2149',
                NAME: '254',
                ENG_NAME: '254',
            },
            {
                CODE: '2150',
                NAME: '255',
                ENG_NAME: '255',
            },
            {
                CODE: '2151',
                NAME: '256',
                ENG_NAME: '256',
            },
            {
                CODE: '2152',
                NAME: '257',
                ENG_NAME: '257',
            },
            {
                CODE: '2153',
                NAME: '258',
                ENG_NAME: '258',
            },
            {
                CODE: '2154',
                NAME: '259',
                ENG_NAME: '259',
            },
            {
                CODE: '2155',
                NAME: '260',
                ENG_NAME: '260',
            },
            {
                CODE: '2156',
                NAME: '261',
                ENG_NAME: '261',
            },
            {
                CODE: '2157',
                NAME: '262',
                ENG_NAME: '262',
            },
            {
                CODE: '2158',
                NAME: '263',
                ENG_NAME: '263',
            },
            {
                CODE: '2159',
                NAME: '264',
                ENG_NAME: '264',
            },
            {
                CODE: '2160',
                NAME: '265',
                ENG_NAME: '265',
            },
            {
                CODE: '2161',
                NAME: '266',
                ENG_NAME: '266',
            },
            {
                CODE: '2162',
                NAME: '267',
                ENG_NAME: '267',
            },
            {
                CODE: '2163',
                NAME: '268',
                ENG_NAME: '268',
            },
            {
                CODE: '2164',
                NAME: '269',
                ENG_NAME: '269',
            },
            {
                CODE: '2165',
                NAME: '270',
                ENG_NAME: '270',
            },
            {
                CODE: '2166',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '2167',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '2168',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '2169',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '2170',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '2171',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '2172',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '2173',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '2174',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '2175',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '2176',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '2177',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '2178',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '2179',
                NAME: '314',
                ENG_NAME: '314',
            },
            {
                CODE: '2180',
                NAME: '315',
                ENG_NAME: '315',
            },
            {
                CODE: '2181',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '2182',
                NAME: '317',
                ENG_NAME: '317',
            },
            {
                CODE: '2183',
                NAME: '318',
                ENG_NAME: '318',
            },
            {
                CODE: '2184',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '2185',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '2186',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '2187',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '2188',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '2189',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '2190',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '2191',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '2192',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '2193',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '2194',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '2195',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '2196',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '2197',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '2198',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '2199',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '2200',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '2201',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '2202',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '2203',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '2204',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '2205',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '2206',
                NAME: '210',
                ENG_NAME: '210',
            },
            {
                CODE: '2207',
                NAME: '211',
                ENG_NAME: '211',
            },
            {
                CODE: '2208',
                NAME: '212',
                ENG_NAME: '212',
            },
            {
                CODE: '2209',
                NAME: '213',
                ENG_NAME: '213',
            },
            {
                CODE: '2210',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '2211',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '2212',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '2213',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '2214',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '2215',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '2216',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '2217',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '2218',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '2219',
                NAME: '310',
                ENG_NAME: '310',
            },
            {
                CODE: '2220',
                NAME: '311',
                ENG_NAME: '311',
            },
            {
                CODE: '2221',
                NAME: '312',
                ENG_NAME: '312',
            },
            {
                CODE: '2222',
                NAME: '313',
                ENG_NAME: '313',
            },
            {
                CODE: '2223',
                NAME: '314',
                ENG_NAME: '314',
            },
            {
                CODE: '2224',
                NAME: '315',
                ENG_NAME: '315',
            },
            {
                CODE: '2225',
                NAME: '316',
                ENG_NAME: '316',
            },
            {
                CODE: '2226',
                NAME: '317',
                ENG_NAME: '317',
            },
            {
                CODE: '2227',
                NAME: '318',
                ENG_NAME: '318',
            },
            {
                CODE: '2228',
                NAME: '319',
                ENG_NAME: '319',
            },
            {
                CODE: '2229',
                NAME: '320',
                ENG_NAME: '320',
            },
            {
                CODE: '2230',
                NAME: '321',
                ENG_NAME: '321',
            },
            {
                CODE: '2231',
                NAME: '401',
                ENG_NAME: '401',
            },
            {
                CODE: '2232',
                NAME: '402',
                ENG_NAME: '402',
            },
            {
                CODE: '2233',
                NAME: '403',
                ENG_NAME: '403',
            },
            {
                CODE: '2234',
                NAME: '404',
                ENG_NAME: '404',
            },
            {
                CODE: '2235',
                NAME: '405',
                ENG_NAME: '405',
            },
            {
                CODE: '2236',
                NAME: '406',
                ENG_NAME: '406',
            },
            {
                CODE: '2237',
                NAME: '407',
                ENG_NAME: '407',
            },
            {
                CODE: '2238',
                NAME: '408',
                ENG_NAME: '408',
            },
            {
                CODE: '2239',
                NAME: '409',
                ENG_NAME: '409',
            },
            {
                CODE: '2240',
                NAME: '410',
                ENG_NAME: '410',
            },
            {
                CODE: '2241',
                NAME: '411',
                ENG_NAME: '411',
            },
            {
                CODE: '2242',
                NAME: '501',
                ENG_NAME: '501',
            },
            {
                CODE: '2243',
                NAME: '502',
                ENG_NAME: '502',
            },
            {
                CODE: '2244',
                NAME: '503',
                ENG_NAME: '503',
            },
            {
                CODE: '2245',
                NAME: '504',
                ENG_NAME: '504',
            },
            {
                CODE: '2246',
                NAME: '505',
                ENG_NAME: '505',
            },
            {
                CODE: '2247',
                NAME: '506',
                ENG_NAME: '506',
            },
            {
                CODE: '2248',
                NAME: '507',
                ENG_NAME: '507',
            },
            {
                CODE: '2249',
                NAME: '508',
                ENG_NAME: '508',
            },
            {
                CODE: '2250',
                NAME: '509',
                ENG_NAME: '509',
            },
            {
                CODE: '2251',
                NAME: '510',
                ENG_NAME: '510',
            },
            {
                CODE: '2252',
                NAME: '511',
                ENG_NAME: '511',
            },
            {
                CODE: '2253',
                NAME: '512',
                ENG_NAME: '512',
            },
            {
                CODE: '2254',
                NAME: '513',
                ENG_NAME: '513',
            },
            {
                CODE: '2255',
                NAME: '601',
                ENG_NAME: '601',
            },
            {
                CODE: '2256',
                NAME: '602',
                ENG_NAME: '602',
            },
            {
                CODE: '2257',
                NAME: '603',
                ENG_NAME: '603',
            },
            {
                CODE: '2258',
                NAME: '604',
                ENG_NAME: '604',
            },
            {
                CODE: '2259',
                NAME: '605',
                ENG_NAME: '605',
            },
            {
                CODE: '2260',
                NAME: '606',
                ENG_NAME: '606',
            },
            {
                CODE: '2261',
                NAME: '607',
                ENG_NAME: '607',
            },
            {
                CODE: '2262',
                NAME: '608',
                ENG_NAME: '608',
            },
            {
                CODE: '2263',
                NAME: '609',
                ENG_NAME: '609',
            },
            {
                CODE: '2264',
                NAME: '610',
                ENG_NAME: '610',
            },
            {
                CODE: '2265',
                NAME: '611',
                ENG_NAME: '611',
            },
            {
                CODE: '2266',
                NAME: '612',
                ENG_NAME: '612',
            },
            {
                CODE: '2267',
                NAME: '613',
                ENG_NAME: '613',
            },
            {
                CODE: '2268',
                NAME: 'B101',
                ENG_NAME: 'B101',
            },
            {
                CODE: '2269',
                NAME: 'B102',
                ENG_NAME: 'B102',
            },
            {
                CODE: '2270',
                NAME: 'B103',
                ENG_NAME: 'B103',
            },
            {
                CODE: '2271',
                NAME: 'B104',
                ENG_NAME: 'B104',
            },
            {
                CODE: '2272',
                NAME: 'B105',
                ENG_NAME: 'B105',
            },
            {
                CODE: '2273',
                NAME: 'B106',
                ENG_NAME: 'B106',
            },
            {
                CODE: '2274',
                NAME: 'B107',
                ENG_NAME: 'B107',
            },
            {
                CODE: '2275',
                NAME: 'B108',
                ENG_NAME: 'B108',
            },
            {
                CODE: '2276',
                NAME: 'B109',
                ENG_NAME: 'B109',
            },
            {
                CODE: '2277',
                NAME: 'B110',
                ENG_NAME: 'B110',
            },
            {
                CODE: '2278',
                NAME: 'B111',
                ENG_NAME: 'B111',
            },
            {
                CODE: '2279',
                NAME: 'B112',
                ENG_NAME: 'B112',
            },
            {
                CODE: '2280',
                NAME: 'B113',
                ENG_NAME: 'B113',
            },
            {
                CODE: '2281',
                NAME: 'B114',
                ENG_NAME: 'B114',
            },
            {
                CODE: '2282',
                NAME: 'B115',
                ENG_NAME: 'B115',
            },
            {
                CODE: '2283',
                NAME: 'B116',
                ENG_NAME: 'B116',
            },
            {
                CODE: '2284',
                NAME: 'B117',
                ENG_NAME: 'B117',
            },
            {
                CODE: '2285',
                NAME: 'B118',
                ENG_NAME: 'B118',
            },
            {
                CODE: '2286',
                NAME: 'B119',
                ENG_NAME: 'B119',
            },
            {
                CODE: '2287',
                NAME: 'B120',
                ENG_NAME: 'B120',
            },
            {
                CODE: '2288',
                NAME: 'B121',
                ENG_NAME: 'B121',
            },
            {
                CODE: '2289',
                NAME: 'B122',
                ENG_NAME: 'B122',
            },
            {
                CODE: '2290',
                NAME: 'B123',
                ENG_NAME: 'B123',
            },
            {
                CODE: '2291',
                NAME: 'B124',
                ENG_NAME: 'B124',
            },
            {
                CODE: '2292',
                NAME: 'B125',
                ENG_NAME: 'B125',
            },
            {
                CODE: '2293',
                NAME: 'B126',
                ENG_NAME: 'B126',
            },
            {
                CODE: '2294',
                NAME: 'B127',
                ENG_NAME: 'B127',
            },
            {
                CODE: '2295',
                NAME: 'B128',
                ENG_NAME: 'B128',
            },
            {
                CODE: '2296',
                NAME: 'B129',
                ENG_NAME: 'B129',
            },
            {
                CODE: '2297',
                NAME: 'B130',
                ENG_NAME: 'B130',
            },
            {
                CODE: '2298',
                NAME: 'B131',
                ENG_NAME: 'B131',
            },
            {
                CODE: '2299',
                NAME: 'B132',
                ENG_NAME: 'B132',
            },
            {
                CODE: '2300',
                NAME: 'B133',
                ENG_NAME: 'B133',
            },
            {
                CODE: '2301',
                NAME: 'B134',
                ENG_NAME: 'B134',
            },
            {
                CODE: '2302',
                NAME: 'B135',
                ENG_NAME: 'B135',
            },
            {
                CODE: '2303',
                NAME: 'B136',
                ENG_NAME: 'B136',
            },
            {
                CODE: '2304',
                NAME: 'B137',
                ENG_NAME: 'B137',
            },
            {
                CODE: '2305',
                NAME: 'B138',
                ENG_NAME: 'B138',
            },
            {
                CODE: '2306',
                NAME: 'B139',
                ENG_NAME: 'B139',
            },
            {
                CODE: '2307',
                NAME: 'B140',
                ENG_NAME: 'B140',
            },
            {
                CODE: '2308',
                NAME: 'B141',
                ENG_NAME: 'B141',
            },
            {
                CODE: '2309',
                NAME: 'B142',
                ENG_NAME: 'B142',
            },
            {
                CODE: '2310',
                NAME: 'B143',
                ENG_NAME: 'B143',
            },
            {
                CODE: '2311',
                NAME: 'B144',
                ENG_NAME: 'B144',
            },
            {
                CODE: '2312',
                NAME: 'B145',
                ENG_NAME: 'B145',
            },
            {
                CODE: '2313',
                NAME: 'B146',
                ENG_NAME: 'B146',
            },
            {
                CODE: '2314',
                NAME: 'B201',
                ENG_NAME: 'B201',
            },
            {
                CODE: '2315',
                NAME: 'B202',
                ENG_NAME: 'B202',
            },
            {
                CODE: '2316',
                NAME: 'B203',
                ENG_NAME: 'B203',
            },
            {
                CODE: '2317',
                NAME: 'B204',
                ENG_NAME: 'B204',
            },
            {
                CODE: '2318',
                NAME: 'B205',
                ENG_NAME: 'B205',
            },
            {
                CODE: '2319',
                NAME: 'B206',
                ENG_NAME: 'B206',
            },
            {
                CODE: '2320',
                NAME: 'B207',
                ENG_NAME: 'B207',
            },
            {
                CODE: '2321',
                NAME: 'B208',
                ENG_NAME: 'B208',
            },
            {
                CODE: '2322',
                NAME: 'B209',
                ENG_NAME: 'B209',
            },
            {
                CODE: '2323',
                NAME: 'B210',
                ENG_NAME: 'B210',
            },
            {
                CODE: '2324',
                NAME: 'B211',
                ENG_NAME: 'B211',
            },
            {
                CODE: '2325',
                NAME: 'B212',
                ENG_NAME: 'B212',
            },
            {
                CODE: '2326',
                NAME: 'B213',
                ENG_NAME: 'B213',
            },
            {
                CODE: '2327',
                NAME: 'B214',
                ENG_NAME: 'B214',
            },
            {
                CODE: '2328',
                NAME: 'B215',
                ENG_NAME: 'B215',
            },
            {
                CODE: '2329',
                NAME: 'B216',
                ENG_NAME: 'B216',
            },
            {
                CODE: '2330',
                NAME: 'B217',
                ENG_NAME: 'B217',
            },
            {
                CODE: '2331',
                NAME: 'B217A',
                ENG_NAME: 'B217A',
            },
            {
                CODE: '2332',
                NAME: 'B217B',
                ENG_NAME: 'B217B',
            },
            {
                CODE: '2333',
                NAME: 'B218',
                ENG_NAME: 'B218',
            },
            {
                CODE: '2334',
                NAME: 'B218A',
                ENG_NAME: 'B218A',
            },
            {
                CODE: '2335',
                NAME: 'B218B',
                ENG_NAME: 'B218B',
            },
            {
                CODE: '2336',
                NAME: 'B219',
                ENG_NAME: 'B219',
            },
            {
                CODE: '2337',
                NAME: 'B220',
                ENG_NAME: 'B220',
            },
            {
                CODE: '2338',
                NAME: 'B230',
                ENG_NAME: 'B230',
            },
            {
                CODE: '2339',
                NAME: 'B250',
                ENG_NAME: 'B250',
            },
            {
                CODE: '2340',
                NAME: 'B251',
                ENG_NAME: 'B251',
            },
            {
                CODE: '2341',
                NAME: 'B252',
                ENG_NAME: 'B252',
            },
            {
                CODE: '2342',
                NAME: 'B253',
                ENG_NAME: 'B253',
            },
            {
                CODE: '2343',
                NAME: 'B254',
                ENG_NAME: 'B254',
            },
            {
                CODE: '2344',
                NAME: 'B260',
                ENG_NAME: 'B260',
            },
            {
                CODE: '2345',
                NAME: 'B262',
                ENG_NAME: 'B262',
            },
            {
                CODE: '2346',
                NAME: 'B261',
                ENG_NAME: 'B261',
            },
            {
                CODE: '2347',
                NAME: 'B208-1',
                ENG_NAME: 'B208-1',
            },
            {
                CODE: '2348',
                NAME: 'B208-2',
                ENG_NAME: 'B208-2',
            },
            {
                CODE: '2349',
                NAME: 'B208-3',
                ENG_NAME: 'B208-3',
            },
            {
                CODE: '2350',
                NAME: 'B208-4',
                ENG_NAME: 'B208-4',
            },
            {
                CODE: '2351',
                NAME: 'B208-5',
                ENG_NAME: 'B208-5',
            },
            {
                CODE: '2352',
                NAME: 'B215-4',
                ENG_NAME: 'B215-4',
            },
            {
                CODE: '2353',
                NAME: 'B215-3',
                ENG_NAME: 'B215-3',
            },
            {
                CODE: '2354',
                NAME: 'B215-2',
                ENG_NAME: 'B215-2',
            },
            {
                CODE: '2355',
                NAME: 'B215-1',
                ENG_NAME: 'B215-1',
            },
            {
                CODE: '2356',
                NAME: 'B217-1',
                ENG_NAME: 'B217-1',
            },
            {
                CODE: '2357',
                NAME: 'B217-2',
                ENG_NAME: 'B217-2',
            },
            {
                CODE: '2358',
                NAME: 'B217-3',
                ENG_NAME: 'B217-3',
            },
            {
                CODE: '2359',
                NAME: 'B217-4',
                ENG_NAME: 'B217-4',
            },
            {
                CODE: '2360',
                NAME: 'B217-31',
                ENG_NAME: 'B217-31',
            },
            {
                CODE: '2361',
                NAME: 'B217-32',
                ENG_NAME: 'B217-32',
            },
            {
                CODE: '2362',
                NAME: 'B217-41',
                ENG_NAME: 'B217-41',
            },
            {
                CODE: '2363',
                NAME: 'B217-42',
                ENG_NAME: 'B217-42',
            },
            {
                CODE: '2364',
                NAME: 'B217-43',
                ENG_NAME: 'B217-43',
            },
            {
                CODE: '2365',
                NAME: 'B217-5',
                ENG_NAME: 'B217-5',
            },
            {
                CODE: '2366',
                NAME: 'B217-6',
                ENG_NAME: 'B217-6',
            },
            {
                CODE: '2367',
                NAME: 'B217-7',
                ENG_NAME: 'B217-7',
            },
            {
                CODE: '2368',
                NAME: 'B217-8',
                ENG_NAME: 'B217-8',
            },
            {
                CODE: '2369',
                NAME: 'B217-9',
                ENG_NAME: 'B217-9',
            },
            {
                CODE: '2370',
                NAME: 'B217-10',
                ENG_NAME: 'B217-10',
            },
            {
                CODE: '2371',
                NAME: 'B217-11',
                ENG_NAME: 'B217-11',
            },
            {
                CODE: '2372',
                NAME: 'B218-1',
                ENG_NAME: 'B218-1',
            },
            {
                CODE: '2373',
                NAME: 'B218-2',
                ENG_NAME: 'B218-2',
            },
            {
                CODE: '2374',
                NAME: 'B218-6',
                ENG_NAME: 'B218-6',
            },
            {
                CODE: '2375',
                NAME: 'B218-7',
                ENG_NAME: 'B218-7',
            },
            {
                CODE: '2376',
                NAME: 'B218-8',
                ENG_NAME: 'B218-8',
            },
            {
                CODE: '2377',
                NAME: 'B218-9',
                ENG_NAME: 'B218-9',
            },
            {
                CODE: '2378',
                NAME: 'B218-10',
                ENG_NAME: 'B218-10',
            },
            {
                CODE: '2379',
                NAME: 'B218-11',
                ENG_NAME: 'B218-11',
            },
            {
                CODE: '2380',
                NAME: 'B218-3',
                ENG_NAME: 'B218-3',
            },
            {
                CODE: '2381',
                NAME: 'B218-4',
                ENG_NAME: 'B218-4',
            },
            {
                CODE: '2382',
                NAME: 'B218-5',
                ENG_NAME: 'B218-5',
            },
            {
                CODE: '2383',
                NAME: 'B250-1',
                ENG_NAME: 'B250-1',
            },
            {
                CODE: '2384',
                NAME: 'B250-2',
                ENG_NAME: 'B250-2',
            },
            {
                CODE: '2385',
                NAME: 'B250-3',
                ENG_NAME: 'B250-3',
            },
            {
                CODE: '2386',
                NAME: 'B250-4',
                ENG_NAME: 'B250-4',
            },
            {
                CODE: '2387',
                NAME: 'B250-5',
                ENG_NAME: 'B250-5',
            },
            {
                CODE: '2388',
                NAME: 'B250-6',
                ENG_NAME: 'B250-6',
            },
            {
                CODE: '2389',
                NAME: 'B250-7',
                ENG_NAME: 'B250-7',
            },
            {
                CODE: '2390',
                NAME: 'B250-8',
                ENG_NAME: 'B250-8',
            },
            {
                CODE: '2391',
                NAME: 'B250-81',
                ENG_NAME: 'B250-81',
            },
            {
                CODE: '2392',
                NAME: 'B250-82',
                ENG_NAME: 'B250-82',
            },
            {
                CODE: '2393',
                NAME: 'B250-9',
                ENG_NAME: 'B250-9',
            },
            {
                CODE: '2394',
                NAME: 'B250-10',
                ENG_NAME: 'B250-10',
            },
            {
                CODE: '2395',
                NAME: 'B250-11',
                ENG_NAME: 'B250-11',
            },
            {
                CODE: '2396',
                NAME: 'B250-12',
                ENG_NAME: 'B250-12',
            },
            {
                CODE: '2397',
                NAME: 'B250-13',
                ENG_NAME: 'B250-13',
            },
            {
                CODE: '2398',
                NAME: 'B250-13A',
                ENG_NAME: 'B250-13A',
            },
            {
                CODE: '2399',
                NAME: 'B250-14',
                ENG_NAME: 'B250-14',
            },
            {
                CODE: '2400',
                NAME: 'B250-15',
                ENG_NAME: 'B250-15',
            },
            {
                CODE: '2401',
                NAME: 'B250-16',
                ENG_NAME: 'B250-16',
            },
            {
                CODE: '2402',
                NAME: 'B260-1',
                ENG_NAME: 'B260-1',
            },
            {
                CODE: '2403',
                NAME: 'B260-2',
                ENG_NAME: 'B260-2',
            },
            {
                CODE: '2404',
                NAME: 'B260-3',
                ENG_NAME: 'B260-3',
            },
            {
                CODE: '2405',
                NAME: 'B260-4',
                ENG_NAME: 'B260-4',
            },
            {
                CODE: '2406',
                NAME: 'B260-5',
                ENG_NAME: 'B260-5',
            },
            {
                CODE: '2407',
                NAME: 'B260-6',
                ENG_NAME: 'B260-6',
            },
            {
                CODE: '2408',
                NAME: 'B260-7',
                ENG_NAME: 'B260-7',
            },
            {
                CODE: '2409',
                NAME: 'B270-1',
                ENG_NAME: 'B270-1',
            },
            {
                CODE: '2410',
                NAME: 'B240-1',
                ENG_NAME: 'B240-1',
            },
            {
                CODE: '2411',
                NAME: 'B240',
                ENG_NAME: 'B240',
            },
            {
                CODE: '2412',
                NAME: 'B270',
                ENG_NAME: 'B270',
            },
            {
                CODE: '2413',
                NAME: '101',
                ENG_NAME: '101',
            },
            {
                CODE: '2414',
                NAME: '102',
                ENG_NAME: '102',
            },
            {
                CODE: '2415',
                NAME: '103',
                ENG_NAME: '103',
            },
            {
                CODE: '2416',
                NAME: '104',
                ENG_NAME: '104',
            },
            {
                CODE: '2417',
                NAME: '105',
                ENG_NAME: '105',
            },
            {
                CODE: '2418',
                NAME: '106',
                ENG_NAME: '106',
            },
            {
                CODE: '2419',
                NAME: '107',
                ENG_NAME: '107',
            },
            {
                CODE: '2420',
                NAME: '108',
                ENG_NAME: '108',
            },
            {
                CODE: '2421',
                NAME: '109',
                ENG_NAME: '109',
            },
            {
                CODE: '2422',
                NAME: '110',
                ENG_NAME: '110',
            },
            {
                CODE: '2423',
                NAME: '111',
                ENG_NAME: '111',
            },
            {
                CODE: '2424',
                NAME: '112',
                ENG_NAME: '112',
            },
            {
                CODE: '2425',
                NAME: '113',
                ENG_NAME: '113',
            },
            {
                CODE: '2426',
                NAME: '114',
                ENG_NAME: '114',
            },
            {
                CODE: '2427',
                NAME: '115',
                ENG_NAME: '115',
            },
            {
                CODE: '2428',
                NAME: '116',
                ENG_NAME: '116',
            },
            {
                CODE: '2429',
                NAME: '117',
                ENG_NAME: '117',
            },
            {
                CODE: '2430',
                NAME: '118',
                ENG_NAME: '118',
            },
            {
                CODE: '2431',
                NAME: '119',
                ENG_NAME: '119',
            },
            {
                CODE: '2432',
                NAME: '120',
                ENG_NAME: '120',
            },
            {
                CODE: '2433',
                NAME: '121',
                ENG_NAME: '121',
            },
            {
                CODE: '2434',
                NAME: '201',
                ENG_NAME: '201',
            },
            {
                CODE: '2435',
                NAME: '202',
                ENG_NAME: '202',
            },
            {
                CODE: '2436',
                NAME: '203',
                ENG_NAME: '203',
            },
            {
                CODE: '2437',
                NAME: '204',
                ENG_NAME: '204',
            },
            {
                CODE: '2438',
                NAME: '205',
                ENG_NAME: '205',
            },
            {
                CODE: '2439',
                NAME: '206',
                ENG_NAME: '206',
            },
            {
                CODE: '2440',
                NAME: '207',
                ENG_NAME: '207',
            },
            {
                CODE: '2441',
                NAME: '208',
                ENG_NAME: '208',
            },
            {
                CODE: '2442',
                NAME: '209',
                ENG_NAME: '209',
            },
            {
                CODE: '2443',
                NAME: '(홀 출입문)',
                ENG_NAME: '(홀 출입문)',
            },
            {
                CODE: '2444',
                NAME: '301',
                ENG_NAME: '301',
            },
            {
                CODE: '2445',
                NAME: '302',
                ENG_NAME: '302',
            },
            {
                CODE: '2446',
                NAME: '303',
                ENG_NAME: '303',
            },
            {
                CODE: '2447',
                NAME: '304',
                ENG_NAME: '304',
            },
            {
                CODE: '2448',
                NAME: '305',
                ENG_NAME: '305',
            },
            {
                CODE: '2449',
                NAME: '306',
                ENG_NAME: '306',
            },
            {
                CODE: '2450',
                NAME: '307',
                ENG_NAME: '307',
            },
            {
                CODE: '2451',
                NAME: '308',
                ENG_NAME: '308',
            },
            {
                CODE: '2452',
                NAME: '309',
                ENG_NAME: '309',
            },
            {
                CODE: '2462',
                NAME: '608',
                ENG_NAME: '608',
            },
            {
                CODE: '2482',
                NAME: '101호',
                ENG_NAME: '101호',
            },
            {
                CODE: '2484',
                NAME: '105호',
                ENG_NAME: '105호',
            },
            {
                CODE: '2485',
                NAME: '104호',
                ENG_NAME: '104호',
            },
            {
                CODE: '2486',
                NAME: '103호',
                ENG_NAME: '103호',
            },
            {
                CODE: '2487',
                NAME: '102호',
                ENG_NAME: '102호',
            },
            {
                CODE: '2489',
                NAME: '108호',
                ENG_NAME: '108호',
            },
            {
                CODE: '2490',
                NAME: '109호',
                ENG_NAME: '109호',
            },
            {
                CODE: '2491',
                NAME: '110호',
                ENG_NAME: '110호',
            },
            {
                CODE: '2492',
                NAME: '201호',
                ENG_NAME: '201호',
            },
            {
                CODE: '2493',
                NAME: '122호',
                ENG_NAME: '122호',
            },
            {
                CODE: '2494',
                NAME: '121호',
                ENG_NAME: '121호',
            },
            {
                CODE: '2495',
                NAME: '120호',
                ENG_NAME: '120호',
            },
            {
                CODE: '2496',
                NAME: '119호',
                ENG_NAME: '119호',
            },
            {
                CODE: '2497',
                NAME: '118호',
                ENG_NAME: '118호',
            },
            {
                CODE: '2498',
                NAME: '117호',
                ENG_NAME: '117호',
            },
            {
                CODE: '2499',
                NAME: '116호',
                ENG_NAME: '116호',
            },
            {
                CODE: '2500',
                NAME: '115호',
                ENG_NAME: '115호',
            },
            {
                CODE: '2501',
                NAME: '114호',
                ENG_NAME: '114호',
            },
            {
                CODE: '2502',
                NAME: '113호',
                ENG_NAME: '113호',
            },
            {
                CODE: '2503',
                NAME: '112호',
                ENG_NAME: '112호',
            },
            {
                CODE: '2504',
                NAME: '111호',
                ENG_NAME: '111호',
            },
            {
                CODE: '2505',
                NAME: '204호',
                ENG_NAME: '204호',
            },
            {
                CODE: '2506',
                NAME: '203호',
                ENG_NAME: '203호',
            },
            {
                CODE: '2507',
                NAME: '202호',
                ENG_NAME: '202호',
            },
            {
                CODE: '2508',
                NAME: '1층 휴게실',
                ENG_NAME: '1층 휴게실',
            },
            {
                CODE: '2509',
                NAME: '215호',
                ENG_NAME: '215호',
            },
            {
                CODE: '2510',
                NAME: '214호',
                ENG_NAME: '214호',
            },
            {
                CODE: '2511',
                NAME: '213호',
                ENG_NAME: '213호',
            },
            {
                CODE: '2512',
                NAME: '212호',
                ENG_NAME: '212호',
            },
            {
                CODE: '2513',
                NAME: '211호',
                ENG_NAME: '211호',
            },
            {
                CODE: '2514',
                NAME: '210호',
                ENG_NAME: '210호',
            },
            {
                CODE: '2515',
                NAME: '209호',
                ENG_NAME: '209호',
            },
            {
                CODE: '2516',
                NAME: '208호',
                ENG_NAME: '208호',
            },
            {
                CODE: '2517',
                NAME: '207호',
                ENG_NAME: '207호',
            },
            {
                CODE: '2518',
                NAME: '206호',
                ENG_NAME: '206호',
            },
            {
                CODE: '2519',
                NAME: '205호',
                ENG_NAME: '205호',
            },
            {
                CODE: '2520',
                NAME: '224호',
                ENG_NAME: '224호',
            },
            {
                CODE: '2521',
                NAME: '223호',
                ENG_NAME: '223호',
            },
            {
                CODE: '2522',
                NAME: '222호',
                ENG_NAME: '222호',
            },
            {
                CODE: '2523',
                NAME: '221호',
                ENG_NAME: '221호',
            },
            {
                CODE: '2524',
                NAME: '220호',
                ENG_NAME: '220호',
            },
            {
                CODE: '2525',
                NAME: '219호',
                ENG_NAME: '219호',
            },
            {
                CODE: '2526',
                NAME: '218호',
                ENG_NAME: '218호',
            },
            {
                CODE: '2527',
                NAME: '217호',
                ENG_NAME: '217호',
            },
            {
                CODE: '2528',
                NAME: '216호',
                ENG_NAME: '216호',
            },
            {
                CODE: '2529',
                NAME: '324호',
                ENG_NAME: '324호',
            },
            {
                CODE: '2530',
                NAME: '323호',
                ENG_NAME: '323호',
            },
            {
                CODE: '2531',
                NAME: '322호',
                ENG_NAME: '322호',
            },
            {
                CODE: '2532',
                NAME: '321호',
                ENG_NAME: '321호',
            },
            {
                CODE: '2533',
                NAME: '320호',
                ENG_NAME: '320호',
            },
            {
                CODE: '2534',
                NAME: '319호',
                ENG_NAME: '319호',
            },
            {
                CODE: '2535',
                NAME: '318호',
                ENG_NAME: '318호',
            },
            {
                CODE: '2536',
                NAME: '317호 ',
                ENG_NAME: '317호 ',
            },
            {
                CODE: '2537',
                NAME: '316호 ',
                ENG_NAME: '316호 ',
            },
            {
                CODE: '2538',
                NAME: '315호 ',
                ENG_NAME: '315호 ',
            },
            {
                CODE: '2539',
                NAME: '314호 ',
                ENG_NAME: '314호 ',
            },
            {
                CODE: '2540',
                NAME: '313호 ',
                ENG_NAME: '313호 ',
            },
            {
                CODE: '2541',
                NAME: '312호 ',
                ENG_NAME: '312호 ',
            },
            {
                CODE: '2542',
                NAME: '311호 ',
                ENG_NAME: '311호 ',
            },
            {
                CODE: '2543',
                NAME: '310호 ',
                ENG_NAME: '310호 ',
            },
            {
                CODE: '2544',
                NAME: '309호 ',
                ENG_NAME: '309호 ',
            },
            {
                CODE: '2545',
                NAME: '308호 ',
                ENG_NAME: '308호 ',
            },
            {
                CODE: '2550',
                NAME: '213-B호 ',
                ENG_NAME: '213-B호 ',
            },
            {
                CODE: '2551',
                NAME: '213-A호 ',
                ENG_NAME: '213-A호 ',
            },
            {
                CODE: '2599',
                NAME: '1층',
                ENG_NAME: '1층',
            },
            {
                CODE: '2600',
                NAME: '2층',
                ENG_NAME: '2층',
            },
            {
                CODE: '2602',
                NAME: 'E8',
                ENG_NAME: 'E8',
            },
        ],
    },
    {
        NAME: 'TODO상태',
        codeList: [
            {
                CODE: 'PL',
                NAME: '계획중',
                ENG_NAME: null,
            },
            {
                CODE: 'AP',
                NAME: '진행중',
                ENG_NAME: null,
            },
            {
                CODE: 'ST',
                NAME: '일시중지',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: 'DL',
                NAME: '삭제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '일정-구분',
        codeList: [
            {
                CODE: 'DR',
                NAME: '매',
                ENG_NAME: null,
            },
            {
                CODE: 'DE',
                NAME: '평일',
                ENG_NAME: null,
            },
            {
                CODE: 'WR',
                NAME: '매',
                ENG_NAME: null,
            },
            {
                CODE: 'MD',
                NAME: '일',
                ENG_NAME: null,
            },
            {
                CODE: 'MW',
                NAME: '요일',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '일정-반복구간',
        codeList: [
            {
                CODE: '1',
                NAME: '1',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '2',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '3',
                ENG_NAME: null,
            },
            {
                CODE: '4',
                NAME: '4',
                ENG_NAME: null,
            },
            {
                CODE: '5',
                NAME: '5',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '일정-업무유형',
        codeList: [
            {
                CODE: 'WT001',
                NAME: '휴가',
                ENG_NAME: null,
            },
            {
                CODE: 'WT002',
                NAME: '회의',
                ENG_NAME: null,
            },
            {
                CODE: 'WT003',
                NAME: '출장',
                ENG_NAME: null,
            },
            {
                CODE: 'WT004',
                NAME: '교육',
                ENG_NAME: null,
            },
            {
                CODE: 'WT005',
                NAME: '개인일정',
                ENG_NAME: null,
            },
            {
                CODE: 'WT006',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '일정-요일',
        codeList: [
            {
                CODE: '1',
                NAME: '일요일',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '월요일',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '화요일',
                ENG_NAME: null,
            },
            {
                CODE: '4',
                NAME: '수요일',
                ENG_NAME: null,
            },
            {
                CODE: '5',
                NAME: '목요일',
                ENG_NAME: null,
            },
            {
                CODE: '6',
                NAME: '금요일',
                ENG_NAME: null,
            },
            {
                CODE: '7',
                NAME: '토요일',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '일정-유형',
        codeList: [
            {
                CODE: 'D',
                NAME: '매일',
                ENG_NAME: null,
            },
            {
                CODE: 'W',
                NAME: '주별',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '월별',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '일정-일',
        codeList: [
            {
                CODE: '01',
                NAME: '1',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '2',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '3',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '4',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '5',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '6',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '7',
                ENG_NAME: null,
            },
            {
                CODE: '08',
                NAME: '8',
                ENG_NAME: null,
            },
            {
                CODE: '09',
                NAME: '9',
                ENG_NAME: null,
            },
            {
                CODE: '10',
                NAME: '10',
                ENG_NAME: null,
            },
            {
                CODE: '11',
                NAME: '11',
                ENG_NAME: null,
            },
            {
                CODE: '12',
                NAME: '12',
                ENG_NAME: null,
            },
            {
                CODE: '13',
                NAME: '13',
                ENG_NAME: null,
            },
            {
                CODE: '14',
                NAME: '14',
                ENG_NAME: null,
            },
            {
                CODE: '15',
                NAME: '15',
                ENG_NAME: null,
            },
            {
                CODE: '16',
                NAME: '16',
                ENG_NAME: null,
            },
            {
                CODE: '17',
                NAME: '17',
                ENG_NAME: null,
            },
            {
                CODE: '18',
                NAME: '18',
                ENG_NAME: null,
            },
            {
                CODE: '19',
                NAME: '19',
                ENG_NAME: null,
            },
            {
                CODE: '20',
                NAME: '20',
                ENG_NAME: null,
            },
            {
                CODE: '21',
                NAME: '21',
                ENG_NAME: null,
            },
            {
                CODE: '22',
                NAME: '22',
                ENG_NAME: null,
            },
            {
                CODE: '23',
                NAME: '23',
                ENG_NAME: null,
            },
            {
                CODE: '24',
                NAME: '24',
                ENG_NAME: null,
            },
            {
                CODE: '25',
                NAME: '25',
                ENG_NAME: null,
            },
            {
                CODE: '26',
                NAME: '26',
                ENG_NAME: null,
            },
            {
                CODE: '27',
                NAME: '27',
                ENG_NAME: null,
            },
            {
                CODE: '28',
                NAME: '28',
                ENG_NAME: null,
            },
            {
                CODE: '29',
                NAME: '29',
                ENG_NAME: null,
            },
            {
                CODE: '30',
                NAME: '30',
                ENG_NAME: null,
            },
            {
                CODE: '31',
                NAME: '31',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '일정-주차',
        codeList: [
            {
                CODE: '1',
                NAME: '첫번째',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '두번째',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '세번째',
                ENG_NAME: null,
            },
            {
                CODE: '4',
                NAME: '네번째',
                ENG_NAME: null,
            },
            {
                CODE: 'E',
                NAME: '마지막',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '그룹 생성 테스트',
        codeList: [
            {
                CODE: '수정테스트',
                NAME: '수정테스트',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '거래처 구분2',
        codeList: [
            {
                CODE: '01',
                NAME: 'SBH',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '입주기업',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: 'MOU',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '거래처유형',
        codeList: [
            {
                CODE: '01',
                NAME: '기관',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '기업',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '말머리',
        codeList: [
            {
                CODE: 'R',
                NAME: '공지사항',
                ENG_NAME: null,
            },
            {
                CODE: 'E',
                NAME: '교육/세미나',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ',
                NAME: '장비',
                ENG_NAME: null,
            },
            {
                CODE: 'T',
                NAME: '견학/투어',
                ENG_NAME: null,
            },
            {
                CODE: 'ET',
                NAME: '기타',
                ENG_NAME: null,
            },
            {
                CODE: 'TEST',
                NAME: '코드명',
                ENG_NAME: null,
            },
            {
                CODE: 'TESTCODE',
                NAME: '코드추가 테스트',
                ENG_NAME: null,
            },
            {
                CODE: '14',
                NAME: '테스트14',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '격리구역이동유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '관리자이동',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '동일룸이동',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '이동 가능',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '이동 불가',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '견학/투어 건물코드',
        codeList: [
            {
                CODE: 'R6',
                NAME: 'R6',
                ENG_NAME: null,
            },
            {
                CODE: 'E9',
                NAME: 'E9',
                ENG_NAME: null,
            },
            {
                CODE: 'E10',
                NAME: 'E10',
                ENG_NAME: null,
            },
            {
                CODE: 'test',
                NAME: 'atest',
                ENG_NAME: null,
            },
            {
                CODE: 'B1',
                NAME: '빌딩1',
                ENG_NAME: null,
            },
            {
                CODE: 'B2',
                NAME: '빌딩2',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '견학/투어 견학범위',
        codeList: [
            {
                CODE: 'TU01',
                NAME: '센터 전체',
                ENG_NAME: null,
            },
            {
                CODE: 'TU02',
                NAME: '센터 일부',
                ENG_NAME: null,
            },
            {
                CODE: 'TU03',
                NAME: '분석담당자 면담',
                ENG_NAME: null,
            },
            {
                CODE: 'TU04',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '견학/투어 기관유형',
        codeList: [
            {
                CODE: 'C',
                NAME: '산',
                ENG_NAME: null,
            },
            {
                CODE: 'GO',
                NAME: '학',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '연',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '견학/투어 방문자정보',
        codeList: [
            {
                CODE: 'TV01',
                NAME: '연구원',
                ENG_NAME: null,
            },
            {
                CODE: 'TV02',
                NAME: '대학원생',
                ENG_NAME: null,
            },
            {
                CODE: 'TV03',
                NAME: '대학생',
                ENG_NAME: null,
            },
            {
                CODE: 'TV04',
                NAME: '중/고등학생',
                ENG_NAME: null,
            },
            {
                CODE: 'TV05',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '견학/투어 승인상태',
        codeList: [
            {
                CODE: '0',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: '1',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '견학/투어상태',
        codeList: [
            {
                CODE: 'P',
                NAME: '생성',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '활성',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '비활성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '투어서브정보유형',
        codeList: [
            {
                CODE: 'IA01',
                NAME: '전체설명',
                ENG_NAME: null,
            },
            {
                CODE: 'IT01',
                NAME: '투어',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '투어정보유형',
        codeList: [
            {
                CODE: 'IA',
                NAME: '전체',
                ENG_NAME: null,
            },
            {
                CODE: 'IT',
                NAME: '투어연결',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '상태',
        codeList: [
            {
                CODE: 'A',
                NAME: '활성',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '비활성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '직원상태',
        codeList: [
            {
                CODE: 'A',
                NAME: '활성',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '비활성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '자문상태',
        codeList: [
            {
                CODE: 'P',
                NAME: '문의',
                ENG_NAME: null,
            },
            {
                CODE: 'G',
                NAME: '진행',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비대여상태',
        codeList: [
            {
                CODE: 'C',
                NAME: '반납완료',
                ENG_NAME: null,
            },
            {
                CODE: 'W',
                NAME: '대여가능',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '대여중',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '로그인잠김여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '잠금',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '열림',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '가동율유형',
        codeList: [
            {
                CODE: '8H',
                NAME: '8시간',
                ENG_NAME: null,
            },
            {
                CODE: '24H',
                NAME: '24시간',
                ENG_NAME: null,
            },
            {
                CODE: 'YC',
                NAME: '연간사용율',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '단말기방식',
        codeList: [
            {
                CODE: 'HS',
                NAME: '홀센서',
                ENG_NAME: null,
            },
            {
                CODE: 'TP',
                NAME: '삼상',
                ENG_NAME: null,
            },
            {
                CODE: 'SP',
                NAME: '단상',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '모니터링내외부구분',
        codeList: [
            {
                CODE: 'SS',
                NAME: '자체 연구',
                ENG_NAME: null,
            },
            {
                CODE: 'PU',
                NAME: '공동활용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '작업알림',
        codeList: [
            {
                CODE: 'NN',
                NAME: '알리지 않음',
                ENG_NAME: null,
            },
            {
                CODE: 'NT',
                NAME: '장비 작동시 알림',
                ENG_NAME: null,
            },
            {
                CODE: 'UT',
                NAME: '실적등록 화면에서 시작 확인 하지 않고 장비 작동 시 알림',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비모니터링상태',
        codeList: [
            {
                CODE: 'W',
                NAME: '작업 준비중',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '작업 기록중',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '작업 완료',
                ENG_NAME: null,
            },
            {
                CODE: 'P',
                NAME: '작업 멈춤',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '물품체크 담당자 상태',
        codeList: [
            {
                CODE: 'WB',
                NAME: '작성 전',
                ENG_NAME: null,
            },
            {
                CODE: 'WF',
                NAME: '작성 완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '물품체크 상태',
        codeList: [
            {
                CODE: 'W',
                NAME: '작성 전',
                ENG_NAME: null,
            },
            {
                CODE: 'S',
                NAME: '작성 중',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '작성 완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '물품체크 이력유형',
        codeList: [
            {
                CODE: 'BF',
                NAME: '사용전',
                ENG_NAME: null,
            },
            {
                CODE: 'AF',
                NAME: '사용후',
                ENG_NAME: null,
            },
            {
                CODE: 'MG',
                NAME: '담당자',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '물품체크 확인여부',
        codeList: [
            {
                CODE: '01',
                NAME: '확인',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '이상',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '처리',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '그룹별업무',
        codeList: [
            {
                CODE: 'DF',
                NAME: '기본',
                ENG_NAME: null,
            },
            {
                CODE: 'RV',
                NAME: '예약',
                ENG_NAME: null,
            },
            {
                CODE: 'RT',
                NAME: '대여',
                ENG_NAME: null,
            },
            {
                CODE: 'RQ',
                NAME: '정산',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ',
                NAME: '장비',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '그룹종류',
        codeList: [
            {
                CODE: 'U',
                NAME: '회원',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '관리자',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '발송구분',
        codeList: [
            {
                CODE: 'REC',
                NAME: '받는사람',
                ENG_NAME: null,
            },
            {
                CODE: 'CC',
                NAME: '참조',
                ENG_NAME: null,
            },
            {
                CODE: 'BCC',
                NAME: '숨은참조',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '발송메시지유형',
        codeList: [
            {
                CODE: 'RV',
                NAME: '예약',
                ENG_NAME: null,
            },
            {
                CODE: 'RN',
                NAME: '대여',
                ENG_NAME: null,
            },
            {
                CODE: 'RQ',
                NAME: '정산',
                ENG_NAME: null,
            },
            {
                CODE: 'UM',
                NAME: '회원',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '발송메시지유형상세',
        codeList: [
            {
                CODE: 'WA',
                NAME: '승인요청',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'TRI',
                NAME: '청구서발행(내부)',
                ENG_NAME: null,
            },
            {
                CODE: 'TRO',
                NAME: '청구서발행(외부)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '발송상태',
        codeList: [
            {
                CODE: 'W',
                NAME: '대기',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '예약',
                ENG_NAME: null,
            },
            {
                CODE: 'S',
                NAME: '발송중',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '발송완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '발송여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '발송',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '미발송',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '발송유형',
        codeList: [
            {
                CODE: 'S',
                NAME: '문자',
                ENG_NAME: null,
            },
            {
                CODE: 'E',
                NAME: '이메일',
                ENG_NAME: null,
            },
            {
                CODE: 'K',
                NAME: '카카오',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '블랙리스트차단범위',
        codeList: [
            {
                CODE: 'A',
                NAME: '전체',
                ENG_NAME: null,
            },
            {
                CODE: 'P',
                NAME: '개별',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '블랙리스트차단상태',
        codeList: [
            {
                CODE: 'W',
                NAME: '승인대기',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '승인요청',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'RJ',
                NAME: '반려',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '블랙리스트차단유형',
        codeList: [
            {
                CODE: '01',
                NAME: '차단 대상',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '차단',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '보류',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '해제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '블랙리스트차단판정',
        codeList: [
            {
                CODE: '01',
                NAME: '차단 대상',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '차단 해지',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '차단',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '블랙리스트평가대상',
        codeList: [
            {
                CODE: 'P',
                NAME: '개인',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '기관',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '블랙리스트폼차단유형',
        codeList: [
            {
                CODE: 'EQ',
                NAME: '장비',
                ENG_NAME: null,
            },
            {
                CODE: 'FC',
                NAME: '시설',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '블랙리스트해제여부',
        codeList: [
            {
                CODE: 'ML',
                NAME: '수동해제',
                ENG_NAME: null,
            },
            {
                CODE: 'AT',
                NAME: '자동해제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '색상',
        codeList: [
            {
                CODE: 'blueGray',
                NAME: 'blueGray',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-gray-200',
                NAME: 'coolGray',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-gray-400',
                NAME: 'gray',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-gray-500',
                NAME: 'trueGray',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-gray-300',
                NAME: 'warmGray',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-red-500',
                NAME: 'red',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-orange-500',
                NAME: 'orange',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-amber-300',
                NAME: 'amber',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-yellow-300',
                NAME: 'yellow',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-lime-300',
                NAME: 'lime',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-green-700',
                NAME: 'green',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-emerald-300',
                NAME: 'emerald',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-teal-500',
                NAME: 'teal',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-cyan-300',
                NAME: 'cyan',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-lightBlue-200',
                NAME: 'lightBlue',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-blue-500',
                NAME: 'blue',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-indigo-500',
                NAME: 'indigo',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-violet-300',
                NAME: 'violet',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-purple-400',
                NAME: 'purple',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-fuchsia-300',
                NAME: 'fuchsia',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-pink-500',
                NAME: 'pink',
                ENG_NAME: null,
            },
            {
                CODE: 'bg-rose-500',
                NAME: 'rose',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '설문결과유형',
        codeList: [
            {
                CODE: '01',
                NAME: '문항별',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '장비별',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '설문위치',
        codeList: [
            {
                CODE: 'ER',
                NAME: '장비예약',
                ENG_NAME: null,
            },
            {
                CODE: 'IV',
                NAME: '청구서출력',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '설문유형',
        codeList: [
            {
                CODE: 'G',
                NAME: '일반설문',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '코로나',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '만족도조사',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '설문참여대상',
        codeList: [
            {
                CODE: 'A',
                NAME: '전체',
                ENG_NAME: null,
            },
            {
                CODE: 'PI',
                NAME: '내부사용자',
                ENG_NAME: null,
            },
            {
                CODE: 'PO',
                NAME: '외부사용자',
                ENG_NAME: null,
            },
            {
                CODE: 'PN',
                NAME: '일반사용자(장비권한)',
                ENG_NAME: null,
            },
            {
                CODE: 'PS',
                NAME: '자율사용자(장비권한)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '설문참조유형',
        codeList: [
            {
                CODE: 'ER',
                NAME: '장비예약',
                ENG_NAME: null,
            },
            {
                CODE: 'IV',
                NAME: '청구서 발행',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '지정기준구분',
        codeList: [
            {
                CODE: 'RS',
                NAME: '예약시작',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '예약종료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '지정발송구분',
        codeList: [
            {
                CODE: 'DB',
                NAME: '일 전',
                ENG_NAME: null,
            },
            {
                CODE: 'TB',
                NAME: '시간 전',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '지정발송시간구분',
        codeList: [
            {
                CODE: 'IS',
                NAME: '즉시발송',
                ENG_NAME: null,
            },
            {
                CODE: 'RS',
                NAME: '예약발송',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '성과분류',
        codeList: [
            {
                CODE: 'A001',
                NAME: '논문분류1',
                ENG_NAME: null,
            },
            {
                CODE: 'A002',
                NAME: '논문분류2',
                ENG_NAME: null,
            },
            {
                CODE: 'B001',
                NAME: '특허분류1',
                ENG_NAME: null,
            },
            {
                CODE: 'B002',
                NAME: '특허분류2',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '성과자료유형',
        codeList: [
            {
                CODE: 'A0',
                NAME: '논문',
                ENG_NAME: null,
            },
            {
                CODE: 'B0',
                NAME: '특허',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '테스트 그룹명',
        codeList: [
            {
                CODE: 'testGroup',
                NAME: '테스트',
                ENG_NAME: null,
            },
            {
                CODE: 'dd',
                NAME: 'ddddddd',
                ENG_NAME: null,
            },
            {
                CODE: 'ㄱㄱ',
                NAME: 'cccccc',
                ENG_NAME: null,
            },
            {
                CODE: '00',
                NAME: 'aa',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기간구분',
        codeList: [
            {
                CODE: 'MT',
                NAME: '개월',
                ENG_NAME: null,
            },
            {
                CODE: 'DY',
                NAME: '일',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용자구분',
        codeList: [
            {
                CODE: 'IN',
                NAME: '내부',
                ENG_NAME: null,
            },
            {
                CODE: 'OTE',
                NAME: '외부(교육기간)',
                ENG_NAME: null,
            },
            {
                CODE: 'OTN',
                NAME: '외부(교육기간외)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정액여부',
        codeList: [
            {
                CODE: 'FYA',
                NAME: '정액A',
                ENG_NAME: null,
            },
            {
                CODE: 'FYB',
                NAME: '정액B',
                ENG_NAME: null,
            },
            {
                CODE: 'FN',
                NAME: '종량',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '스케쥴 유형',
        codeList: [
            {
                CODE: 'P',
                NAME: '개인',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설공개여부',
        codeList: [
            {
                CODE: 'C',
                NAME: '비공개',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '내부공개',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '외부공개',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설권한',
        codeList: [
            {
                CODE: 'I',
                NAME: '내부사용',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '외부사용',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '내·외부 사용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설상태',
        codeList: [
            {
                CODE: 'UP',
                NAME: '이용가능',
                ENG_NAME: null,
            },
            {
                CODE: 'UN',
                NAME: '이용불가능',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설서브유형',
        codeList: [
            {
                CODE: 'NL',
                NAME: '일반',
                ENG_NAME: null,
            },
            {
                CODE: 'DC',
                NAME: '소자클린룸',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설실적상태',
        codeList: [
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설실적유형',
        codeList: [
            {
                CODE: 'CO',
                NAME: '완료실적',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '취소실적',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설예약단위',
        codeList: [
            {
                CODE: 'T1',
                NAME: '30분',
                ENG_NAME: null,
            },
            {
                CODE: 'T2',
                NAME: '60분',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '1일',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '1개월',
                ENG_NAME: null,
            },
            {
                CODE: '6M',
                NAME: '6개월',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설예약부가세',
        codeList: [
            {
                CODE: 'TAX0',
                NAME: '없음',
                ENG_NAME: null,
            },
            {
                CODE: 'TAX10',
                NAME: '부가세 10%',
                ENG_NAME: null,
            },
            {
                CODE: 'TAX20',
                NAME: '부가세 20%',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설예약상태',
        codeList: [
            {
                CODE: 'AP',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '예약',
                ENG_NAME: null,
            },
            {
                CODE: 'RT',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설유형',
        codeList: [
            {
                CODE: 'MR',
                NAME: '회의실',
                ENG_NAME: null,
            },
            {
                CODE: 'EF',
                NAME: '교육장',
                ENG_NAME: null,
            },
            {
                CODE: 'RF',
                NAME: '연구시설',
                ENG_NAME: null,
            },
            {
                CODE: 'ES',
                NAME: '기업지원실',
                ENG_NAME: null,
            },
            {
                CODE: 'SF',
                NAME: '특수시설',
                ENG_NAME: null,
            },
            {
                CODE: 'SC',
                NAME: '슈퍼컴퓨터',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '혁신커뮤니티센터',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설체크리스트상태',
        codeList: [
            {
                CODE: 'Y',
                NAME: '이상없음',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '이상있음',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '거래처부서구분',
        codeList: [
            {
                CODE: 'I',
                NAME: '부서',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '거래처',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '거래처정산유형',
        codeList: [
            {
                CODE: 'IDV',
                NAME: '개별',
                ENG_NAME: null,
            },
            {
                CODE: 'ITG',
                NAME: '통합',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '게시글유형',
        codeList: [
            {
                CODE: '1',
                NAME: '장비심의',
                ENG_NAME: 'Equip. Deliberation',
            },
            {
                CODE: '2',
                NAME: '장비등록 및 관리',
                ENG_NAME: 'Equip. Registration and Mng.',
            },
            {
                CODE: '3',
                NAME: '장비활용',
                ENG_NAME: 'Equip. Utilization',
            },
            {
                CODE: '4',
                NAME: '관련서식 및 자료',
                ENG_NAME: 'Relevant Data of Form',
            },
            {
                CODE: '5',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '게시판분류',
        codeList: [
            {
                CODE: '1',
                NAME: '공통',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '장비',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '게시판유형',
        codeList: [
            {
                CODE: 'notice',
                NAME: '공지사항',
                ENG_NAME: null,
            },
            {
                CODE: 'reference',
                NAME: '자료실',
                ENG_NAME: null,
            },
            {
                CODE: 'faq',
                NAME: 'FAQ',
                ENG_NAME: null,
            },
            {
                CODE: 'qna',
                NAME: 'QNA',
                ENG_NAME: null,
            },
            {
                CODE: 'equipSurvey',
                NAME: '장비 수요조사',
                ENG_NAME: null,
            },
            {
                CODE: 'techSupport',
                NAME: '기술자문',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '게시판접근권한',
        codeList: [
            {
                CODE: 'A',
                NAME: '전체',
                ENG_NAME: null,
            },
            {
                CODE: 'W',
                NAME: '쓰기',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '삭제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '게시판접근유형',
        codeList: [
            {
                CODE: 'PV',
                NAME: '개인',
                ENG_NAME: null,
            },
            {
                CODE: 'RU',
                NAME: '운영실',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '국가',
        codeList: [
            {
                CODE: 'GH',
                NAME: '가나',
                ENG_NAME: null,
            },
            {
                CODE: 'GA',
                NAME: '가봉',
                ENG_NAME: null,
            },
            {
                CODE: 'U',
                NAME: '대기',
                ENG_NAME: null,
            },
            {
                CODE: 'GY',
                NAME: '가이아나',
                ENG_NAME: null,
            },
            {
                CODE: 'GM',
                NAME: '감비아',
                ENG_NAME: null,
            },
            {
                CODE: 'GP',
                NAME: '과달로프',
                ENG_NAME: null,
            },
            {
                CODE: 'GT',
                NAME: '과테말라',
                ENG_NAME: null,
            },
            {
                CODE: 'GU',
                NAME: '괌',
                ENG_NAME: null,
            },
            {
                CODE: 'SU',
                NAME: '구소련',
                ENG_NAME: null,
            },
            {
                CODE: 'GD',
                NAME: '그레나다',
                ENG_NAME: null,
            },
            {
                CODE: 'GE',
                NAME: '그루지야',
                ENG_NAME: null,
            },
            {
                CODE: 'GR',
                NAME: '그리스',
                ENG_NAME: null,
            },
            {
                CODE: 'GL',
                NAME: '그린랜드',
                ENG_NAME: null,
            },
            {
                CODE: 'GW',
                NAME: '기네비쏘',
                ENG_NAME: null,
            },
            {
                CODE: 'GN',
                NAME: '기니',
                ENG_NAME: null,
            },
            {
                CODE: 'CV',
                NAME: '까뽀베르데',
                ENG_NAME: null,
            },
            {
                CODE: 'NR',
                NAME: '나우루',
                ENG_NAME: null,
            },
            {
                CODE: 'NG',
                NAME: '나이지리아',
                ENG_NAME: null,
            },
            {
                CODE: 'AQ',
                NAME: '남극',
                ENG_NAME: null,
            },
            {
                CODE: 'ZA',
                NAME: '남아프리카공화국',
                ENG_NAME: null,
            },
            {
                CODE: 'NL',
                NAME: '네덜란드',
                ENG_NAME: null,
            },
            {
                CODE: 'AN',
                NAME: '네덜란드령 안틸레스',
                ENG_NAME: null,
            },
            {
                CODE: 'NP',
                NAME: '네팔',
                ENG_NAME: null,
            },
            {
                CODE: 'NO',
                NAME: '노르웨이',
                ENG_NAME: null,
            },
            {
                CODE: 'NF',
                NAME: '노퍽',
                ENG_NAME: null,
            },
            {
                CODE: 'NZ',
                NAME: '뉴질랜드',
                ENG_NAME: null,
            },
            {
                CODE: 'NC',
                NAME: '뉴칼레도니아',
                ENG_NAME: null,
            },
            {
                CODE: 'NU',
                NAME: '니우에',
                ENG_NAME: null,
            },
            {
                CODE: 'NE',
                NAME: '니제르',
                ENG_NAME: null,
            },
            {
                CODE: 'NI',
                NAME: '니카라과',
                ENG_NAME: null,
            },
            {
                CODE: 'TW',
                NAME: '대만',
                ENG_NAME: null,
            },
            {
                CODE: 'KR',
                NAME: '대한민국',
                ENG_NAME: null,
            },
            {
                CODE: 'DK',
                NAME: '덴마크',
                ENG_NAME: null,
            },
            {
                CODE: 'DM',
                NAME: '도미니카',
                ENG_NAME: null,
            },
            {
                CODE: 'DO',
                NAME: '도미니카 공화국',
                ENG_NAME: null,
            },
            {
                CODE: 'DE',
                NAME: '독일',
                ENG_NAME: null,
            },
            {
                CODE: 'TP',
                NAME: '동티모르',
                ENG_NAME: null,
            },
            {
                CODE: 'LA',
                NAME: '라오스',
                ENG_NAME: null,
            },
            {
                CODE: 'LV',
                NAME: '라트비아',
                ENG_NAME: null,
            },
            {
                CODE: 'RU',
                NAME: '러시아',
                ENG_NAME: null,
            },
            {
                CODE: 'LB',
                NAME: '레바논',
                ENG_NAME: null,
            },
            {
                CODE: 'LS',
                NAME: '레소토',
                ENG_NAME: null,
            },
            {
                CODE: 'RO',
                NAME: '루마니아',
                ENG_NAME: null,
            },
            {
                CODE: 'LU',
                NAME: '룩셈부르크',
                ENG_NAME: null,
            },
            {
                CODE: 'RW',
                NAME: '르완다',
                ENG_NAME: null,
            },
            {
                CODE: 'LR',
                NAME: '리베리아',
                ENG_NAME: null,
            },
            {
                CODE: 'LY',
                NAME: '리비아',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '리유니언',
                ENG_NAME: null,
            },
            {
                CODE: 'LT',
                NAME: '리투아니아',
                ENG_NAME: null,
            },
            {
                CODE: 'LI',
                NAME: '리히텐슈타인',
                ENG_NAME: null,
            },
            {
                CODE: 'MG',
                NAME: '마다가스카르',
                ENG_NAME: null,
            },
            {
                CODE: 'MQ',
                NAME: '마르티니크',
                ENG_NAME: null,
            },
            {
                CODE: 'MH',
                NAME: '마샬군도',
                ENG_NAME: null,
            },
            {
                CODE: 'FM',
                NAME: '마이크로네시아',
                ENG_NAME: null,
            },
            {
                CODE: 'MO',
                NAME: '마카오',
                ENG_NAME: null,
            },
            {
                CODE: 'MW',
                NAME: '말라위',
                ENG_NAME: null,
            },
            {
                CODE: 'MY',
                NAME: '말레이지아',
                ENG_NAME: null,
            },
            {
                CODE: 'ML',
                NAME: '말리',
                ENG_NAME: null,
            },
            {
                CODE: 'MT',
                NAME: '말타',
                ENG_NAME: null,
            },
            {
                CODE: 'MX',
                NAME: '멕시코',
                ENG_NAME: null,
            },
            {
                CODE: 'MC',
                NAME: '모나코',
                ENG_NAME: null,
            },
            {
                CODE: 'MA',
                NAME: '모로코',
                ENG_NAME: null,
            },
            {
                CODE: 'MU',
                NAME: '모리셔스',
                ENG_NAME: null,
            },
            {
                CODE: 'MR',
                NAME: '모리타니아',
                ENG_NAME: null,
            },
            {
                CODE: 'MZ',
                NAME: '모잠비크',
                ENG_NAME: null,
            },
            {
                CODE: 'MS',
                NAME: '몬트세라트',
                ENG_NAME: null,
            },
            {
                CODE: 'MD',
                NAME: '몰도바',
                ENG_NAME: null,
            },
            {
                CODE: 'MV',
                NAME: '몰디브',
                ENG_NAME: null,
            },
            {
                CODE: 'MN',
                NAME: '몽골',
                ENG_NAME: null,
            },
            {
                CODE: 'US',
                NAME: '미국',
                ENG_NAME: null,
            },
            {
                CODE: 'VI',
                NAME: '미국령 버진아일랜드',
                ENG_NAME: null,
            },
            {
                CODE: 'AS',
                NAME: '미국령 사모아',
                ENG_NAME: null,
            },
            {
                CODE: 'UM',
                NAME: '미국령 소군도',
                ENG_NAME: null,
            },
            {
                CODE: 'MM',
                NAME: '미얀마',
                ENG_NAME: null,
            },
            {
                CODE: 'VU',
                NAME: '바누아투',
                ENG_NAME: null,
            },
            {
                CODE: 'BH',
                NAME: '바레인',
                ENG_NAME: null,
            },
            {
                CODE: 'BB',
                NAME: '바베이도스',
                ENG_NAME: null,
            },
            {
                CODE: 'VA',
                NAME: '바티칸 ',
                ENG_NAME: null,
            },
            {
                CODE: 'BS',
                NAME: '바하마',
                ENG_NAME: null,
            },
            {
                CODE: 'BD',
                NAME: '방글라데시',
                ENG_NAME: null,
            },
            {
                CODE: 'BM',
                NAME: '버뮤다',
                ENG_NAME: null,
            },
            {
                CODE: 'VE',
                NAME: '베네수엘라',
                ENG_NAME: null,
            },
            {
                CODE: 'BJ',
                NAME: '베넹',
                ENG_NAME: null,
            },
            {
                CODE: 'VN',
                NAME: '베트남',
                ENG_NAME: null,
            },
            {
                CODE: 'BE',
                NAME: '벨기에',
                ENG_NAME: null,
            },
            {
                CODE: 'BY',
                NAME: '벨라루스',
                ENG_NAME: null,
            },
            {
                CODE: 'BZ',
                NAME: '벨리즈',
                ENG_NAME: null,
            },
            {
                CODE: 'BA',
                NAME: '보스니아 헤르체고비나',
                ENG_NAME: null,
            },
            {
                CODE: 'BW',
                NAME: '보트와나',
                ENG_NAME: null,
            },
            {
                CODE: 'BO',
                NAME: '볼리비아',
                ENG_NAME: null,
            },
            {
                CODE: 'BF',
                NAME: '부르키나파소',
                ENG_NAME: null,
            },
            {
                CODE: 'BV',
                NAME: '부베이 섬',
                ENG_NAME: null,
            },
            {
                CODE: 'BT',
                NAME: '부탄',
                ENG_NAME: null,
            },
            {
                CODE: 'MP',
                NAME: '북마리아나 군도',
                ENG_NAME: null,
            },
            {
                CODE: 'KP',
                NAME: '북한 ',
                ENG_NAME: null,
            },
            {
                CODE: 'BG',
                NAME: '불가리아',
                ENG_NAME: null,
            },
            {
                CODE: 'BR',
                NAME: '브라질',
                ENG_NAME: null,
            },
            {
                CODE: 'BN',
                NAME: '브루나이',
                ENG_NAME: null,
            },
            {
                CODE: 'BI',
                NAME: '브룬디',
                ENG_NAME: null,
            },
            {
                CODE: 'WS',
                NAME: '사모아',
                ENG_NAME: null,
            },
            {
                CODE: 'SA',
                NAME: '사우디아라비아',
                ENG_NAME: null,
            },
            {
                CODE: 'CY',
                NAME: '사이프러스',
                ENG_NAME: null,
            },
            {
                CODE: 'EH',
                NAME: '사하라',
                ENG_NAME: null,
            },
            {
                CODE: 'SM',
                NAME: '산마리노',
                ENG_NAME: null,
            },
            {
                CODE: 'SN',
                NAME: '세네갈',
                ENG_NAME: null,
            },
            {
                CODE: 'SC',
                NAME: '세이셸',
                ENG_NAME: null,
            },
            {
                CODE: 'LC',
                NAME: '세인트 루시아',
                ENG_NAME: null,
            },
            {
                CODE: 'VC',
                NAME: '세인트 빈센트 그레나딘스',
                ENG_NAME: null,
            },
            {
                CODE: 'KN',
                NAME: '세인트 크리스토퍼 니비스',
                ENG_NAME: null,
            },
            {
                CODE: 'PM',
                NAME: '세인트 피에르 미？론',
                ENG_NAME: null,
            },
            {
                CODE: 'SH',
                NAME: '세인트 헬레나',
                ENG_NAME: null,
            },
            {
                CODE: 'SO',
                NAME: '소말리아',
                ENG_NAME: null,
            },
            {
                CODE: 'SB',
                NAME: '솔로몬 군도',
                ENG_NAME: null,
            },
            {
                CODE: 'SD',
                NAME: '수단',
                ENG_NAME: null,
            },
            {
                CODE: 'SR',
                NAME: '수리남',
                ENG_NAME: null,
            },
            {
                CODE: 'LK',
                NAME: '스리랑카',
                ENG_NAME: null,
            },
            {
                CODE: 'SJ',
                NAME: '스발바르드 얀마이엔 제도',
                ENG_NAME: null,
            },
            {
                CODE: 'SZ',
                NAME: '스와질랜드',
                ENG_NAME: null,
            },
            {
                CODE: 'SE',
                NAME: '스웨덴',
                ENG_NAME: null,
            },
            {
                CODE: 'CH',
                NAME: '스위스',
                ENG_NAME: null,
            },
            {
                CODE: 'ES',
                NAME: '스페인',
                ENG_NAME: null,
            },
            {
                CODE: 'SK',
                NAME: '슬로바키아',
                ENG_NAME: null,
            },
            {
                CODE: 'SI',
                NAME: '슬로베니아',
                ENG_NAME: null,
            },
            {
                CODE: 'SY',
                NAME: '시리아',
                ENG_NAME: null,
            },
            {
                CODE: 'SL',
                NAME: '시에라리온',
                ENG_NAME: null,
            },
            {
                CODE: 'SG',
                NAME: '싱가포르',
                ENG_NAME: null,
            },
            {
                CODE: 'ST',
                NAME: '쌍투메 프린시페',
                ENG_NAME: null,
            },
            {
                CODE: 'AE',
                NAME: '아랍에미리트연합국',
                ENG_NAME: null,
            },
            {
                CODE: 'AW',
                NAME: '아루바',
                ENG_NAME: null,
            },
            {
                CODE: 'AM',
                NAME: '아르메니아',
                ENG_NAME: null,
            },
            {
                CODE: 'AR',
                NAME: '아르헨티나',
                ENG_NAME: null,
            },
            {
                CODE: 'IS',
                NAME: '아이슬랜드',
                ENG_NAME: null,
            },
            {
                CODE: 'HT',
                NAME: '아이티',
                ENG_NAME: null,
            },
            {
                CODE: 'IE',
                NAME: '아일랜드',
                ENG_NAME: null,
            },
            {
                CODE: 'AZ',
                NAME: '아제르바이잔',
                ENG_NAME: null,
            },
            {
                CODE: 'AF',
                NAME: '아프가니스탄',
                ENG_NAME: null,
            },
            {
                CODE: 'AI',
                NAME: '안길라',
                ENG_NAME: null,
            },
            {
                CODE: 'AD',
                NAME: '안도라',
                ENG_NAME: null,
            },
            {
                CODE: 'AG',
                NAME: '안티구아 바부다 ',
                ENG_NAME: null,
            },
            {
                CODE: 'AL',
                NAME: '알바니아 ',
                ENG_NAME: null,
            },
            {
                CODE: 'DZ',
                NAME: '알제리',
                ENG_NAME: null,
            },
            {
                CODE: 'AO',
                NAME: '앙골라',
                ENG_NAME: null,
            },
            {
                CODE: 'EE',
                NAME: '에스토니아',
                ENG_NAME: null,
            },
            {
                CODE: 'EC',
                NAME: '에쿠아도르',
                ENG_NAME: null,
            },
            {
                CODE: 'SV',
                NAME: '엘살바도르',
                ENG_NAME: null,
            },
            {
                CODE: 'GB',
                NAME: '영국',
                ENG_NAME: null,
            },
            {
                CODE: 'VG',
                NAME: '영국령 버진아일랜드',
                ENG_NAME: null,
            },
            {
                CODE: 'IO',
                NAME: '영인도 제도',
                ENG_NAME: null,
            },
            {
                CODE: 'YE',
                NAME: '예멘',
                ENG_NAME: null,
            },
            {
                CODE: 'OM',
                NAME: '오만',
                ENG_NAME: null,
            },
            {
                CODE: 'AU',
                NAME: '오스트레일리아',
                ENG_NAME: null,
            },
            {
                CODE: 'AT',
                NAME: '오스트리아',
                ENG_NAME: null,
            },
            {
                CODE: 'HN',
                NAME: '온두라스',
                ENG_NAME: null,
            },
            {
                CODE: 'JO',
                NAME: '요르단',
                ENG_NAME: null,
            },
            {
                CODE: 'UG',
                NAME: '우간다',
                ENG_NAME: null,
            },
            {
                CODE: 'UY',
                NAME: '우루과이',
                ENG_NAME: null,
            },
            {
                CODE: 'UZ',
                NAME: '우즈베키스탄',
                ENG_NAME: null,
            },
            {
                CODE: 'UA',
                NAME: '우크라이나',
                ENG_NAME: null,
            },
            {
                CODE: 'WF',
                NAME: '월리스 후트나',
                ENG_NAME: null,
            },
            {
                CODE: 'YU',
                NAME: '유고슬라비아',
                ENG_NAME: null,
            },
            {
                CODE: 'ET',
                NAME: '이디오피아',
                ENG_NAME: null,
            },
            {
                CODE: 'IQ',
                NAME: '이라크',
                ENG_NAME: null,
            },
            {
                CODE: 'IR',
                NAME: '이란(이슬람 공화국) ',
                ENG_NAME: null,
            },
            {
                CODE: 'IL',
                NAME: '이스라엘',
                ENG_NAME: null,
            },
            {
                CODE: 'EG',
                NAME: '이집트',
                ENG_NAME: null,
            },
            {
                CODE: 'IT',
                NAME: '이탈리아',
                ENG_NAME: null,
            },
            {
                CODE: 'IN',
                NAME: '인도',
                ENG_NAME: null,
            },
            {
                CODE: 'ID',
                NAME: '인도네시아',
                ENG_NAME: null,
            },
            {
                CODE: 'JP',
                NAME: '일본',
                ENG_NAME: null,
            },
            {
                CODE: 'JM',
                NAME: '자메이카',
                ENG_NAME: null,
            },
            {
                CODE: 'ZR',
                NAME: '자이르',
                ENG_NAME: null,
            },
            {
                CODE: 'ZM',
                NAME: '잠비아',
                ENG_NAME: null,
            },
            {
                CODE: 'GQ',
                NAME: '적도 기니',
                ENG_NAME: null,
            },
            {
                CODE: 'CN',
                NAME: '중국',
                ENG_NAME: null,
            },
            {
                CODE: 'NT',
                NAME: '중립 지대',
                ENG_NAME: null,
            },
            {
                CODE: 'CF',
                NAME: '중앙 아프리카',
                ENG_NAME: null,
            },
            {
                CODE: 'DJ',
                NAME: '지부티',
                ENG_NAME: null,
            },
            {
                CODE: 'GI',
                NAME: '지브랄타',
                ENG_NAME: null,
            },
            {
                CODE: 'ZW',
                NAME: '짐바브웨',
                ENG_NAME: null,
            },
            {
                CODE: 'TD',
                NAME: '차드',
                ENG_NAME: null,
            },
            {
                CODE: 'CZ',
                NAME: '체코',
                ENG_NAME: null,
            },
            {
                CODE: 'CS',
                NAME: '체코슬로바키아',
                ENG_NAME: null,
            },
            {
                CODE: 'CL',
                NAME: '칠레',
                ENG_NAME: null,
            },
            {
                CODE: 'CM',
                NAME: '카메룬',
                ENG_NAME: null,
            },
            {
                CODE: 'KY',
                NAME: '카이만 군도',
                ENG_NAME: null,
            },
            {
                CODE: 'KZ',
                NAME: '카자흐스탄',
                ENG_NAME: null,
            },
            {
                CODE: 'QA',
                NAME: '카타르',
                ENG_NAME: null,
            },
            {
                CODE: 'KH',
                NAME: '캄보디아',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '캐나다',
                ENG_NAME: null,
            },
            {
                CODE: 'KE',
                NAME: '케냐',
                ENG_NAME: null,
            },
            {
                CODE: 'KM',
                NAME: '코모르',
                ENG_NAME: null,
            },
            {
                CODE: 'CR',
                NAME: '코스타리카',
                ENG_NAME: null,
            },
            {
                CODE: 'CC',
                NAME: '코코스킬링 제도',
                ENG_NAME: null,
            },
            {
                CODE: 'CI',
                NAME: '코트디부와르',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '콜롬비아',
                ENG_NAME: null,
            },
            {
                CODE: 'CG',
                NAME: '콩고',
                ENG_NAME: null,
            },
            {
                CODE: 'CU',
                NAME: '쿠바',
                ENG_NAME: null,
            },
            {
                CODE: 'KW',
                NAME: '쿠웨이트',
                ENG_NAME: null,
            },
            {
                CODE: 'CK',
                NAME: '쿠크 군도',
                ENG_NAME: null,
            },
            {
                CODE: 'HR',
                NAME: '크로아티아',
                ENG_NAME: null,
            },
            {
                CODE: 'CX',
                NAME: '크리스마스 섬',
                ENG_NAME: null,
            },
            {
                CODE: 'KG',
                NAME: '키르기스스탄',
                ENG_NAME: null,
            },
            {
                CODE: 'KI',
                NAME: '키리바시',
                ENG_NAME: null,
            },
            {
                CODE: 'TJ',
                NAME: '타지키스탄',
                ENG_NAME: null,
            },
            {
                CODE: 'TZ',
                NAME: '탄자니아',
                ENG_NAME: null,
            },
            {
                CODE: 'TH',
                NAME: '태국',
                ENG_NAME: null,
            },
            {
                CODE: 'TC',
                NAME: '터크스 카이코스 제도',
                ENG_NAME: null,
            },
            {
                CODE: 'TR',
                NAME: '터키',
                ENG_NAME: null,
            },
            {
                CODE: 'TG',
                NAME: '토고',
                ENG_NAME: null,
            },
            {
                CODE: 'TK',
                NAME: '토켈라우',
                ENG_NAME: null,
            },
            {
                CODE: 'TO',
                NAME: '통가',
                ENG_NAME: null,
            },
            {
                CODE: 'TM',
                NAME: '투르크메니스탄',
                ENG_NAME: null,
            },
            {
                CODE: 'TV',
                NAME: '투발루',
                ENG_NAME: null,
            },
            {
                CODE: 'TN',
                NAME: '튀니지',
                ENG_NAME: null,
            },
            {
                CODE: 'TT',
                NAME: '트리니다드 토바고',
                ENG_NAME: null,
            },
            {
                CODE: 'PA',
                NAME: '파나마',
                ENG_NAME: null,
            },
            {
                CODE: 'PY',
                NAME: '파라과이',
                ENG_NAME: null,
            },
            {
                CODE: 'PK',
                NAME: '파키스탄',
                ENG_NAME: null,
            },
            {
                CODE: 'PG',
                NAME: '파푸아뉴기니',
                ENG_NAME: null,
            },
            {
                CODE: 'PW',
                NAME: '팔라우',
                ENG_NAME: null,
            },
            {
                CODE: 'FO',
                NAME: '페로 군도',
                ENG_NAME: null,
            },
            {
                CODE: 'PE',
                NAME: '페루',
                ENG_NAME: null,
            },
            {
                CODE: 'PT',
                NAME: '포르투갈',
                ENG_NAME: null,
            },
            {
                CODE: 'FK',
                NAME: '포클랜드',
                ENG_NAME: null,
            },
            {
                CODE: 'PL',
                NAME: '폴란드',
                ENG_NAME: null,
            },
            {
                CODE: 'PR',
                NAME: '푸에르토리코',
                ENG_NAME: null,
            },
            {
                CODE: 'FR',
                NAME: '프랑스',
                ENG_NAME: null,
            },
            {
                CODE: 'TF',
                NAME: '프랑스 남부 지역',
                ENG_NAME: null,
            },
            {
                CODE: 'GF',
                NAME: '프랑스령 기아나',
                ENG_NAME: null,
            },
            {
                CODE: 'PF',
                NAME: '프랑스령 폴리네시아',
                ENG_NAME: null,
            },
            {
                CODE: 'FJ',
                NAME: '피지',
                ENG_NAME: null,
            },
            {
                CODE: 'FI',
                NAME: '핀란드',
                ENG_NAME: null,
            },
            {
                CODE: 'PH',
                NAME: '필리핀',
                ENG_NAME: null,
            },
            {
                CODE: 'PN',
                NAME: '핏케언 군도',
                ENG_NAME: null,
            },
            {
                CODE: 'HM',
                NAME: '허드 섬 및 맥도날드 군도',
                ENG_NAME: null,
            },
            {
                CODE: 'HU',
                NAME: '헝가리',
                ENG_NAME: null,
            },
            {
                CODE: 'HK',
                NAME: '홍콩',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '권한유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '일반권한',
                ENG_NAME: null,
            },
            {
                CODE: 'W',
                NAME: '원도우권한',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기관관리 진행상태',
        codeList: [
            {
                CODE: 'AL',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'AP',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'RJ',
                NAME: '반려',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기관구분',
        codeList: [
            {
                CODE: '01',
                NAME: '공공기관',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '대학',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '연구소',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '민간기업',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기관유형(일반)',
        codeList: [
            {
                CODE: 'O',
                NAME: '기타',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '일반기업',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '연구기관',
                ENG_NAME: null,
            },
            {
                CODE: 'GO',
                NAME: '기타국가기관',
                ENG_NAME: null,
            },
            {
                CODE: 'GM',
                NAME: '주관기관',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '다국어연결유형',
        codeList: [
            {
                CODE: 'AUTH',
                NAME: '서비스 페이지',
                ENG_NAME: null,
            },
            {
                CODE: 'MIDDLE',
                NAME: '중간 페이지',
                ENG_NAME: null,
            },
            {
                CODE: 'ROOT',
                NAME: '최상위 페이지',
                ENG_NAME: null,
            },
            {
                CODE: 'ROLE',
                NAME: '역할',
                ENG_NAME: null,
            },
            {
                CODE: 'SER_ROLE',
                NAME: '서비스 롤',
                ENG_NAME: null,
            },
            {
                CODE: 'FAVORITES',
                NAME: '즐겨찾기',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '도움말유형',
        codeList: [
            {
                CODE: '1',
                NAME: '회원관련',
                ENG_NAME: 'Membership',
            },
            {
                CODE: '2',
                NAME: '장비심의',
                ENG_NAME: 'Equipment Deliberation',
            },
            {
                CODE: '3',
                NAME: '연구장비',
                ENG_NAME: 'Research Equipment',
            },
            {
                CODE: '4',
                NAME: '장비활용',
                ENG_NAME: 'Equipment Utilization',
            },
            {
                CODE: '5',
                NAME: '기타',
                ENG_NAME: 'Others',
            },
        ],
    },
    {
        NAME: '리턴값유형',
        codeList: [
            {
                CODE: 'INT',
                NAME: '숫자',
                ENG_NAME: null,
            },
            {
                CODE: 'STRING',
                NAME: '문자',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '리턴유형',
        codeList: [
            {
                CODE: 'LIST',
                NAME: '리스트',
                ENG_NAME: null,
            },
            {
                CODE: 'NL',
                NAME: '일반',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '매칭유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '자동',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '지정',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '메뉴레벨',
        codeList: [
            {
                CODE: 'L1',
                NAME: '레벨 1',
                ENG_NAME: null,
            },
            {
                CODE: 'L2',
                NAME: '레벨 2',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '발급유형',
        codeList: [
            {
                CODE: 'TB',
                NAME: '청구서',
                ENG_NAME: null,
            },
            {
                CODE: 'EF',
                NAME: '이수증',
                ENG_NAME: null,
            },
            {
                CODE: 'TR',
                NAME: '시험결과서',
                ENG_NAME: null,
            },
            {
                CODE: 'ET',
                NAME: '견적서',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '번호리셋유무',
        codeList: [
            {
                CODE: 'N',
                NAME: '미사용',
                ENG_NAME: null,
            },
            {
                CODE: 'Y',
                NAME: '사용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '번호생성순서',
        codeList: [
            {
                CODE: 'T',
                NAME: '기본문자',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '일',
                ENG_NAME: null,
            },
            {
                CODE: 'S',
                NAME: '순서',
                ENG_NAME: null,
            },
            {
                CODE: 'ST',
                NAME: '특수문자',
                ENG_NAME: null,
            },
            {
                CODE: 'T1',
                NAME: '추가문자1',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '미사용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '번호유형',
        codeList: [
            {
                CODE: 'EQ',
                NAME: '장비기본정보',
                ENG_NAME: null,
            },
            {
                CODE: 'MR',
                NAME: '소모품기본정보',
                ENG_NAME: null,
            },
            {
                CODE: 'RV',
                NAME: '예약번호',
                ENG_NAME: null,
            },
            {
                CODE: 'RT',
                NAME: '장비대여번호',
                ENG_NAME: null,
            },
            {
                CODE: 'PAY',
                NAME: '선지급번호',
                ENG_NAME: null,
            },
            {
                CODE: 'REQ',
                NAME: '정산번호',
                ENG_NAME: null,
            },
            {
                CODE: 'TAX',
                NAME: '세금계산서',
                ENG_NAME: null,
            },
            {
                CODE: 'PJN',
                NAME: '프로젝트번호',
                ENG_NAME: null,
            },
            {
                CODE: 'FAC',
                NAME: '시설관리',
                ENG_NAME: null,
            },
            {
                CODE: 'DEP',
                NAME: '장비운영실번호',
                ENG_NAME: null,
            },
            {
                CODE: 'EL',
                NAME: '유지보수로그인코드',
                ENG_NAME: null,
            },
            {
                CODE: 'TRF',
                NAME: '거래번호',
                ENG_NAME: null,
            },
            {
                CODE: 'ET',
                NAME: '장비견적서번호',
                ENG_NAME: null,
            },
            {
                CODE: 'AR',
                NAME: '분석결과서',
                ENG_NAME: null,
            },
            {
                CODE: 'BII',
                NAME: '청구서 내부',
                ENG_NAME: null,
            },
            {
                CODE: 'BIO',
                NAME: '청구서 외부',
                ENG_NAME: null,
            },
            {
                CODE: 'ESI',
                NAME: '견적서 내부',
                ENG_NAME: null,
            },
            {
                CODE: 'ESO',
                NAME: '견적서 외부',
                ENG_NAME: null,
            },
            {
                CODE: 'AP',
                NAME: '출입카드승인번호',
                ENG_NAME: null,
            },
            {
                CODE: 'INST',
                NAME: '기관번호',
                ENG_NAME: null,
            },
            {
                CODE: 'CMP',
                NAME: '기업',
                ENG_NAME: null,
            },
            {
                CODE: 'INT',
                NAME: '기관',
                ENG_NAME: null,
            },
            {
                CODE: 'DEPT',
                NAME: '부서',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '번호자릿수',
        codeList: [
            {
                CODE: '02',
                NAME: '2',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '3',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '4',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '5',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '알림유형',
        codeList: [
            {
                CODE: 'WR',
                NAME: '경고',
                ENG_NAME: null,
            },
            {
                CODE: 'NT',
                NAME: '알림',
                ENG_NAME: null,
            },
            {
                CODE: 'ER',
                NAME: '오류',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '알림참조유형',
        codeList: [
            {
                CODE: 'EQ',
                NAME: '장비',
                ENG_NAME: null,
            },
            {
                CODE: 'EU',
                NAME: '교육',
                ENG_NAME: null,
            },
            {
                CODE: 'TU',
                NAME: '견학',
                ENG_NAME: null,
            },
            {
                CODE: 'PT',
                NAME: '프로젝트',
                ENG_NAME: null,
            },
            {
                CODE: 'SP',
                NAME: '기술',
                ENG_NAME: null,
            },
            {
                CODE: 'FA',
                NAME: '시설',
                ENG_NAME: null,
            },
            {
                CODE: 'TX',
                NAME: '정산',
                ENG_NAME: null,
            },
            {
                CODE: 'EQUS',
                NAME: '장비이용권한',
                ENG_NAME: null,
            },
            {
                CODE: 'FAUS',
                NAME: '시설이용권한',
                ENG_NAME: null,
            },
            {
                CODE: 'EQIF',
                NAME: '장비정보',
                ENG_NAME: null,
            },
            {
                CODE: 'TUCP',
                NAME: '견학승인',
                ENG_NAME: null,
            },
            {
                CODE: 'EQIFN',
                NAME: '장비정보 등록',
                ENG_NAME: null,
            },
            {
                CODE: 'EQIFU',
                NAME: '장비정보 수정',
                ENG_NAME: null,
            },
            {
                CODE: 'AL',
                NAME: '결재선',
                ENG_NAME: null,
            },
            {
                CODE: 'ALCO',
                NAME: '결재선 결과',
                ENG_NAME: null,
            },
            {
                CODE: 'EUR',
                NAME: '교육(정기)',
                ENG_NAME: null,
            },
            {
                CODE: 'EUF',
                NAME: '교육(수시)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '언어',
        codeList: [
            {
                CODE: 'KR',
                NAME: '한국어',
                ENG_NAME: 'Korean',
            },
            {
                CODE: 'EN',
                NAME: '영어',
                ENG_NAME: 'English',
            },
            {
                CODE: 'JP',
                NAME: '일어',
                ENG_NAME: 'Japanese',
            },
            {
                CODE: 'CH',
                NAME: '중국어',
                ENG_NAME: 'Chinese',
            },
            {
                CODE: 'AF',
                NAME: '아프리카어',
                ENG_NAME: 'African',
            },
            {
                CODE: 'AR',
                NAME: '아라비아어',
                ENG_NAME: 'Arabic',
            },
            {
                CODE: 'BG',
                NAME: '불가리아어',
                ENG_NAME: 'Bulgarian',
            },
            {
                CODE: 'CA',
                NAME: '카탈로니아어',
                ENG_NAME: 'Catalan',
            },
            {
                CODE: 'CZ',
                NAME: '체코어',
                ENG_NAME: 'Czech',
            },
            {
                CODE: 'DA',
                NAME: '덴마크어',
                ENG_NAME: 'Danish',
            },
            {
                CODE: 'DE',
                NAME: '독어',
                ENG_NAME: 'German',
            },
            {
                CODE: 'GR',
                NAME: '그리스어',
                ENG_NAME: 'Greek',
            },
            {
                CODE: 'SP',
                NAME: '스페인어',
                ENG_NAME: 'Spanish',
            },
            {
                CODE: 'ET',
                NAME: '에스토니아어',
                ENG_NAME: 'Estonian',
            },
            {
                CODE: 'FI',
                NAME: '핀란드어',
                ENG_NAME: 'Finnish',
            },
            {
                CODE: 'FR',
                NAME: '불어',
                ENG_NAME: 'French',
            },
            {
                CODE: 'HE',
                NAME: '헤브라이어',
                ENG_NAME: 'Hebrew',
            },
            {
                CODE: 'CR',
                NAME: '크로아티아어',
                ENG_NAME: 'Croatian',
            },
            {
                CODE: 'HU',
                NAME: '헝가리어',
                ENG_NAME: 'Hungarian',
            },
            {
                CODE: 'ID',
                NAME: '인도네시아어',
                ENG_NAME: 'Indonesian',
            },
            {
                CODE: 'IC',
                NAME: '아이슬란드어',
                ENG_NAME: 'Icelandic',
            },
            {
                CODE: 'IT',
                NAME: '이탈리아어',
                ENG_NAME: 'Italian',
            },
            {
                CODE: 'LT',
                NAME: '리투아니아어',
                ENG_NAME: 'Lithuanian',
            },
            {
                CODE: 'LA',
                NAME: '라트비아어',
                ENG_NAME: 'Latvian',
            },
            {
                CODE: 'MA',
                NAME: '말레이어',
                ENG_NAME: 'Malay',
            },
            {
                CODE: 'DU',
                NAME: '네덜란드어',
                ENG_NAME: 'Dutch',
            },
            {
                CODE: 'NO',
                NAME: '노르웨이어',
                ENG_NAME: 'Norwegian',
            },
            {
                CODE: 'PL',
                NAME: '폴란드어',
                ENG_NAME: 'Polish',
            },
            {
                CODE: 'PT',
                NAME: '포르투갈어',
                ENG_NAME: 'Portuguese',
            },
            {
                CODE: 'RO',
                NAME: '루마니아어',
                ENG_NAME: 'Romanian',
            },
            {
                CODE: 'RU',
                NAME: '러시아어',
                ENG_NAME: 'Russian',
            },
            {
                CODE: 'SE',
                NAME: '세르비아어(라틴)',
                ENG_NAME: 'Serbian',
            },
            {
                CODE: 'SK',
                NAME: '슬로바키아어',
                ENG_NAME: 'Slovak',
            },
            {
                CODE: 'SL',
                NAME: '슬로베니아어',
                ENG_NAME: 'Slovenian',
            },
            {
                CODE: 'SB',
                NAME: '세르비아어',
                ENG_NAME: 'Serbian',
            },
            {
                CODE: 'SW',
                NAME: '스웨덴어',
                ENG_NAME: 'Swedish',
            },
            {
                CODE: 'TH',
                NAME: '타이어',
                ENG_NAME: 'Thais',
            },
            {
                CODE: 'TR',
                NAME: '터키어',
                ENG_NAME: 'Turkish',
            },
            {
                CODE: 'UK',
                NAME: '우크라이나어',
                ENG_NAME: 'Ukrainian',
            },
        ],
    },
    {
        NAME: '연구단구분',
        codeList: [
            {
                CODE: 'I',
                NAME: '소속연구단',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '일반기관',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연구단분야',
        codeList: [
            {
                CODE: '01',
                NAME: '수학분야',
                ENG_NAME: 'Mathematics',
            },
            {
                CODE: '02',
                NAME: '물리학분야',
                ENG_NAME: 'Physics',
            },
            {
                CODE: '03',
                NAME: '화학분야',
                ENG_NAME: 'Chemistry',
            },
            {
                CODE: '04',
                NAME: '생명과학분야',
                ENG_NAME: 'Life Sciences',
            },
            {
                CODE: '05',
                NAME: '융합연구분야',
                ENG_NAME: 'Interdisciplinary',
            },
        ],
    },
    {
        NAME: '예/아니오',
        codeList: [
            {
                CODE: 'Y',
                NAME: '예',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '아니오',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '예아니오',
        codeList: [
            {
                CODE: 'Y',
                NAME: '예',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '아니오',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용구분',
        codeList: [
            {
                CODE: 'UST01',
                NAME: '시스템',
                ENG_NAME: null,
            },
            {
                CODE: 'UST02',
                NAME: '심의',
                ENG_NAME: null,
            },
            {
                CODE: 'UST03',
                NAME: '장비',
                ENG_NAME: null,
            },
            {
                CODE: 'UST04',
                NAME: '활용',
                ENG_NAME: null,
            },
            {
                CODE: 'UST05',
                NAME: '모니터링',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용영역',
        codeList: [
            {
                CODE: 'SC',
                NAME: '표준점검표',
                ENG_NAME: null,
            },
            {
                CODE: 'PL',
                NAME: '설문',
                ENG_NAME: null,
            },
            {
                CODE: 'AR',
                NAME: '분석의뢰서',
                ENG_NAME: null,
            },
            {
                CODE: 'EM',
                NAME: '이메일',
                ENG_NAME: null,
            },
            {
                CODE: 'PT',
                NAME: '증빙유형',
                ENG_NAME: null,
            },
            {
                CODE: 'CL',
                NAME: '체크리스트',
                ENG_NAME: null,
            },
            {
                CODE: 'PU',
                NAME: '팝업',
                ENG_NAME: null,
            },
            {
                CODE: 'RT',
                NAME: '신청서',
                ENG_NAME: null,
            },
            {
                CODE: 'ES',
                NAME: '장비실태조사',
                ENG_NAME: null,
            },
            {
                CODE: 'AT',
                NAME: '분석결과서',
                ENG_NAME: null,
            },
            {
                CODE: 'BL',
                NAME: '블랙리스트',
                ENG_NAME: null,
            },
            {
                CODE: 'TS',
                NAME: '거래명세서',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '입력폼 유형',
        codeList: [
            {
                CODE: 'P',
                NAME: '단독 TAB 오픈',
                ENG_NAME: null,
            },
            {
                CODE: 'S',
                NAME: '시스템 화면',
                ENG_NAME: null,
            },
            {
                CODE: 'E',
                NAME: '내부 사용 요소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '자료실유형',
        codeList: [
            {
                CODE: '3',
                NAME: '일반',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '홍보',
                ENG_NAME: null,
            },
            {
                CODE: '1',
                NAME: '기술',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '작업역할',
        codeList: [
            {
                CODE: 'ST',
                NAME: '학생',
                ENG_NAME: null,
            },
            {
                CODE: 'PF',
                NAME: '교수',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정보확인유형',
        codeList: [
            {
                CODE: 'PP',
                NAME: '약관 및 개인정보',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '존재여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '존재',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '미존재',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '지역구분',
        codeList: [
            {
                CODE: '01',
                NAME: '강원',
                ENG_NAME: 'Gangwon-do',
            },
            {
                CODE: '02',
                NAME: '경기',
                ENG_NAME: 'Gyeonggi-do',
            },
            {
                CODE: '03',
                NAME: '경남',
                ENG_NAME: 'Gyeongsangnam-do',
            },
            {
                CODE: '04',
                NAME: '경북',
                ENG_NAME: 'Gyeongsangbuk-do',
            },
            {
                CODE: '05',
                NAME: '광주',
                ENG_NAME: 'Gwangju',
            },
            {
                CODE: '06',
                NAME: '대구',
                ENG_NAME: 'Daegu',
            },
            {
                CODE: '07',
                NAME: '대전',
                ENG_NAME: 'Daejeon',
            },
            {
                CODE: '08',
                NAME: '부산',
                ENG_NAME: 'Busan',
            },
            {
                CODE: '09',
                NAME: '서울',
                ENG_NAME: 'Seoul',
            },
            {
                CODE: '10',
                NAME: '울산',
                ENG_NAME: 'Ulsan',
            },
            {
                CODE: '11',
                NAME: '인천',
                ENG_NAME: 'Incheon',
            },
            {
                CODE: '12',
                NAME: '전남',
                ENG_NAME: 'Jeollanam-do',
            },
            {
                CODE: '13',
                NAME: '전북',
                ENG_NAME: 'Jeollabuk-do',
            },
            {
                CODE: '14',
                NAME: '제주',
                ENG_NAME: 'Jeju',
            },
            {
                CODE: '15',
                NAME: '충남',
                ENG_NAME: 'Chungcheongnam-do',
            },
            {
                CODE: '16',
                NAME: '충북',
                ENG_NAME: 'Chungcheongbuk-do',
            },
            {
                CODE: '17',
                NAME: '해외',
                ENG_NAME: null,
            },
            {
                CODE: '18',
                NAME: '세종',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '참여기관 유형',
        codeList: [
            {
                CODE: '01',
                NAME: 'SBH',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '기관',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '팝업유형',
        codeList: [
            {
                CODE: 'L',
                NAME: '레이어 팝업',
                ENG_NAME: null,
            },
            {
                CODE: 'P',
                NAME: '페이지 팝업',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '폼확장유형',
        codeList: [
            {
                CODE: 'FMAL',
                NAME: '-- 선택 --',
                ENG_NAME: null,
            },
            {
                CODE: 'FMTP',
                NAME: '템플릿',
                ENG_NAME: null,
            },
            {
                CODE: 'FMST',
                NAME: '스크립트',
                ENG_NAME: null,
            },
            {
                CODE: 'FMTS',
                NAME: '템플릿&스크립트',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '허용유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '허용유형1',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '허용유형2',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '확인여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '확인',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '미확인',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '활성여부',
        codeList: [
            {
                CODE: 'A',
                NAME: '활성',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '비활성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실태변경',
        codeList: [
            {
                CODE: 'A',
                NAME: '일치',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '변경',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실태이용상태',
        codeList: [
            {
                CODE: 'U',
                NAME: '사용',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '폐기',
                ENG_NAME: null,
            },
            {
                CODE: 'S',
                NAME: '판매',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실태조사작업상태',
        codeList: [
            {
                CODE: 'AP',
                NAME: '작업',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실태진행상태',
        codeList: [
            {
                CODE: 'R',
                NAME: '등록',
                ENG_NAME: null,
            },
            {
                CODE: 'P',
                NAME: '진행',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실태진행여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '확인',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '미확인',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실태활용정보타입',
        codeList: [
            {
                CODE: 'RE',
                NAME: '실사용시간',
                ENG_NAME: null,
            },
            {
                CODE: 'AD',
                NAME: '보조가동시간',
                ENG_NAME: null,
            },
            {
                CODE: 'MT',
                NAME: '유지보수',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '생성유형',
        codeList: [
            {
                CODE: 'A',
                NAME: 'A타입',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: 'B타입',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '액션태그유형',
        codeList: [
            {
                CODE: 'SHR',
                NAME: 'special handling request',
                ENG_NAME: null,
            },
            {
                CODE: 'CT',
                NAME: 'cage transfer',
                ENG_NAME: null,
            },
            {
                CODE: 'OC',
                NAME: 'overcrowded',
                ENG_NAME: null,
            },
            {
                CODE: 'NP',
                NAME: 'new pubs',
                ENG_NAME: null,
            },
            {
                CODE: 'MTL',
                NAME: 'mortality',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '액션태그종료유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '임시코드A타입',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '임시코드B타입',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실험관리작업유형',
        codeList: [
            {
                CODE: 'R',
                NAME: '입고',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '폐기',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '변경유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '반입',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '유지',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '폐기',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실험재료판매상태',
        codeList: [
            {
                CODE: 'AP',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: 'DI',
                NAME: '배송중',
                ENG_NAME: null,
            },
            {
                CODE: 'DC',
                NAME: '배송완료',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '2015추가심의사유',
        codeList: [
            {
                CODE: '01',
                NAME: '예산집행 시점에 연구책임자를 공모·선정하는 과제로 구축하려는 경우',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '전년도 예산의 이월금으로 구축하려는 경우',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '정부 예산편성 이후 추가 증액된 예산으로 구축하려는 경우',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '연구시설장비 구축 이후 남은 입찰 차액을 합하여 구축하려는 경우',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '사업(연구)계획 변경에 따라 추가 구축하려는 경우',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '연구개발적립금 등 R&D 통해 발생한 재원으로 구축하려는 경우',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '기타(위 항목 외에 사유가 있을 시 표시)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '구축목적항목',
        codeList: [
            {
                CODE: 'AA',
                NAME: '사업(연구)과의 부합성',
                ENG_NAME: null,
            },
            {
                CODE: 'NP',
                NAME: '국가전략적 필요성',
                ENG_NAME: null,
            },
            {
                CODE: 'ED',
                NAME: '연구장비의 중복성',
                ENG_NAME: null,
            },
            {
                CODE: 'EU',
                NAME: '연구장비의 활용성',
                ENG_NAME: null,
            },
            {
                CODE: 'EA',
                NAME: '연구장비의 적정성',
                ENG_NAME: null,
            },
            {
                CODE: 'RP',
                NAME: '장비운영의 계획성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '구축목적항목15',
        codeList: [
            {
                CODE: 'AA',
                NAME: '사업(연구)과의 부합성',
                ENG_NAME: null,
            },
            {
                CODE: 'NP',
                NAME: '국가전략적 필요성',
                ENG_NAME: null,
            },
            {
                CODE: 'ED',
                NAME: '연구장비의 중복성',
                ENG_NAME: null,
            },
            {
                CODE: 'EU',
                NAME: '연구장비의 활용성',
                ENG_NAME: null,
            },
            {
                CODE: 'EA',
                NAME: '연구장비의 적정성',
                ENG_NAME: null,
            },
            {
                CODE: 'RP',
                NAME: '장비운영의 계획성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '구축목적항목16',
        codeList: [
            {
                CODE: 'AA',
                NAME: '사업(연구)과의 부합성',
                ENG_NAME: null,
            },
            {
                CODE: 'NP',
                NAME: '국가전략적 필요성',
                ENG_NAME: null,
            },
            {
                CODE: 'ED',
                NAME: '연구장비의 중복성',
                ENG_NAME: null,
            },
            {
                CODE: 'EU',
                NAME: '연구장비의 활용성',
                ENG_NAME: null,
            },
            {
                CODE: 'EA',
                NAME: '연구장비의 적정성',
                ENG_NAME: null,
            },
            {
                CODE: 'RP',
                NAME: '장비운영의 계획성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기관유형(중복도)',
        codeList: [
            {
                CODE: '01',
                NAME: '국/공립 연구기관',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '심의정부출연 연구기관',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '지자체출연 연구기관',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '연구조합',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '기타공공기관',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '4년제 국/공립대학',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '2년제 국/공립대학',
                ENG_NAME: null,
            },
            {
                CODE: '08',
                NAME: '4년제 사립대학',
                ENG_NAME: null,
            },
            {
                CODE: '09',
                NAME: '2년제 사립대학',
                ENG_NAME: null,
            },
            {
                CODE: '10',
                NAME: '국/공립 의료기관',
                ENG_NAME: null,
            },
            {
                CODE: '11',
                NAME: '사립 의료기관',
                ENG_NAME: null,
            },
            {
                CODE: '12',
                NAME: '국/공립대학 부속병원',
                ENG_NAME: null,
            },
            {
                CODE: '13',
                NAME: '사립대학 부속병원',
                ENG_NAME: null,
            },
            {
                CODE: '14',
                NAME: '민간기업',
                ENG_NAME: null,
            },
            {
                CODE: '15',
                NAME: '시장형 공기업',
                ENG_NAME: null,
            },
            {
                CODE: '16',
                NAME: '준시장형 공기업',
                ENG_NAME: null,
            },
            {
                CODE: '17',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기술분야',
        codeList: [
            {
                CODE: '01',
                NAME: '기초과학',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '생명',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '해양',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '우주·천문',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '에너지',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '환경',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '기계부품소재',
                ENG_NAME: null,
            },
            {
                CODE: '08',
                NAME: '정보전자통신',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '반려의견 위치',
        codeList: [
            {
                CODE: 'RW',
                NAME: '심의요청서',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '장비기본정보',
                ENG_NAME: null,
            },
            {
                CODE: 'QU',
                NAME: '견적서정보',
                ENG_NAME: null,
            },
            {
                CODE: 'AA',
                NAME: '사업(연구)과의 부합성',
                ENG_NAME: null,
            },
            {
                CODE: 'NP',
                NAME: '국가전략적 필요성',
                ENG_NAME: null,
            },
            {
                CODE: 'ED',
                NAME: '연구장비의 중복성',
                ENG_NAME: null,
            },
            {
                CODE: 'EU',
                NAME: '연구장비의 활용성',
                ENG_NAME: null,
            },
            {
                CODE: 'EA',
                NAME: '연구장비의 적정성',
                ENG_NAME: null,
            },
            {
                CODE: 'RP',
                NAME: '장비운영의 계획성',
                ENG_NAME: null,
            },
            {
                CODE: 'RD',
                NAME: '중복성검토',
                ENG_NAME: null,
            },
            {
                CODE: 'RA',
                NAME: '추가심의내용',
                ENG_NAME: null,
            },
            {
                CODE: 'RCP',
                NAME: '이의신청',
                ENG_NAME: null,
            },
            {
                CODE: 'RC',
                NAME: '변경신청내용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '변경신청유형',
        codeList: [
            {
                CODE: 'CN',
                NAME: '구축포기',
                ENG_NAME: null,
            },
            {
                CODE: 'CG',
                NAME: '금액변경',
                ENG_NAME: null,
            },
            {
                CODE: 'CE',
                NAME: '장비변경',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '분과상태',
        codeList: [
            {
                CODE: 'O',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '작성완료',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '심의중',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '사업분류',
        codeList: [
            {
                CODE: '01',
                NAME: '순수연구개발사업',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '시설장비구축사업',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '연구기관지원사업',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '사업유형',
        codeList: [
            {
                CODE: 'D',
                NAME: '세부사업',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '내역사업',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '연구과제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의결과',
        codeList: [
            {
                CODE: 'A',
                NAME: '가결',
                ENG_NAME: null,
            },
            {
                CODE: 'J',
                NAME: '조건부가결',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '부결',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '인정',
                ENG_NAME: null,
            },
            {
                CODE: 'CJ',
                NAME: '조건부인정',
                ENG_NAME: null,
            },
            {
                CODE: 'CR',
                NAME: '불인정',
                ENG_NAME: null,
            },
            {
                CODE: 'NA',
                NAME: '심의미참석',
                ENG_NAME: null,
            },
            {
                CODE: 'NR',
                NAME: '구축포기',
                ENG_NAME: null,
            },
            {
                CODE: 'NC',
                NAME: '신청취소',
                ENG_NAME: null,
            },
            {
                CODE: 'AA',
                NAME: '구입승인',
                ENG_NAME: null,
            },
            {
                CODE: 'JG',
                NAME: '보완',
                ENG_NAME: null,
            },
            {
                CODE: 'RX',
                NAME: '검토불가',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의결과유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '평균심의',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '중점심의',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의계획상태',
        codeList: [
            {
                CODE: 'O',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'PL',
                NAME: '심의계획상태',
                ENG_NAME: null,
            },
            {
                CODE: 'RP',
                NAME: '심의요청접수',
                ENG_NAME: null,
            },
            {
                CODE: 'SC',
                NAME: '심의요청마감',
                ENG_NAME: null,
            },
            {
                CODE: 'MN',
                NAME: '발표자료등록',
                ENG_NAME: null,
            },
            {
                CODE: 'MP',
                NAME: '요청장비심의',
                ENG_NAME: null,
            },
            {
                CODE: '1E',
                NAME: '1차결과통보',
                ENG_NAME: null,
            },
            {
                CODE: 'OR',
                NAME: '조건부가결',
                ENG_NAME: null,
            },
            {
                CODE: 'OC',
                NAME: '조건부가결마감',
                ENG_NAME: null,
            },
            {
                CODE: 'ON',
                NAME: '2차심의확정',
                ENG_NAME: null,
            },
            {
                CODE: 'OP',
                NAME: '장비2차심의',
                ENG_NAME: null,
            },
            {
                CODE: 'DE',
                NAME: '심의결과통보',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '종료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의계획테스트여부',
        codeList: [
            {
                CODE: 'N',
                NAME: '심의',
                ENG_NAME: null,
            },
            {
                CODE: 'Y',
                NAME: '테스트',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '결과',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의구분',
        codeList: [
            {
                CODE: 'R',
                NAME: 'RED',
                ENG_NAME: null,
            },
            {
                CODE: 'S',
                NAME: '자체장비심의위원회',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '연구과제개발평가단',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '내부심의',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의요청상태',
        codeList: [
            {
                CODE: 'OP',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'SM',
                NAME: '제출',
                ENG_NAME: null,
            },
            {
                CODE: 'NR',
                NAME: '접수반려',
                ENG_NAME: null,
            },
            {
                CODE: 'NC',
                NAME: '접수',
                ENG_NAME: null,
            },
            {
                CODE: 'CP',
                NAME: '심의계획생성',
                ENG_NAME: null,
            },
            {
                CODE: 'DP',
                NAME: '심의진행',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'RR',
                NAME: '이의신청',
                ENG_NAME: null,
            },
            {
                CODE: 'CR',
                NAME: '변경신청',
                ENG_NAME: null,
            },
            {
                CODE: 'RP',
                NAME: '2차심의',
                ENG_NAME: null,
            },
            {
                CODE: 'X',
                NAME: '삭제',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의위원역할',
        codeList: [
            {
                CODE: 'M',
                NAME: '위원장',
                ENG_NAME: null,
            },
            {
                CODE: 'RM',
                NAME: '중점위원(정)',
                ENG_NAME: null,
            },
            {
                CODE: 'RS',
                NAME: '중점위원(부)',
                ENG_NAME: null,
            },
            {
                CODE: 'NC',
                NAME: '일반위원',
                ENG_NAME: null,
            },
            {
                CODE: 'XC',
                NAME: '이해관계자',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의유형',
        codeList: [
            {
                CODE: 'DO',
                NAME: '심의',
                ENG_NAME: null,
            },
            {
                CODE: 'DC',
                NAME: '변경심의',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의장비상태',
        codeList: [
            {
                CODE: 'RO',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'RF',
                NAME: '제출',
                ENG_NAME: null,
            },
            {
                CODE: 'DR',
                NAME: '부처반려',
                ENG_NAME: null,
            },
            {
                CODE: 'DF',
                NAME: '부처접수',
                ENG_NAME: null,
            },
            {
                CODE: 'NR',
                NAME: 'IBS반려',
                ENG_NAME: null,
            },
            {
                CODE: 'NC',
                NAME: 'IBS접수',
                ENG_NAME: null,
            },
            {
                CODE: 'CF',
                NAME: '심의계획확정',
                ENG_NAME: null,
            },
            {
                CODE: 'CP',
                NAME: '심의시작',
                ENG_NAME: null,
            },
            {
                CODE: 'MC',
                NAME: '1차심의완료',
                ENG_NAME: null,
            },
            {
                CODE: 'OM',
                NAME: '이의신청',
                ENG_NAME: null,
            },
            {
                CODE: 'OR',
                NAME: '이의신청반려',
                ENG_NAME: null,
            },
            {
                CODE: 'OP',
                NAME: '2차심의확정',
                ENG_NAME: null,
            },
            {
                CODE: 'DC',
                NAME: 'IBS확정',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'XC',
                NAME: '변경대체',
                ENG_NAME: null,
            },
            {
                CODE: 'X',
                NAME: '삭제',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: 'BG',
                NAME: '구축포기',
                ENG_NAME: null,
            },
            {
                CODE: 'OC',
                NAME: '변경신청작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'OO',
                NAME: '이의신청작성중',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의장비취득방법',
        codeList: [
            {
                CODE: 'P',
                NAME: '구매',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '임대',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '제작의뢰',
                ENG_NAME: null,
            },
            {
                CODE: 'OM',
                NAME: '자체제작',
                ENG_NAME: null,
            },
            {
                CODE: '99',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '심의항목타입',
        codeList: [
            {
                CODE: 'A',
                NAME: 'AND형',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '선택형',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연구장비표준분류',
        codeList: [
            {
                CODE: 'EQ0001',
                NAME: '광학·전자 영상장비',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ0002',
                NAME: '화합물 전처리·분석장비',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ0003',
                NAME: '기계가공·시험장비',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ0004',
                NAME: '전기·전자장비',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ0005',
                NAME: '데이터 처리장비',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ0006',
                NAME: '물리적 측정장비',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ0007',
                NAME: '임상의료장비',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ0008',
                NAME: '환경조성·사육시설',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '위원등급',
        codeList: [
            {
                CODE: '1',
                NAME: '우수',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '미흡',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '아주미흡',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '위원회상태',
        codeList: [
            {
                CODE: 'O',
                NAME: '계획',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '진행',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '심의중',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '위원회유형',
        codeList: [
            {
                CODE: 'O',
                NAME: '1차',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '2차',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '위원회테스트여부',
        codeList: [
            {
                CODE: 'R',
                NAME: '일반',
                ENG_NAME: null,
            },
            {
                CODE: 'T',
                NAME: '테스트',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용용도',
        codeList: [
            {
                CODE: '01',
                NAME: '시험용',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '분석용',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '계측용',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '교육용',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '생산용',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '기타',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '미지정',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '중점투자분야',
        codeList: [
            {
                CODE: '01',
                NAME: '기초과학.융합기술 연구개발활성화',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '주력기간산업기술 고도화',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '신산업창출 핵심기술개발 강화',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '글로벌이슈대응 연구개발추진',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '국가주도기술 핵심역량 확보',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '활용목적별구분',
        codeList: [
            {
                CODE: '01',
                NAME: '공동활용 서비스',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '공동활용 허용',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '단독활용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연구실험실유형',
        codeList: [
            {
                CODE: '01',
                NAME: '제약바이오',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '의료기기',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '청구단위',
        codeList: [
            {
                CODE: '01',
                NAME: '일',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '시간',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '시험횟수',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연구원역할',
        codeList: [
            {
                CODE: 'P',
                NAME: '책임연구자',
                ENG_NAME: null,
            },
            {
                CODE: 'L',
                NAME: '실험실관리자',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연계분류그룹코드',
        codeList: [
            {
                CODE: 'TR001',
                NAME: '장비정보',
                ENG_NAME: null,
            },
            {
                CODE: 'TR002',
                NAME: '운영실적',
                ENG_NAME: null,
            },
            {
                CODE: 'TR003',
                NAME: '유지보수실적',
                ENG_NAME: null,
            },
            {
                CODE: 'TR004',
                NAME: '사용자인증',
                ENG_NAME: null,
            },
            {
                CODE: 'TR005',
                NAME: '불용장비',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연계상태',
        codeList: [
            {
                CODE: 'TST01',
                NAME: '대기',
                ENG_NAME: null,
            },
            {
                CODE: 'TST02',
                NAME: '전송',
                ENG_NAME: null,
            },
            {
                CODE: 'TST03',
                NAME: '승인대기',
                ENG_NAME: null,
            },
            {
                CODE: 'TST04',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'TST05',
                NAME: '오류',
                ENG_NAME: null,
            },
            {
                CODE: 'TST06',
                NAME: '수정완료',
                ENG_NAME: null,
            },
            {
                CODE: 'TST07',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'TST08',
                NAME: 'ZEUS 연결 오류 재전송 대기',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연계유형',
        codeList: [
            {
                CODE: 'RS001',
                NAME: '최초 등록',
                ENG_NAME: null,
            },
            {
                CODE: 'RS002',
                NAME: '정보변경',
                ENG_NAME: null,
            },
            {
                CODE: 'RS004',
                NAME: '운영실적등록',
                ENG_NAME: null,
            },
            {
                CODE: 'RS005',
                NAME: '유지보수실적등록',
                ENG_NAME: null,
            },
            {
                CODE: 'RS006',
                NAME: '불용장비등록',
                ENG_NAME: null,
            },
            {
                CODE: 'RS007',
                NAME: '정보삭제',
                ENG_NAME: null,
            },
            {
                CODE: 'RS008',
                NAME: '운영실적수정',
                ENG_NAME: null,
            },
            {
                CODE: 'RS009',
                NAME: '운영실적삭제',
                ENG_NAME: null,
            },
            {
                CODE: 'RS010',
                NAME: '유지보수실적수정',
                ENG_NAME: null,
            },
            {
                CODE: 'RS011',
                NAME: '유지보수실적삭제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '유휴저활용 발생형태',
        codeList: [
            {
                CODE: 'EC',
                NAME: '실태조사',
                ENG_NAME: null,
            },
            {
                CODE: 'EI',
                NAME: '임의등록',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '유휴저활용 상태',
        codeList: [
            {
                CODE: 'P',
                NAME: '등록',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '진행',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '유휴저활용 심의결과',
        codeList: [
            {
                CODE: '01',
                NAME: '이전',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '폐기',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '재활용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '유휴저활용 작업식별번호',
        codeList: [
            {
                CODE: '01',
                NAME: '장비심의 결과등록',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: 'ZEUS 유휴·저활용 등록',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: 'ZEUS 심의 결과등록',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: 'ZEUS 게시판 정보등록',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '이전/폐기 준비',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '결과입력',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '유휴저활용 작업유형',
        codeList: [
            {
                CODE: '01',
                NAME: '이전',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '폐기',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '재활용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '유휴저활용 장비상태',
        codeList: [
            {
                CODE: 'A',
                NAME: '활성',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '비활성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육과금여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '예',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '아니오',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '신청중',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육서브유형',
        codeList: [
            {
                CODE: 'RG',
                NAME: '정기',
                ENG_NAME: null,
            },
            {
                CODE: 'FQ',
                NAME: '수시',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육수료여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '예',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '아니오',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육신청상태',
        codeList: [
            {
                CODE: 'P',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육예약상태',
        codeList: [
            {
                CODE: 'AP',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '예약',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육유형',
        codeList: [
            {
                CODE: 'EDU01',
                NAME: '일반교육',
                ENG_NAME: 'General Education',
            },
            {
                CODE: 'EDU02',
                NAME: '세미나',
                ENG_NAME: 'Seminar',
            },
            {
                CODE: 'EDU03',
                NAME: '장비병행교육',
                ENG_NAME: 'Equipment Training',
            },
            {
                CODE: 'EDU04',
                NAME: '출입권한',
                ENG_NAME: 'Access Right',
            },
            {
                CODE: 'EDU05',
                NAME: '안전교육',
                ENG_NAME: 'Safety Education',
            },
            {
                CODE: 'EDU06',
                NAME: '장비교육',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육증빙유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '참가증',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '이수증',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육참석여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '예',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '아니오',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육참여자참조유형',
        codeList: [
            {
                CODE: 'EQRV',
                NAME: '교육병행의뢰(예약)',
                ENG_NAME: null,
            },
            {
                CODE: 'EQRS',
                NAME: '교육병행의뢰(실적)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '교육활성여부',
        codeList: [
            {
                CODE: 'A',
                NAME: '활성',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '비활성',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비교육분야',
        codeList: [
            {
                CODE: 'BIO',
                NAME: '제약바이오',
                ENG_NAME: null,
            },
            {
                CODE: 'MD',
                NAME: '의료기기',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용계약단위',
        codeList: [
            {
                CODE: '01',
                NAME: '개월',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '분기',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '년도',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용계약상태',
        codeList: [
            {
                CODE: 'A',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용계약처리방안',
        codeList: [
            {
                CODE: '01',
                NAME: '계약 후 예약',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '계약, 예약 병행',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '거부사유',
        codeList: [
            {
                CODE: 'F',
                NAME: '없음',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '추가교육필요',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '결제여부',
        codeList: [
            {
                CODE: 'W',
                NAME: '대기',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '결제',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '실패',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '권한상태',
        codeList: [
            {
                CODE: 'A',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '거부',
                ENG_NAME: null,
            },
            {
                CODE: 'P',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용권한교육참조유형',
        codeList: [
            {
                CODE: 'EQRV',
                NAME: '교육병행의뢰(예약)',
                ENG_NAME: null,
            },
            {
                CODE: 'EQRS',
                NAME: '교육병행의뢰(실적)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용권한신청기간',
        codeList: [
            {
                CODE: '1M',
                NAME: '1개월',
                ENG_NAME: null,
            },
            {
                CODE: '6M',
                NAME: '6개월',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용권한신청상태',
        codeList: [
            {
                CODE: 'P',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'I',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '해제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '출입권한유형',
        codeList: [
            {
                CODE: '1',
                NAME: '부여',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '해제',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '출입카드대상유형',
        codeList: [
            {
                CODE: 'EQ',
                NAME: '장비이용',
                ENG_NAME: null,
            },
            {
                CODE: 'FA',
                NAME: '시설이용',
                ENG_NAME: null,
            },
            {
                CODE: 'MT',
                NAME: '장비유지보수',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '출입카드상태',
        codeList: [
            {
                CODE: '01',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '발급',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '회수',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용료 폼유형',
        codeList: [
            {
                CODE: '01',
                NAME: '유료',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '무료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용료 합계여부',
        codeList: [
            {
                CODE: 'N',
                NAME: '아니오',
                ENG_NAME: null,
            },
            {
                CODE: 'Y',
                NAME: '예',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용일지상태',
        codeList: [
            {
                CODE: '01',
                NAME: '사용중',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '이상',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '인증유형',
        codeList: [
            {
                CODE: 'MJN',
                NAME: '신규회원',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '대여단위',
        codeList: [
            {
                CODE: 'EA',
                NAME: 'EA',
                ENG_NAME: null,
            },
            {
                CODE: 'PCS',
                NAME: 'PCS',
                ENG_NAME: null,
            },
            {
                CODE: 'BX',
                NAME: 'BX',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '소모품 분류',
        codeList: [
            {
                CODE: 'MR',
                NAME: '실험재료',
                ENG_NAME: null,
            },
            {
                CODE: 'ES',
                NAME: '부가 서비스',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '연구장비분류체계',
        codeList: [
            {
                CODE: 'A',
                NAME: '광학·전자 영상장비',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '화합물·전처리 분석장비',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '기계가공·시험장비',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '전기·전자장비',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '물리적 측정장비',
                ENG_NAME: null,
            },
            {
                CODE: 'G',
                NAME: '임상의료장비',
                ENG_NAME: null,
            },
            {
                CODE: 'H',
                NAME: '환경조성·사육시설',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용권한',
        codeList: [
            {
                CODE: '5',
                NAME: '일반사용자',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '셀프유저',
                ENG_NAME: null,
            },
            {
                CODE: '1',
                NAME: '슈퍼유저',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '작업유형',
        codeList: [
            {
                CODE: 'LB',
                NAME: '연구소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비분야',
        codeList: [
            {
                CODE: 'BIO',
                NAME: '제약바이오',
                ENG_NAME: null,
            },
            {
                CODE: 'MD',
                NAME: '의료기기',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비예약권한',
        codeList: [
            {
                CODE: 'I',
                NAME: '내부',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '외부',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '전체',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비이용권한',
        codeList: [
            {
                CODE: '1',
                NAME: '슈퍼유저',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '셀프유저',
                ENG_NAME: null,
            },
            {
                CODE: '5',
                NAME: '일반사용자',
                ENG_NAME: null,
            },
            {
                CODE: '10',
                NAME: '시설이용권한',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비작업유형',
        codeList: [
            {
                CODE: 'ME',
                NAME: '주요',
                ENG_NAME: null,
            },
            {
                CODE: 'SE',
                NAME: '장터',
                ENG_NAME: null,
            },
            {
                CODE: 'PE',
                NAME: '구매',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '참고자료유형',
        codeList: [
            {
                CODE: 'NLD',
                NAME: '일반자료',
                ENG_NAME: null,
            },
            {
                CODE: 'VOD',
                NAME: '동영상',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비견적상태',
        codeList: [
            {
                CODE: 'PR',
                NAME: '요청',
                ENG_NAME: null,
            },
            {
                CODE: 'CP',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'PT',
                NAME: '발급',
                ENG_NAME: null,
            },
            {
                CODE: 'CL',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비견적유형',
        codeList: [
            {
                CODE: 'FE',
                NAME: '가견적',
                ENG_NAME: null,
            },
            {
                CODE: 'OE',
                NAME: '진견적',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'NTIS연계현황',
        codeList: [
            {
                CODE: '1',
                NAME: '연계완료',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '대기',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '반려',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'NTIS정보연계상태',
        codeList: [
            {
                CODE: '01',
                NAME: '대기',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '요청(승인)',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '요청(삭제)',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '요청(오류)',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '요청(삭제)반려',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '개발장비공개여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '공개',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '비공개',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '관리구분',
        codeList: [
            {
                CODE: '01',
                NAME: '설치',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '점검',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '변경',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '이동',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '고장',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '수리',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '반출',
                ENG_NAME: null,
            },
            {
                CODE: '08',
                NAME: '반입',
                ENG_NAME: null,
            },
            {
                CODE: '09',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시설장비구분',
        codeList: [
            {
                CODE: 'P',
                NAME: '구매장비',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '실적업로드상태',
        codeList: [
            {
                CODE: 'PFM001',
                NAME: '생성',
                ENG_NAME: null,
            },
            {
                CODE: 'PFM002',
                NAME: '사전검토 완료',
                ENG_NAME: null,
            },
            {
                CODE: 'PFM003',
                NAME: '작업중',
                ENG_NAME: null,
            },
            {
                CODE: 'PFM004',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비관리유형',
        codeList: [
            {
                CODE: 'RE',
                NAME: 'NFEC장비',
                ENG_NAME: null,
            },
            {
                CODE: 'NE',
                NAME: '미등록장비',
                ENG_NAME: null,
            },
            {
                CODE: 'PE',
                NAME: '이전장비',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비담당자구분코드',
        codeList: [
            {
                CODE: '01',
                NAME: '장비담당자',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '장비책임자',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '장비활용담당자',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비실적상태',
        codeList: [
            {
                CODE: 'UT',
                NAME: '미처리',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '처리',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비취득방법',
        codeList: [
            {
                CODE: 'P',
                NAME: '구매',
                ENG_NAME: null,
            },
            {
                CODE: 'DE',
                NAME: '개발',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '처리결과',
        codeList: [
            {
                CODE: '01',
                NAME: '양호',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '보류',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기관연결 유형',
        codeList: [
            {
                CODE: 'CM',
                NAME: '거래처',
                ENG_NAME: null,
            },
            {
                CODE: 'DP',
                NAME: '부서',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '내/외부구분',
        codeList: [
            {
                CODE: 'I',
                NAME: '내부사용',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '외부오픈',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시험분석결과서 작성상태',
        codeList: [
            {
                CODE: 'CA',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '작성완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '예약유형',
        codeList: [
            {
                CODE: 'SU',
                NAME: '직접이용',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '이용의뢰',
                ENG_NAME: null,
            },
            {
                CODE: 'WE',
                NAME: '교육병행의뢰',
                ENG_NAME: null,
            },
            {
                CODE: 'EX',
                NAME: '일반이용(with전문가)',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비 예약 상태',
        codeList: [
            {
                CODE: 'AW',
                NAME: '신청대기',
                ENG_NAME: null,
            },
            {
                CODE: 'AP',
                NAME: '신청',
                ENG_NAME: null,
            },
            {
                CODE: 'CA',
                NAME: '취소',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '예약',
                ENG_NAME: null,
            },
            {
                CODE: 'RT',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비예약부가세',
        codeList: [
            {
                CODE: 'TAX0',
                NAME: '없음',
                ENG_NAME: null,
            },
            {
                CODE: 'TAX10',
                NAME: '부가세 10%',
                ENG_NAME: null,
            },
            {
                CODE: 'TAX20',
                NAME: '부가세 20%',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비운영실 유형',
        codeList: [
            {
                CODE: 'E',
                NAME: '장비운영실',
                ENG_NAME: null,
            },
            {
                CODE: 'ccrf',
                NAME: '중앙연구기기센터',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '계산유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '금액',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '퍼센트',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '과금기준',
        codeList: [
            {
                CODE: '01',
                NAME: '시간',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '시료수',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '시험횟수',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '시료수*시험횟수',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '과금단위',
        codeList: [
            {
                CODE: 'A',
                NAME: '시료',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '재료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '과금유형',
        codeList: [
            {
                CODE: 'Y',
                NAME: '후지불',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '선지불',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '금액유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '기본',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '외부할증',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '내부사용',
                ENG_NAME: null,
            },
            {
                CODE: 'D',
                NAME: '그룹',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '반려사유',
        codeList: [
            {
                CODE: 'AT',
                NAME: '금액',
                ENG_NAME: null,
            },
            {
                CODE: 'EQ',
                NAME: '장비',
                ENG_NAME: null,
            },
            {
                CODE: 'DT',
                NAME: '일정',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '소모품단위',
        codeList: [
            {
                CODE: 'EA',
                NAME: 'EA',
                ENG_NAME: null,
            },
            {
                CODE: 'PCS',
                NAME: 'PCS',
                ENG_NAME: null,
            },
            {
                CODE: 'BX',
                NAME: 'BX',
                ENG_NAME: null,
            },
            {
                CODE: 'PR',
                NAME: 'PR',
                ENG_NAME: null,
            },
            {
                CODE: 'AY',
                NAME: 'AY',
                ENG_NAME: null,
            },
            {
                CODE: 'Set',
                NAME: 'Set',
                ENG_NAME: null,
            },
            {
                CODE: 'g',
                NAME: 'g',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '소모품유형',
        codeList: [
            {
                CODE: 'A',
                NAME: '입고',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '사용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '스케줄단위',
        codeList: [
            {
                CODE: '30M',
                NAME: '30분',
                ENG_NAME: null,
            },
            {
                CODE: '1H',
                NAME: '1시간',
                ENG_NAME: null,
            },
            {
                CODE: '2H',
                NAME: '2시간',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '스케줄분류',
        codeList: [
            {
                CODE: 'E',
                NAME: '장비',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '시설',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '스케줄시작시간',
        codeList: [
            {
                CODE: '00',
                NAME: '00:00',
                ENG_NAME: null,
            },
            {
                CODE: '01',
                NAME: '01:00',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '02:00',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '03:00',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '04:00',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '05:00',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '06:00',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '07:00',
                ENG_NAME: null,
            },
            {
                CODE: '08',
                NAME: '08:00',
                ENG_NAME: null,
            },
            {
                CODE: '09',
                NAME: '09:00',
                ENG_NAME: null,
            },
            {
                CODE: '10',
                NAME: '10:00',
                ENG_NAME: null,
            },
            {
                CODE: '11',
                NAME: '11:00',
                ENG_NAME: null,
            },
            {
                CODE: '12',
                NAME: '12:00',
                ENG_NAME: null,
            },
            {
                CODE: '13',
                NAME: '13:00',
                ENG_NAME: null,
            },
            {
                CODE: '14',
                NAME: '14:00',
                ENG_NAME: null,
            },
            {
                CODE: '15',
                NAME: '15:00',
                ENG_NAME: null,
            },
            {
                CODE: '16',
                NAME: '16:00',
                ENG_NAME: null,
            },
            {
                CODE: '17',
                NAME: '17:00',
                ENG_NAME: null,
            },
            {
                CODE: '18',
                NAME: '18:00',
                ENG_NAME: null,
            },
            {
                CODE: '19',
                NAME: '19:00',
                ENG_NAME: null,
            },
            {
                CODE: '20',
                NAME: '20:00',
                ENG_NAME: null,
            },
            {
                CODE: '21',
                NAME: '21:00',
                ENG_NAME: null,
            },
            {
                CODE: '22',
                NAME: '22:00',
                ENG_NAME: null,
            },
            {
                CODE: '23',
                NAME: '23:00',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '스케줄유형',
        codeList: [
            {
                CODE: '04',
                NAME: '휴일',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '스케줄종료시간',
        codeList: [
            {
                CODE: '00',
                NAME: '00:00',
                ENG_NAME: null,
            },
            {
                CODE: '01',
                NAME: '01:00',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '02:00',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '03:00',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '04:00',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '05:00',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '06:00',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '07:00',
                ENG_NAME: null,
            },
            {
                CODE: '08',
                NAME: '08:00',
                ENG_NAME: null,
            },
            {
                CODE: '09',
                NAME: '09:00',
                ENG_NAME: null,
            },
            {
                CODE: '10',
                NAME: '10:00',
                ENG_NAME: null,
            },
            {
                CODE: '11',
                NAME: '11:00',
                ENG_NAME: null,
            },
            {
                CODE: '12',
                NAME: '12:00',
                ENG_NAME: null,
            },
            {
                CODE: '13',
                NAME: '13:00',
                ENG_NAME: null,
            },
            {
                CODE: '14',
                NAME: '14:00',
                ENG_NAME: null,
            },
            {
                CODE: '15',
                NAME: '15:00',
                ENG_NAME: null,
            },
            {
                CODE: '16',
                NAME: '16:00',
                ENG_NAME: null,
            },
            {
                CODE: '17',
                NAME: '17:00',
                ENG_NAME: null,
            },
            {
                CODE: '18',
                NAME: '18:00',
                ENG_NAME: null,
            },
            {
                CODE: '19',
                NAME: '19:00',
                ENG_NAME: null,
            },
            {
                CODE: '20',
                NAME: '20:00',
                ENG_NAME: null,
            },
            {
                CODE: '21',
                NAME: '21:00',
                ENG_NAME: null,
            },
            {
                CODE: '22',
                NAME: '22:00',
                ENG_NAME: null,
            },
            {
                CODE: '23',
                NAME: '23:00',
                ENG_NAME: null,
            },
            {
                CODE: '24',
                NAME: '24:00',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시간단위',
        codeList: [
            {
                CODE: 'M10',
                NAME: '10분',
                ENG_NAME: null,
            },
            {
                CODE: 'M20',
                NAME: '20분',
                ENG_NAME: null,
            },
            {
                CODE: 'M30',
                NAME: '30분',
                ENG_NAME: null,
            },
            {
                CODE: 'H1',
                NAME: '1시간',
                ENG_NAME: null,
            },
            {
                CODE: 'H2',
                NAME: '2시간',
                ENG_NAME: null,
            },
            {
                CODE: 'H3',
                NAME: '3시간',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '시간조정유형',
        codeList: [
            {
                CODE: '01',
                NAME: '시간만사용',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '시험 횟수기준 변경',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '시료기준 변경',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '업무대행상태',
        codeList: [
            {
                CODE: 'W',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '요청',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '반려',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '예약시간기본단위',
        codeList: [
            {
                CODE: '10',
                NAME: '10분',
                ENG_NAME: null,
            },
            {
                CODE: '15',
                NAME: '15분',
                ENG_NAME: null,
            },
            {
                CODE: '30',
                NAME: '30분',
                ENG_NAME: null,
            },
            {
                CODE: '60',
                NAME: '60분',
                ENG_NAME: null,
            },
            {
                CODE: '1',
                NAME: '1일',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '예약신청유형',
        codeList: [
            {
                CODE: 'SU',
                NAME: '셀프',
                ENG_NAME: null,
            },
            {
                CODE: 'RT',
                NAME: '의뢰',
                ENG_NAME: null,
            },
            {
                CODE: 'MR',
                NAME: '재료',
                ENG_NAME: null,
            },
            {
                CODE: 'TA',
                NAME: '자문',
                ENG_NAME: null,
            },
            {
                CODE: 'FY',
                NAME: '시설',
                ENG_NAME: null,
            },
            {
                CODE: 'EU',
                NAME: '교육',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '운영스케줄유형',
        codeList: [
            {
                CODE: 'T8',
                NAME: '8시간운영',
                ENG_NAME: null,
            },
            {
                CODE: 'T24',
                NAME: '24시간운영',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '이용료항목',
        codeList: [
            {
                CODE: '01',
                NAME: '이용단가',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '사용량',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '직접비',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '간접비',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '할인률',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비상태',
        codeList: [
            {
                CODE: 'O',
                NAME: '정상가동',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '수리중',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비예약결제여부 ',
        codeList: [
            {
                CODE: 'PA',
                NAME: '결제',
                ENG_NAME: null,
            },
            {
                CODE: 'OT',
                NAME: '미결제',
                ENG_NAME: null,
            },
            {
                CODE: 'PO',
                NAME: '후불',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비예약과금유형',
        codeList: [
            {
                CODE: 'AD',
                NAME: '선금예약',
                ENG_NAME: null,
            },
            {
                CODE: 'PS',
                NAME: '후불예약',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비예약상태',
        codeList: [
            {
                CODE: 'W',
                NAME: '작성중',
                ENG_NAME: null,
            },
            {
                CODE: 'WF',
                NAME: '작성완료',
                ENG_NAME: null,
            },
            {
                CODE: 'WA',
                NAME: '승인요청',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '반려',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'WI',
                NAME: '대기중',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '작동중',
                ENG_NAME: null,
            },
            {
                CODE: 'CL',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비이용진행상태',
        codeList: [
            {
                CODE: '0',
                NAME: '사용취소',
                ENG_NAME: null,
            },
            {
                CODE: '1',
                NAME: '사용신청',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '사용승인',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '사용완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비작업상태',
        codeList: [
            {
                CODE: 'R',
                NAME: '예약',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '점검',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비점검작업유형',
        codeList: [
            {
                CODE: 'M',
                NAME: '점검',
                ENG_NAME: null,
            },
            {
                CODE: 'R',
                NAME: '수리',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비활용상태',
        codeList: [
            {
                CODE: 'PD',
                NAME: '대기중',
                ENG_NAME: null,
            },
            {
                CODE: 'DT',
                NAME: '시험중',
                ENG_NAME: null,
            },
            {
                CODE: 'CI',
                NAME: '점검중',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '장비활용종류',
        codeList: [
            {
                CODE: 'EM',
                NAME: '점검/수리',
                ENG_NAME: null,
            },
            {
                CODE: 'ER',
                NAME: '대여',
                ENG_NAME: null,
            },
            {
                CODE: 'EV',
                NAME: '예약',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '실적',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '점검수리방법',
        codeList: [
            {
                CODE: 'SM',
                NAME: '셀프수리',
                ENG_NAME: null,
            },
            {
                CODE: 'CM',
                NAME: '업체수리',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정산유형',
        codeList: [
            {
                CODE: 'CS',
                NAME: '현금',
                ENG_NAME: null,
            },
            {
                CODE: 'CD',
                NAME: '카드',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '지급유형',
        codeList: [
            {
                CODE: 'PP',
                NAME: '예약선지급',
                ENG_NAME: null,
            },
            {
                CODE: 'EP',
                NAME: '장비사용료',
                ENG_NAME: null,
            },
            {
                CODE: 'ER',
                NAME: '장비대여',
                ENG_NAME: null,
            },
            {
                CODE: 'PE',
                NAME: '패널티',
                ENG_NAME: null,
            },
            {
                CODE: 'MI',
                NAME: '선수금입금',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '추가금액유형',
        codeList: [
            {
                CODE: '0',
                NAME: '없음',
                ENG_NAME: null,
            },
            {
                CODE: '1',
                NAME: '비율',
                ENG_NAME: null,
            },
            {
                CODE: '2',
                NAME: '고정금액',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '페널티방법',
        codeList: [
            {
                CODE: 'A',
                NAME: '비율',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '차감금액',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '고정금액',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '할인률',
        codeList: [
            {
                CODE: '50',
                NAME: '직접 사용자',
                ENG_NAME: null,
            },
            {
                CODE: '30',
                NAME: '(사용의뢰)유치기관 소속 연구자',
                ENG_NAME: null,
            },
            {
                CODE: '30',
                NAME: '(사용의뢰)중소기업 소속 연구자',
                ENG_NAME: null,
            },
            {
                CODE: '10',
                NAME: '(사용의뢰)대학 소속 연구자',
                ENG_NAME: null,
            },
            {
                CODE: '10',
                NAME: '(사용의뢰)공공기관 소속 연구자',
                ENG_NAME: null,
            },
            {
                CODE: '0',
                NAME: '(사용의뢰)영리단체 소속 연구자',
                ENG_NAME: null,
            },
            {
                CODE: '0',
                NAME: '(사용의뢰)일반기업 소속 연구자',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '활용구분',
        codeList: [
            {
                CODE: 'IS',
                NAME: '내부서비스',
                ENG_NAME: null,
            },
            {
                CODE: 'ES',
                NAME: '외부서비스',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '전문(연구)분야',
        codeList: [
            {
                CODE: '01',
                NAME: '항체의약품',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '단백질의약품',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '백신',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '천연물의약품',
                ENG_NAME: null,
            },
            {
                CODE: '05',
                NAME: '세포치료제',
                ENG_NAME: null,
            },
            {
                CODE: '06',
                NAME: '합성(화학) 의약품',
                ENG_NAME: null,
            },
            {
                CODE: '07',
                NAME: '한약제재, 생약제재',
                ENG_NAME: null,
            },
            {
                CODE: '08',
                NAME: '방사선 영상 진단기기',
                ENG_NAME: null,
            },
            {
                CODE: '09',
                NAME: '생체계측기기',
                ENG_NAME: null,
            },
            {
                CODE: '10',
                NAME: '체외진단기기',
                ENG_NAME: null,
            },
            {
                CODE: '11',
                NAME: '진료장치',
                ENG_NAME: null,
            },
            {
                CODE: '12',
                NAME: '마취 및 호흡기기',
                ENG_NAME: null,
            },
            {
                CODE: '13',
                NAME: '수술 및 치료기기',
                ENG_NAME: null,
            },
            {
                CODE: '14',
                NAME: '정형용품',
                ENG_NAME: null,
            },
            {
                CODE: '15',
                NAME: '내장기능대용기(인공장기)',
                ENG_NAME: null,
            },
            {
                CODE: '16',
                NAME: '의료기경',
                ENG_NAME: null,
            },
            {
                CODE: '17',
                NAME: '의료용품',
                ENG_NAME: null,
            },
            {
                CODE: '18',
                NAME: '치과용기기.기계(치과재료 포함)',
                ENG_NAME: null,
            },
            {
                CODE: '19',
                NAME: '가정용 치료기기',
                ENG_NAME: null,
            },
            {
                CODE: '20',
                NAME: '재활기기',
                ENG_NAME: null,
            },
            {
                CODE: '21',
                NAME: '체외진단용 시약',
                ENG_NAME: null,
            },
            {
                CODE: '22',
                NAME: '웰니스기기',
                ENG_NAME: null,
            },
            {
                CODE: '99',
                NAME: '위 분야 중 해당되는 분야가 없을 경우',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '전문(연구)분야구분',
        codeList: [
            {
                CODE: 'BIM',
                NAME: '제약바이오(의약품)',
                ENG_NAME: null,
            },
            {
                CODE: 'BIO',
                NAME: '제약바이오',
                ENG_NAME: null,
            },
            {
                CODE: 'MD',
                NAME: '의료기기',
                ENG_NAME: null,
            },
            {
                CODE: 'ET',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '세션이력유형',
        codeList: [
            {
                CODE: 'LI',
                NAME: '로그인',
                ENG_NAME: null,
            },
            {
                CODE: 'LO',
                NAME: '로그아웃',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정보이력상세유형',
        codeList: [
            {
                CODE: 'LI',
                NAME: '로그인',
                ENG_NAME: null,
            },
            {
                CODE: 'LO',
                NAME: '로그아웃',
                ENG_NAME: null,
            },
            {
                CODE: 'SCH',
                NAME: '스케줄러',
                ENG_NAME: null,
            },
            {
                CODE: 'DA',
                NAME: '정보접근',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정보이력유형',
        codeList: [
            {
                CODE: 'ALL',
                NAME: '전체',
                ENG_NAME: null,
            },
            {
                CODE: 'MB',
                NAME: '회원',
                ENG_NAME: null,
            },
            {
                CODE: 'NMB',
                NAME: '비회원',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '제외유형',
        codeList: [
            {
                CODE: 'PG',
                NAME: '페이지',
                ENG_NAME: null,
            },
            {
                CODE: 'ET',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '공과금 구분',
        codeList: [
            {
                CODE: 'WU',
                NAME: '수도',
                ENG_NAME: null,
            },
            {
                CODE: 'GU',
                NAME: '가스',
                ENG_NAME: null,
            },
            {
                CODE: 'EU',
                NAME: '전기',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '과금여부',
        codeList: [
            {
                CODE: 'Y',
                NAME: '예',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '아니오',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '신청중',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '부가세유형',
        codeList: [
            {
                CODE: 'TAX0',
                NAME: '없음',
                ENG_NAME: null,
            },
            {
                CODE: 'TAX10',
                NAME: '부가세 10%',
                ENG_NAME: null,
            },
            {
                CODE: 'TAX30',
                NAME: '부가세 30%',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '세금계산서유형',
        codeList: [
            {
                CODE: 'INV0',
                NAME: '면제',
                ENG_NAME: null,
            },
            {
                CODE: 'INV10',
                NAME: '부가세 10%',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정산거래유형',
        codeList: [
            {
                CODE: 'I',
                NAME: '내부',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '외부',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정산결재상태',
        codeList: [
            {
                CODE: 'SB',
                NAME: '대기',
                ENG_NAME: null,
            },
            {
                CODE: 'AP',
                NAME: '요청',
                ENG_NAME: null,
            },
            {
                CODE: 'RE',
                NAME: '승인',
                ENG_NAME: null,
            },
            {
                CODE: 'RT',
                NAME: '반려',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정산비용유형',
        codeList: [
            {
                CODE: 'EQFEES',
                NAME: '장비이용료',
                ENG_NAME: null,
            },
            {
                CODE: 'PYFEES',
                NAME: '패널티 금액',
                ENG_NAME: null,
            },
            {
                CODE: 'MRFEES',
                NAME: '실험재료 판매',
                ENG_NAME: null,
            },
            {
                CODE: 'EDFEES',
                NAME: '교육수강료(일반)',
                ENG_NAME: null,
            },
            {
                CODE: 'EUFEES',
                NAME: '교육수강료(장비,시설)',
                ENG_NAME: null,
            },
            {
                CODE: 'FYFEES',
                NAME: '시설이용료',
                ENG_NAME: null,
            },
            {
                CODE: 'TAFEES',
                NAME: '기술자문료',
                ENG_NAME: null,
            },
            {
                CODE: 'ETFEES',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '정산상태',
        codeList: [
            {
                CODE: 'O',
                NAME: '미처리',
                ENG_NAME: null,
            },
            {
                CODE: 'CO',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'AL',
                NAME: '결재선',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '청구서참조유형',
        codeList: [
            {
                CODE: 'SU',
                NAME: '설문',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '기본정책',
        codeList: [
            {
                CODE: 'N',
                NAME: '아니오',
                ENG_NAME: null,
            },
            {
                CODE: 'Y',
                NAME: '예',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '컨텐츠-금액-구분',
        codeList: [
            {
                CODE: 'I',
                NAME: '내부',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '외부',
                ENG_NAME: null,
            },
            {
                CODE: 'U',
                NAME: '직접사용자',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '컨텐츠-금액-이용구분',
        codeList: [
            {
                CODE: 'TA',
                NAME: '시험분석료',
                ENG_NAME: null,
            },
            {
                CODE: 'SS',
                NAME: '부가 서비스',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '컨텐츠-층',
        codeList: [
            {
                CODE: 'F01',
                NAME: '1층',
                ENG_NAME: null,
            },
            {
                CODE: 'F02',
                NAME: '2층',
                ENG_NAME: null,
            },
            {
                CODE: 'F03',
                NAME: '3층',
                ENG_NAME: null,
            },
            {
                CODE: 'F04',
                NAME: '4층',
                ENG_NAME: null,
            },
            {
                CODE: 'CSG',
                NAME: 'CSG',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '컨텐츠유형',
        codeList: [
            {
                CODE: 'CN001',
                NAME: '장비이용료',
                ENG_NAME: null,
            },
            {
                CODE: 'CN002',
                NAME: '조직도 및 업무 담당자',
                ENG_NAME: null,
            },
            {
                CODE: 'CN003',
                NAME: '층별안내',
                ENG_NAME: null,
            },
            {
                CODE: 'CN004',
                NAME: '플랫폼',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'testGroup',
        codeList: [
            {
                CODE: 'C',
                NAME: '구획',
                ENG_NAME: null,
            },
            {
                CODE: 'P',
                NAME: '명',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'graphql 테스트',
        codeList: [
            {
                CODE: 'A',
                NAME: '테스트코드 1',
                ENG_NAME: null,
            },
            {
                CODE: 'BBBBB',
                NAME: 'BBBBB',
                ENG_NAME: null,
            },
            {
                CODE: 'CCCCC',
                NAME: 'CCCCC',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '특이사항요청유형',
        codeList: [
            {
                CODE: 'EU',
                NAME: '장비 이용',
                ENG_NAME: null,
            },
            {
                CODE: 'ER',
                NAME: '장비 예약',
                ENG_NAME: null,
            },
            {
                CODE: 'ET',
                NAME: '장비 실적',
                ENG_NAME: null,
            },
            {
                CODE: 'EM',
                NAME: '유지보수',
                ENG_NAME: null,
            },
            {
                CODE: 'DT',
                NAME: '직접',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '특이사항처리유형',
        codeList: [
            {
                CODE: 'NC',
                NAME: '미처리',
                ENG_NAME: null,
            },
            {
                CODE: 'CP',
                NAME: '처리완료',
                ENG_NAME: null,
            },
            {
                CODE: 'MC',
                NAME: '유지보수 처리',
                ENG_NAME: null,
            },
            {
                CODE: 'WT',
                NAME: '기록',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '페널티유형',
        codeList: [
            {
                CODE: 'C',
                NAME: '비율',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '금액',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '포탈_레이아웃',
        codeList: [
            {
                CODE: '2',
                NAME: '2',
                ENG_NAME: null,
            },
            {
                CODE: '3',
                NAME: '3',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: 'TASK 상태',
        codeList: [
            {
                CODE: 'P',
                NAME: '계획',
                ENG_NAME: null,
            },
            {
                CODE: 'G',
                NAME: '진행',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '완료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '공동파일작업상태',
        codeList: [
            {
                CODE: 'R',
                NAME: '열람',
                ENG_NAME: null,
            },
            {
                CODE: 'W',
                NAME: '작업중',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '완료',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '취소',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '내외구분',
        codeList: [
            {
                CODE: 'I',
                NAME: '비공개',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '공개',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '프로젝트상태',
        codeList: [
            {
                CODE: '01',
                NAME: '준비중',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '모집중',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '진행중',
                ENG_NAME: null,
            },
            {
                CODE: '04',
                NAME: '종료',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '작업그룹유형',
        codeList: [
            {
                CODE: 'WG',
                NAME: '작업그룹',
                ENG_NAME: null,
            },
            {
                CODE: 'ER',
                NAME: '장비운영실',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '추가할인유형',
        codeList: [
            {
                CODE: 'C',
                NAME: '할인율',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '고정금액이용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '할인유형',
        codeList: [
            {
                CODE: 'C',
                NAME: '할인율',
                ENG_NAME: null,
            },
            {
                CODE: 'P',
                NAME: '일정금액이용',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '고정금액이용',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '내/외부이용자',
        codeList: [
            {
                CODE: 'I',
                NAME: '내부회원',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '외부회원',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '내/외부이용자 선택',
        codeList: [
            {
                CODE: 'I',
                NAME: '내부',
                ENG_NAME: null,
            },
            {
                CODE: 'O',
                NAME: '외부',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '내_외국인',
        codeList: [
            {
                CODE: 'L',
                NAME: '내국인',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '외국인',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '부서',
        codeList: [
            {
                CODE: 'P',
                NAME: '공공기기센터',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '산학연구분',
        codeList: [
            {
                CODE: 'A',
                NAME: '산업',
                ENG_NAME: null,
            },
            {
                CODE: 'B',
                NAME: '학교',
                ENG_NAME: null,
            },
            {
                CODE: 'C',
                NAME: '연구소',
                ENG_NAME: null,
            },
            {
                CODE: 'E',
                NAME: '기타',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '성별',
        codeList: [
            {
                CODE: 'M',
                NAME: '남',
                ENG_NAME: null,
            },
            {
                CODE: 'F',
                NAME: '여',
                ENG_NAME: null,
            },
            {
                CODE: 'X',
                NAME: '기타',
                ENG_NAME: null,
            },
            {
                CODE: 'N',
                NAME: '미지정',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '참여업무',
        codeList: [
            {
                CODE: 'S',
                NAME: '시스템',
                ENG_NAME: null,
            },
            {
                CODE: 'M',
                NAME: '관리',
                ENG_NAME: null,
            },
            {
                CODE: 'E',
                NAME: '장비관리',
                ENG_NAME: null,
            },
            {
                CODE: 'P',
                NAME: '장비활용',
                ENG_NAME: null,
            },
            {
                CODE: 'A',
                NAME: '정산',
                ENG_NAME: null,
            },
            {
                CODE: 'U',
                NAME: '회원',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '참여역할',
        codeList: [
            {
                CODE: 'M',
                NAME: '관리자',
                ENG_NAME: 'Administrator',
            },
            {
                CODE: 'P',
                NAME: '담당자',
                ENG_NAME: 'Staff',
            },
            {
                CODE: 'U',
                NAME: '일반회원',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '참여역할-관리자',
        codeList: [
            {
                CODE: 'ST',
                NAME: '시스템',
                ENG_NAME: null,
            },
            {
                CODE: 'RO',
                NAME: '운영실',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '참여역할-담당자',
        codeList: [
            {
                CODE: 'EQ',
                NAME: '장비',
                ENG_NAME: null,
            },
            {
                CODE: 'IN',
                NAME: '정산',
                ENG_NAME: null,
            },
            {
                CODE: 'IF',
                NAME: '출입',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '회원추가정보유형',
        codeList: [
            {
                CODE: '01',
                NAME: '증빙자료',
                ENG_NAME: null,
            },
            {
                CODE: '02',
                NAME: '사진',
                ENG_NAME: null,
            },
            {
                CODE: '03',
                NAME: '사인',
                ENG_NAME: null,
            },
        ],
    },
    {
        NAME: '룸관리자권한',
        codeList: [
            {
                CODE: 'P',
                NAME: '임시권한코드',
                ENG_NAME: null,
            },
        ],
    },
]